(function () {
    'use strict';

    angular.module('question_bank', []).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('app.question_bank', {
            url: 'question-bank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/modules/question-bank/question-bank.html',
                    controller: 'QuestionBankController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_answer', {
            url: '/question-answer',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-answer/question-answer.html',
                    controller: 'QuestionAnswerController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_answer.create_question', {
            url: '/question-answer/question-create',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-answer/create-question/create-question.html',
                    controller: 'CreateQuestionController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_answer.import_question', {
            url: '/question-answer/question-import',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-answer/import-question/import-question.html',
                    controller: 'ImportQuestionController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_pool', {
            url: '/question-pool',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-pool/question-pool.html',
                    controller: 'QuestionPoolController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_pool.create_pool', {
            url: '/question-pool/create-pool',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-pool/create-pool/create-pool.html',
                    controller: 'CreatePoolController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_answer.edit', {
            url: '/edit',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-answer/edit-question/edit.html',
                    controller: 'EditQuestionController as vm'
                }
            },
            params: {
                obj: null
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_pool.edit_pool', {
            url: '/edit',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-pool/edit-pool/edit.html',
                    controller: 'EditPoolController as vm'
                }
            },
            params: {
                obj: null
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_category', {
            url: '/question-category',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-category/question-category.html',
                    controller: 'QuestionCategoryController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_category.create', {
            url: '/question-category/create',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-category/create-question-category/create-question-category.html',
                    controller: 'CreateQuestionCategoryController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_category.update', {
            url: '/question-category/update',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-category/update-question-category/update-question-category.html',
                    controller: 'UpdateQuestionCategoryController as vm'
                }
            },
            params: {
                obj: null
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_competency', {
            url: '/question-competency',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-competency/question-competency.html',
                    controller: 'QuestionCompetencyController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_answer_tiki', {
            url: '/question-tiki',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-answer-tiki/question-answer-tiki.html',
                    controller: 'QuestionAnswerTikiController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_excel', {
            url: '/question-excel',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-excel/question-excel.html',
                    controller: 'QuestionExcelController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_excel_file', {
            url: '/question-excel-file',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-excel/question-excel-file.html',
                    controller: 'QuestionExcelFileController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_excel_file.question', {
            url: '/question-excel-file/{id}',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-excel/question-excel.html',
                    controller: 'QuestionExcelController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state('app.question_bank.question_excel_file.question.form', {
            url: '/question-excel-file/{id}/{question_id}',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-excel/question-excel-question.form.html',
                    controller: 'QuestionExcelFormController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function () {
  'use strict';

  angular
    .module('question_bank')
    .controller('EditPoolController', EditPoolController);

  /** @ngInject */
  EditPoolController.$inject = [
    '$timeout', 
    '$state', 
    'QuestionPool',
    '$stateParams'
  ];

  function EditPoolController(
    $timeout, 
    $state,
    QuestionPool,
    $stateParams
  ) {

    var vm = this;
    vm.savePool = savePool;
    vm.data = $stateParams.obj
    vm.back = back;

    setData()

    function back ()
    {
      $state.go('app.question_bank.question_pool');
    }

    function setData()
    {
      vm.poolName = vm.data.name
      vm.poolDesc = vm.data.description
      if (vm.data.created_at) {
        vm.poolCreatedAt = new Date(vm.data.created_at);
      }
    }

    function savePool() {

      var data = {
        'name' : vm.poolName,
        'description' : vm.poolDesc,
        'id' : vm.data.id
      };

      QuestionPool.update(data).then(function(resp){
        if ( resp.data.code == 200 ) {
          swal({
            title: "Success",
            text: resp.data.message,
            type: "success",
            showCancelButton: false,
            confirmButtonText: "OK",
            closeOnConfirm: true}, 
          function(){ 
             $state.reload();
          });
        } else {
          swal("Error", resp.data.message, "error")
        }
      }, function(err){
        swal("Oops!", 'Something went wrong', "error")
      })

    }

  }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('CreatePoolController', CreatePoolController);

    /** @ngInject */
    CreatePoolController.$inject = ['$timeout', '$state', 'QuestionPool'];

    function CreatePoolController($timeout, $state, QuestionPool) {
        var vm = this;
        vm.savePool = savePool;
        vm.back = back;

        function back() {
            $state.go('app.question_bank.question_pool');
        }

        function savePool() {
            var data = {
                name: vm.poolName,
                description: vm.poolDesc
            };

            QuestionPool.save(data).then(
                function(resp) {
                    if (resp.data.code == 200) {
                        swal(
                            {
                                title: 'Success',
                                text: resp.data.message,
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller(
            'UpdateQuestionCategoryController',
            UpdateQuestionCategoryController
        );

    /** @ngInject */
    UpdateQuestionCategoryController.$inject = [
        '$timeout',
        '$state',
        'QuestionCategory',
        '$stateParams'
    ];

    function UpdateQuestionCategoryController(
        $timeout,
        $state,
        QuestionCategory,
        $stateParams
    ) {
        var vm = this;
        vm.updateData = updateData;
        vm.back = back;

        if ($stateParams.obj !== null) {
            vm.desc = $stateParams.obj.description;
            vm.name = $stateParams.obj.name;
            vm.id = $stateParams.obj.id;
        }

        function back() {
            $state.go('app.question_bank.question_category');
        }

        function updateData(form) {
            var data = {
                id: vm.id,
                name: vm.name,
                desc: vm.desc
            };

            QuestionCategory.update(data).then(
                function(resp) {
                    if (resp.data.code == 1) {
                        swal(
                            {
                                title: 'Success',
                                text: resp.data.messages,
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', resp.data.messages, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller(
            'CreateQuestionCategoryController',
            CreateQuestionCategoryController
        );

    /** @ngInject */
    CreateQuestionCategoryController.$inject = [
        '$timeout',
        '$state',
        'QuestionCategory'
    ];

    function CreateQuestionCategoryController($timeout, $state, QuestionCategory) {
        var vm = this;

        vm.saveData = saveData;
        vm.back = back;

        function back() {
            $state.go('app.question_bank.question_category');
        }

        function saveData(formController) {
            var data = {
                name: formController.desc.$viewValue,
                description: formController.name.$viewValue
            };
            QuestionCategory.save(data).then(
                function(resp) {
                    console.log(resp);
                    if (resp.data.code == 1) {
                        swal(
                            {
                                title: 'Success',
                                text: resp.data.messages,
                                type: 'success',
                                showCancelButton: false,
                                // confirmButtonColor: "#DD6B55",
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', resp.data.messages, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('RangeBehavioralController', RangeBehavioralController);

    /** @ngInject */
    RangeBehavioralController.$inject = [
        '$state',
        'BehavioralRange',
        '$timeout'
    ];

    function RangeBehavioralController($state, BehavioralRange, $timeout) {
        var vm = this;
        vm.gotoBack = gotoBack;
        vm.gotoCreate = gotoCreate;
        vm.gotoEdit = gotoEdit;
        vm.deleteItem = deleteItem;
        vm.loadData = loadData;
        vm.search = '';
        vm.pageLength = 20;
        vm.rangeList = [];
        vm.currentPage = 1;
        vm.totalItems = 0;
        vm.pageSize = 0;
        vm.from = 0;
        vm.to = 0;
        vm.isLoading = false;

        activate();

        function activate() {
            loadData(1);
        }

        function gotoBack() {
            $state.go('app.question_bank.question_behavioral');
        }

        function gotoCreate() {
            $state.go('app.question_bank.behavioral_range.create');
        }

        function gotoEdit(data) {
            $state.go('app.question_bank.behavioral_range.edit', {obj: data});
        }

        function loadData(pageNo) {
            vm.isLoading = true;
            vm.rangeList = [];
            BehavioralRange.get(pageNo, vm.search, vm.pageLength).then(
                function(resp) {
                    vm.rangeList = resp.data.data;
                    vm.currentPage = resp.data.current_page;
                    vm.pageSize = resp.data.per_page;
                    vm.totalItems = resp.data.total;
                    vm.from = resp.data.from;
                    vm.to = resp.data.to;
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 300);
                },
                function(err) {
                    vm.rangeList = [];
                    vm.isLoading = false;
                }
            );
        }

        function deleteItem(ev, id) {
            swal(
                {
                    title: 'Are you sure?',
                    text: 'This range score will be removed!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        BehavioralRange.delete({id: id}).then(
                            function(resp) {
                                if (resp.data.code == 200 || resp.data.code == 1) {
                                    swal({
                                        title: 'Success',
                                        text: resp.data.message,
                                        type: 'success',
                                        showCancelButton: false,
                                        confirmButtonText: 'OK',
                                        closeOnConfirm: true
                                    }, function() {
                                        $state.reload();
                                    });
                                } else {
                                    swal('Error', resp.data.message, 'error');
                                }
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('EditRangeBehavioralController', EditRangeBehavioralController);

    /** @ngInject */
    EditRangeBehavioralController.$inject = [
        '$state',
        '$stateParams',
        'BehavioralRange'
    ];

    function EditRangeBehavioralController($state, $stateParams, BehavioralRange) {
        var vm = this;
        vm.back = back;
        vm.save = save;
        vm.data = $stateParams.obj || {};

        function back() {
            $state.go('app.question_bank.behavioral_range');
        }

        function save() {
            var payload = angular.copy(vm.data);
            BehavioralRange.update(payload).then(
                function(resp) {
                    if (resp.data.code == 200 || resp.data.code == 1) {
                        swal('Success', resp.data.message, 'success');
                        $state.go('app.question_bank.behavioral_range');
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('CreateRangeBehavioralController', CreateRangeBehavioralController);

    /** @ngInject */
    CreateRangeBehavioralController.$inject = [
        '$state',
        'BehavioralRange',
        'lodash'
    ];

    function CreateRangeBehavioralController($state, BehavioralRange, lodash) {
        var vm = this;
        vm.back = back;
        vm.save = save;
        vm.score_min = null;
        vm.score_max = null;
        vm.percentage_min = null;
        vm.percentage_max = null;
        vm.category = '';
        vm.recommendation = '';
        vm.follow_up = '';

        function back() {
            $state.go('app.question_bank.behavioral_range');
        }

        function save() {
            var payload = {
                score_min: vm.score_min,
                score_max: vm.score_max,
                percentage_min: vm.percentage_min,
                percentage_max: vm.percentage_max,
                category: vm.category,
                recommendation: vm.recommendation,
                follow_up: vm.follow_up
            };
            BehavioralRange.create(payload).then(
                function(resp) {
                    if (resp.data.code == 200 || resp.data.code == 1) {
                        swal('Success', resp.data.message, 'success');
                        $state.go('app.question_bank.behavioral_range');
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();
(function() {
    angular
        .module('question_bank')
        .factory('BehavioralRange', BehavioralRange);

    function BehavioralRange($http, appConfig, apiConfig) {
        var factory = {};
        var base = appConfig.appApi;
        var endpoint = apiConfig.behavioral.range;

        factory.get = function(page, search, length) {
            return $http.get(base + endpoint.list + '?page=' + page + '&search=' + encodeURIComponent(search) + '&length=' + length);
        };

        factory.create = function(data) {
            return $http.post(base + endpoint.save, data);
        };

        factory.update = function(data) {
            return $http.post(base + endpoint.update, data);
        };

        factory.delete = function(ids) {
            return $http.post(base + endpoint.delete, ids);
        };

        return factory;
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QualityBehavioralController', QualityBehavioralController);

    /** @ngInject */
    QualityBehavioralController.$inject = [
        '$state',
        'BehavioralQuality',
        '$timeout'
    ];

    function QualityBehavioralController($state, BehavioralQuality, $timeout) {
        var vm = this;
        vm.gotoBack = gotoBack;
        vm.gotoCreate = gotoCreate;
        vm.gotoEdit = gotoEdit;
        vm.deleteItem = deleteItem;
        vm.loadData = loadData;
        vm.search = '';
        vm.pageLength = 20;
        vm.qualityList = [];
        vm.currentPage = 1;
        vm.totalItems = 0;
        vm.pageSize = 0;
        vm.from = 0;
        vm.to = 0;
        vm.isLoading = false;

        activate();

        function activate() {
            loadData(1);
        }

        function gotoBack() {
            $state.go('app.question_bank.question_behavioral');
        }

        function gotoCreate() {
            $state.go('app.question_bank.behavioral_quality.create');
        }

        function gotoEdit(data) {
            $state.go('app.question_bank.behavioral_quality.edit', {obj: data});
        }

        function loadData(pageNo) {
            vm.isLoading = true;
            vm.qualityList = [];
            BehavioralQuality.get(pageNo, vm.search, vm.pageLength).then(
                function(resp) {
                    vm.qualityList = resp.data.data;
                    vm.currentPage = resp.data.current_page;
                    vm.pageSize = resp.data.per_page;
                    vm.totalItems = resp.data.total;
                    vm.from = resp.data.from;
                    vm.to = resp.data.to;
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 300);
                },
                function(err) {
                    vm.qualityList = [];
                    vm.isLoading = false;
                }
            );
        }

        function deleteItem(ev, id) {
            swal(
                {
                    title: 'Are you sure?',
                    text: 'This quality score will be removed!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        BehavioralQuality.delete({id: id}).then(
                            function(resp) {
                                if (resp.data.code == 200 || resp.data.code == 1) {
                                    swal({
                                        title: 'Success',
                                        text: resp.data.message,
                                        type: 'success',
                                        showCancelButton: false,
                                        confirmButtonText: 'OK',
                                        closeOnConfirm: true
                                    }, function() {
                                        $state.reload();
                                    });
                                } else {
                                    swal('Error', resp.data.message, 'error');
                                }
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('EditQualityBehavioralController', EditQualityBehavioralController);

    /** @ngInject */
    EditQualityBehavioralController.$inject = [
        '$state',
        '$stateParams',
        'BehavioralQuality'
    ];

    function EditQualityBehavioralController($state, $stateParams, BehavioralQuality) {
        var vm = this;
        vm.back = back;
        vm.save = save;
        vm.data = $stateParams.obj || {};

        function back() {
            $state.go('app.question_bank.behavioral_quality');
        }

        function save() {
            var payload = angular.copy(vm.data);
            BehavioralQuality.update(payload).then(
                function(resp) {
                    if (resp.data.code == 200 || resp.data.code == 1) {
                        swal('Success', resp.data.message, 'success');
                        $state.go('app.question_bank.behavioral_quality');
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('CreateQualityBehavioralController', CreateQualityBehavioralController);

    /** @ngInject */
    CreateQualityBehavioralController.$inject = [
        '$state',
        'BehavioralQuality'
    ];

    function CreateQualityBehavioralController($state, BehavioralQuality) {
        var vm = this;
        vm.back = back;
        vm.save = save;
        vm.score = null;
        vm.label = '';
        vm.primary_criteria = '';
        vm.concrete_indicator = '';

        function back() {
            $state.go('app.question_bank.behavioral_quality');
        }

        function save() {
            var payload = {
                score: vm.score,
                label: vm.label,
                primary_criteria: vm.primary_criteria,
                concrete_indicator: vm.concrete_indicator
            };
            BehavioralQuality.create(payload).then(
                function(resp) {
                    if (resp.data.code == 200 || resp.data.code == 1) {
                        swal('Success', resp.data.message, 'success');
                        $state.go('app.question_bank.behavioral_quality');
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();
(function() {
    angular
        .module('question_bank')
        .factory('BehavioralQuality', BehavioralQuality);

    function BehavioralQuality($http, appConfig, apiConfig) {
        var factory = {};
        var base = appConfig.appApi;
        var endpoint = apiConfig.behavioral.quality;

        factory.get = function(page, search, length) {
            return $http.get(base + endpoint.list + '?page=' + page + '&search=' + encodeURIComponent(search) + '&length=' + length);
        };

        factory.create = function(data) {
            return $http.post(base + endpoint.save, data);
        };

        factory.update = function(data) {
            return $http.post(base + endpoint.update, data);
        };

        factory.delete = function(ids) {
            return $http.post(base + endpoint.delete, ids);
        };

        return factory;
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('EditCategoryBehavioralController', EditCategoryBehavioralController);

    /** @ngInject */
    EditCategoryBehavioralController.$inject = [
        '$state',
        '$stateParams',
        'BehavioralCategory'
    ];

    function EditCategoryBehavioralController($state, $stateParams, BehavioralCategory) {
        var vm = this;
        vm.back = back;
        vm.save = save;
        vm.data = $stateParams.obj || {};

        function back() {
            $state.go('app.question_bank.behavioral_category');
        }

        function save() {
            var payload = angular.copy(vm.data);
            BehavioralCategory.update(payload).then(
                function(resp) {
                    if (resp.data.code == 200 || resp.data.code == 1) {
                        swal('Success', resp.data.message, 'success');
                        $state.go('app.question_bank.behavioral_category');
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('CreateCategoryBehavioralController', CreateCategoryBehavioralController);

    /** @ngInject */
    CreateCategoryBehavioralController.$inject = [
        '$state',
        'BehavioralCategory'
    ];

    function CreateCategoryBehavioralController($state, BehavioralCategory) {
        var vm = this;
        vm.back = back;
        vm.save = save;
        vm.weighted_score_min = null;
        vm.weighted_score_max = null;
        vm.category = '';
        vm.recommendation = '';
        vm.category_after_ai = '';
        vm.after_ai_correction_score_min = null;
        vm.after_ai_correction_score_max = null;
        vm.follow_up = '';

        function back() {
            $state.go('app.question_bank.behavioral_category');
        }

        function save() {
            var payload = {
                weighted_score_min: vm.weighted_score_min,
                weighted_score_max: vm.weighted_score_max,
                category: vm.category,
                recommendation: vm.recommendation,
                category_after_ai: vm.category_after_ai,
                after_ai_correction_score_min: vm.after_ai_correction_score_min,
                after_ai_correction_score_max: vm.after_ai_correction_score_max,
                follow_up: vm.follow_up
            };
            BehavioralCategory.create(payload).then(
                function(resp) {
                    if (resp.data.code == 200 || resp.data.code == 1) {
                        swal('Success', resp.data.message, 'success');
                        $state.go('app.question_bank.behavioral_category');
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('CategoryBehavioralController', CategoryBehavioralController);

    /** @ngInject */
    CategoryBehavioralController.$inject = [
        '$state',
        'BehavioralCategory',
        '$timeout'
    ];

    function CategoryBehavioralController($state, BehavioralCategory, $timeout) {
        var vm = this;
        vm.gotoBack = gotoBack;
        vm.gotoCreate = gotoCreate;
        vm.gotoEdit = gotoEdit;
        vm.deleteItem = deleteItem;
        vm.loadData = loadData;
        vm.search = '';
        vm.pageLength = 20;
        vm.categoryList = [];
        vm.currentPage = 1;
        vm.totalItems = 0;
        vm.pageSize = 0;
        vm.from = 0;
        vm.to = 0;
        vm.isLoading = false;

        activate();

        function activate() {
            loadData(1);
        }

        function gotoBack() {
            $state.go('app.question_bank.question_behavioral');
        }

        function gotoCreate() {
            $state.go('app.question_bank.behavioral_category.create');
        }

        function gotoEdit(data) {
            $state.go('app.question_bank.behavioral_category.edit', {obj: data});
        }

        function loadData(pageNo) {
            vm.isLoading = true;
            vm.categoryList = [];
            BehavioralCategory.get(pageNo, vm.search, vm.pageLength).then(
                function(resp) {
                    vm.categoryList = resp.data.data;
                    vm.currentPage = resp.data.current_page;
                    vm.pageSize = resp.data.per_page;
                    vm.totalItems = resp.data.total;
                    vm.from = resp.data.from;
                    vm.to = resp.data.to;
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 300);
                },
                function(err) {
                    vm.categoryList = [];
                    vm.isLoading = false;
                }
            );
        }

        function deleteItem(ev, id) {
            swal(
                {
                    title: 'Are you sure?',
                    text: 'This category score will be removed!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        BehavioralCategory.delete({id: id}).then(
                            function(resp) {
                                if (resp.data.code == 200 || resp.data.code == 1) {
                                    swal({
                                        title: 'Success',
                                        text: resp.data.message,
                                        type: 'success',
                                        showCancelButton: false,
                                        confirmButtonText: 'OK',
                                        closeOnConfirm: true
                                    }, function() {
                                        $state.reload();
                                    });
                                } else {
                                    swal('Error', resp.data.message, 'error');
                                }
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function() {
    angular
        .module('question_bank')
        .factory('BehavioralCategory', BehavioralCategory);

    function BehavioralCategory($http, appConfig, apiConfig) {
        var factory = {};
        var base = appConfig.appApi;
        var endpoint = apiConfig.behavioral.category;

        factory.get = function(page, search, length) {
            return $http.get(base + endpoint.list + '?page=' + page + '&search=' + encodeURIComponent(search) + '&length=' + length);
        };

        factory.create = function(data) {
            return $http.post(base + endpoint.save, data);
        };

        factory.update = function(data) {
            return $http.post(base + endpoint.update, data);
        };

        factory.delete = function(ids) {
            return $http.post(base + endpoint.delete, ids);
        };

        return factory;
    }
})();
(function () {
  'use strict';

  angular
    .module('question_bank')
    .controller('ImportQuestionController', ImportQuestionController);

  /** @ngInject */
  ImportQuestionController.$inject = [
    '$timeout',
    '$state',
    '$scope',
    'appConfig',
    'apiConfig',
    'Upload',
    'blockUI',
    'QuestionAnswer'
  ];

  function ImportQuestionController(
    $timeout,
    $state,
    $scope,
    appConfig,
    apiConfig,
    Upload,
    blockUI,
    QuestionAnswer
  ) {

    var vm = this;
    vm.progressEnable = false;
    vm.uploadQuestion = uploadQuestion;
    vm.statusFilter = '';
    vm.errors = [];

    activate();

    function activate() {
      getQuestionPool();
    }

    function getQuestionPool() {
      QuestionAnswer.getQpoolDataOnly().then(
        function (res) {
          vm.questionPool = res.data;
        },
        function (err) {
          vm.questionPool = [];
        }
      );
    }

    vm.filterError = filterError;
    function filterError(item) {
      if (vm.statusFilter === '') {
        return true;
      }
      return item.status === vm.statusFilter;
    }

    function uploadQuestion(file) {
      blockUI.start();
      file.upload = Upload.upload({
        url: appConfig.appApi + apiConfig.questionBank.uploadData,
        data: {
          poolId: vm.selectedQPool.id,
          file: file
        },
      });

      file.upload.then(function (response) {
        blockUI.stop();
        if (response.data.code == 1) {
          swal({
            title: "Success",
            text: response.data.message,
            type: "success",
            showCancelButton: false,
            // confirmButtonColor: "#DD6B55",
            confirmButtonText: "OK",
            closeOnConfirm: true
          },
            function () {
              $state.reload();
            });
        } else {
          swal("Error", response.data.message, "error");
          // vm.errors = [];
          // for (var key in response.data.data) {
          //   if (!Object.hasOwn(response.data.data, key)) continue;
          //   var element = response.data.data[key];
          //   vm.errors.push({
          //     sheetName: key,
          //     items: element
          //   });
          // }
          // console.log(vm.errors);
        }
      }, function (response) {
        blockUI.stop();
        swal("Oops!", 'Something went wrong', "error");
      }, function (evt) {
        vm.progressEnable = true;
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('question_bank')
    .controller('EditQuestionController', EditQuestionController);

  /** @ngInject */
  EditQuestionController.$inject = [
    '$timeout',
    '$state',
    '$scope',
    'Upload',
    'appConfig',
    'apiConfig',
    '$mdDialog',
    'QuestionAnswer',
    '$stateParams'
  ];

  function EditQuestionController(
    $timeout,
    $state,
    $scope,
    Upload,
    appConfig,
    apiConfig,
    $mdDialog,
    QuestionAnswer,
    $stateParams
  ) {

    var vm = this;
    vm.selectedQuestionType = 1;
    vm.answerOptions = [];
    vm.saveQuestion = saveQuestion;
    vm.addOptions = addOptions;
    vm.saveQuestionNoImage = saveQuestionNoImage;
    vm.imageBaseUrl = appConfig.questionPic;
    vm.back = back;

    vm.data = $stateParams.obj;

    activate();

    function activate() {
      getCompetency();
      getCategory();
      getQuestionPool();
      setData();
    }
    console.log(vm.data);

    function back() {
      $state.go('app.question_bank.question_answer');
    }

    function getCompetency() {
      QuestionAnswer.getCompDataOnly().then(
        function (res) {
          vm.competency = res.data;
        },
        function (err) {
          console.log(err);
          vm.competency = [];
        }
      );
    }

    function getCategory() {
      QuestionAnswer.getCategoryDataOnly().then(
        function (res) {
          vm.category = res.data;
        },
        function (err) {
          vm.category = [];
        }
      );
    }

    function getQuestionPool() {
      QuestionAnswer.getQpoolDataOnly().then(
        function (res) {
          console.log(res);
          vm.questionPool = res.data;
        },
        function (err) {
          console.log(err);
          vm.questionPool = [];
        }
      );
    }

    function setData() {
      if (vm.data !== null) {
        vm.selectedCategory = vm.data.question_category;
        vm.selectedCompetency = vm.data.competency;
        vm.selectedQPool = vm.data.question_pool;
        if (vm.data.question.answer_pool.answer_bank.length > 0) {
          vm.selectedQuestionType = 1;
          angular.forEach(vm.data.question.answer_pool.answer_bank, function (value, key) {
            var opt = {
              'id': value.id,
              'option': value.answer,
              'correct': value.flag
            };
            vm.answerOptions.push(opt);
          });

        } else {
          vm.selectedQuestionType = 2;
        }

        if (vm.data.question.images !== null) {
          vm.linkImages = vm.imageBaseUrl + '/' + vm.data.question.images;
        }

        vm.question = vm.data.question.question;
      }
    }

    function addOptions() {
      var length = vm.answerOptions.length;
      var opt = {
        'id': length,
        'option': 'change with your answer key',
        'correct': 0
      };
      vm.answerOptions.push(opt);
    }

    function saveQuestionNoImage(form) {

      if (vm.selectedQuestionType == 2) {
        vm.answerOptions = '';
      }

      var newData = {
        'competency': vm.selectedCompetency.id,
        'category': vm.selectedCategory.id,
        'pool': vm.selectedQPool.id,
        'question': vm.question,
        'answer': vm.answerOptions
      };

      var data = {
        'old' : vm.data,
        'new' : newData
      };

      QuestionAnswer.update(data)
        .then(function (resp) {
          if (resp.data.code == 200) {
            swal({
                title: "Success",
                text: resp.data.message,
                type: "success",
                showCancelButton: false,
                // confirmButtonColor: "#DD6B55",
                confirmButtonText: "OK",
                closeOnConfirm: true
              },
              function () {
                $state.reload();
              });
          } else {
            swal("Error", resp.data.message, "error");
          }
          console.log(resp);
        }, function (err) {
          console.log(err);
          swal("Oops!", 'Something went wrong', "error");
        });
    }

    function saveQuestion(file) {

      if (vm.selectedQuestionType == 2) {
        vm.answerOptions = '';
      }

      var newData = {
        'competency': vm.selectedCompetency.id,
        'category': vm.selectedCategory.id,
        'pool': vm.selectedQPool.id,
        'question': vm.question,
        'answer': vm.answerOptions,
      };

      file.upload = Upload.upload({
        url: appConfig.appApi + apiConfig.questionBank.updateData,
        data: {
          old : vm.data,
          new : newData,
          file: file
        },
      });

      file.upload.then(function (resp) {
        if (resp.data.code == 200) {
          swal({
              title: "Success",
              text: resp.data.message,
              type: "success",
              showCancelButton: false,
              // confirmButtonColor: "#DD6B55",
              confirmButtonText: "OK",
              closeOnConfirm: true
            },
            function () {
              $state.reload();
            });
        } else {
          swal("Error", resp.data.message, "error")
        }
      }, function (err) {
        swal("Oops!", 'Something went wrong', "error")
        console.log(err);
      }, function (evt) {
        // Math.min is to fix IE which reports 200% sometimes
        file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
      });
    }

  }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('CreateQuestionController', CreateQuestionController);

    /** @ngInject */
    CreateQuestionController.$inject = [
        '$timeout',
        '$state',
        '$scope',
        'Upload',
        'appConfig',
        'apiConfig',
        '$mdDialog',
        'QuestionAnswer'
    ];

    function CreateQuestionController(
        $timeout,
        $state,
        $scope,
        Upload,
        appConfig,
        apiConfig,
        $mdDialog,
        QuestionAnswer
    ) {
        var vm = this;
        vm.selectedQuestionType = 1;
        vm.answerOptions = [
            {
                id: 0,
                option: '',
                placeholder: 'change with your answer key',
                correct: 1
            }
        ];
        vm.saveQuestion = saveQuestion;
        vm.addOptions = addOptions;
        vm.removeOptions = removeOptions;
        vm.Msg = '';
        vm.MsgDisabled = false;
        vm.saveQuestionNoImage = saveQuestionNoImage;
        vm.back = back;

        activate();

        function activate() {
            getCompetency();
            getCategory();
            getQuestionPool();
        }

        vm.test = function(a) {
            console.log(a);
        };

        function back() {
            $state.go('app.question_bank.question_answer');
        }

        function addOptions() {
            var length = vm.answerOptions.length;
            var opt = {
                id: length,
                option: '',
                placeholder: 'change with your answer key',
                correct: 0
            };
            vm.answerOptions.push(opt);
        }

        function removeOptions() {
            var index = vm.answerOptions.length - 1;
            vm.answerOptions.splice(index, 1);
        }

        function getCompetency() {
            QuestionAnswer.getCompDataOnly().then(
                function(res) {
                    vm.competency = res.data;
                },
                function(err) {
                    console.log(err);
                    vm.competency = [];
                }
            );
        }

        function getCategory() {
            QuestionAnswer.getCategoryDataOnly().then(
                function(res) {
                    vm.category = res.data;
                },
                function(err) {
                    vm.category = [];
                }
            );
        }

        function getQuestionPool() {
            QuestionAnswer.getQpoolDataOnly().then(
                function(res) {
                    console.log(res);
                    vm.questionPool = res.data;
                },
                function(err) {
                    console.log(err);
                    vm.questionPool = [];
                }
            );
        }

        function saveQuestionNoImage(form) {
            if (vm.selectedQuestionType == 2) {
                vm.answerOptions = '';
            }
            var data = {
                competency: vm.selectedCompetency.id,
                category: vm.selectedCategory.id,
                pool: vm.selectedQPool.id,
                question: vm.question,
                answer: vm.answerOptions
            };
            console.log(data);
            QuestionAnswer.save(data).then(
                function(resp) {
                    if (resp.data.code == 1) {
                        swal(
                            {
                                title: 'Success',
                                text: resp.data.message,
                                type: 'success',
                                showCancelButton: false,
                                // confirmButtonColor: "#DD6B55",
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }

        function saveQuestion(ev, file) {
            if (vm.selectedQuestionType == 2) {
                vm.answerOptions = '';
            }

            file.upload = Upload.upload({
                url: appConfig.appApi + apiConfig.questionBank.saveData,
                data: {
                    competency: vm.selectedCompetency.id,
                    category: vm.selectedCategory.id,
                    pool: vm.selectedQPool.id,
                    question: vm.question,
                    answer: vm.answerOptions,
                    file: file
                }
            });

            file.upload.then(
                function(res) {
                    if (res.data.code == 1) {
                        swal(
                            {
                                title: 'Success',
                                text: res.data.message,
                                type: 'success',
                                showCancelButton: false,
                                // confirmButtonColor: "#DD6B55",
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', res.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                },
                function(evt) {
                    // Math.min is to fix IE which reports 200% sometimes
                    file.progress = Math.min(
                        100,
                        parseInt((100.0 * evt.loaded) / evt.total)
                    );
                }
            );
        }
    }
})();

(function() {
    "use strict";

    angular.module("report", ["chart.js"]).config(config);

    config.$inject = ["$stateProvider", "ChartJsProvider"];

    function config($stateProvider, ChartJsProvider) {
        // ChartJsProvider.setOptions({
        //     // chartColors: ["#12d3cf", "#67eaca", "#b0f4e6"],
        //     responsive: true,
        //     maintainAspectRatio: false
        // });

        $stateProvider.state("app.report", {
            url: "report",
            views: {
                "content@app": {
                    templateUrl: "app/main/modules/report/report.html",
                    controller: "ReportController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.general", {
            url: "/report-general",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-general/report-general.html",
                    controller: "ReportGeneralController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.general.detail", {
            url: "/detail/:id/:userId",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-general/report-general-detail/report-detail.html",
                    controller: "ReportGeneralDetailController as vm"
                }
            },
            params: {
                obj: null,
                id: null,
                userId: null
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.intray", {
            url: "/report-intray",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-intray/report-intray.html",
                    controller: "ReportIntrayController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.papikostik", {
            url: "/report-papikostik",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-papikostik/report-papikostik.html",
                    controller: "ReportPapikostikController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.papikostik.detail", {
            url: "/detail/:submission_id/:uid",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-papikostik/report-papikostik-detail/report-papikostik-detail.html",
                    controller: "ReportPapikostikDetailController as vm"
                }
            },
            params: {
                uid: null,
                submission_id: null
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.tiki", {
            url: "/tiki",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-tiki/report-tiki.html",
                    controller: "ReportIntelligenceController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.beq", {
            url: "/beq",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-beq/report-beq.html",
                    controller: "ReportBeqController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.behavioral", {
            url: "/behavioral",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-behavioral/report-behavioral.html",
                    controller: "ReportBehavioralController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.behavioral.detail", {
            url: "/detail/:submissionId/:userId",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-behavioral/report-behavioral-detail/report-behavioral-detail.html",
                    controller: "ReportBehavioralDetailController as vm"
                }
            },
            params: {
                submissionId: null,
                userId: null
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state("app.report.survey", {
            url: "/survey",
            views: {
                "report@app.report": {
                    templateUrl:
                        "app/main/modules/report/report-survey/report-survey.html",
                    controller: "ReportSurveyController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller(
            "ReportPapikostikDetailController",
            ReportPapikostikDetailController
        );
    /** @ngInject */
    ReportPapikostikDetailController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "$mdDialog",
        "$stateParams",
        "blockUI",
        "$interval",
        "$apiService"
    ];

    function ReportPapikostikDetailController(
        $timeout,
        $state,
        $localStorage,
        $mdDialog,
        $stateParams,
        blockUI,
        $interval,
        $apiService
    ) {
        var vm = this;
        var Papikostik = $apiService.papikostik(true);
        var block = blockUI.instances.get("block-container");
        vm.params = $stateParams;
        vm.tableData = [];
        vm.submission = {};
        vm.back = back;
        vm.chart = {
            data: [],
            labels: [],
            options: {
                legend: {
                    display: false,
                    labels: {
                        fontColor: "rgb(255, 99, 132)"
                    }
                },
                scale: {
                    display: true,
                    gridLines: {
                        display: true,
                        circular: true,
                        lineWidth: 1
                    },
                    angleLines: {
                        display: true,
                        lineWidth: 1
                    },
                    ticks: {
                        display: true,
                        suggestedMin: 0,
                        suggestedMax: 9,
                        beginAtZero: true,
                        stepSize: 1,
                        fontColor: "#000",
                        fontSize: 14,
                        drawTicks: true
                    }
                },
                scaleLabel: {
                    fontColor: "#000",
                    fontSize: 18
                },
                maintainAspectRatio: false,
                responsive: true
            },
            // colors: ["rgba(62,118,30,0.1)"],
            override: {
                borderWidth: 3,
                fill: true, // for filling area with color in the bottom line
                borderColor: "rgba(236,63,122,1)",
                pointBackgroundColor: "rgba(255,255,255,1)",
                pointHoverBackgroundColor: "rgba(236,63,122,1)",
                pointHoverBorderColor: "rgba(236,63,122,1)",
                backgroundColor: "rgba(236,63,122,0.1)",
                type: "radar",
                borderCapStyle: "round",
                pointBorderWidth: 1,
                pointBorderColor: "#000"
            }
        };

        loadData();

        function loadData() {
            block.start({ message: "please wait" });
            var request = Papikostik.get({
                endpoint: "getFinalScores",
                submission_id: vm.params.submission_id
            });
            request.$promise.then(function(response) {
                console.log(response);
                block.stop();
                vm.submission = response.submission;
                vm.tableData = response.scores;
                buildChartData(response.scores);
            });
            request.$promise.catch(function(err) {
                block.stop();
                console.log(err);
            });
        }

        function buildChartData(data) {
            for (var i = 0; i < data.length; i++) {
                vm.chart.data.push(data[i].total);
                vm.chart.labels.push(data[i].flag_abjact);
            }
        }

        function back() {
            $state.go("app.report.papikostik");
        }
    }
})();

(function () {
    "use strict";

    angular
        .module("report")
        .controller(
            "ReportGeneralDetailController",
            ReportGeneralDetailController
        );
    /** @ngInject */
    ReportGeneralDetailController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "ReportGeneral",
        "$mdDialog",
        "$stateParams",
        "blockUI",
        "AccountFactory",
        "$interval",
    ];

    function ReportGeneralDetailController(
        $timeout,
        $state,
        $localStorage,
        ReportGeneral,
        $mdDialog,
        $stateParams,
        blockUI,
        AccountFactory,
        $interval
    ) {
        var vm = this;
        vm.data = $stateParams;
        vm.clickChart = clickChart;
        vm.viewChart = viewChart;
        vm.createPDF = createPDF;
        vm.detail = [];
        vm.isLoading = false;
        vm.goBack = goBack;
        activate();

        function activate() {
            getDetail(vm.data.id);
            getDetailUser(vm.data.userId);
        }

        vm.labels = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
        ];
        vm.series = ["Series A", "Series B"];
        vm.data.chart = [
            [65, 59, 80, 81, 56, 55, 40],
            [28, 48, 40, 19, 86, 27, 90],
        ];

        function clickChart(points, evt) {
            console.log(points, evt);
        }

        function viewChart(ev) {
            $mdDialog
                .show({
                    controller: "ReportGeneralDetailController",
                    controllerAs: "vm",
                    templateUrl:
                        "app/main/modules/report/report-detail/report-detail-chart.html",
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true, // Only for -xs, -sm breakpoints.
                })
                .then(
                    function (answer) {
                        vm.status =
                            'You said the information was "' + answer + '".';
                    },
                    function () {
                        vm.status = "You cancelled the dialog.";
                    }
                );
        }

        function getDetailUser(params) {
            AccountFactory.getUser(params).then(
                function (res) {
                    vm.data.user = res.data;
                },
                function (err) {}
            );
        }

        function createPDF() {
            console.log("test");
        }

        function getDetail(params) {
            vm.isLoading = true;
            ReportGeneral.getDetail(params).then(
                function (resp) {
                    // console.log(resp);
                    vm.data.achievement = resp.data.achievement;
                    vm.detail = resp.data.achievementDetail;
                    // console.log(vm.data);
                    vm.isLoading = false;
                },
                function (err) {
                    console.log(err);
                    vm.isLoading = false;
                }
            );
        }

        function goBack(data) {
            $state.go("app.report.general");
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller(
            "ReportBehavioralDetailController",
            ReportBehavioralDetailController
        );

    /** @ngInject */
    ReportBehavioralDetailController.$inject = [
        "$timeout",
        "$window",
        "$http",
        "$state",
        "$stateParams",
        "blockUI",
        "ngDialog",
        "appConfig",
        "$apiService",
        "$mdToast"
    ];

    function ReportBehavioralDetailController(
        $timeout,
        $window,
        $http,
        $state,
        $stateParams,
        blockUI,
        ngDialog,
        appConfig,
        $apiService,
        $mdToast
    ) {
        var vm = this;
        vm.params = $stateParams;
        vm.submission = {};
        vm.results = [];
        vm.finalScore = 0;
        vm.isAllFinished = false;
        vm.goBack = goBack;
        vm.save = markAsFinished;
        vm.markAsFinished = markAsFinished;
        vm.markAsDraft = markAsDraft;
        vm.onReasonChange = onReasonChange;
        vm.openNoteDialog = openNoteDialog;
        vm.export = download; // renamed to avoid conflict with reserved keyword
        vm.scrollToQuestion = scrollToQuestion;
        vm.scrollToTop = scrollToTop;
        vm.activeQuestionIndex = null;
        vm.onCheckClick = onCheckClick;

        var Behavioral = $apiService.behavioral();
        var block = blockUI.instances.get("block-container");
        vm.base = appConfig.appApi;

        function openNoteDialog(item, $event) {
            // preserve current scroll position so it can be restored when dialog closes
            var navigation = document.querySelector(".table-navigation");
            var scrollContainer = getScrollContainer(navigation);
            var scrollTop =
                scrollContainer === $window
                    ? ($window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0)
                    : scrollContainer.scrollTop;

            var dialog = ngDialog.open({
                template:
                    '<div class="ngdialog-message">' +
                    '  <h2>Catatan Asesor</h2>' +
                    '  <textarea ng-model="note" ng-init="note=ngDialogData.note" rows="6" style="width:100%;" maxlength="500"></textarea>' +
                    '  <div class="ngdialog-buttons" style="text-align:right; margin-top:10px;">' +
                    '    <button type="button" class="ngdialog-button" ng-click="closeThisDialog()">Batal</button>' +
                    '    <button type="button" class="ngdialog-button ngdialog-button-primary" ng-click="closeThisDialog(note)">Simpan</button>' +
                    '  </div>' +
                    '</div>',
                plain: true,
                className: 'ngdialog-theme-default',
                data: {
                    note: item.accessor_note || ''
                },
                showClose: false,
                closeByDocument: false,
                closeByEscape: true
            });

            dialog.closePromise.then(function(data) {
                // update note if saved
                if (data && data.value !== undefined) {
                    item.accessor_note = data.value;
                }
                $timeout(function() {
                    // restore scroll position after dialog close
                    if (scrollContainer === $window) {
                        $window.scrollTo(0, scrollTop);
                        return;
                    }

                    scrollContainer.scrollTop = scrollTop;
                }, 1000);
            });
        }

        activate();

        function activate() {
            getDetail();
        }

        function getDetail() {
            block.start({ message: "Please wait" });
            var request = Behavioral.get({
                endpoint: "getDetail",
                submission_id: vm.params.submissionId
            });
            request.$promise.then(function(response) {
                vm.submission = response.submission;
                vm.results = response.results || [];
                vm.results.forEach(function(item) {
                    updateScore(item);
                });
                recalculateFinalScore();
                refreshFinishedState();
                block.stop();
            });
            request.$promise.catch(function(err) {
                console.log(err);
                block.stop();
            });
        }

        function onCheckClick(item) {
            if (normalizeStatus(item && item.status) === 'finished') {
                return;
            }

            var previousChecked = !!item.checked;
            item.checked = !item.checked;

            var payload = {
                submission_id: vm.params.submissionId,
                results: vm.results
                    .filter(function(resultItem) {
                        return resultItem && resultItem.id;
                    })
                    .map(function(resultItem) {
                        return {
                            id: resultItem.id,
                            checked: !!resultItem.checked
                        };
                    })
            };

            var request = Behavioral.save({
                endpoint: "updateChecked"
            }, payload);

            request.$promise.then(function(response) {
                if (!response || !response.status) {
                    item.checked = previousChecked;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent((response && response.message) || "Failed to update checked status")
                            .position("bottom left")
                            .hideDelay(3000)
                    );
                    return;
                }

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Checked status for question ' + item.id + ' is now ' + (item.checked ? 'checked' : 'unchecked'))
                        .position('bottom left')
                        .hideDelay(3000)
                );

                refreshFinishedState();
            });

            request.$promise.catch(function() {
                item.checked = previousChecked;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent("Failed to update checked status")
                        .position("bottom left")
                        .hideDelay(3000)
                );

                refreshFinishedState();
            });
        }

        function normalizeStatus(status) {
            return (status || '').toString().trim().toLowerCase();
        }

        function refreshFinishedState() {
            if (!vm.results || vm.results.length === 0) {
                vm.isAllFinished = false;
                return;
            }

            vm.isAllFinished = vm.results.every(function(item) {
                return normalizeStatus(item.status) === 'finished';
            });
        }

        function findFirstUncheckedIndex() {
            if (!vm.results || vm.results.length === 0) {
                return -1;
            }

            for (var i = 0; i < vm.results.length; i++) {
                if (!vm.results[i].checked) {
                    return i;
                }
            }

            return -1;
        }

        function updateScore(item) {
            // derive choice score from answer value first, fallback to A/B/C/D distance
            var keyOption = null;
            if (item.question && item.question.answers) {
                item.question.answers.forEach(function(ans) {
                    if (ans.flag) {
                        keyOption = (ans.option || "").toString().toUpperCase();
                    }
                });
            }

            var choiceScore = 0;
            if (item.answer) {
                var valueCandidate = (item.answer.value !== undefined && item.answer.value !== null)
                    ? item.answer.value
                    : item.answer.proficiency_level;

                var answerValue = Number(valueCandidate);
                if (!isNaN(answerValue)) {
                    choiceScore = answerValue;
                }
            }

            if (choiceScore === 0 && item.answer && item.answer.option) {
                var options = ["A", "B", "C", "D"];
                var keyIndex = options.indexOf(keyOption);
                var answerIndex = options.indexOf((item.answer.option || "").toString().toUpperCase());
                if (keyIndex !== -1 && answerIndex !== -1) {
                    var diff = Math.abs(keyIndex - answerIndex);
                    var scoreMap = [4, 3, 2, 1];
                    choiceScore = scoreMap[diff] || 1;
                }
            }

            item.choiceScore = choiceScore;
            item.qualityId = (item.answer && item.answer.quality_id) ? item.answer.quality_id : item.quality_id;
            item.reason_value = Number(item.reason_value) || 0;
            item.accessor_note = item.accessor_note || "";

            var rawWeight = (item.question && item.question.weight) ? Number(item.question.weight) : 0;
            var weightFactor = rawWeight;
            if (rawWeight > 1) {
                weightFactor = rawWeight / 100;
            }
            item.weightPercent = weightFactor * 100;

            var baseScore = choiceScore * 0.7 + item.reason_value * 0.3;
            item.score = Number(((baseScore * weightFactor) || 0).toFixed(3));
            if (item.score > 0) {
                item.score = Number((item.score / 3).toFixed(2)); // by formula
            }

            // score display with percentage, fallback to '-'
            if (item.score === null || item.score === undefined || item.score === 0) {
                item.scorePercent = '-';
            } else {
                item.scorePercent = Number((item.score * 100).toFixed(2)) + '%';
            }
        }

        function normalizeReasonValue(value) {
            if (value === null || value === undefined) {
                return 0;
            }
            // keep only digits
            var asString = value.toString().replace(/[^0-9]/g, "");
            var num = Number(asString);
            if (isNaN(num)) {
                return 0;
            }
            if (num < 0) {
                return 0;
            }
            if (num > 4) {
                return 4;
            }
            return num;
        }

        function onReasonChange(item) {
            var previousValue = item.reason_value;
            item.reason_value = normalizeReasonValue(item.reason_value);
            updateScore(item);
            recalculateFinalScore();

            // send immediate backend update for reason value
            var payload = {
                submission_id: vm.params.submissionId,
                results: [
                    {
                        id: item.id,
                        reason_value: item.reason_value,
                        checked: item.checked ? 1 : 0
                    }
                ]
            };

            var request = Behavioral.save({ endpoint: 'updateChecked' }, payload);
            request.$promise.then(function(response) {
                if (!response || !response.status) {
                    item.reason_value = previousValue;
                    updateScore(item);
                    recalculateFinalScore();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent((response && response.message) || 'Failed to update reason value')
                            .position('bottom left')
                            .hideDelay(3000)
                    );
                }
            });
            request.$promise.catch(function(err) {
                item.reason_value = previousValue;
                updateScore(item);
                recalculateFinalScore();

                var msg = (err && err.data && (err.data.message || err.data.error))
                    ? (err.data.message || err.data.error)
                    : 'Failed to update reason value';

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(msg)
                        .position('bottom left')
                        .hideDelay(3000)
                );
            });
        }

        function recalculateFinalScore() {
            var totalWeightedScore = 0;

            (vm.results || []).forEach(function(item) {
                var rowScore = Number(item && item.score);
                if (!isNaN(rowScore)) {
                    totalWeightedScore += rowScore;
                }
            });

            vm.finalScore = Number((totalWeightedScore / 4).toFixed(2)) * 100;
        }

        function scrollToQuestion(index) {
            vm.activeQuestionIndex = index;

            $timeout(function() {
                var targetRow = document.getElementById("question-row-" + index);
                if (!targetRow) {
                    return;
                }

                var scrollContainer = getScrollContainer(targetRow);
                var navigation = document.querySelector(".table-navigation");
                var navigationHeight = navigation ? navigation.offsetHeight : 0;
                var navigationTop = navigation
                    ? parseInt($window.getComputedStyle(navigation).top, 10)
                    : 0;
                var spacing = 16;

                if (isNaN(navigationTop)) {
                    navigationTop = 0;
                }

                if (scrollContainer === $window) {
                    var header = document.querySelector(".main-header-top");
                    var headerHeight = header ? header.offsetHeight : 0;
                    var windowScroll =
                        $window.pageYOffset ||
                        document.documentElement.scrollTop ||
                        document.body.scrollTop ||
                        0;

                    var windowTargetTop =
                        targetRow.getBoundingClientRect().top +
                        windowScroll -
                        headerHeight -
                        navigationHeight -
                        spacing;

                    scrollWindow(windowTargetTop);
                    return;
                }

                var containerRect = scrollContainer.getBoundingClientRect();
                var targetRect = targetRow.getBoundingClientRect();
                var containerTargetTop =
                    targetRect.top -
                    containerRect.top +
                    scrollContainer.scrollTop -
                    navigationHeight -
                    navigationTop -
                    spacing;

                scrollElement(scrollContainer, containerTargetTop);
            }, 0);
        }

        function scrollToTop() {
            vm.activeQuestionIndex = -1;

            $timeout(function() {
                var navigation = document.querySelector(".table-navigation");
                var scrollContainer = getScrollContainer(navigation);

                if (scrollContainer === $window) {
                    scrollWindow(0);
                    return;
                }

                scrollElement(scrollContainer, 0);
            }, 0);
        }

        function getScrollContainer(targetElement) {
            var contentWrapper = document.querySelector(".content-wrapper");
            if (isScrollable(contentWrapper)) {
                return contentWrapper;
            }

            var current = targetElement ? targetElement.parentElement : null;
            while (current && current !== document.body && current !== document.documentElement) {
                if (isScrollable(current)) {
                    return current;
                }
                current = current.parentElement;
            }

            return $window;
        }

        function isScrollable(element) {
            if (!element) {
                return false;
            }

            var style = $window.getComputedStyle(element);
            var overflowY = style.overflowY;
            var canScroll = overflowY === "auto" || overflowY === "scroll";

            return canScroll && element.scrollHeight > element.clientHeight;
        }

        function scrollElement(element, targetTop) {
            var finalTop = targetTop;
            if (finalTop < 0) {
                finalTop = 0;
            }

            if ("scrollBehavior" in document.documentElement.style && typeof element.scrollTo === "function") {
                element.scrollTo({
                    top: finalTop,
                    behavior: "smooth"
                });
                return;
            }

            element.scrollTop = finalTop;
        }

        function scrollWindow(targetTop) {
            var finalTop = targetTop;
            if (finalTop < 0) {
                finalTop = 0;
            }

            if ("scrollBehavior" in document.documentElement.style) {
                $window.scrollTo({
                    top: finalTop,
                    behavior: "smooth"
                });
                return;
            }

            $window.scrollTo(0, finalTop);
        }

        function markAsFinished() {
            var firstUncheckedIndex = findFirstUncheckedIndex();
            if (firstUncheckedIndex !== -1) {
                scrollToQuestion(firstUncheckedIndex);
                swal('Warning', 'Masih ada soal yang belum di-check. Silakan check semua soal terlebih dahulu.', 'warning');
                return;
            }

            save('finished');
        }

        function markAsDraft() {
            save('draft');
        }

        function save(targetStatus) {
            recalculateFinalScore();

            var payload = {
                submission_id: vm.params.submissionId,
                target_status: targetStatus,
                final_score: vm.finalScore,
                results: vm.results.map(function(item) {
                    return {
                        id: item.id,
                        reason_value: item.reason_value,
                        accessor_note: item.accessor_note,
                        score: item.score,
                        checked: !!item.checked
                    };
                })
            };

            console.log('saving payload', payload);


            block.start({ message: "Saving..." });
            var request = Behavioral.save({
                endpoint: "save"
            }, payload);
            request.$promise.then(function(response) {
                block.stop();
                if (response && response.status) {
                    vm.results.forEach(function(item) {
                        item.status = targetStatus;
                    });
                    refreshFinishedState();
                    swal("Success", response.message || "Saved", "success");
                } else {
                    swal("Error", (response && response.message) || "Failed to save", "error");
                }
            });
            request.$promise.catch(function(err) {
                block.stop();
                console.error(err);
                var msg = (err && err.data && (err.data.message || err.data.error))
                    ? (err.data.message || err.data.error)
                    : "Failed to save behavioral result";
                swal("Error", msg, "error");
            });
        }

        function download(type) {
            if (!vm.params.submissionId) {
                swal("Error", "Submission ID not found", "error");
                return;
            }

            var exportType = type === "excel" ? "xlsx" : type;
            var url = vm.base + "/behavioral/export/" + vm.params.submissionId + "/" + exportType;
            block.start({ message: "Preparing export..." });

            $http.post(url, {}, { responseType: "arraybuffer" }).then(
                function(response) {
                    var contentDisposition = response.headers("content-disposition") || "";
                    var fileNameMatch = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                    var fileName = "behavioral-report-" + vm.params.submissionId + "." + exportType;

                    if (fileNameMatch && fileNameMatch[1]) {
                        fileName = fileNameMatch[1].replace(/["']/g, "").trim();
                    }

                    var mime = exportType === "pdf"
                        ? "application/pdf"
                        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                    var blob = new Blob([response.data], { type: mime });

                    if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                        $window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        var downloadUrl = $window.URL.createObjectURL(blob);
                        var link = $window.document.createElement("a");
                        link.href = downloadUrl;
                        link.download = fileName;
                        $window.document.body.appendChild(link);
                        link.click();
                        $window.document.body.removeChild(link);
                        $window.URL.revokeObjectURL(downloadUrl);
                    }

                    block.stop();
                },
                function(err) {
                    block.stop();
                    var msg = (err && err.data && err.data.message)
                        ? err.data.message
                        : "Failed to export behavioral report";
                    swal("Error", msg, "error");
                }
            );
        }

        function goBack() {
            $state.go("app.report.behavioral");
        }
    }
})();

(function() {
    "use strict";
    angular.module("enrollment", []).config(config);
    config.$inject = ["$stateProvider"];

    function config($stateProvider) {
        $stateProvider.state("app.enrollment", {
            url: "enrollment",
            views: {
                "content@app": {
                    templateUrl: "app/main/modules/enrollment/enrollment.html",
                    controller: "EnrollmentController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state("app.enrollment.question_assignment", {
            url: "/question-assignment",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/question-assignment/question-assignment.html",
                    controller: "QuestionAssignmentController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state("app.enrollment.assessment_session", {
            url: "/assessment-session",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/assessment-session/assessment-session.html",
                    controller: "AssessmentSessionController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state(
            "app.enrollment.assessment_session.create_session",
            {
                url: "/assessment-session/create-session",
                views: {
                    "enrollment@app.enrollment": {
                        templateUrl:
                            "app/main/modules/enrollment/assessment-session/create-session/create-session.html",
                        controller: "CreateSessionController as vm"
                    }
                },
                data: {
                    requiresLogin: true
                }
            }
        );
        $stateProvider.state(
            "app.enrollment.assessment_session.update_session",
            {
                url: "/assessment-session/update-session",
                views: {
                    "enrollment@app.enrollment": {
                        templateUrl:
                            "app/main/modules/enrollment/assessment-session/update-session/update-session.html",
                        controller: "UpdateSessionController as vm"
                    }
                },
                data: {
                    requiresLogin: true
                },
                params: {
                    obj: null
                }
            }
        );
        $stateProvider.state("app.enrollment.user_participant", {
            url: "/user-participant",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/user-participant/user-participant.html",
                    controller: "UserParticipantController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state("app.enrollment.user_participant.assign", {
            url: "/user-participant/assign",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/user-participant/assign-participant/assign-participant.html",
                    controller: "AssignParticipantController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state("app.enrollment.user_participant.edit", {
            url: "/user-participant/edit",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/user-participant/edit-participant/edit-participant.html",
                    controller: "EditParticipantController as vm"
                }
            },
            data: {
                requiresLogin: true
            },
            params: {
                obj: null
            }
        });
        $stateProvider.state("app.enrollment.class_room", {
            url: "/proxy",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/classroom/index.html",
                    controller: "ClassRoomController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state("app.enrollment.class_room.create", {
            url: "/create",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/classroom/create/form.html",
                    controller: "CreateClassRoomController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state("app.enrollment.class_room.edit", {
            url: "/edit",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/classroom/edit/form.html",
                    controller: "EditClassRoomController as vm"
                }
            },
            data: {
                requiresLogin: true
            },
            params: {
                obj: null
            }
        });
        $stateProvider.state("app.enrollment.group_participant", {
            url: "/group-participant",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/group-participant/group-participant.html",
                    controller: "GroupParticipantController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state("app.enrollment.group_participant.create", {
            url: "/group-participant/create",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/group-participant/create-group-participant/create-group-participant.html",
                    controller: "CreateGroupParticipantController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
        $stateProvider.state("app.enrollment.group_participant.edit", {
            url: "/group-participant/edit",
            views: {
                "enrollment@app.enrollment": {
                    templateUrl:
                        "app/main/modules/enrollment/group-participant/edit-group-participant/edit-group-participant.html",
                    controller: "EditGroupParticipantController as vm"
                }
            },
            data: {
                requiresLogin: true
            },
            params: {
                obj: null
            }
        });
    }
})();

(function () {
  'use strict';

  angular
    .module('enrollment')
    .controller('EditParticipantController', EditParticipantController);

  /** @ngInject */
  EditParticipantController.$inject = [
    '$state',
    'Enrollment',
    'AccountFactory',
    '$stateParams'
  ];

  function EditParticipantController($state, Enrollment, AccountFactory, $stateParams) {

    var vm = this;
    vm.data = $stateParams.obj;
    vm.updateData = updateData;

    activate();

    function activate() {
      console.log(vm.data)
      if (vm.data !== null) {
        getDataGroup();
        vm.selectedGroup = vm.data.group_participant;
        vm.selectedUser = vm.data.user;
      }
    }

    function getDataGroup() {
      AccountFactory.getDataGroup().then(
        function (response) {
          vm.group = response.data;
        },
        function (err) {
          console.log(err);
        }
      );
    }

    function updateData() {
      var data = {
        'id' : vm.data.id,
        'uid': vm.selectedUser.id,
        'gpid': vm.selectedGroup.id
      };

      Enrollment.updateUser(data).then(
        function (resp) {
          if (resp.data.code == 1) {
            swal({
                title: "Success",
                text: resp.data.messages,
                type: "success",
                showCancelButton: false,
                // confirmButtonColor: "#DD6B55",
                confirmButtonText: "OK",
                closeOnConfirm: true
              },
              function () {
                $state.go('app.enrollment.user_participant');
              });
          } else {
            swal("Error", resp.data.messages, "error");
          }
        },
        function (err) {
          swal("Oops!", 'Something went wrong', "error");
        }
      );

    }


  }
})();

(function() {
    'use strict';
    angular
        .module('enrollment')
        .controller('AssignParticipantController', AssignParticipantController);
    /** @ngInject */
    AssignParticipantController.$inject = [
        '$timeout',
        '$state',
        '$scope',
        'Enrollment',
        'AccountFactory'
    ];

    function AssignParticipantController(
        $timeout,
        $state,
        $scope,
        Enrollment,
        AccountFactory
    ) {
        var vm = this;
        vm.group = [];
        vm.assignUser = assignUser;
        vm.brackets = [];
        vm.submitSelected = submitSelected;
        vm.findUser = findUser;
        vm.addUser = addUser;
        vm.user = [];
        vm.resetData = resetData;
        vm.removeUser = removeUser;
        vm.back = back;
        vm.isLoading = false;
        activate();

        function activate() {
            // getDataUser();
            getDataGroup();
        }

        function back() {
            $state.go('app.enrollment.user_participant');
        }

        function getDataUser() {
            AccountFactory.getDataUserOnly().then(function(resp) {
                vm.user = resp.data;
            });
        }

        function removeUser(i) {
            vm.brackets.splice(i, 1);
        }

        function resetData() {
            vm.brackets = [];
        }

        function getDataGroup() {
            AccountFactory.getDataGroup().then(
                function(response) {
                    vm.group = response.data;
                },
                function(err) {
                    console.log(err);
                }
            );
        }

        function findUser(select) {
            vm.isLoading = true;
            AccountFactory.findUser(select.search).then(
                function(res) {
                    vm.user = res.data;
                    vm.isLoading = false;
                },
                function(err) {
                    console.log(err);
                }
            );
        }

        function addUser(selected, group) {
            var found = true;
            for (var i = vm.brackets.length - 1; i >= 0; i--) {
                if (vm.brackets[i].user.nik == selected.nik) {
                    found = false;
                    break;
                }
            }
            if (found) {
                vm.brackets.push({
                    group: vm.selectedGroup,
                    user: selected
                });
            }
        }

        function submitSelected(data) {
            vm.brackets.push(data);
        }

        function assignUser() {
            Enrollment.assignUser(vm.brackets).then(
                function(resp) {
                    if (resp.data.code == 1) {
                        swal(
                            {
                                title: 'Success',
                                text: resp.data.messages,
                                type: 'success',
                                showCancelButton: false,
                                // confirmButtonColor: "#DD6B55",
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.go('app.enrollment.user_participant');
                            }
                        );
                    } else {
                        swal('Error', resp.data.messages, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();

(function () {
    'use strict';
  
    angular
      .module('core', [
        'ngAnimate', 
        'ngCookies', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ngResource',
        'ngMaterial',
        'ui.bootstrap',
        'ngFileUpload',
        'ui.slimscroll', 
        'ui.router',
        'ui.select', 
        'toastr',
        'blockUI',
        'bw.paging',
        'moment-picker',
        'bootstrapLightbox',
        'chart.js'
      ]);
  
  })();
  
angular.module('core').filter('propsFilter', function() {
    return function(items, props) {
        var out = [];
        if (angular.isArray(items)) {
            items.forEach(function(item) {
                var itemMatches = false;
                var keys = Object.keys(props);
                for (var i = 0; i < keys.length; i++) {
                    var prop = keys[i];
                    var text = props[prop].toLowerCase();
                    if (
                        item[prop]
                            .toString()
                            .toLowerCase()
                            .indexOf(text) !== -1
                    ) {
                        itemMatches = true;
                        break;
                    }
                }
                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            out = items;
        }
        return out;
    };
});

(function() {
    'use strict';

    angular
        .module('enrollment')
        .controller('EditClassRoomController', EditClassRoomController);

    /** @ngInject */
    EditClassRoomController.$inject = [
        '$timeout',
        '$state',
        '$scope',
        'MasterClassRoom',
        '$stateParams'
    ];

    function EditClassRoomController(
        $timeout,
        $state,
        $scope,
        MasterClassRoom,
        $stateParams
    ) {
        var vm = this;
        vm.save = save;
        vm.back = back;

        var d = new Date();

        vm.data = $stateParams.obj;

        function back() {
            $state.go('app.enrollment.class_room');
        }

        function save() {
            var data = vm.data;

            MasterClassRoom.update(data).then(
                function(resp) {
                    if (resp.data.code == 200) {
                        swal(
                            {
                                title: 'Success',
                                text: resp.data.message,
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('enrollment')
        .controller('CreateClassRoomController', CreateClassRoomController);

    /** @ngInject */
    CreateClassRoomController.$inject = [
        '$timeout',
        '$state',
        '$scope',
        'MasterClassRoom'
    ];

    function CreateClassRoomController($timeout, $state, $scope, MasterClassRoom) {
        var vm = this;
        vm.save = save;
        vm.back = back;

        function back() {
            $state.go('app.enrollment.class_room');
        }

        function save() {
            var data = vm.data;

            // data.start_at =
            //     vm.data.start_at.getHours() +
            //     ':' +
            //     vm.data.start_at.getMinutes() +
            //     ':' +
            //     vm.data.start_at.getSeconds();
            // data.end_at =
            //     vm.data.end_at.getHours() +
            //     ':' +
            //     vm.data.end_at.getMinutes() +
            //     ':' +
            //     vm.data.end_at.getSeconds();

            MasterClassRoom.save(data).then(
                function(resp) {
                    if (resp.data.code == 200) {
                        swal(
                            {
                                title: 'Success',
                                text: resp.data.message,
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('enrollment')
    .controller('CreateGroupParticipantController', CreateGroupParticipantController);

  /** @ngInject */
  CreateGroupParticipantController.$inject = ['$state', 'Enrollment'];

  function CreateGroupParticipantController($state, Enrollment) {
    
    var vm = this;
    vm.saveData = saveData;

    function saveData(form) {
      var data = {
        code : form.code.$viewValue,
        name : form.name.$viewValue,
        description : form.description.$viewValue
      };
      Enrollment.saveDataGroupParticipant(data).then(
        function (res) {
          if (res.data.code == 1) {
            swal({
                title: "Success",
                text: res.data.message,
                type: "success",
                showCancelButton: false,
                // confirmButtonColor: "#DD6B55",
                confirmButtonText: "OK",
                closeOnConfirm: true
              },
              function () {
                $state.reload();
              });
          } else {
            swal("Error", response.data.message, "error");
          }
        },
        function (err) {
          swal("Oops!", 'Something went wrong', "error");
        }
      );
      console.log(data);
    }


  }
})();

(function() {
    "use strict";

    angular
        .module("enrollment")
        .controller("UpdateSessionController", UpdateSessionController);

    /** @ngInject */
    UpdateSessionController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "Enrollment",
        "$stateParams"
    ];

    function UpdateSessionController(
        $timeout,
        $state,
        $scope,
        Enrollment,
        $stateParams
    ) {
        var vm = this;
        vm.updateSession = updateSession;
        vm.back = back;
        vm.data = $stateParams.obj;
        vm.sessionType = [
            "GENERAL",
            "TIKI",
            "PAPIKOSTIK",
            "INTRAY",
            "BEQ",
            "SURVEY",
            "BEHAVIORAL"
        ];

        var d = new Date();
        var year = d.getFullYear();
        var month = d.getMonth();
        var date = d.getDate();

        activate();

        function activate() {
            getDataClass();
            getQuestionPool();
            getGroupParticipant();
            setData();
        }

        function setData() {
            if (vm.data !== null) {
                console.log(vm.data);

                var start_at = vm.data.session_start_time.split(":");
                var end_at = vm.data.session_end_time.split(":");
                vm.data.session_start_time = new Date(
                    year,
                    month,
                    date,
                    start_at[0],
                    start_at[1],
                    start_at[2]
                );
                vm.data.session_end_time = new Date(
                    year,
                    month,
                    date,
                    end_at[0],
                    end_at[1],
                    end_at[2]
                );

                vm.selectedClassroom = vm.data.class;
                vm.selectedGpart = vm.data.group_participant;
                vm.selectedQPool = vm.data.pool;
                vm.startSession = vm.data.session_start_date;
                vm.endSession = vm.data.session_end_date;
                vm.shuffle = vm.data.is_question_shuffled;
                vm.selectedSessionType = vm.data.session_type.toUpperCase();
                vm.selectedDuration = vm.data.session_duration;
                vm.selectedStartAt = vm.data.session_start_time;
                vm.selectedEndAt = vm.data.session_end_time;
            }
        }

        function getDataClass() {
            Enrollment.getDataClass().then(
                function(resp) {
                    vm.classroom = resp.data;
                },
                function(err) {
                    vm.classroom = [];
                    console.log(err);
                }
            );
        }

        function getQuestionPool() {
            Enrollment.getQuestionPool().then(
                function(resp) {
                    vm.questionPool = resp.data;
                },
                function(err) {
                    vm.questionPool = [];
                    console.log(err);
                }
            );
        }

        function getGroupParticipant() {
            Enrollment.getDataGroupParticipant().then(
                function(response) {
                    vm.groupParticipant = response.data;
                },
                function(err) {
                    vm.groupParticipant = [];
                    console.log(err);
                }
            );
        }

        function updateSession(form) {
            console.log(form);
            var data = {
                id: vm.data.id,
                qPoolId: form.QPool.$viewValue.id,
                gPartId: form.GPart.$viewValue.id,
                aClasId: form.classroom.$viewValue.id,
                startDate: form.startSession.$viewValue,
                endDate: form.endSession.$viewValue,
                shuffle: 0,
                startAt: form.startAt.$viewValue,
                endAt: form.endAt.$viewValue,
                duration: form.duration.$viewValue,
                sessionType: form.sessionType.$viewValue.toLowerCase(),
                session_order: vm.data.session_order,
                has_rules: vm.data.has_rules
            };

            Enrollment.updateDataSession(data).then(
                function(res) {
                    if (res.data.code == 1) {
                        swal(
                            {
                                title: "Success",
                                text: res.data.messages,
                                type: "success",
                                showCancelButton: false,
                                confirmButtonText: "OK",
                                closeOnConfirm: true
                            },
                            function() {
                                $state.go("app.enrollment.assessment_session");
                            }
                        );
                    } else {
                        swal("Error", response.data.messages, "error");
                    }
                },
                function(err) {
                    swal("Oops!", "Something went wrong", "error");
                }
            );
        }

        function back() {
            $state.go("app.enrollment.assessment_session");
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('enrollment')
    .controller('EditGroupParticipantController', EditGroupParticipantController);

  /** @ngInject */
  EditGroupParticipantController.$inject = ['$state', '$stateParams','Enrollment'];

  function EditGroupParticipantController($state, $stateParams, Enrollment) {
    
    var vm = this;
    vm.updateData = updateData;
    vm.data = $stateParams.obj;
    console.log(vm.data);

    setData();

    function setData() {
      if (vm.data !== null) {
        vm.code = vm.data.code;
        vm.name = vm.data.name;
        vm.description = vm.data.description;
      }  
    }

    function updateData(form) {
      var data = {
        id   : vm.data.id,
        code : form.code.$viewValue,
        name : form.name.$viewValue,
        description : form.description.$viewValue
      };
      Enrollment.updateDataGroupParticipant(data).then(
        function (res) {
          if (res.data.code == 1) {
            swal({
                title: "Success",
                text: res.data.message,
                type: "success",
                showCancelButton: false,
                // confirmButtonColor: "#DD6B55",
                confirmButtonText: "OK",
                closeOnConfirm: true
              },
              function () {
                $state.go('app.enrollment.group_participant');
              });
          } else {
            swal("Error", response.data.message, "error");
          }
        },
        function (err) {
          swal("Oops!", 'Something went wrong', "error");
        }
      );
      console.log(data);
    }


  }
})();

(function() {
    "use strict";

    angular
        .module("enrollment")
        .controller("CreateSessionController", CreateSessionController);

    /** @ngInject */
    CreateSessionController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "Enrollment"
    ];

    function CreateSessionController($timeout, $state, $scope, Enrollment) {
        var vm = this;
        vm.saveSession = saveSession;
        vm.back = back;
        vm.endSessionDisabled = true;
        vm.shuffle = 0;
        vm.data = {
            session_order: 1,
            has_rules: 0
        };
        vm.sessionType = [
            "GENERAL",
            "TIKI",
            "PAPIKOSTIK",
            "INTRAY",
            "BEQ",
            "SURVEY",
            "BEHAVIORAL"
        ];

        activate();

        function activate() {
            getDataClass();
            getQuestionPool();
            getGroupParticipant();
        }

        vm.minDateString = moment().format("YYYY-MM-DD");
        console.log(vm.minDateString);
        $scope.$watch("vm.startSession", function(newValue, endValue) {
            if (newValue != undefined) {
                vm.endSessionDisabled = false;
            }
        });

        function getDataClass() {
            Enrollment.getDataClass().then(
                function(resp) {
                    vm.classroom = resp.data;
                },
                function(err) {
                    vm.classroom = [];
                    console.log(err);
                }
            );
        }

        function getQuestionPool() {
            Enrollment.getQuestionPool().then(
                function(resp) {
                    vm.questionPool = resp.data;
                },
                function(err) {
                    vm.questionPool = [];
                    console.log(err);
                }
            );
        }

        function getGroupParticipant() {
            Enrollment.getDataGroupParticipant().then(
                function(response) {
                    vm.groupParticipant = response.data;
                },
                function(err) {
                    vm.groupParticipant = [];
                    console.log(err);
                }
            );
        }

        function saveSession(form) {
            var data = {
                qPoolId: form.QPool.$viewValue.id,
                gPartId: form.GPart.$viewValue.id,
                aClasId: form.classroom.$viewValue.id,
                startDate: form.startSession.$viewValue,
                endDate: form.endSession.$viewValue,
                shuffle: 0,
                sessionType: form.sessionType.$viewValue.toLowerCase(),
                startAt: form.startAt.$viewValue + ":00",
                duration: form.duration.$viewValue,
                endAt: form.endAt.$viewValue + ":00",
                session_order: vm.data.session_order,
                has_rules: vm.data.has_rules
            };

            console.log(data);

            Enrollment.saveDataSession(data).then(
                function(res) {
                    if (res.data.code == 1) {
                        swal(
                            {
                                title: "Success",
                                text: res.data.messages,
                                type: "success",
                                showCancelButton: false,
                                confirmButtonText: "OK",
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal("Error", res.data.messages, "error");
                    }
                },
                function(err) {
                    swal("Oops!", "Something went wrong", "error");
                }
            );
        }

        function back() {
            $state.go("app.enrollment.assessment_session");
        }
    }
})();

(function () {
  angular
    .module('question_bank')
    .factory('QuestionPool', QuestionPoolFactory);

  function QuestionPoolFactory(
    $http,
    appConfig,
    apiConfig
  ) {

    var factory = {};
    var base = appConfig.appApi;
    var questionPool = apiConfig.questionBank.questionPool;

    factory.get  = function (data, search, orderBy, orderDir, archived) {
      return $http.get(base + questionPool.getData + '?page='+data + '&search=' + search + '&orderBy=' + orderBy + '&orderDir=' + orderDir + '&archived=' + archived);
    };

    factory.save = function (data) {
      return $http.post(base + questionPool.saveData, data);
    };

    factory.delete = function (data) {
      return $http.post(base + questionPool.deleteData, data);
    };

    factory.update = function (data) {
      return $http.post(base + questionPool.updateData, data);
    };

    factory.archive = function (data) {
      return $http.post(base + questionPool.deleteData, data);
    }

    factory.unarchive = function (data) {
      return $http.post(base + questionPool.unarchiveData, data);
    }

    return factory;

  }

})();

(function () {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionPoolController', QuestionPoolController);

    /** @ngInject */
    QuestionPoolController.$inject = [
        '$timeout',
        '$state',
        '$scope',
        'QuestionPool',
        '$mdToast',
        '$window',
        'appConfig',
        'apiConfig',
        'blockUI'
    ];

    function QuestionPoolController(
        $timeout,
        $state,
        $scope,
        QuestionPool,
        $mdToast,
        $window,
        appConfig,
        apiConfig,
        blockUI
    ) {
        var block = blockUI.instances.get('QuestionPoolBlock');
        var vm = this;
        vm.gotoCreate = gotoCreate;
        vm.totalPages = 0;
        vm.currentPage = 1;
        vm.loadData = loadData;
        vm.search = '';
        vm.edit = edit;
        vm.deleteData = deleteData;
        vm.base = appConfig.appApi;
        vm.exportToExcel = exportToExcel;
        vm.exportToExcels = exportToExcels;
        vm.selected = [];
        vm.items = [];
        vm.selectAll = false;
        vm.orderBy = 'id';
        vm.orderDir = 'ASC';
        vm.changeOrder = changeOrder;
        vm.archive = archive;
        vm.unarchive = unarchive;
        vm.archived = false;
        vm.headerOrder = {
            id: {
                order: 'ASC',
                active: true
            },
            name: {
                order: 'ASC',
                active: false
            },
            created_at: {
                order: 'ASC',
                active: false
            },
            last_used_at: {
                order: 'ASC',
                active: false
            },
        }

        activate();

        function activate() {
            loadData(1);
        }

        function gotoCreate() {
            $state.go('app.question_bank.question_pool.create_pool');
        }

        vm.checkAll = function () {
            vm.selected = vm.items.map(function (item) { return item.id; });
        };
        vm.uncheckAll = function () {
            vm.selected = [];
        };

        vm.toggleSelectedAll = function (state) {
            if (state) {
                vm.checkAll();
            } else {
                vm.uncheckAll();
            }
        }

        vm.getHeaderIcon = function (column) {
            if (vm.headerOrder[column].active) {
                if (vm.headerOrder[column].order == 'ASC') {
                    return 'fa fa-arrow-up';
                } else {
                    return 'fa fa-arrow-down';
                }
            }
            return 'fa fa-sort';
        }

        function changeOrder(column) {
            // Change order direction
            if (vm.headerOrder[column].order == 'ASC') {
                vm.headerOrder[column].order = 'DESC';
            } else {
                vm.headerOrder[column].order = 'ASC';
            }

            // Set active column
            for (var key in vm.headerOrder) {
                if (vm.headerOrder.hasOwnProperty(column)) {
                    vm.headerOrder[key].active = false;
                }
            }
            vm.headerOrder[column].active = true;

            // Set orderBy and orderDir
            vm.orderBy = column;
            vm.orderDir = vm.headerOrder[column].order;

            // Reload data
            loadData(1);
        }

        function loadData(pageNo) {
            block.start({ message: "Loading Question Pools..." });
            QuestionPool.get(pageNo, vm.search, vm.orderBy, vm.orderDir, vm.archived).then(
                function (resp) {
                    vm.items = resp.data.data;
                    vm.paginate = resp.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                    vm.from = vm.paginate.from;
                    vm.to = vm.paginate.to;
                    block.stop();
                },
                function (err) {
                    vm.items = [];
                    block.stop();
                }
            );
        }

        function edit(data) {
            $state.go('app.question_bank.question_pool.edit_pool', {
                obj: data
            });
        }

        function exportToExcels() {
            if (vm.selected.length == 0) {
                swal('Oops!', 'Please select at least one data to export', 'error');
                return;
            }
            var ids = vm.selected.join(',');
            $window.open(
                vm.base + apiConfig.questionBank.questionPool.exportData + "?id=" + ids,
                "_blank"
            );
        }

        function exportToExcel(data) {
            $window.open(
                vm.base + apiConfig.questionBank.questionPool.exportData + "?id=" + data.id,
                "_blank"
            );
        }

        function unarchive(data) {
            swal(
                {
                    title: 'Would you like to unarchive this question pool ?',
                    text: 'Question pool will be unarchived',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        QuestionPool.unarchive({
                            id: data.id
                        }).then(
                            function (resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                "Successfully unarchived question pool."
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    );
                                loadData(1);

                            },
                            function (err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }

        function archive(data) {
            swal(
                {
                    title: 'Would you like to archive this question pool ?',
                    text: 'Question pool will be archived!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        QuestionPool.delete({
                            id: data.id
                        }).then(
                            function (resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                "Successfully archived question pool."
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    );
                                loadData(1);

                            },
                            function (err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }

        function deleteData(data) {
            swal(
                {
                    title: 'Would you like to delete this question pool ?',
                    text: 'Question data will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        QuestionPool.delete({
                            id: data.id
                        }).then(
                            function (resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                resp.data.message.toUpperCase()
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    )
                                    .then(function () {
                                        console.log('Toast dismissed.');
                                    })
                                    .catch(function () {
                                        console.log(
                                            'Toast failed or was forced to close early by another toast.'
                                        );
                                    });
                                loadData(1);
                            },
                            function (err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('question_bank')
        .factory('QuestionExcel', QuestionExcel);

    /** @ngInject */
    function QuestionExcel($http, appConfig, apiConfig) {
        var service = {
            scheme: {
                VLOOKUP: {
                    range: 'A4:D9',
                    reference: 'sheet3',
                    exact_match: false,
                    lookup_row: 4,
                    lookup_value: 'B3',
                },
                HLOOKUP: {
                    range: "F3:K4",
                    reference: "sheet3",
                    lookup_row: 2,
                    exact_match: false,
                    lookup_value: "B3"
                },
                COUNTIF: {
                    range: "A4:A9",
                    criteria: "K"
                },
                SUM: {
                    range: "D:F"
                },
                CUSTOM: {
                    formula: "G3-(H3*G3)"
                },
            }
        };

        service.get = function (page, search, fileId) {
            var params = { per_page: 10 };
            if (page) params.page = page;
            if (search) params.search = search;
            if (fileId) params.file_id = fileId;
            return $http.get(appConfig.appApi + apiConfig.question.excel.list, { params: params });
        };

        service.show = function (id) {
            return $http.get(appConfig.appApi + apiConfig.question.excel.show.replace('{id}', id));
        };

        service.save = function (data) {
            return $http.post(appConfig.appApi + apiConfig.question.excel.save, data);
        };

        service.update = function (data) {
            return $http.post(appConfig.appApi + apiConfig.question.excel.update, data);
        };

        service.delete = function (id) {
            return $http.post(appConfig.appApi + apiConfig.question.excel.delete, { id: id });
        };

        return service;
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionExcelFormController', QuestionExcelFormController);

    /** @ngInject */
    QuestionExcelFormController.$inject = ['QuestionExcel', '$mdDialog', 'item'];

    function QuestionExcelFormController(QuestionExcel, $mdDialog, item) {
        var vm = this;
        vm.model = item ? angular.copy(item) : { schemas: [], order_number: null, question: '', assessment_excel_file_id: 1 };
        vm.addSchema = addSchema;
        vm.removeSchema = removeSchema;
        vm.submit = submit;
        vm.cancel = cancel;

        function addSchema() {
            vm.model.schemas.push({ formula: '', cell_start: '', cell_end: '', description: '', formula_detail_json: '{}' });
        }

        function removeSchema(idx) {
            vm.model.schemas.splice(idx, 1);
        }

        function submit() {
            // convert formula_detail_json into object
            vm.model.schemas = vm.model.schemas.map(function(s) {
                try {
                    s.formula_detail = JSON.parse(s.formula_detail_json || '{}');
                } catch (e) {
                    s.formula_detail = {};
                }
                delete s.formula_detail_json;
                return s;
            });
            if (vm.model.id) {
                QuestionExcel.update(vm.model).then(function(resp) {
                    $mdDialog.hide();
                });
            } else {
                QuestionExcel.save(vm.model).then(function(resp) {
                    $mdDialog.hide();
                });
            }
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionExcelController', QuestionExcelController);

    /** @ngInject */
    QuestionExcelController.$inject = ['QuestionExcel', '$mdDialog', '$mdToast', '$state'];

    function QuestionExcelController(QuestionExcel, $mdDialog, $mdToast, $state) {
        var vm = this;
        vm.showForm = showForm;
        vm.search = '';
        vm.getExcel = getExcel;
        vm.showForm = showForm;
        vm.showDelete = showDelete;
        vm.fileId = null;
        vm.file = null;
        vm.back = back;
        vm.goToQuestion = goToQuestion;

        activate();

        function activate() {
            vm.fileId = $state.params.id;
            getExcel(1);
        }

        function back() {
            $state.go('app.question_bank.question_excel_file');
        }

        function goToQuestion(item) {
            if (item) {
                $state.go('app.question_bank.question_excel_file.question.form', { id: item.file.id, question_id: item.id });
            } else {
                $state.go('app.question_bank.question_excel_file.question.form', { id: vm.fileId, question_id: null });
            }
        }

        function getExcel(pageNo) {
            QuestionExcel.get(pageNo, vm.search, vm.fileId).then(
                function(resp) {
                    vm.paginate = resp.data;
                    vm.items = vm.paginate.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                    if (vm.items.length > 0 && vm.fileId) {
                        vm.file = vm.items[0].file;
                    }
                },
                function(err) {
                    vm.items = [];
                }
            );
        }

        function showForm(ev, item) {
            $mdDialog.show({
                controller: 'QuestionExcelFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/question-bank/question-excel/question-excel.form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: { item: item }
            }).then(function() {
                getExcel(vm.currentPage || 1);
            });
        }

        function showDelete(ev, item) {
            var confirm = $mdDialog.confirm().title('Delete?').textContent('Are you sure to delete this question?').targetEvent(ev).ok('Delete').cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                QuestionExcel.delete(item.id).then(function() {
                    getExcel(vm.currentPage || 1);
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionExcelFormController', QuestionExcelFormController);

    /** @ngInject */
    QuestionExcelFormController.$inject = ['QuestionExcel', 'QuestionExcelFile', '$state'];

    function QuestionExcelFormController(QuestionExcel, QuestionExcelFile, $state) {
        var vm = this;
        vm.model = { schemas: [], order_number: null, question: '', assessment_excel_file_id: 1 };
        vm.addSchema = addSchema;
        vm.removeSchema = removeSchema;
        vm.submit = submit;
        vm.getViewerUrl = getViewerUrl;

        activate();

        function activate() {
            show();
        }

        function show() {
            var id = $state.params.question_id;
            if (id) {
                QuestionExcel.show(id).then(function(resp) {
                    vm.model = resp.data;
                });
            }
        }

        function addSchema() {
            vm.model.schemas.push({ formula: '', cell_start: '', cell_end: '', description: '', formula_detail_json: '{}' });
        }

        function removeSchema(idx) {
            vm.model.schemas.splice(idx, 1);
        }

        function getViewerUrl() {
            return QuestionExcelFile.viewerUrl($state.params.question_id);
        }

        function submit() {
            // convert formula_detail_json into object
            vm.model.schemas = vm.model.schemas.map(function(s) {
                try {
                    s.formula_detail = JSON.parse(s.formula_detail_json || '{}');
                } catch (e) {
                    s.formula_detail = {};
                }
                delete s.formula_detail_json;
                return s;
            });
            if (vm.model.id) {
                QuestionExcel.update(vm.model).then(function(resp) {
                    $mdDialog.hide();
                });
            } else {
                QuestionExcel.save(vm.model).then(function(resp) {
                    $mdDialog.hide();
                });
            }
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .factory('QuestionExcelFile', QuestionExcelFile);

    /** @ngInject */
    function QuestionExcelFile($http, appConfig, apiConfig) {
        var service = {};

        service.get = function(page, search) {
            var params = { per_page: 10 };
            if (page) params.page = page;
            if (search) params.search = search;
            return $http.get(appConfig.appApi + apiConfig.question.excelFile.list, { params: params });
        };

        service.upload = function(formData) {
            return $http.post(appConfig.appApi + apiConfig.question.excelFile.save, formData, {
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined }
            });
        };

        service.delete = function(id) {
            return $http.post(appConfig.appApi + apiConfig.question.excelFile.delete, { id: id });
        };

        service.viewerUrl = function(id) {
            return appConfig.appApi + apiConfig.question.excelFile.viewer.replace('{id}', id);
        };

        return service;
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionExcelFileFormController', QuestionExcelFileFormController);

    /** @ngInject */
    QuestionExcelFileFormController.$inject = ['QuestionExcelFile', '$mdDialog'];

    function QuestionExcelFileFormController(QuestionExcelFile, $mdDialog) {
        var vm = this;
        vm.file = null;
        vm.submit = submit;
        vm.cancel = cancel;

        function submit() {
            if (!vm.file) return;
            var fd = new FormData();
            fd.append('file', vm.file);
            QuestionExcelFile.upload(fd).then(function() {
                $mdDialog.hide();
            });
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionExcelFileController', QuestionExcelFileController);

    /** @ngInject */
    QuestionExcelFileController.$inject = ['QuestionExcelFile', '$mdDialog', '$mdToast', '$state'];

    // ensure file controller is available in module initialization (no-op, just referenced)

    function QuestionExcelFileController(QuestionExcelFile, $mdDialog, $mdToast, $state) {
        var vm = this;
        vm.showForm = showForm;
        vm.search = '';
        vm.getExcel = getExcel;
        vm.showForm = showForm;
        vm.showDelete = showDelete;
        vm.download = download;
        vm.del = del;
        vm.goToDetail = goToDetail;

        activate();

        function activate() {
            getExcel(1);
        }

        function goToDetail(item) {
            $state.go('app.question_bank.question_excel_file.question', { id: item.id });
        }

        function getExcel(pageNo) {
            QuestionExcelFile.get(pageNo, vm.search).then(
                function(resp) {
                    vm.paginate = resp.data;
                    vm.items = vm.paginate.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                },
                function(err) {
                    vm.items = [];
                }
            );
        }

        function showForm(ev, item) {
            $mdDialog.show({
                controller: 'QuestionExcelFileFormController',
                controllerAs: 'vm',
                templateUrl: 'app/main/modules/question-bank/question-excel/question-excel-file.form.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                locals: { item: item }
            }).then(function() {
                getExcel(vm.currentPage || 1);
            });
        }

        function download(item) {
            var url = window.location.origin + '/api/v1/question/excel-file/download/' + item.id;
            window.open(url, '_blank');
        }
        
        function showDelete(ev, item) {
            var confirm = $mdDialog.confirm().title('Delete?').textContent('Are you sure to delete this file?').targetEvent(ev).ok('Delete').cancel('Cancel');
            $mdDialog.show(confirm).then(function() {
                QuestionExcelFile.delete(item.id).then(function() {
                    getExcel(vm.currentPage || 1);
                });
            });
        }

        function del(item) {
            QuestionExcelFile.delete(item.id).then(function() {
                getExcel(vm.currentPage || 1);
            });
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionCompetencyController', QuestionCompetencyController);

    /** @ngInject */
    QuestionCompetencyController.$inject = ['QuestionBank', '$mdDialog', '$mdToast'];

    function QuestionCompetencyController(QuestionBank, $mdDialog, $mdToast) {
        var vm = this;
        vm.search = '';
        vm.getCompetency = getCompetency;
        vm.submit = submit;
        vm.showForm = showForm;
        vm.showDelete = showDelete;

        activate();

        function activate() {
            getCompetency(1);
        }

        function getCompetency(pageNo) {
            QuestionBank.getCompetency(pageNo, vm.search).then(
                function(resp) {
                    vm.paginate = resp.data;
                    console.log(vm.paginate);
                    vm.items = vm.paginate.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                },
                function(err) {
                    vm.questionList = [];
                }
            );
        }

        function showForm(data, ev) {
            $mdDialog
                .show({
                    controller: 'FormCompetencyCompetencyController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/modules/question-bank/question-competency/form.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    locals: {
                        data: data
                    },
                    clickOutsideToClose: true,
                    fullscreen: true // Only for -xs, -sm breakpoints.
                })
                .then(
                    function(answer) {
                        vm.status = 'You said the information was "' + answer + '".';
                    },
                    function() {
                        vm.status = 'You cancelled the dialog.';
                    }
                );
        }

        function submit(frm) {
            console.log(frm);
        }

        function showDelete(data) {
            swal(
                {
                    title: 'Are you sure ?',
                    text:
                        'Be careful, if you delete this main category, the question that have this category will be deleted too',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        QuestionBank.deleteCompetency({
                            id: data.id
                        }).then(
                            function(resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                resp.data.message.toUpperCase()
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    )
                                    .then(function() {
                                        console.log('Toast dismissed.');
                                    })
                                    .catch(function() {
                                        console.log(
                                            'Toast failed or was forced to close early by another toast.'
                                        );
                                    });
                                getCompetency(1);
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller(
            'FormCompetencyCompetencyController',
            FormCompetencyCompetencyController
        );

    /** @ngInject */
    FormCompetencyCompetencyController.$inject = [
        'QuestionBank',
        'data',
        '$mdDialog',
        '$state'
    ];

    function FormCompetencyCompetencyController(
        QuestionBank,
        data,
        $mdDialog,
        $state
    ) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.submit = submit;
        vm.competency = '';
        vm.description = '';
        vm.code = '';
        vm.id = 0;
        vm.isUpdate = false;

        activate();

        function activate() {
            if (data) {
                vm.competency = data.competency;
                vm.description = data.description;
                vm.code = data.code;
                vm.id = data.id;
                vm.isUpdate = true;
            }
        }

        function closeDialog() {
            $mdDialog.hide();
        }

        function submit(frm) {
            var payload = {};
            var request = null;
            if (!vm.isUpdate) {
                payload.code = frm.code.$viewValue;
                payload.competency = frm.competency.$viewValue;
                payload.description = frm.description.$viewValue;
                payload.description_en = frm.description.$viewValue;
                request = QuestionBank.createCompetency(payload);
            } else {
                payload.id = data.id;
                payload.code = frm.code.$viewValue;
                payload.competency = frm.competency.$viewValue;
                payload.description = frm.description.$viewValue;
                payload.description_en = frm.description.$viewValue;
                request = QuestionBank.updateCompetency(payload);
            }

            request.then(
                function(success) {
                    closeDialog();
                    swal(
                        {
                            title: 'Success',
                            text: success.data.message,
                            type: 'success',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            closeOnConfirm: true
                        },
                        function() {
                            $state.reload();
                        }
                    );
                },
                function(error) {
                    swal(
                        {
                            title: 'Failed',
                            text: success.data.message,
                            type: 'warn',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            closeOnConfirm: true
                        },
                        function() {
                            $state.reload();
                        }
                    );
                }
            );

            console.log(frm);
        }
    }
})();

(function () {
  angular
    .module('question_bank')
    .factory('QuestionCategory', QuestionCategoryFactory);

  function QuestionCategoryFactory(
    $http,
    appConfig,
    apiConfig
  ) {

    var factory = {};
    var base = appConfig.appApi;
    var questionCategory = apiConfig.questionBank.questionCategory;

    // QuestionBank Endpoint
    factory.get = function (data, search) {
      return $http.get(base + questionCategory.getData + '?page=' + data + '&search=' + search);
    };

    factory.save = function (data) {
      return $http.post(base + questionCategory.saveData, data);
    };

    factory.delete = function (data) {
      return $http.post(base + questionCategory.deleteData, data);
    };

    factory.update = function (data) {
      return $http.post(base + questionCategory.updateData, data);
    };

    return factory;

  }

})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionCategoryController', QuestionCategoryController);

    /** @ngInject */
    QuestionCategoryController.$inject = [
        '$timeout',
        '$state',
        '$mdToast',
        'QuestionCategory'
    ];

    function QuestionCategoryController(
        $timeout,
        $state,
        $mdToast,
        QuestionCategory
    ) {
        var vm = this;
        vm.gotoCreate = gotoCreate;
        vm.deleteData = deleteData;
        vm.edit = edit;
        vm.search = '';
        vm.getQuestionCategory = getQuestionCategory;

        activate();

        function activate() {
            getQuestionCategory(1);
        }

        function gotoCreate() {
            $state.go('app.question_bank.question_category.create');
        }

        function edit(data) {
            $state.go('app.question_bank.question_category.update', { obj: data });
        }

        function getQuestionCategory(pageNo) {
            QuestionCategory.get(pageNo, vm.search).then(
                function(resp) {
                    var data = resp.data.data;
                    console.log(data);
                    vm.items = data.data;
                    vm.lastPage = data.last_page;
                    vm.totalItems = data.total;
                    vm.currentPage = data.current_page;
                    vm.pageSize = data.per_page;
                },
                function(err) {
                    vm.questionList = [];
                }
            );
        }

        function deleteData(data) {
            swal(
                {
                    title: 'Would you like to delete this question category ?',
                    text: 'Question Category will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        QuestionCategory.delete({
                            id: data.id
                        }).then(
                            function(resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                resp.data.messages.toUpperCase()
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    )
                                    .then(function() {
                                        console.log('Toast dismissed.');
                                    })
                                    .catch(function() {
                                        console.log(
                                            'Toast failed or was forced to close early by another toast.'
                                        );
                                    });
                                getQuestionCategory(1);
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function() {
    angular
        .module('question_bank')
        .factory('QuestionBehavioral', QuestionBehavioral);

    function QuestionBehavioral($http, appConfig, apiConfig) {
        var factory = {};
        var base = appConfig.appApi;
        var endpoint = apiConfig.behavioral.question;

        factory.get = function(page, search, length) {
            return $http.get(
                base + endpoint.list + '?page=' + page + '&search=' + encodeURIComponent(search) + '&length=' + length
            );
        };

        factory.getCompDataOnly = function() {
            return $http.get(base + apiConfig.general.competency.getCompDataOnly);
        };

        factory.getQpoolDataOnly = function() {
            return $http.get(base + apiConfig.questionBank.questionPool.getDataOnly);
        };

        factory.create = function(data) {
            return $http.post(base + endpoint.save, data);
        };

        factory.update = function(data) {
            return $http.post(base + endpoint.update, data);
        };

        factory.delete = function(ids) {
            return $http.post(base + endpoint.delete, ids);
        };

        factory.upload = function(formData) {
            return $http.post(base + endpoint.upload, formData, {
                headers: {'Content-Type': undefined},
                transformRequest: angular.identity
            });
        };

        // download template file (xlsx) for import
        factory.template = function() {
            // returning a blob so caller can trigger download if needed
            return $http.post(base + endpoint.template, {}, { responseType: 'arraybuffer' });
        };

        return factory;
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionBehavioralController', QuestionBehavioralController);

    /** @ngInject */
    QuestionBehavioralController.$inject = [
        '$state',
        'QuestionBehavioral',
        'appConfig',
        '$timeout'
    ];

    function QuestionBehavioralController($state, QuestionBehavioral, appConfig, $timeout) {
        var vm = this;
        vm.gotoCreate = gotoCreate;
        vm.gotoImport = gotoImport;
        vm.gotoEdit = gotoEdit;
        vm.gotoCategory = gotoCategory;
        vm.gotoRange = gotoRange;
        vm.gotoQuality = gotoQuality;
        vm.deleteQuestion = deleteQuestion;
        vm.loadData = loadData;
        vm.search = '';
        vm.pageLength = 20;
        vm.imageBaseUrl = appConfig.questionPic;
        vm.questionList = [];
        vm.currentPage = 1;
        vm.totalItems = 0;
        vm.pageSize = 0;
        vm.from = 0;
        vm.to = 0;
        vm.isLoading = false;

        activate();

        function activate() {
            loadData(1);
            getCompetency();
        }

        function gotoImport() {
            $state.go('app.question_bank.question_behavioral.import');
        }

        function gotoCreate() {
            $state.go('app.question_bank.question_behavioral.create');
        }

        function gotoCategory() {
            $state.go('app.question_bank.question_behavioral.behavioral_category');
        }

        function gotoRange() {
            $state.go('app.question_bank.question_behavioral.behavioral_range');
        }

        function gotoQuality() {
            $state.go('app.question_bank.question_behavioral.behavioral_quality');
        }

        function gotoEdit(data) {
            $state.go('app.question_bank.question_behavioral.edit', {
                obj: data
            });
        }

        function getCompetency() {
            QuestionBehavioral.getCompDataOnly ? QuestionBehavioral.getCompDataOnly().then(
                function(res) {
                    vm.competency = res.data;
                },
                function(err) {
                    vm.competency = [];
                }
            ) : (vm.competency = []);
        }

        function loadData(pageNo) {
            vm.isLoading = true;
            vm.questionList = [];
            QuestionBehavioral.get(pageNo, vm.search, vm.pageLength).then(
                function(resp) {
                    vm.questionList = resp.data.data;
                    vm.currentPage = resp.data.current_page;
                    vm.pageSize = resp.data.per_page;
                    vm.totalItems = resp.data.total;
                    vm.from = resp.data.from;
                    vm.to = resp.data.to;
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 500);
                },
                function(err) {
                    vm.questionList = [];
                    vm.isLoading = false;
                }
            );
        }

        function deleteQuestion(ev, id) {
            swal(
                {
                    title: 'Would you like to delete this question ?',
                    text: 'Behavioral question will be removed!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        QuestionBehavioral.delete({
                            id: id
                        }).then(
                            function(resp) {
                                if (resp.data.code == 200 || resp.data.code == 1) {
                                    swal(
                                        {
                                            title: 'Success',
                                            text: resp.data.message,
                                            type: 'success',
                                            showCancelButton: false,
                                            confirmButtonText: 'OK',
                                            closeOnConfirm: true
                                        },
                                        function() {
                                            $state.reload();
                                        }
                                    );
                                } else {
                                    swal('Error', resp.data.message, 'error');
                                }
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('question_bank')
        .controller('ImportQuestionBehavioralController', ImportQuestionBehavioralController);

    /** @ngInject */
    ImportQuestionBehavioralController.$inject = [
        '$timeout',
        '$state',
        '$window',
        'appConfig',
        'apiConfig',
        'Upload',
        'blockUI',
        'QuestionBehavioral'
    ];

    function ImportQuestionBehavioralController(
        $timeout,
        $state,
        $window,
        appConfig,
        apiConfig,
        Upload,
        blockUI,
        QuestionBehavioral
    ) {
        var vm = this;
        vm.progressEnable = false;
        vm.importFile = null;
        vm.uploadQuestion = uploadQuestion;
        vm.downloadTemplate = downloadTemplate;
        vm.back = back;

        function back() {
            $state.go('app.question_bank.question_behavioral');
        }

        function uploadQuestion(file) {
            if (!file) {
                swal('Error', 'Please select a file first', 'warning');
                return;
            }
            blockUI.start();
            file.upload = Upload.upload({
                url: appConfig.appApi + apiConfig.behavioral.question.upload,
                data: {
                    file: file
                }
            });

            file.upload.then(
                function (response) {
                    blockUI.stop();
                    if (response.data.code == 1) {
                        swal(
                            {
                                title: 'Success',
                                text: response.data.message,
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function () {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', response.data.message, 'error');
                    }
                },
                function (response) {
                    blockUI.stop();
                    swal('Oops!', 'Something went wrong', 'error');
                },
                function (evt) {
                    vm.progressEnable = true;
                    file.progress = Math.min(100, parseInt((100.0 * evt.loaded) / evt.total));
                }
            );
        }

        function downloadTemplate() {
            blockUI.start();

            QuestionBehavioral.template().then(
                function (response) {
                    var contentDisposition = response.headers('content-disposition') || '';
                    var fileNameMatch = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/.exec(contentDisposition);
                    var fileName = 'behavioral_question_template.xlsx';

                    if (fileNameMatch && fileNameMatch[1]) {
                        fileName = fileNameMatch[1].replace(/['"]/g, '').trim();
                    }

                    var blob = new Blob(
                        [response.data],
                        {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        }
                    );

                    if ($window.navigator && $window.navigator.msSaveOrOpenBlob) {
                        $window.navigator.msSaveOrOpenBlob(blob, fileName);
                    } else {
                        var downloadUrl = $window.URL.createObjectURL(blob);
                        var link = $window.document.createElement('a');
                        link.href = downloadUrl;
                        link.download = fileName;
                        $window.document.body.appendChild(link);
                        link.click();
                        $window.document.body.removeChild(link);
                        $window.URL.revokeObjectURL(downloadUrl);
                    }

                    blockUI.stop();
                },
                function () {
                    blockUI.stop();
                    swal('Error', 'Failed to download template', 'error');
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('EditQuestionBehavioralController', EditQuestionBehavioralController);

    /** @ngInject */
    EditQuestionBehavioralController.$inject = [
        '$timeout',
        '$state',
        '$stateParams',
        'QuestionBehavioral'
    ];

    function EditQuestionBehavioralController(
        $timeout,
        $state,
        $stateParams,
        QuestionBehavioral
    ) {
        var vm = this;
        vm.answerOptions = [];
        vm.saveQuestion = saveQuestion;
        vm.addOptions = addOptions;
        vm.removeOptions = removeOptions;
        vm.toggleCorrect = toggleCorrect;
        vm.back = back;

        activate();

        function activate() {
            loadInitial();
            getCompetency();
            getQuestionPool();
        }

        function loadInitial() {
            if ($stateParams.obj) {
                var obj = $stateParams.obj;
                vm.id = obj.id;
                vm.number = obj.number;
                vm.text = obj.text;
                vm.weight = (obj.weight === null || obj.weight === undefined || obj.weight === '')
                    ? 100
                    : Number(obj.weight);
                vm.selectedCompetency = obj.competency;
                vm.selectedQPool = obj.question_pool || null;
                vm.pendingQuestionPoolId = obj.question_pool_id || null;
                vm.answerOptions = (obj.answers || []).map(function(a, idx) {
                    return {
                        id: idx,
                        option: a.option,
                        text: a.text,
                        value: (a.value !== undefined && a.value !== null) ? a.value : a.proficiency_level,
                        correct: a.flag
                    };
                });
                normalizeAnswerOptions();
            }
        }

        function back() {
            $state.go('app.question_bank.question_behavioral');
        }

        function addOptions() {
            var length = vm.answerOptions.length;
            var letter = String.fromCharCode(65 + length);
            vm.answerOptions.push({
                id: length,
                option: letter,
                text: '',
                value: null,
                correct: 0
            });
            normalizeAnswerOptions();
        }

        function removeOptions() {
            vm.answerOptions.splice(vm.answerOptions.length - 1, 1);
            normalizeAnswerOptions();
        }

        function getCompetency() {
            QuestionBehavioral.getCompDataOnly().then(
                function(res) {
                    vm.competency = res.data;
                },
                function(err) {
                    vm.competency = [];
                }
            );
        }

        function getQuestionPool() {
            QuestionBehavioral.getQpoolDataOnly().then(
                function(res) {
                    vm.questionPool = res.data;

                    if (!vm.selectedQPool && vm.pendingQuestionPoolId) {
                        vm.selectedQPool = (vm.questionPool || []).find(function(pool) {
                            return pool.id == vm.pendingQuestionPoolId;
                        }) || null;
                    }
                },
                function() {
                    vm.questionPool = [];
                }
            );
        }

        function normalizeAnswerOptions() {
            vm.answerOptions = (vm.answerOptions || []).map(function(answer, idx) {
                return {
                    id: idx,
                    option: String.fromCharCode(65 + idx),
                    text: answer.text,
                    value: normalizeValue((answer.value !== undefined && answer.value !== null) ? answer.value : answer.proficiency_level),
                    correct: answer.correct ? 1 : 0
                };
            });
        }

        function normalizeValue(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var asNumber = Number(value);
            if (isNaN(asNumber)) {
                return null;
            }

            return Math.round(asNumber);
        }

        function prepareAnswersPayload() {
            normalizeAnswerOptions();

            return vm.answerOptions
                .filter(function(answer) {
                    return answer && answer.text && answer.text.toString().trim() !== '';
                })
                .map(function(answer) {
                    return {
                        option: answer.option,
                        text: answer.text,
                        value: normalizeValue(answer.value),
                        flag: answer.correct ? 1 : 0
                    };
                });
        }

        function toggleCorrect(index) {
            if (!vm.answerOptions || !vm.answerOptions[index]) {
                return;
            }

            if (vm.answerOptions[index].correct != 1) {
                return;
            }

            vm.answerOptions.forEach(function(answer, idx) {
                answer.correct = idx === index ? 1 : 0;
            });
        }

        function saveQuestion() {
            var answers = prepareAnswersPayload();
            if (answers.length === 0) {
                swal('Error', 'At least one answer is required', 'error');
                return;
            }

            var hasCorrect = answers.some(function(answer) {
                return answer.flag === 1;
            });
            if (!hasCorrect) {
                swal('Error', 'Select one correct answer', 'error');
                return;
            }

            var hasMissingValue = answers.some(function(answer) {
                return answer.value === null;
            });
            if (hasMissingValue) {
                swal('Error', 'Value is required for each answer', 'error');
                return;
            }

            var data = {
                id: vm.id,
                number: vm.number,
                text: vm.text,
                competency_id: vm.selectedCompetency ? vm.selectedCompetency.id : null,
                question_pool_id: vm.selectedQPool ? vm.selectedQPool.id : null,
                weight: vm.weight,
                answers: answers
            };
            QuestionBehavioral.update(data).then(
                function(resp) {
                    if (resp.data.code == 1 || resp.data.code == 200) {
                        swal({
                            title: 'Success',
                            text: resp.data.message,
                            type: 'success',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            closeOnConfirm: true
                        },
                        function() {
                            $state.reload();
                        });
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('CreateQuestionBehavioralController', CreateQuestionBehavioralController);

    /** @ngInject */
    CreateQuestionBehavioralController.$inject = [
        '$timeout',
        '$state',
        'QuestionBehavioral'
    ];

    function CreateQuestionBehavioralController(
        $timeout,
        $state,
        QuestionBehavioral
    ) {
        var vm = this;
        vm.weight = 100;
        vm.answerOptions = [
            {
                id: 0,
                option: 'A',
                text: '',
                value: null,
                correct: 1
            }
        ];
        vm.saveQuestion = saveQuestion;
        vm.addOptions = addOptions;
        vm.removeOptions = removeOptions;
        vm.toggleCorrect = toggleCorrect;
        vm.back = back;

        activate();

        function activate() {
            getCompetency();
            getQuestionPool();
        }

        function back() {
            $state.go('app.question_bank.question_behavioral');
        }

        function addOptions() {
            var length = vm.answerOptions.length;
            // assign letter based on index (A, B, C...)
            var letter = String.fromCharCode(65 + length);
            vm.answerOptions.push({
                id: length,
                option: letter,
                text: '',
                value: null,
                correct: 0
            });
            normalizeAnswerOptions();
        }

        function removeOptions() {
            vm.answerOptions.splice(vm.answerOptions.length - 1, 1);
            normalizeAnswerOptions();
        }

        function getCompetency() {
            QuestionBehavioral.getCompDataOnly().then(
                function(res) {
                    vm.competency = res.data;
                },
                function(err) {
                    vm.competency = [];
                }
            );
        }

        function getQuestionPool() {
            QuestionBehavioral.getQpoolDataOnly().then(
                function(res) {
                    vm.questionPool = res.data;
                },
                function() {
                    vm.questionPool = [];
                }
            );
        }

        function normalizeAnswerOptions() {
            vm.answerOptions = (vm.answerOptions || []).map(function(answer, idx) {
                return {
                    id: idx,
                    option: String.fromCharCode(65 + idx),
                    text: answer.text,
                    value: normalizeValue((answer.value !== undefined && answer.value !== null) ? answer.value : answer.proficiency_level),
                    correct: answer.correct ? 1 : 0
                };
            });
        }

        function normalizeValue(value) {
            if (value === null || value === undefined || value === '') {
                return null;
            }

            var asNumber = Number(value);
            if (isNaN(asNumber)) {
                return null;
            }

            return Math.round(asNumber);
        }

        function prepareAnswersPayload() {
            normalizeAnswerOptions();

            return vm.answerOptions
                .filter(function(answer) {
                    return answer && answer.text && answer.text.toString().trim() !== '';
                })
                .map(function(answer) {
                    return {
                        option: answer.option,
                        text: answer.text,
                        value: normalizeValue(answer.value),
                        flag: answer.correct ? 1 : 0
                    };
                });
        }

        function toggleCorrect(index) {
            if (!vm.answerOptions || !vm.answerOptions[index]) {
                return;
            }

            if (vm.answerOptions[index].correct != 1) {
                return;
            }

            vm.answerOptions.forEach(function(answer, idx) {
                answer.correct = idx === index ? 1 : 0;
            });
        }

        function saveQuestion() {
            var answers = prepareAnswersPayload();
            if (answers.length === 0) {
                swal('Error', 'At least one answer is required', 'error');
                return;
            }

            var hasCorrect = answers.some(function(answer) {
                return answer.flag === 1;
            });
            if (!hasCorrect) {
                swal('Error', 'Select one correct answer', 'error');
                return;
            }

            var hasMissingValue = answers.some(function(answer) {
                return answer.value === null;
            });
            if (hasMissingValue) {
                swal('Error', 'Value is required for each answer', 'error');
                return;
            }

            var data = {
                number: vm.number,
                text: vm.text,
                competency_id: vm.selectedCompetency ? vm.selectedCompetency.id : null,
                question_pool_id: vm.selectedQPool ? vm.selectedQPool.id : null,
                weight: vm.weight,
                answers: answers
            };
            QuestionBehavioral.create(data).then(
                function(resp) {
                    if (resp.data.code == 1 || resp.data.code == 200) {
                        swal({
                            title: 'Success',
                            text: resp.data.message,
                            type: 'success',
                            showCancelButton: false,
                            confirmButtonText: 'OK',
                            closeOnConfirm: true
                        },
                        function() {
                            $state.reload();
                        });
                    } else {
                        swal('Error', resp.data.message, 'error');
                    }
                },
                function(err) {
                    swal('Oops!', 'Something went wrong', 'error');
                }
            );
        }
    }
})();

(function() {
    angular
        .module('question_bank')
        .factory('QuestionAnswerTiki', QuestionAnswerTiki);

    function QuestionAnswerTiki($http, appConfig, apiConfig) {
        var factory = {};
        var base = appConfig.appApi;
        var endpoint = apiConfig.tiki.question;

        factory.load = function(page, section, length) {
            return $http.get(
                base +
                    endpoint.load +
                    '?page=' +
                    page +
                    '&section=' +
                    section +
                    '&length=' +
                    length
            );
        };

        factory.detail = function(id) {
            return $http.get(base + endpoint.detail + '/' + id);
        };

        factory.delete = function(ids) {
            return $http.post(base + endpoint.delete, ids);
        };

        factory.create = function(data) {
            return $http.post(base + apiConfig.endpoint.create, data);
        };

        factory.update = function(data) {
            return $http.post(base + apiConfig.endpoint.update, data);
        };

        return factory;
    }
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionAnswerTikiController', QuestionAnswerTikiController);

    /** @ngInject */
    QuestionAnswerTikiController.$inject = [
        '$timeout',
        '$state',
        '$mdToast',
        'QuestionAnswerTiki'
    ];

    function QuestionAnswerTikiController(
        $timeout,
        $state,
        $mdToast,
        QuestionAnswerTiki
    ) {
        var vm = this;
        vm.search = '';
        vm.items = [];
        vm.createData = createData;
        vm.deleteData = deleteData;
        vm.updateData = updateData;
        vm.loadData = loadData;
        vm.pageLength = 20;
        vm.selectedSection = 0;
        vm.isLoading = true;
        vm.convertIntToChar = convertIntToChar;
        vm.sections = [
            { id: 0, name: 'All' },
            { id: 1, name: 'Berhitung Angka' },
            { id: 2, name: 'Gabungan Bagian' },
            { id: 3, name: 'Hubungan Kata' },
            { id: 4, name: 'Abstraksi Non Verbal' }
        ];

        vm.selectedSection = { id: 0, name: 'All' };

        activate();

        function activate() {
            loadData(1);
        }

        function createData() {}

        function updateData() {}

        function loadData(pageNo) {
            QuestionAnswerTiki.load(
                pageNo,
                vm.selectedSection.id,
                vm.pageLength
            ).then(
                function(resp) {
                    vm.isLoading = false;
                    console.log(resp);
                    var paginate = resp.data;
                    vm.items = paginate.data;
                    vm.lastPage = paginate.last_page;
                    vm.totalItems = paginate.total;
                    vm.currentPage = paginate.current_page;
                    vm.pageSize = paginate.per_page;
                    vm.from = paginate.from;
                    vm.to = paginate.to;
                },
                function(err) {
                    console.log(err);
                    vm.isLoading = false;
                    vm.items = [];
                }
            );
        }

        function deleteData(data) {
            swal(
                {
                    title: 'Would you like to delete this question category ?',
                    text: 'Question Category will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        QuestionAnswerTiki.delete({
                            id: data.id
                        }).then(
                            function(resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                resp.data.messages.toUpperCase()
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    )
                                    .then(function() {
                                        console.log('Toast dismissed.');
                                    })
                                    .catch(function() {
                                        console.log(
                                            'Toast failed or was forced to close early by another toast.'
                                        );
                                    });
                                getQuestionAnswerTiki(1);
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }

        function convertIntToChar(data) {
            return String.fromCharCode(65 + data);
        }
    }
})();

(function () {
  angular
    .module('question_bank')
    .factory('QuestionAnswer', QuestionAnswerFactory);

  function QuestionAnswerFactory(
    $http,
    appConfig,
    apiConfig
  ) {

    var factory = {};
    var base = appConfig.appApi;
    var questionBank = apiConfig.questionBank;

    // QuestionBank Endpoint
    // factory.get = function (data, search) {
    //   return $http.get(base + questionBank.getData + '?page=' + data + '&search=' + search);
    // };

    factory.get = function (page, search, filter, length) {
      return $http.get(base + questionBank.getQuestionData + '?page=' + page + '&search=' + search + '&competency=' + filter.competency + '&category=' + filter.category + '&pool=' + filter.pool + '&length=' + length);
    };

    factory.delete = function (data) {
      return $http.post(base + questionBank.deleteData, data);
    };

    factory.save = function (data) {
      return $http.post(base + apiConfig.questionBank.saveData, data);
    };

    factory.update = function (data) {
      return $http.post(base + apiConfig.questionBank.updateData, data);
    };

    factory.getCompDataOnly = function () {
      return $http.get(base + apiConfig.general.competency.getCompDataOnly);
    };

    factory.getCategoryDataOnly = function () {
      return $http.get(base + questionBank.questionCategory.getDataOnly);
    };

    factory.getQpoolDataOnly  = function () {
      return $http.get(base + questionBank.questionPool.getDataOnly);
    };

    return factory;

  }

})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .controller('QuestionAnswerController', QuestionAnswerController);

    /** @ngInject */
    QuestionAnswerController.$inject = [
        '$state',
        'QuestionAnswer',
        'appConfig',
        '$timeout'
    ];

    function QuestionAnswerController($state, QuestionAnswer, appConfig, $timeout) {
        var vm = this;
        vm.gotoCreate = gotoCreate;
        vm.gotoImport = gotoImport;
        vm.gotoEdit = gotoEdit;
        vm.convertIntToChar = convertIntToChar;
        vm.totalPages = 0;
        vm.currentPage = 1;
        vm.deleteQuestion = deleteQuestion;
        vm.loadData = loadData;
        vm.search = '';
        vm.imagePath = 'http://localhost:8000/question';
        vm.aClass = 'page-link';
        vm.questionList = [];
        vm.pageFilter = '';
        vm.pageLength = 20;
        vm.imageBaseUrl = appConfig.questionPic;
        vm.showImages = showImages;
        vm.resetFilter = resetFilter;
        vm.isLoading = false;

        activate();

        function activate() {
            loadData(1);
            getCompetency();
            getCategory();
            getQuestionPool();
        }

        function gotoImport() {
            $state.go('app.question_bank.question_answer.import_question');
        }

        function gotoCreate() {
            $state.go('app.question_bank.question_answer.create_question');
        }

        function gotoEdit(data) {
            $state.go('app.question_bank.question_answer.edit', {
                obj: data
            });
        }

        function getCompetency() {
            QuestionAnswer.getCompDataOnly().then(
                function(res) {
                    vm.competency = res.data;
                },
                function(err) {
                    console.log(err);
                    vm.competency = [];
                }
            );
        }

        function getCategory() {
            QuestionAnswer.getCategoryDataOnly().then(
                function(res) {
                    vm.category = res.data;
                },
                function(err) {
                    vm.category = [];
                }
            );
        }

        function getQuestionPool() {
            QuestionAnswer.getQpoolDataOnly().then(
                function(res) {
                    console.log(res);
                    vm.questionPool = res.data;
                },
                function(err) {
                    console.log(err);
                    vm.questionPool = [];
                }
            );
        }

        function loadData(pageNo) {
            vm.isLoading = true;
            vm.questionList = [];
            vm.pageFilter = {
                competency: vm.selectedCompetency ? vm.selectedCompetency.id : '0',
                category: vm.selectedCategory ? vm.selectedCategory.id : '0',
                pool: vm.selectedQPool ? vm.selectedQPool.id : '0'
            };
            QuestionAnswer.get(pageNo, vm.search, vm.pageFilter, vm.pageLength).then(
                function(resp) {
                    vm.questionList = resp.data.data;
                    vm.paginate = resp.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                    vm.from = vm.paginate.from;
                    vm.to = vm.paginate.to;
                    $timeout(function() {
                        vm.isLoading = false;
                    }, 1000);
                },
                function(err) {
                    vm.questionList = [];
                }
            );
        }

        function showImages(img) {
            swal({
                title: 'Images Preview',
                text: img,
                imageUrl: vm.imageBaseUrl + '/' + img,
                imageSize: '400x400',
                imageAlt: img,
                animation: true
            });
        }

        function convertIntToChar(data) {
            return String.fromCharCode(65 + data);
        }

        function resetFilter() {
            vm.selectedQPool = '';
            vm.selectedCategory = '';
            vm.selectedCompetency = '';
        }

        function deleteQuestion(ev, id) {
            swal(
                {
                    title: 'Would you like to delete this question ?',
                    text: 'Question data will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        QuestionAnswer.delete({
                            id: id
                        }).then(
                            function(resp) {
                                if (resp.data.code == 200) {
                                    swal(
                                        {
                                            title: 'Success',
                                            text: resp.data.message,
                                            type: 'success',
                                            showCancelButton: false,
                                            confirmButtonText: 'OK',
                                            closeOnConfirm: true
                                        },
                                        function() {
                                            $state.reload();
                                        }
                                    );
                                } else {
                                    swal('Error', resp.data.message, 'error');
                                }
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function() {
    angular.module("report").factory("ReportIntelligence", ReportIntelligence);

    function ReportIntelligence($http, appConfig, apiConfig) {
        var factory = {};
        var base = appConfig.appApi;

        factory.getResult = function(page, search, length, date) {
            return $http.get(
                base +
                    apiConfig.assessmentTiki.getResult +
                    "?page=" +
                    page +
                    "&search=" +
                    search +
                    "&date=" +
                    date +
                    "&length=" +
                    length
            );
        };

        factory.getDate = function() {
            return $http.get(base + apiConfig.assessmentTiki.date);
        };

        factory.exportData = function(data) {
            return $http.get(
                base + apiConfig.assessmentTiki.export + "/" + data
            );
        };

        return factory;
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller(
            "ReportIntelligenceController",
            ReportIntelligenceController
        );

    /** @ngInject */
    ReportIntelligenceController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "$window",
        "blockUI",
        "$interval",
        "appConfig",
        "apiConfig",
        "ReportIntelligence"
    ];

    function ReportIntelligenceController(
        $timeout,
        $state,
        $localStorage,
        $window,
        blockUI,
        $interval,
        appConfig,
        apiConfig,
        ReportIntelligence
    ) {
        var vm = this;
        var block = blockUI.instances.get("block-container");
        vm.search = "";
        vm.pageSize = 20;
        vm.totalItems = 0;
        vm.from = 0;
        vm.to = 0;
        vm.currentPage = 1;
        vm.paginate = [];
        vm.loadData = loadData;
        vm.listDate = [];
        vm.selectedDate = "all";
        vm.base = appConfig.appApi;
        vm.exportData = exportData;

        activate();

        function activate() {
            loadData(1);
            getFinishedDate();
        }

        function getFinishedDate() {
            var request = ReportIntelligence.getDate();
            request.then(
                function(response) {
                    vm.listDate = response.data;
                },
                function(error) {
                    vm.listDate = [];
                    vm.selectedDate = "all";
                }
            );
        }

        function loadData(page) {
            block.start({ message: "Please wait" });
            var request = ReportIntelligence.getResult(
                page,
                vm.search,
                vm.pageSize,
                vm.selectedDate
            );
            request.then(
                function(response) {
                    vm.paginate = response.data.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                    vm.from = vm.paginate.from;
                    vm.to = vm.paginate.to;
                    block.stop();
                },
                function(error) {
                    vm.paginate = [];
                    block.stop();
                }
            );
        }

        function exportData() {
            $window.open(
                vm.base +
                    apiConfig.assessmentTiki.export +
                    "?token=" +
                    $localStorage.jwt +
                    "&session_date=" +
                    vm.selectedDate,
                "_blank"
            );
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller("ReportSurveyController", ReportSurveyController);

    /** @ngInject */
    ReportSurveyController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "$window",
        "blockUI",
        "$interval",
        "appConfig",
        "apiConfig",
        "$apiService"
    ];

    function ReportSurveyController(
        $timeout,
        $state,
        $localStorage,
        $window,
        blockUI,
        $interval,
        appConfig,
        apiConfig,
        $apiService
    ) {
        var vm = this;
        var Intray = $apiService.survey();
        var block = blockUI.instances.get("block-container");
        vm.search = "";
        vm.pageSize = 20;
        vm.totalItems = 0;
        vm.from = 0;
        vm.to = 0;
        vm.currentPage = 1;
        vm.paginate = [];
        vm.loadData = loadData;
        vm.listDate = [];
        vm.selectedDate = "all";
        vm.base = appConfig.appApi;
        vm.exportDataSingle = exportDataSingle;
        vm.exportDataMultiple = exportDataMultiple;

        activate();

        function activate() {
            loadData(1);
            getFinishedDate();
        }

        function getFinishedDate() {
            var request = Intray.query({
                endpoint: "getFinishedDate"
            });
            request.$promise.then(function(response) {
                vm.listDate = response;
                console.log("response", response);
            });
            request.$promise.catch(function(err) {
                console.log(err);
            });
        }

        function loadData(page) {
            block.start({ message: "Please wait" });
            var request = Intray.get({
                endpoint: "loadDataReport",
                page: page,
                search: vm.search,
                pageSize: vm.pageSize,
                date: vm.selectedDate
            });
            request.$promise.then(function(response) {
                console.log(response);
                vm.paginate = response;
                vm.totalItems = vm.paginate.total;
                vm.currentPage = vm.paginate.current_page;
                vm.pageSize = vm.paginate.per_page;
                vm.from = vm.paginate.from;
                vm.to = vm.paginate.to;
                block.stop();
            });
            request.$promise.catch(function(err) {
                console.log(err);
                block.stop();
            });
        }

        function exportDataSingle(submissionId) {
            $window.open(
                vm.base +
                    "/survey/generateReport/" +
                    submissionId +
                    "?token=" +
                    $localStorage.token,
                "_blank"
            );
        }

        function exportDataMultiple(type) {
            $window.open(
                vm.base +
                    "/survey/generateReportMultiple/" +
                    vm.selectedDate +
                    "/" +
                    type +
                    "?token=" +
                    $localStorage.token,
                "_blank"
            );
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller("ReportPapikostikController", ReportPapikostikController);

    /** @ngInject */
    ReportPapikostikController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "$window",
        "blockUI",
        "$interval",
        "appConfig",
        "apiConfig",
        "$apiService"
    ];

    function ReportPapikostikController(
        $timeout,
        $state,
        $localStorage,
        $window,
        blockUI,
        $interval,
        appConfig,
        apiConfig,
        $apiService
    ) {
        var vm = this;
        var Papikostik = $apiService.papikostik(true);
        var block = blockUI.instances.get("block-container");
        vm.search = "";
        vm.pageSize = 20;
        vm.totalItems = 0;
        vm.from = 0;
        vm.to = 0;
        vm.currentPage = 1;
        vm.paginate = [];
        vm.loadData = loadData;
        vm.listDate = [];
        vm.selectedDate = "all";
        vm.base = appConfig.appApi;
        vm.exportDataSingle = exportDataSingle;
        vm.exportDataMultiple = exportDataMultiple;
        vm.goToDetail = goToDetail;

        activate();

        function activate() {
            loadData(1);
            getFinishedDate();
        }

        function getFinishedDate() {
            var request = Papikostik.query({
                endpoint: "getFinishedDate"
            });
            request.$promise.then(function(response) {
                vm.listDate = response;
                console.log(response);
            });
            request.$promise.catch(function(err) {
                console.log(err);
            });
        }

        function loadData(page) {
            block.start({ message: "Please wait" });
            var request = Papikostik.get({
                endpoint: "loadDataReport",
                page: page,
                search: vm.search,
                pageSize: vm.pageSize,
                date: vm.selectedDate
            });
            request.$promise.then(function(response) {
                console.log(response);
                vm.paginate = response;
                vm.totalItems = vm.paginate.total;
                vm.currentPage = vm.paginate.current_page;
                vm.pageSize = vm.paginate.per_page;
                vm.from = vm.paginate.from;
                vm.to = vm.paginate.to;
                block.stop();
            });
            request.$promise.catch(function(err) {
                console.log(err);
                block.stop();
            });
        }

        function exportDataSingle(submissionId) {
            $window.open(
                vm.base +
                    "/papikostik/management/generateReport/" +
                    submissionId +
                    "?token=" +
                    $localStorage.jwt,
                "_blank"
            );
        }

        function exportDataMultiple() {
            $window.open(
                vm.base +
                    "/papikostik/management/getReport/" +
                    vm.selectedDate +
                    "?token=" +
                    $localStorage.jwt,
                "_blank"
            );
        }

        function goToDetail(submissionId, uid) {
            $state.go("app.report.papikostik.detail", {
                submission_id: submissionId,
                uid: uid
            });
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller("ReportBeqController", ReportBeqController);

    /** @ngInject */
    ReportBeqController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "$window",
        "blockUI",
        "$interval",
        "appConfig",
        "apiConfig",
        "$apiService"
    ];

    function ReportBeqController(
        $timeout,
        $state,
        $localStorage,
        $window,
        blockUI,
        $interval,
        appConfig,
        apiConfig,
        $apiService
    ) {
        var vm = this;
        var Intray = $apiService.beq();
        var block = blockUI.instances.get("block-container");
        vm.search = "";
        vm.pageSize = 20;
        vm.totalItems = 0;
        vm.from = 0;
        vm.to = 0;
        vm.currentPage = 1;
        vm.paginate = [];
        vm.loadData = loadData;
        vm.listDate = [];
        vm.selectedDate = "all";
        vm.base = appConfig.appApi;
        vm.exportDataSingle = exportDataSingle;
        vm.exportDataMultiple = exportDataMultiple;

        activate();

        function activate() {
            loadData(1);
            getFinishedDate();
        }

        function getFinishedDate() {
            var request = Intray.query({
                endpoint: "getFinishedDate"
            });
            request.$promise.then(function(response) {
                vm.listDate = response;
                console.log("response", response);
            });
            request.$promise.catch(function(err) {
                console.log(err);
            });
        }

        function loadData(page) {
            block.start({ message: "Please wait" });
            var request = Intray.get({
                endpoint: "loadDataReport",
                page: page,
                search: vm.search,
                pageSize: vm.pageSize,
                date: vm.selectedDate
            });
            request.$promise.then(function(response) {
                console.log(response);
                vm.paginate = response;
                vm.totalItems = vm.paginate.total;
                vm.currentPage = vm.paginate.current_page;
                vm.pageSize = vm.paginate.per_page;
                vm.from = vm.paginate.from;
                vm.to = vm.paginate.to;
                block.stop();
            });
            request.$promise.catch(function(err) {
                console.log(err);
                block.stop();
            });
        }

        function exportDataSingle(submissionId) {
            $window.open(
                vm.base +
                    "/beq/generateReport/" +
                    submissionId +
                    "?token=" +
                    $localStorage.jwt,
                "_blank"
            );
        }

        function exportDataMultiple() {
            $window.open(
                vm.base +
                    "/intray/management/generateReportMultiple/" +
                    vm.selectedDate +
                    "?token=" +
                    $localStorage.jwt,
                "_blank"
            );
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller("ReportIntrayController", ReportIntrayController);

    /** @ngInject */
    ReportIntrayController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "$window",
        "blockUI",
        "$interval",
        "appConfig",
        "apiConfig",
        "$apiService"
    ];

    function ReportIntrayController(
        $timeout,
        $state,
        $localStorage,
        $window,
        blockUI,
        $interval,
        appConfig,
        apiConfig,
        $apiService
    ) {
        var vm = this;
        var Intray = $apiService.intray(true);
        var block = blockUI.instances.get("block-container");
        vm.search = "";
        vm.pageSize = 20;
        vm.totalItems = 0;
        vm.from = 0;
        vm.to = 0;
        vm.currentPage = 1;
        vm.paginate = [];
        vm.loadData = loadData;
        vm.listDate = [];
        vm.selectedDate = "all";
        vm.base = appConfig.appApi;
        vm.exportDataSingle = exportDataSingle;
        vm.exportDataMultiple = exportDataMultiple;

        activate();

        function activate() {
            loadData(1);
            getFinishedDate();
        }

        function getFinishedDate() {
            var request = Intray.query({
                endpoint: "getFinishedDate"
            });
            request.$promise.then(function(response) {
                vm.listDate = response;
                console.log("response", response);
            });
            request.$promise.catch(function(err) {
                console.log(err);
            });
        }

        function loadData(page) {
            block.start({ message: "Please wait" });
            var request = Intray.get({
                endpoint: "loadDataReport",
                page: page,
                search: vm.search,
                pageSize: vm.pageSize,
                date: vm.selectedDate
            });
            request.$promise.then(function(response) {
                console.log(response);
                vm.paginate = response;
                vm.totalItems = vm.paginate.total;
                vm.currentPage = vm.paginate.current_page;
                vm.pageSize = vm.paginate.per_page;
                vm.from = vm.paginate.from;
                vm.to = vm.paginate.to;
                block.stop();
            });
            request.$promise.catch(function(err) {
                console.log(err);
                block.stop();
            });
        }

        function exportDataSingle(submissionId) {
            $window.open(
                vm.base +
                    "/intray/management/generateReport/" +
                    submissionId +
                    "?token=" +
                    $localStorage.jwt,
                "_blank"
            );
        }

        function exportDataMultiple() {
            $window.open(
                vm.base +
                    "/intray/management/generateReportMultiple/" +
                    vm.selectedDate +
                    "?token=" +
                    $localStorage.jwt,
                "_blank"
            );
        }
    }
})();

(function() {
    angular.module("report").factory("ReportGeneral", ReportGeneral);

    function ReportGeneral($http, appConfig, apiConfig) {
        var factory = {};
        var base = appConfig.appApi;

        factory.getData = function(page, date, search, length, poolId) {
            return $http.get(
                base +
                    apiConfig.report.list +
                    "?page=" +
                    page +
                    "&date=" +
                    date +
                    "&search=" +
                    search +
                    "&length=" +
                    length
                    + "&poolId=" + poolId
            );
        };

        factory.getDate = function() {
            return $http.get(base + apiConfig.report.date);
        };

        factory.getDetail = function(data) {
            return $http.get(base + apiConfig.report.detail + "/" + data);
        };

        factory.export = function(data) {
            return $http.get(base + apiConfig.report.export + "?date=" + data);
        };

        return factory;
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller("ReportGeneralController", ReportGeneralController);

    /** @ngInject */
    ReportGeneralController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "ReportGeneral",
        "$window",
        "blockUI",
        "$interval",
        "appConfig",
        "apiConfig",
        "Enrollment"
    ];

    function ReportGeneralController(
        $timeout,
        $state,
        $localStorage,
        ReportGeneral,
        $window,
        blockUI,
        $interval,
        appConfig,
        apiConfig,
        Enrollment
    ) {
        var vm = this;
        vm.username = $localStorage.userName;
        var block = blockUI.instances.get("block-container");
        vm.search = "";
        vm.length = 10;
        vm.loadData = loadData;
        vm.getDetail = getDetail;
        vm.exportData = exportData;
        vm.selectedDate = { finished_date: "all" };
        vm.base = appConfig.appApi;
        vm.exportQuestionPool = exportQuestionPool;
        vm.exportDataAchievement = exportDataAchievement;
        vm.questionPool = [];
        vm.selectedPool = {};

        activate();

        function activate() {
            loadData(1);
            date();
            getQuestionPool();
        }

        function getQuestionPool() {
            Enrollment.getQuestionPool().then(
                function(resp) {
                    vm.questionPool = resp.data;
                },
                function(err) {
                    vm.questionPool = [];
                }
            );
        }

        function loadData(pageNo) {
            block.start({ message: "Please wait" });
            vm.date = vm.selectedDate.finished_date;
            vm.poolId = vm.selectedPool.id;
            ReportGeneral.getData(pageNo, vm.date, vm.search, vm.length, vm.poolId).then(
                function(resp) {
                    console.log(resp);
                    vm.list = resp.data.data;
                    vm.paginate = resp.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                    block.stop();
                },
                function(err) {
                    block.stop();
                    console.log(err);
                }
            );
        }

        function exportData() {
            $window.open(
                vm.base + apiConfig.report.export + "?date=" + vm.date,
                "_blank"
            );
        }

        function date() {
            ReportGeneral.getDate().then(
                function(res) {
                    var tmp = res.data;
                    if (tmp.length > 0) {
                        tmp.push({
                            finished_date: "all"
                        });
                    }
                    vm.reportDate = tmp;
                },
                function(err) {
                    console.log(res);
                }
            );
        }

        function getDetail(data) {
            $state.go("app.report.general.detail", {
                obj: data,
                id: data.id,
                userId: data.user.id
            });
        }

        function exportQuestionPool(data) {
            var questionPoolId = data.submission.session.question_pool_id;
            $window.open(
                vm.base + apiConfig.questionBank.questionPool.exportData + "?id=" + questionPoolId,
                "_blank"
            );
        }
        
         function exportDataAchievement(data) {
            var achievementId = data.id;
            var url = vm.base + apiConfig.achievement.export + "/" + achievementId + "?token=" + $localStorage.token;
            console.log(url);
            $window.open(url,"_blank");
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("report")
        .controller("ReportBehavioralController", ReportBehavioralController);

    /** @ngInject */
    ReportBehavioralController.$inject = [
        "$timeout",
        "$state",
        "$localStorage",
        "$window",
        "blockUI",
        "$interval",
        "appConfig",
        "apiConfig",
        "$apiService"
    ];

    function ReportBehavioralController(
        $timeout,
        $state,
        $localStorage,
        $window,
        blockUI,
        $interval,
        appConfig,
        apiConfig,
        $apiService
    ) {
        var vm = this;
        var Behavioral = $apiService.behavioral();
        var block = blockUI.instances.get("block-container");
        vm.search = "";
        vm.pageSize = 20;
        vm.totalItems = 0;
        vm.from = 0;
        vm.to = 0;
        vm.currentPage = 1;
        vm.paginate = [];
        vm.loadData = loadData;
        vm.listDate = [];
        vm.selectedDate = "all";
        vm.base = appConfig.appApi;
        vm.viewDetail = viewDetail;

        activate();

        function activate() {
            loadData(1);
            getFinishedDate();
        }

        function getFinishedDate() {
            var request = Behavioral.query({
                endpoint: "getFinishedDate"
            });
            request.$promise.then(function(response) {
                vm.listDate = response;
            });
            request.$promise.catch(function(err) {
                console.log(err);
            });
        }

        function loadData(page) {
            block.start({ message: "Please wait" });
            var request = Behavioral.get({
                endpoint: "loadDataReport",
                page: page,
                search: vm.search,
                pageSize: vm.pageSize,
                date: vm.selectedDate
            });
            request.$promise.then(function(response) {
                vm.paginate = response;
                vm.totalItems = vm.paginate.total;
                vm.currentPage = vm.paginate.current_page;
                vm.pageSize = vm.paginate.per_page;
                vm.from = vm.paginate.from;
                vm.to = vm.paginate.to;
                block.stop();
            });
            request.$promise.catch(function(err) {
                console.log(err);
                block.stop();
            });
        }

        function viewDetail(item) {
            $state.go("app.report.behavioral.detail", {
                submissionId: item.id,
                userId: item.user.id
            });
        }
    }
})();

(function () {

  'use strict';

  angular
    .module('master_data', [])
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    $stateProvider
      .state('app.master_data', {
        url: 'master-data',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/master-data/master-data.html',
            controller: 'MasterDataController as vm'
          }
        },
        data: {
          requiresLogin: true
        }
      });

    $stateProvider
      .state('app.master_data.question_category_competency', {
        url: '/question-category-competency',
        views: {
          'master-data@app.master_data': {
            templateUrl: 'app/main/modules/master-data/question-category-competency/question-category-competency.html',
            controller: 'QuestionCategoryCompetencyController as vm'
          }
        },
        data: {
          requiresLogin: true
        }
      });
  }

})();

(function () {
  'use strict';

  angular
    .module('master_data')
    .controller('QuestionCategoryCompetencyController', QuestionCategoryCompetencyController);

  /** @ngInject */
  QuestionCategoryCompetencyController.$inject = ['$timeout', '$state', '$scope', 'QuestionBank'];

  function QuestionCategoryCompetencyController($timeout, $state, $scope, QuestionBank) {

    var vm = this;

    activate();

    function activate() {
      getCompCategory();  
    }

    function getCompCategory() {
      QuestionBank.getCompCategory()
      .then(function(resp){
        var data = resp.data.data;
        vm.items = data.data;
        vm.lastPage  = data.last_page;
        console.log(data);
      }, function(err){
        vm.questionList = [];
      });
    }


  }
})();

(function() {
    'use strict';

    angular
        .module('enrollment')
        .controller('UserParticipantController', UserParticipantController);

    /** @ngInject */
    UserParticipantController.$inject = [
        '$timeout',
        '$state',
        'Enrollment',
        '$mdToast'
    ];

    function UserParticipantController($timeout, $state, Enrollment, $mdToast) {
        var vm = this;
        vm.totalPages = 0;
        vm.currentPage = 1;
        vm.loadData = loadData;
        vm.search = '';
        vm.gotoAssign = gotoAssign;
        vm.deleteData = deleteData;
        vm.gotoUpdate = gotoUpdate;

        activate();

        function activate() {
            loadData(1);
        }

        function gotoAssign() {
            $state.go('app.enrollment.user_participant.assign');
        }

        function gotoUpdate(item) {
            $state.go('app.enrollment.user_participant.edit', {
                obj: item
            });
        }

        function loadData(pageNo) {
            Enrollment.getDataUserParticipant(pageNo, vm.search).then(function(
                resp
            ) {
                vm.list = resp.data.data.data;
                vm.paginate = resp.data.data;
                vm.totalItems = vm.paginate.total;
                vm.currentPage = vm.paginate.current_page;
                vm.pageSize = vm.paginate.per_page;
            });
        }

        function deleteData(data) {
            swal(
                {
                    title: 'Would you like to delete this user participant ?',
                    text: 'User participant will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        Enrollment.unassignUser({
                            id: data.id
                        }).then(
                            function(resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                resp.data.messages.toUpperCase()
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    )
                                    .then(function() {
                                        console.log('Toast dismissed.');
                                    })
                                    .catch(function() {
                                        console.log(
                                            'Toast failed or was forced to close early by another toast.'
                                        );
                                    });
                                loadData(1);
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('enrollment')
    .controller('QuestionAssignmentController', QuestionAssignmentController);

  /** @ngInject */
  QuestionAssignmentController.$inject = ['$timeout', '$state', '$scope', 'Enrollment'];

  function QuestionAssignmentController($timeout, $state, $scope, Enrollment) {

    var vm = this;
    vm.getCompetencyByCategory = getCompetencyByCategory;

    activate();

    function activate() {
      getCompetencyCategory();
    }

    function getCompetencyCategory() {
      Enrollment.getCompCategory().then(
        function(resp){
          vm.categoryCompetency = resp.data.data;
        }, function (err) {
          $state.reload();
        }
      );
    }

    function getCompetencyByCategory(id) {
      Enrollment.getCompByCategory(id).then(
        function (resp) {
          vm.competency = resp.data.data;
          getQuestionCategory();
        }, function (err) {
          swal("Error", "Check your connection", "error");
        }
      );
    }

    function getQuestionCategory() {
      Enrollment.getQuestionCategory().then(
        function (resp) {
          vm.questionCategory = resp.data.data;
        }, function (err) {
          swal("Error", "Check your connection", "error");
        }
      );
    }

    function getQuestion() {
      Enrollment.getQuestion().then(
        function (resp) {
          vm.questions = resp.data.data;
        }, function (err) {
          swal("Error", "Check your connection", "error");
        }
      );
    }

  }
})();

(function () {
  angular
    .module('enrollment')
    .factory('MasterClassRoom', MasterClassRoomFactory);

  function MasterClassRoomFactory(
    $http,
    appConfig,
    apiConfig
  ) {

    var factory = {};
    var base = appConfig.appApi;
    var classRoomApi = apiConfig.MasterData.classroom;

    factory.get  = function (data, search) {
      return $http.get(base + classRoomApi.getData + '?page='+data + '&search=' + search);
    };

    factory.save = function (data) {
      return $http.post(base + classRoomApi.save, data);
    };

    factory.delete = function (data) {
      return $http.post(base + classRoomApi.delete, data);
    };

    factory.update = function (data) {
      return $http.post(base + classRoomApi.update, data);
    };

    return factory;

  }

})();

(function() {
    'use strict';

    angular
        .module('enrollment')
        .controller('ClassRoomController', ClassRoomController);

    /** @ngInject */
    ClassRoomController.$inject = [
        '$timeout',
        '$state',
        '$mdToast',
        'MasterClassRoom'
    ];

    function ClassRoomController($timeout, $state, $mdToast, MasterClassRoom) {
        var vm = this;
        vm.gotoCreate = gotoCreate;
        vm.totalPages = 0;
        vm.currentPage = 1;
        vm.loadData = loadData;
        vm.search = '';
        vm.edit = edit;
        vm.deleteData = deleteData;

        activate();

        function activate() {
            loadData(1);
        }

        function gotoCreate() {
            $state.go('app.enrollment.class_room.create');
        }

        function loadData(pageNo) {
            MasterClassRoom.get(pageNo, vm.search).then(
                function(resp) {
                    vm.items = resp.data.data;
                    vm.paginate = resp.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                },
                function(err) {
                    vm.items = [];
                }
            );
        }

        function edit(data) {
            $state.go('app.enrollment.class_room.edit', {
                obj: data
            });
        }

        function deleteData(data) {
            swal(
                {
                    title: 'Would you like to delete this class room ?',
                    text: 'Master class room data will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        MasterClassRoom.delete({
                            id: data.id
                        }).then(
                            function(resp) {
                                if (resp.data.code == 200) {
                                    $mdToast
                                        .show(
                                            $mdToast
                                                .simple()
                                                .textContent(
                                                    resp.data.message.toUpperCase()
                                                )
                                                .position('bottom right')
                                                .hideDelay(3000)
                                        )
                                        .then(function() {
                                            console.log('Toast dismissed.');
                                        })
                                        .catch(function() {
                                            console.log(
                                                'Toast failed or was forced to close early by another toast.'
                                            );
                                        });
                                    loadData(1);
                                } else {
                                    swal('Error', resp.data.message, 'error');
                                }
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('enrollment')
        .controller('GroupParticipantController', GroupParticipantController);

    /** @ngInject */
    GroupParticipantController.$inject = ['$state', 'Enrollment', '$mdToast'];

    function GroupParticipantController($state, Enrollment, $mdToast) {
        var vm = this;
        vm.totalPages = 0;
        vm.currentPage = 1;
        vm.loadData = loadData;
        vm.search = '';
        vm.selectedLength = 10;
        vm.gotoCreate = gotoCreate;
        vm.gotoUpdate = gotoUpdate;
        vm.gotoDelete = deleteData;

        activate();

        function activate() {
            loadData(1);
        }

        function gotoCreate() {
            $state.go('app.enrollment.group_participant.create');
        }

        function gotoUpdate(data) {
            $state.go('app.enrollment.group_participant.edit', {
                obj: data
            });
        }

        function loadData(noPage) {
            Enrollment.groupParticipantPaginate(
                noPage,
                vm.search,
                vm.selectedLength
            ).then(
                function(resp) {
                    vm.list = resp.data.data;
                    vm.paginate = resp.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                },
                function(err) {
                    console.log(err);
                }
            );
        }

        function deleteData(data) {
            swal(
                {
                    title: 'Would you like to delete this group participant ?',
                    text: 'Group participant data will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        Enrollment.deleteDataGroupParticipant({
                            id: data.id
                        }).then(
                            function(resp) {
                                if (resp.data.code == 1) {
                                    $mdToast
                                        .show(
                                            $mdToast
                                                .simple()
                                                .textContent(
                                                    resp.data.messages.toUpperCase()
                                                )
                                                .position('bottom right')
                                                .hideDelay(3000)
                                        )
                                        .then(function() {
                                            console.log('Toast dismissed.');
                                        })
                                        .catch(function() {
                                            console.log(
                                                'Toast failed or was forced to close early by another toast.'
                                            );
                                        });
                                    loadData(1);
                                } else {
                                    swal('Error', resp.data.messages, 'error');
                                }
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('enrollment')
        .controller('AssessmentSessionController', AssessmentSessionController);

    /** @ngInject */
    AssessmentSessionController.$inject = [
        '$timeout',
        '$state',
        '$scope',
        'Enrollment',
        '$mdMenu',
        '$mdToast'
    ];

    function AssessmentSessionController(
        $timeout,
        $state,
        $scope,
        Enrollment,
        $mdMenu,
        $mdToast
    ) {
        var vm = this;
        vm.gotoCreate = gotoCreate;
        vm.totalPages = 0;
        vm.currentPage = 1;
        vm.loadData = loadData;
        vm.search = '';
        vm.gotoUpdate = gotoUpdate;
        vm.pageLength = 20;
        vm.deleteData = deleteData;
        vm.lastPage = 1;

        activate();

        function activate() {
            loadData(1);
        }

        function gotoCreate() {
            $state.go('app.enrollment.assessment_session.create_session');
        }

        function gotoUpdate(data) {
            $state.go('app.enrollment.assessment_session.update_session', {
                obj: data
            });
        }

        function loadData(pageNo) {
            Enrollment.getDataSession(pageNo, vm.search, vm.pageLength).then(
                function(resp) {
                    vm.list = resp.data.data;
                    vm.paginate = resp.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                    console.log(vm.list);
                }
            );
        }

        function deleteData(ev, data) {
            swal(
                {
                    title: 'Would you like to delete this session ?',
                    text: 'Session data will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        Enrollment.deleteDataSession({
                            id: data.id
                        }).then(
                            function(resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                resp.data.messages.toUpperCase()
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    )
                                    .then(function() {
                                        console.log('Toast dismissed.');
                                    })
                                    .catch(function() {
                                        console.log(
                                            'Toast failed or was forced to close early by another toast.'
                                        );
                                    });
                                loadData(vm.lastPage);
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }

        vm.openMenu = function($mdMenu, ev) {
            $mdMenu.open(ev);
        };
    }
})();

(function () {

  'use strict';

  angular
    .module('account', [])
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    $stateProvider
      .state('app.account', {
        url: 'account',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/account/account.html',
            controller: 'AccountController as vm'
          }
        },
        data: {
          requiresLogin: true
        }
      });

    $stateProvider
      .state('app.account.create_account', {
        url: '/create-account',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/account/create-account/create-account.html',
            controller: 'CreateAccountController as vm'
          }
        },
        data: {
          requiresLogin: true
        }
      });

      $stateProvider
      .state('app.account.import_account', {
        url: '/import-account',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/account/import-account/import-account.html',
            controller: 'ImportAccountController as vm'
          }
        },
        data: {
          requiresLogin: true
        }
      });

      $stateProvider
      .state('app.account.update_account', {
        url: '/update-account',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/account/update-account/update-account.html',
            controller: 'UpdateAccountController as vm'
          }
        },
        data: {
          requiresLogin: true
        },
        params : {
          obj : null
        }
      });


      $stateProvider
      .state('app.account.sync', {
        url: '/syncrhonize',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/account/sync-account/sync-account.html',
            controller: 'SyncAccountController as vm'
          }
        },
        data: {
          requiresLogin: true
        },
        params : {
          obj : null
        }
      });

  }

})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('SyncAccountController', SyncAccountController);

    /** @ngInject */
    SyncAccountController.$inject = [
        '$state',
        'AccountFactory',
        'SyncFactory',
        '$mdDialog',
        'appConfig',
        'apiConfig',
        'Auth',
        '$localStorage',
        'jwtHelper',
        '$timeout',
        'blockUI',
        '$scope',
        '$interval'
    ];

    function SyncAccountController(
        $state,
        AccountFactory,
        SyncFactory,
        $mdDialog,
        appConfig,
        apiConfig,
        Account,
        $localStorage,
        jwtHelper,
        $timeout,
        blockUI,
        $scope,
        $interval
    ) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.getDivision = getDivision;
        vm.getDepartment = getDepartment;
        vm.syncAccount = syncAccount;
        vm.formDisabled = true;
        vm.parsingJson = parsingJson;
        vm.getSyncLogs = getSyncLogs;
        vm.logs = [];
        vm.syncProgress = false;
        vm.syncResult = [];
        vm.syncFinish = false;

        function closeDialog() {
            $mdDialog.hide();
        }

        activate();

        function activate() {
            blockUI.start();
            getSyncLogs(1);
            getDivision();
            $timeout(function() {
                vm.formDisabled = false;
                blockUI.stop();
            }, 3000);
        }

        function getSyncLogs(pageNo) {
            var tmpData = [];
            AccountFactory.syncLogs(pageNo).then(
                function(resp) {
                    var temp = resp.data.data.data;
                    for (var i = 0; i < temp.length; i++) {
                        tmpData.push({
                            status: temp[i].status,
                            time: temp[i].sync_time,
                            date: temp[i].sync_date,
                            by: temp[i].sync_by
                            // detail: JSON.parse(temp[i].detail)
                        });
                    }
                    vm.logs = tmpData;
                    vm.paginate = resp.data.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                },
                function(err) {}
            );
        }

        function parsingJson(data, key) {
            var temp = JSON.parse(data);
            return temp.key;
        }

        function getDivision() {
            SyncFactory.getDivision().then(
                function(success) {
                    vm.division = success.data;
                },
                function(err) {
                    console.log(err);
                    vm.division = [];
                }
            );
        }

        function getDepartment(division) {
            SyncFactory.getDepartment(division).then(
                function(success) {
                    vm.department = success.data;
                },
                function(err) {
                    console.log(err);
                    vm.department = [];
                }
            );
        }

        function syncAccount(form) {
            vm.syncFinish = false;
            blockUI.start();
            var division = form.division.$viewValue.id;
            var department = form.department.$viewValue.id;
            console.log(form);

            SyncFactory.syncAccount(division, department).then(
                function(success) {
                    console.log(success.data);
                    vm.syncResult = success.data.info;
                    vm.syncFinish = true;
                    getSyncLogs(1);
                    blockUI.stop();
                },
                function(err) {
                    console.log(err);
                    vm.syncFinish = true;
                    blockUI.stop();
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('UpdateAccountController', UpdateAccountController);

    /** @ngInject */
    UpdateAccountController.$inject = [
        '$timeout',
        '$state',
        '$stateParams',
        'AccountFactory',
        'blockUI',
        '$scope'
    ];

    function UpdateAccountController(
        $timeout,
        $state,
        $stateParams,
        AccountFactory,
        blockUI,
        $scope
    ) {
        var vm = this;
        vm.back = back;
        vm.updateData = updateData;
        vm.data = $stateParams.obj;
        vm.msg = false;
        vm.showPasswordData = false;
        vm.showPassword = showPassword;
        vm.generatePassword = generatePassword;

        setData();
        vm.group = [
            {
                id: 1,
                name: 'Superadmin'
            },
            {
                id: 2,
                name: 'Admin'
            },
            {
                id: 3,
                name: 'User'
            }
        ];

        $scope.$watch('vm.passwordConfirm', function(newValue, oldValue) {
            if (vm.password !== undefined) {
                if (vm.password != newValue) {
                    vm.msg = true;
                } else {
                    vm.msg = false;
                }
            }
        });

        function showPassword() {
            if (vm.showPasswordData) {
                vm.showPasswordData = false;
            } else {
                vm.showPasswordData = true;
            }
        }

        function setData() {
            if (vm.data !== null) {
                vm.selectedGroup = vm.data.roles.group;
                vm.username = vm.data.name;
                vm.userid = vm.data.nik;
                vm.email = vm.data.email;
            }
        }

        function updateData(form) {
            var data = {
                uid: vm.data.id,
                roles: vm.data.roles.id,
                nik: form.userid.$viewValue,
                name: form.username.$viewValue,
                password: vm.password,
                // email: form.email.$viewValue,
                group: form.group.$viewValue.id
            };
            blockUI.start();
            AccountFactory.updateDataUser(data).then(
                function(response) {
                    blockUI.stop();
                    if (response.data.code === 1) {
                        swal(
                            {
                                title: 'Success',
                                text: response.data.messages,
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.go('app.account');
                            }
                        );
                    } else {
                        swal('Error', response.data.message, 'error');
                    }
                },
                function(error) {
                    blockUI.stop();
                    swal('Error', 'Oops There Is Something Wrong', 'error');
                }
            );
        }

        function back() {
            $state.go('app.account');
        }

        function generatePassword() {
            var temp = '';
            var possible =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&()';

            for (var i = 0; i < 12; i++)
                temp += possible.charAt(Math.floor(Math.random() * possible.length));

            vm.password = temp;
            vm.passwordConfirm = vm.password;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('ImportAccountController', ImportAccountController);

    /** @ngInject */
    ImportAccountController.$inject = [
        '$timeout',
        '$state',
        'AccountFactory',
        'Upload',
        '$mdDialog',
        'appConfig',
        'apiConfig'
    ];

    function ImportAccountController(
        $timeout,
        $state,
        AccountFactory,
        Upload,
        $mdDialog,
        appConfig,
        apiConfig
    ) {
        var vm = this;
        vm.closeDialog = closeDialog;
        vm.uploadURL = appConfig.appApi + apiConfig.accounts.upload;
        vm.uploadData = uploadData;

        function closeDialog() {
            $mdDialog.hide();
        }

        function uploadData(file) {
            file.upload = Upload.upload({
                url: vm.uploadURL,
                data: {
                    file: file
                }
            });

            file.upload.then(
                function(response) {
                    if (response.data.code === 1) {
                        swal(
                            {
                                title: 'Success',
                                text: response.message,
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                closeDialog();
                                $state.reload();
                            }
                        );
                    } else {
                        closeDialog();
                        swal('Error', response.data.message, 'error');
                    }
                },
                function(error) {
                    swal(
                        'Error',
                        'Opps There is something wrong, please check your internet connection',
                        'error'
                    );
                },
                function(evt) {
                    file.progress = Math.min(
                        100,
                        parseInt((100.0 * evt.loaded) / evt.total)
                    );
                }
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('account')
        .controller('CreateAccountController', CreateAccountController);

    /** @ngInject */
    CreateAccountController.$inject = [
        '$timeout',
        '$state',
        'AccountFactory',
        'blockUI',
        '$scope'
    ];

    function CreateAccountController(
        $timeout,
        $state,
        AccountFactory,
        blockUI,
        $scope
    ) {
        var vm = this;
        vm.back = back;
        vm.save = saveData;
        vm.showPasswordData = false;
        vm.showPassword = showPassword;
        vm.tempGenerate = '';
        vm.generatePassword = generatePassword;

        vm.group = [
            {
                id: 1,
                name: 'Superadmin'
            },
            {
                id: 2,
                name: 'Admin'
            },
            {
                id: 3,
                name: 'User'
            }
        ];

        function saveData(form) {
            var data = {
                nik: form.userid.$viewValue,
                name: form.username.$viewValue,
                // email: form.email.$viewValue,
                password: vm.password,
                group: form.group.$viewValue.id
            };
            blockUI.start();
            AccountFactory.createDataUser(data).then(
                function(response) {
                    blockUI.stop();
                    if (response.data.code === 1) {
                        swal(
                            {
                                title: 'Success',
                                text: response.data.message,
                                type: 'success',
                                showCancelButton: false,
                                confirmButtonText: 'OK',
                                closeOnConfirm: true
                            },
                            function() {
                                $state.reload();
                            }
                        );
                    } else {
                        swal('Error', response.data.message, 'error');
                    }
                },
                function(error) {
                    blockUI.stop();
                    swal('Error', 'Oops There Is Something Wrong', 'error');
                }
            );
        }

        function showPassword() {
            if (vm.showPasswordData) {
                vm.showPasswordData = false;
            } else {
                vm.showPasswordData = true;
            }
        }

        $scope.$watch('vm.passwordConfirm', function(newValue, oldValue) {
            if (vm.password !== undefined) {
                if (vm.password != newValue) {
                    vm.msg = true;
                } else {
                    vm.msg = false;
                }
            }
        });

        function back() {
            $state.go('app.account');
        }

        function generatePassword() {
            var temp = '';
            var possible =
                'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&()';

            for (var i = 0; i < 12; i++)
                temp += possible.charAt(Math.floor(Math.random() * possible.length));

            vm.password = temp;
            vm.passwordConfirm = vm.password;
        }
    }
})();

(function() {
    angular.module('question_bank').factory('QuestionBank', QuestionBankFactory);

    function QuestionBankFactory(
        $q,
        $http,
        $location,
        appConfig,
        apiConfig,
        $timeout
    ) {
        var factory = {};
        var base = appConfig.appApi;
        var competency = apiConfig.general.competency;
        var questionCategory = apiConfig.questionBank.questionCategory;

        // Competency endpoint
        factory.getCompetency = function(data, search) {
            return $http.get(
                base + competency.getComp + '?page=' + data + '&search=' + search
            );
        };

        factory.getCompCategory = function() {
            return $http.get(base + competency.getCompCategory);
        };

        factory.getCompByCategory = function(data) {
            return $http.get(base + competency.getCompByCategory + '/' + data);
        };

        factory.getQuestionCategory = function() {
            return $http.get(base + questionCategory.getData);
        };

        factory.createCompetency = function(data) {
            return $http.post(base + competency.createCompetency, data);
        };

        factory.updateCompetency = function(data) {
            return $http.post(base + competency.updateCompetency, data);
        };

        factory.deleteCompetency = function(data) {
            return $http.post(base + competency.deleteCompetency, data);
        };

        return factory;
    }
})();

(function() {
    angular
        .module("question_bank")
        .directive("questionBankToolbar", QuestionBankToolbarConfig);

    /** @ngInject */
    function QuestionBankToolbarConfig() {
        var directive = {
            restrict: "E",
            templateUrl:
                "app/main/modules/question-bank/question-bank-toolbar.html",
            scope: {
                creationDate: "="
            },
            transclude: true,
            controller: QuestionBankToolbarController,
            controllerAs: "vm",
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function QuestionBankToolbarController(
            $scope,
            $location,
            $window,
            $state
        ) {
            vm = this;
            vm.$state = $state;
            vm.toggleNav = toggleNav;

            function toggleNav() {
                var x = document.getElementById("myTopnav");
                if (x.className === "topnav") {
                    x.className += " responsive";
                } else {
                    x.className = "topnav";
                }
            }
        }
    }
})();

(function() {
    "use strict";

    angular
        .module("question_bank")
        .controller("QuestionBankController", QuestionBankController);

    /** @ngInject */
    QuestionBankController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "QuestionBank"
    ];

    function QuestionBankController($timeout, $state, $scope, QuestionBank) {
        var vm = this;
        vm.checkState = checkState;

        activate();

        function activate() {
            $state.go($state.current);
        }

        function checkState() {
            if ($state.current.name == "app.question_bank") {
                return true;
            }
            return false;
        }
    }
})();

(function() {
    angular.module("report").directive("reportToolbar", ReportToolbarConfig);

    /** @ngInject */
    function ReportToolbarConfig() {
        var directive = {
            restrict: "E",
            templateUrl: "app/main/modules/report/report-toolbar.html",
            scope: {
                creationDate: "="
            },
            transclude: true,
            controller: ReportToolbarController,
            controllerAs: "vm",
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function ReportToolbarController($scope, $location, $window, $state) {
            vm = this;
            vm.$state = $state;
            vm.toggleNav = toggleNav;

            function toggleNav() {
                var x = document.getElementById("myTopnav");
                if (x.className === "topnav") {
                    x.className += " responsive";
                } else {
                    x.className = "topnav";
                }
            }
        }
    }
})();

(function() {
    "use strict";

    angular.module("report").controller("ReportController", ReportController);

    /** @ngInject */
    ReportController.$inject = ["$timeout", "$state", "$scope"];

    function ReportController($timeout, $state, $scope) {
        var vm = this;
        vm.checkState = checkState;

        activate();

        function activate() {
            $state.go($state.current);
        }

        function checkState() {
            if ($state.current.name == "app.report") {
                return true;
            }
            return false;
        }
    }
})();

(function () {

  'use strict';

  angular
    .module('wizard', [])
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    $stateProvider
      .state('app.wizard', {
        url: 'wizard',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/wizard/wizard.html',
            controller: 'WizardController as vm'
          }
        },
        data: {
          requiresLogin: true
        }
      });

    $stateProvider
      .state('app.wizard.steps1', {
        url: 'wizard/step1',
        views: {
          'wizard@app.wizard': {
            templateUrl: 'app/main/modules/wizard/steps/step1.html'
          }
        },
        data: {
          requiresLogin: true
        }
      });



  }

})();

(function () {
  'use strict';

  angular
    .module('wizard')
    .controller('WizardController', WizardController);

  /** @ngInject */
  WizardController.$inject = [
    '$timeout', 
    '$state', 
    '$localStorage'
  ];

  function WizardController(
    $timeout, 
    $state, 
    $localStorage
  ) {
    var vm = this;

    $state.go('app.wizard.steps1');

  }
})();

(function () {
  angular
    .module('question_bank')
    .factory('MasterData', MasterDataFactory);

  function MasterDataFactory(
    $q,
    $http,
    $location,
    appConfig,
    apiConfig,
    $timeout
  ) {

    var factory = {};
    var base = appConfig.appApi;
    var master = apiConfig.master;
  
    // Competency endpoint
    // factory.getCompetency = function () {
    //   return $http.get(base + competency.getComp);
    // };

    return factory;

  }

})();

(function () {
  angular
    .module('master_data')
    .directive('masterDataToolbar', MasterDataToolbarConfig);

  /** @ngInject */
  function MasterDataToolbarConfig() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/main/modules/master-data/master-data-toolbar.html',
      scope: {
        creationDate: '='
      },
      transclude: true,
      controller: MasterDataToolbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function MasterDataToolbarController($scope, $location, $window, $state) {
      vm = this;
      vm.$state = $state;
    }
  }


})();

(function () {
  'use strict';

  angular
    .module('master_data')
    .controller('MasterDataController', MasterDataController);

  /** @ngInject */
  MasterDataController.$inject = ['$timeout', '$state', '$scope', 'QuestionBank'];

  function MasterDataController($timeout, $state, $scope, QuestionBank) {

    var vm = this; 

    activate();

    function activate() {
      $state.go('app.master_data.class_room');
    }

  }
})();

(function () {

  'use strict';

  angular
    .module('login', [])
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {
    $stateProvider
      .state('app.login', {
        url: 'login',
        views: {
          'main@': {
            templateUrl: 'app/main/modules/login/login.html',
            controller: 'LoginController as vm'
          }
        }

      });

  }

})();

(function () {
    "use strict";
    angular.module("login").controller("LoginController", LoginController);

    /** @ngInject */
    LoginController.$inject = [
        "$state",
        "$localStorage",
        "$apiService",
        "$rootScope",
        "blockUI",
        "$appHelper",
        "$interval",
    ];

    function LoginController(
        $state,
        $localStorage,
        $apiService,
        $rootScope,
        blockUI,
        $appHelper,
        $interval
    ) {
        var vm = this;
        var Auth = $apiService.auth();
        vm.login = login;
        $rootScope.SwitchClassBody = "login-container";
        vm.isLoading = false;
        vm.isNotValid = false;
        vm.messages = "";

        activate();

        function activate() {
            $localStorage.$reset();
            if (angular.isDefined($rootScope.intervalTimer)) {
                $interval.cancel($rootScope.intervalTimer);
            }

            if (angular.isDefined($rootScope.timerAssessment)) {
                $interval.cancel($rootScope.timerAssessment);
            }

            if (blockUI.isBlocking()) {
                blockUI.stop();
            }
        }

        function login() {
            vm.isLoading = true;
            blockUI.start();
            var request = Auth.login({ nik: vm.nik, password: vm.password });
            request.$promise.then(function (res) {
                blockUI.stop();
                vm.isLoading = false;
                // set token and decode to storage
                $appHelper.setToken(res.token);
                if ($localStorage.rolesId == 3) {
                    $state.go("app.dashboard");
                } else {
                    $state.go("app.dashboard.admin");
                }
            });

            request.$promise.catch(function (err) {
                blockUI.stop();
                vm.isNotValid = true;
                vm.messages = err.data.message;
                console.log(vm.messages);
                vm.password = "";
            });
        }
    }
})();

(function() {
    angular.module('enrollment').factory('Enrollment', Enrollment);

    function Enrollment($q, $http, $location, appConfig, apiConfig, $timeout) {
        var factory = {};
        var base = appConfig.appApi;
        var competency = apiConfig.general.competency;
        var questionCategory = apiConfig.questionBank.questionCategory;
        var enrollment = apiConfig.enrollment;

        factory.getCompCategory = function() {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(base + competency.getCompCatDataOnly);
        };

        factory.getCompByCategory = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(base + competency.getCompByCategory + '/' + data);
        };

        factory.getQuestionCategory = function() {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(base + questionCategory.getData);
        };

        factory.getQuestion = function() {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(base + apiConfig.questionBank.getDataOnly);
        };

        factory.getQuestionPool = function() {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(base + apiConfig.questionBank.questionPool.getDataOnly);
        };

        factory.assignQuestion = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + apiConfig.enrollment.questionEnrollment, data);
        };

        factory.getDataClass = function() {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(base + enrollment.class);
        };

        factory.getDataUserParticipant = function(data, search) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(
                base +
                    enrollment.userParticipant.list +
                    '?page=' +
                    data +
                    '&search=' +
                    search
            );
        };

        factory.groupParticipantPaginate = function(page, search, length) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(
                base +
                    enrollment.groupParticipant.list +
                    '?page=' +
                    page +
                    '&search=' +
                    search +
                    '&length=' +
                    length
            );
        };

        factory.assignUser = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + enrollment.userParticipant.assign, data);
        };

        factory.unassignUser = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + enrollment.userParticipant.unassign, data);
        };

        factory.updateUser = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + enrollment.userParticipant.update, data);
        };

        factory.getDataSession = function(data, search, length) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(
                base +
                    enrollment.session.list +
                    '?page=' +
                    data +
                    '&search=' +
                    search +
                    '&length=' +
                    length
            );
        };

        factory.saveDataSession = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + enrollment.session.save, data);
        };

        factory.updateDataSession = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + enrollment.session.update, data);
        };

        factory.deleteDataSession = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + enrollment.session.delete, data);
        };

        factory.getDataGroupParticipant = function() {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.get(base + enrollment.groupParticipant.data);
        };

        factory.saveDataGroupParticipant = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + enrollment.groupParticipant.save, data);
        };

        factory.updateDataGroupParticipant = function(data) {
            return $http.post(base + enrollment.groupParticipant.update, data);
        };

        factory.deleteDataGroupParticipant = function(data) {
            $http.defaults.useXDomain = true;
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            delete $http.defaults.headers.common['X-Requested-With'];
            return $http.post(base + enrollment.groupParticipant.delete, data);
        };

        return factory;
    }
})();

(function() {
    'use strict';

    angular
        .module('enrollment')
        .controller('EnrollmentController', EnrollmentController);

    /** @ngInject */
    EnrollmentController.$inject = ['$timeout', '$state', '$scope', 'Enrollment'];

    function EnrollmentController($timeout, $state, $scope, Enrollment) {
        var vm = this;
        vm.checkState = checkState;

        activate();

        function activate() {
            $state.go($state.current);
        }

        function checkState() {
            if ($state.current.name == 'app.enrollment') {
                return true;
            }
            return false;
        }
    }
})();

(function() {
    angular
        .module('enrollment')
        .directive('enrollmentToolbar', enrollmentToolbarConfig);

    /** @ngInject */
    function enrollmentToolbarConfig() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/main/modules/enrollment/enrollment-toolbar.html',
            scope: {
                creationDate: '='
            },
            transclude: true,
            controller: enrollmentToolbarController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function enrollmentToolbarController($scope, $location, $window, $state) {
            vm = this;
            vm.$state = $state;
            vm.toggleNav = toggleNav;

            function toggleNav() {
                var x = document.getElementById('myTopnav');
                if (x.className === 'topnav') {
                    x.className += ' responsive';
                } else {
                    x.className = 'topnav';
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('dashboard', []).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('app.dashboard', {
            url: 'dashboard',
            views: {
                'content@app': {
                    templateUrl: 'app/main/modules/dashboard/dashboard.html',
                    controller: 'DashboardController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.dashboard.admin', {
            url: '/admin',
            views: {
                'content@app': {
                    templateUrl: 'app/main/modules/dashboard/dashboard-admin.html',
                    controller: 'DashboardAdminController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function () {
    angular.module("dashboard").factory("Dashboard", DashboardFactory);

    function DashboardFactory($http, appConfig, apiConfig) {
        var factory = {};
        var base = appConfig.appApi;
        var endpoint = apiConfig.assessment;

        factory.getSession = function (uid) {
            return $http.get(base + endpoint.getSession + "/" + uid);
        };

        return factory;
    }
})();

(function () {
    "use strict";

    angular
        .module("dashboard")
        .controller("DashboardController", DashboardController);

    /** @ngInject */
    DashboardController.$inject = [
        "$q",
        "$timeout",
        "$state",
        "$scope",
        "$localStorage",
        "Dashboard",
        "blockUI",
        "appConfig",
    ];

    function DashboardController(
        $q,
        $timeout,
        $state,
        $scope,
        $localStorage,
        Dashboard,
        blockUI,
        appConfig
    ) {
        var vm = this;
        $scope.$state = $state;
        vm.uid = $localStorage.userId;
        vm.username = $localStorage.userName;
        vm.todayClass = false;
        vm.gotoAssessment = gotoAssessment;
        vm.showIntruction = false;
        vm.appName = appConfig.appName;
        vm.session = [];
        vm.isClear = false;

        activate();

        function activate() {
            getSession();
        }

        function gotoAssessment(item) {
            $localStorage.activeSession = item;
            $localStorage.sessionData = item;
            switch (item.session_type) {
                case "tiki":
                    $state.go("app.assessment_tiki", {
                        session_id: item.id,
                    });
                    break;
                case "general":
                    $state.go("app.assessment", {
                        poolId: item.question_pool_id,
                        sessionId: item.id,
                    });
                    break;
                case "papikostik":
                    $state.go("app.assessment-papikostik", {
                        poolId: item.question_pool_id,
                        sessionId: item.id,
                    });
                    break;
                case "intray":
                    $state.go("app.assessment-intray", {
                        poolId: item.question_pool_id,
                        sessionId: item.id,
                    });
                    break;
                case "beq":
                    $state.go("app.assessment-beq", {
                        poolId: item.question_pool_id,
                        sessionId: item.id,
                    });
                    break;
                case "survey":
                    $state.go("app.assessment-survey", {
                        poolId: item.question_pool_id,
                        sessionId: item.id,
                    });
                    break;
                case "behavioral":
                    $state.go("app.assessment-behavioral", {
                        poolId: item.question_pool_id,
                        sessionId: item.id,
                    });
                    break;
                default:
                    console.log("Session type not found");
            }
        }

        function getSession() {
            console.log(vm.uid);
            blockUI.start("Load session data");
            Dashboard.getSession(vm.uid).then(
                function (resp) {
                    if (resp.data.length > 0) {
                        vm.todayClass = true;
                        vm.session = resp.data;
                        vm.showIntruction = true;
                        vm.isClear = false;
                        $timeout(function () {
                            blockUI.stop();
                        }, 2000);
                    } else {
                        $timeout(function () {
                            vm.isClear = true;
                            blockUI.stop();
                        }, 2000);
                    }
                },
                function (err) {
                    $timeout(function () {
                        vm.isClear = true;
                        blockUI.stop();
                    }, 2000);
                    vm.session = [];
                }
            );
        }
    }
})();

(function () {
  angular
    .module('dashboard')
    .factory('DashboardAdmin', DashboardAdminFactory);

  function DashboardAdminFactory(
    $http,
    appConfig,
    apiConfig
  ) {

    var factory = {};
    var base = appConfig.appApi;
    var dashboard = apiConfig.general.dashboard;

    factory.getComponent = function () {
      return $http.get(base + dashboard.getcomponent);
    };

    factory.getlastsubmit = function () {
      return $http.get(base + dashboard.getlastsubmit);
    };



    return factory;

  }

})();

(function() {
    "use strict";

    angular
        .module("dashboard")
        .controller("DashboardAdminController", DashboardAdminController);

    /** @ngInject */
    DashboardAdminController.$inject = [
        "$state",
        "$localStorage",
        "DashboardAdmin",
        "blockUI",
        "appConfig",
        "jwtHelper",
        "SyncFactory"
    ];

    function DashboardAdminController(
        $state,
        $localStorage,
        DashboardAdmin,
        blockUI,
        appConfig,
        jwtHelper,
        SyncFactory
    ) {
        var vm = this;
        vm.labelsQBC = [];
        vm.dataQBC = [];
        vm.lastSubmit = [];
        vm.getDetail = getDetail;
        vm.getLastSubmit = getLastSubmit;
        vm.username = $localStorage.userName;
        vm.optionsQBC = {
            responsive: true,
            maintainAspectRatio: false,
            title: {
                display: true,
                text: "Question By Competency Chart"
            },
            legend: {
                display: true,
                labels: {
                    fontColor: "#000",
                    fontSize: 10
                },
                position: "right"
            }
        };

        activate();

        function activate() {
            getComponents();
            getLastSubmit();
        }

        function getComponents() {
            DashboardAdmin.getComponent().then(
                function(res) {
                    var lenComp = res.data.question_by_competency.length;
                    var data = res.data;
                    vm.data = data;
                    for (var i = 0; i < lenComp; i++) {
                        vm.labelsQBC.push(
                            data.question_by_competency[i].competency.competency
                        );
                        vm.dataQBC.push(data.question_by_competency[i].total);
                    }
                },
                function(err) {
                    console.log(err);
                }
            );
        }

        function getDetail(data) {
            $state.go("app.report.detail", {
                obj: data,
                id: data.achievement_id,
                userId: data.user_id
            });
        }

        function getLastSubmit() {
            DashboardAdmin.getlastsubmit().then(
                function(res) {
                    vm.lastSubmit = res.data.code == 1 ? res.data.data : [];
                },
                function(err) {
                    console.log(err);
                }
            );
        }
    }
})();

(function() {
    "use strict";

    angular.module("assessment_tiki", []).config(config);

    config.$inject = ["$stateProvider"];

    function config($stateProvider) {
        $stateProvider.state("app.assessment_tiki", {
            url: "assessment-tiki/{session_id}",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/modules/assessment-tiki/assessment-tiki.html",
                    controller: "AssessmentTikiController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function() {
    angular
        .module('assessment_tiki')
        .factory('AssessmentTiki', AssessmentTikiFactory);

    function AssessmentTikiFactory(
        $q,
        $http,
        $location,
        appConfig,
        apiConfig,
        $timeout
    ) {
        var factory = {};

        factory.getQuestion = function() {
            return $http.get(
                appConfig.appApi + apiConfig.assessmentTiki.getQuestion
            );
        };

        factory.submit = function(params) {
            return $http.post(
                appConfig.appApi + apiConfig.assessmentTiki.submit,
                params
            );
        };

        return factory;
    }
})();

(function() {
    "use strict";

    angular
        .module("assessment_tiki")
        .controller("AssessmentTikiController", AssessmentTikiController);

    /** @ngInject */
    AssessmentTikiController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "$mdDialog",
        "AssessmentTiki",
        "$localStorage",
        "$stateParams",
        "appConfig",
        "blockUI",
        "$location",
        "$interval",
        "$rootScope"
    ];

    function AssessmentTikiController(
        $timeout,
        $state,
        $scope,
        $mdDialog,
        AssessmentTiki,
        $localStorage,
        $stateParams,
        appConfig,
        blockUI,
        $location,
        $interval,
        $rootScope
    ) {
        var vm = this;
        vm.showMessageNotify = false;
        vm.selectedSection = {};
        vm.section = [];
        vm.timeInterval = -1;
        vm.intervalTimer;
        vm.timeoutNotify;
        vm.intruction = "";
        vm.displayTimer = "00:00";
        vm.showTimer = false;
        vm.guideFinish = false;
        vm.isFetchingData = true;
        vm.startSection = startSection;
        vm.questions = [];
        vm.selectedQuestion = {};
        vm.convertIntToChar = convertIntToChar;
        vm.nextQuestion = nextQuestion;
        vm.prevQuestion = prevQuestion;
        vm.hidePrevious = false;
        vm.sectionIndex = 0;
        vm.isFinished = false;
        vm.submit = submit;
        vm.session_id = $stateParams.session_id;

        activate();

        function activate() {
            if ($localStorage.section) {
                vm.section = $localStorage.section;
                vm.sectionIndex = $localStorage.sectionIndex
                    ? $localStorage.sectionIndex
                    : 0;
                vm.timeInterval =
                    $localStorage.selectedSection.remaining_duration > 0
                        ? $localStorage.selectedSection.remaining_duration
                        : 0;

                vm.isFetchingData = false;
                vm.selectedSection = $localStorage.selectedSection;
                vm.intruction =
                    "assets/guide/" + vm.selectedSection.guide_filename;
                vm.question = vm.selectedSection.question;
                vm.questions = $localStorage.questions;
                vm.selectedQuestion = $localStorage.selectedQuestion;
                if ($localStorage.isLastSection) {
                    vm.isFinished = true;
                } else {
                    vm.isFinished = false;
                    if (vm.selectedSection.is_guide_finished) {
                        vm.intervalTimer = $interval(function() {
                            vm.timeInterval -= 1;
                            vm.selectedSection.remaining_duration =
                                vm.timeInterval;
                            vm.displayTimer = fmtMSS(vm.timeInterval);
                        }, 1000);
                        $rootScope.intervalTimer = vm.intervalTimer;
                    }
                }
            } else {
                getSection();
            }
        }

        function getSection() {
            AssessmentTiki.getQuestion().then(function(response) {
                vm.section = response.data.data;
                setSectionData(vm.section[vm.sectionIndex]);
                $localStorage.section = response.data.data;
            });
        }

        function setSectionData(section) {
            vm.isFetchingData = false;
            vm.selectedSection = section;
            vm.intruction = "assets/guide/" + section.guide_filename;
            vm.selectedSection.is_guide_finished = false;
            vm.question = vm.selectedSection.question;
            vm.questions = section.question[0];
            vm.selectedQuestion = vm.question[0];

            $localStorage.selectedSection = section;
            $localStorage.isFetchingData = vm.isFetchingData;
            $localStorage.question = vm.question;
            $localStorage.questions = vm.questions;
            $localStorage.selectedQuestion = vm.selectedQuestion;
        }

        function setTimer(section) {
            vm.timeInterval = section.duration * 60;
            vm.intervalTimer = $interval(function() {
                vm.timeInterval -= 1;
                vm.selectedSection.remaining_duration = vm.timeInterval;
                vm.displayTimer = fmtMSS(vm.timeInterval);
            }, 1000);
            $rootScope.intervalTimer = vm.intervalTimer;
        }

        $scope.$watch("vm.timeInterval", function(newVal, oldVal) {
            if (newVal !== 0 && newVal === 1) {
                vm.selectedSection.is_guide_finished = true;
                $interval.cancel(vm.intervalTimer);
                vm.timeInterval = 0;
                if ($localStorage.isLastSection) {
                    vm.isFinished = true;
                } else {
                    nextSection();
                }
            }
        });

        function fmtMSS(s) {
            return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
        }

        function startSection() {
            setTimer(vm.selectedSection);
            vm.selectedSection.is_guide_finished = true;
        }

        function convertIntToChar(data) {
            return String.fromCharCode(65 + data);
        }

        function nextQuestion(question, ev) {
            var checked = 0;

            if (angular.isDefined(vm.timeoutNotify)) {
                $timeout.cancel(vm.timeoutNotify);
                vm.showMessageNotify = false;
            }

            question.answer.map(function(val) {
                if (val.selected) {
                    checked += 1;
                }
            });

            if (checked === question.valid_answer_count) {
                if (vm.question[question.index + 1]) {
                    vm.selectedQuestion = vm.question[question.index + 1];
                    $localStorage.selectedQuestion = vm.selectedQuestion;
                } else {
                    if (vm.selectedSection.remaining_duration > 100) {
                        var confirm = $mdDialog
                            .confirm()
                            .title("Confirmation")
                            .textContent(
                                "Anda masih memiliki waktu tersisa untuk menyelesaikan section ini, anda yakin untuk melanjutkan ke session selanjutnya ?"
                            )
                            .ariaLabel("confirmation")
                            .ok("ok")
                            .cancel("cancel");

                        $mdDialog.show(confirm).then(
                            function() {
                                nextSection();
                            },
                            function() {
                                console.log("canceled");
                            }
                        );
                    } else {
                        nextSection();
                    }
                }
            } else {
                vm.showMessageNotify = true;
                vm.timeoutNotify = $timeout(function() {
                    vm.showMessageNotify = false;
                }, 4000);
            }
        }

        function nextSection() {
            if (vm.section[vm.sectionIndex + 1]) {
                setSectionData(vm.section[vm.sectionIndex + 1]);
                vm.sectionIndex += 1;
                $localStorage.sectionIndex = vm.sectionIndex;
                if (angular.isDefined(vm.intervalTimer)) {
                    $interval.cancel(vm.intervalTimer);
                }
                vm.displayTimer = "00:00";
            } else {
                $localStorage.isLastSection = true;
                var confirm = $mdDialog
                    .confirm()
                    .title("Confirmation")
                    .textContent(
                        "Ini adalah section terakhir, kunci semua jawaban ?"
                    )
                    .ariaLabel("confirmation")
                    .ok("ok")
                    .cancel("cancel");

                $mdDialog.show(confirm).then(
                    function() {
                        vm.isFinished = true;
                    },
                    function() {
                        console.log("canceled");
                    }
                );
            }
        }

        function prevQuestion(index) {
            if (index !== 0) {
                vm.selectedQuestion = vm.question[index - 1];
                $localStorage.selectedQuestion = vm.selectedQuestion;
            }
        }

        function submit() {
            blockUI.start("Please wait ..");
            var payload = {
                uid: $localStorage.userId,
                section: vm.section,
                session: vm.session_id
            };
            AssessmentTiki.submit(payload).then(
                function(response) {
                    blockUI.stop();
                    swal(
                        {
                            title: response.data.title,
                            text: response.data.message,
                            type: response.data.type,
                            showCancelButton: false,
                            confirmButtonText: "OK",
                            closeOnConfirm: true
                        },
                        function() {
                            $localStorage.tikiFinished = true;
                            delete $localStorage.sectionIndex;
                            delete $localStorage.selectedSection;
                            delete $localStorage.isFetchingData;
                            delete $localStorage.question;
                            delete $localStorage.questions;
                            delete $localStorage.selectedQuestion;
                            delete $localStorage.sessionTake;
                            delete $localStorage.sessionData;
                            $state.go("app.dashboard");
                        }
                    );
                },
                function(error) {
                    blockUI.stop();
                    swal({
                        title: error.data.title,
                        text: error.data.message,
                        type: error.data.type,
                        showCancelButton: false,
                        confirmButtonText: "OK",
                        closeOnConfirm: true
                    });
                }
            );
        }
    }
})();

(function() {
    "use strict";

    angular.module("assessment_survey", ["ui.tinymce"]).config(config);

    config.$inject = ["$stateProvider"];

    function config($stateProvider) {
        $stateProvider.state("app.assessment-survey", {
            url: "assessment-survey/{poolId}/{sessionId}",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/modules/assessment-survey/assessment-survey.html",
                    controller: "AssessmentSurveyController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function() {
    angular
        .module("assessment_survey")
        .factory("AssessmentSurvey", AssessmentSurvey);

    function AssessmentSurvey(
        $q,
        $http,
        $location,
        appConfig,
        apiConfig,
        $timeout
    ) {
        var factory = {};

        factory.getQuestion = function(data) {
            return $http.post(
                appConfig.appApi + apiConfig.survey.getQuestion,
                data
            );
        };

        factory.submit = function(data) {
            return $http.post(appConfig.appApi + apiConfig.survey.submit, data);
        };

        factory.syncTemp = function(data) {
            return $http.post(
                appConfig.appApi + apiConfig.survey.syncTemp,
                data
            );
        };

        return factory;
    }
})();

(function() {
    "use strict";

    angular
        .module("assessment_survey")
        .controller("AssessmentSurveyController", AssessmentSurveyController);

    /** @ngInject */
    AssessmentSurveyController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "$localStorage",
        "$stateParams",
        "appConfig",
        "blockUI",
        "$location",
        "$interval",
        "$rootScope",
        "AssessmentSurvey",
        "toastr",
        "$q"
    ];

    function AssessmentSurveyController(
        $timeout,
        $state,
        $scope,
        $localStorage,
        $stateParams,
        appConfig,
        blockUI,
        $location,
        $interval,
        $rootScope,
        AssessmentSurvey,
        toastr,
        $q
    ) {
        var vm = this;
        var block = blockUI.instances.get("block-playground");

        vm.data = {
            normal: [],
            essay: []
        };

        vm.tinyMceOptions = {
            menubar: false,
            toolbar:
                "undo redo | bold italic | alignleft aligncenter alignright | code",
            skin: "lightgray"
        };

        vm.submit = submit;
        vm.displayTimer = "00:00";
        vm.isSync = false;
        vm.timeInterval = -1;
        vm.timerAssessment;
        vm.syncMessage = "";
        vm.disabledSubmit = false;

        activate();

        function activate() {
            $localStorage.sessionTake = $stateParams.sessionId;
            if ($stateParams.poolId) {
                var payload = {
                    pool_id: $stateParams.poolId,
                    session_id: $stateParams.sessionId,
                    uid: $localStorage.userId,
                    session_type: "survey"
                };
                loadData(payload)
                    .then(function() {
                        setTimer().then(function() {
                            block.stop();
                            vm.runCheck = !vm.runCheck;
                        });
                    })
                    .catch(function(err) {
                        block.stop();
                    });
            }
        }

        function setTimer() {
            var defer = $q.defer();
            vm.timeInterval = vm.data.remaining_times;
            if (vm.timeInterval === 0) {
                defer.resolve();
            } else {
                vm.timerAssessment = $interval(function() {
                    vm.timeInterval -= 1;
                    if (angular.isDefined(vm.data.remaining_times)) {
                        vm.data.remaining_times = vm.timeInterval;
                    }

                    var toMinute = parseInt(vm.timeInterval);
                    console.log(toMinute);
                    if (toMinute % 30 === 0) {
                        if (!vm.isSync) {
                            syncTemporary(vm.data);
                            autoSave("Saving current progress");
                        }
                    }
                    vm.displayTimer = fmtMSS(vm.timeInterval);
                }, 1000);
                defer.resolve();
                $rootScope.timerAssessment = vm.timerAssessment;
            }
            return defer.promise;
        }

        function syncTemporary(payload) {
            var defer = $q.defer();
            var request = AssessmentSurvey.syncTemp(payload);
            vm.isSync = true;
            request.then(
                function(res) {
                    $timeout(function() {
                        vm.isSync = false;
                    }, 5000);
                    defer.resolve(res.data);
                },
                function(err) {
                    defer.reject(err);
                    $timeout(function() {
                        vm.isSync = false;
                    }, 5000);
                    defer.reject(err.data);
                }
            );
            return defer.promise;
        }

        function fmtMSS(s) {
            return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
        }

        function showMessage(status, message) {
            switch (status) {
                case "success":
                    toastr.success(message);
                    break;
                case "warning":
                    toastr.warning(message);
                    break;
                case "error":
                    toastr.error(message);
                    break;
                case "info":
                    toastr.info(message);
                    break;
            }
        }

        function loadData(params) {
            var defer = $q.defer();
            var request = AssessmentSurvey.getQuestion(params);
            request.then(
                function(response) {
                    vm.data = response.data;
                    if (vm.data.is_init) {
                        syncTemporary(vm.data).then(function(res) {
                            $localStorage.at_data = vm.data;
                            defer.resolve();
                        });
                    } else {
                        $localStorage.at_data = vm.data;
                        defer.resolve();
                    }
                },
                function(err) {
                    defer.reject();
                }
            );
            return defer.promise;
        }

        function submit(ev) {
            vm.disabledSubmit = true;
            $timeout(function() {
                var isInvalid = false;
                for (var i = 0; i < vm.data.questions.normal.length; i++) {
                    if (!vm.data.questions.normal[i].selected) {
                        showMessage(
                            "warning",
                            "Pernyataan no " +
                                vm.data.questions.normal[i].number +
                                " belum di jawab"
                        );
                        isInvalid = true;
                        break;
                    }
                }
                for (var i = 0; i < vm.data.questions.essay.length; i++) {
                    if (!vm.data.questions.essay[i].answer) {
                        showMessage(
                            "warning",
                            "Essay ' " +
                                vm.data.questions.essay[i].question +
                                " ' belum di jawab"
                        );
                        isInvalid = true;
                        break;
                    }
                }

                vm.disabledSubmit = false;

                if (isInvalid) {
                    return;
                }

                saveData();
            }, 500);
        }

        function saveData() {
            vm.disabledSubmit = true;
            block.start({ message: "Please wait" });
            var request = AssessmentSurvey.submit(vm.data);
            request.then(
                function(res) {
                    block.stop();
                    vm.disabledSubmit = false;
                    delete $localStorage.sessionTake;
                    if (angular.isDefined(vm.timerAssessment)) {
                        $interval.cancel(vm.timerAssessment);
                    }
                    responseDialog(res, "app.dashboard", 1);
                },
                function(res) {
                    block.stop();
                    vm.disabledSubmit = false;
                    responseDialog(res, null, 2);
                }
            );
        }

        function responseDialog(response, $state, type) {
            swal(
                {
                    title: response.data.title,
                    text: response.data.message,
                    type: response.data.type,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                },
                function() {
                    goTo(type, $state);
                }
            );
        }

        function goTo(type, state) {
            if (type == 1) {
                $state.go(state);
            } else {
                $state.reload();
            }
        }

        function showMessage(status, message) {
            switch (status) {
                case "success":
                    toastr.success(message);
                    break;
                case "warning":
                    toastr.warning(message);
                    break;
                case "error":
                    toastr.error(message);
                    break;
                case "info":
                    toastr.info(message);
                    break;
            }
        }

        function autoSave(message) {
            showMessage("info", message);
        }

        $scope.$watch("vm.timeInterval", function(nval, oval) {
            if (nval == 0) {
                vm.disabledAnswer = true;
                vm.tinyMceOptions.toolbar = false;
                if (angular.isDefined(vm.timerAssessment)) {
                    $interval.cancel(vm.timerAssessment);
                }
                block.start({ message: "Prepare to submit request" });
                $timeout(function() {
                    saveData();
                }, 3000);
            }
        });
    }
})();

(function() {
    angular
        .module('assessment_papikostik', [])
        .factory('AssessmentPapikostik', AssessmentPapikostik);

    function AssessmentPapikostik($http, appConfig, apiConfig, $resource) {
        var factory = {};
        var base = appConfig.appApi;

        factory.getQuestion = function(data) {
            return $http.post(base + apiConfig.papikostik.assessment.question, data);
        };

        factory.syncTemp = function(data) {
            return $http.post(base + apiConfig.papikostik.assessment.syncTemp, data);
        };

        factory.submit = function(data) {
            return $http.post(base + apiConfig.papikostik.assessment.submit, data);
        };

        return factory;
    }
})();

(function() {
    "use strict";

    angular
        .module("assessment_papikostik", [])
        .controller(
            "AssessmentPapikostikController",
            AssessmentPapikostikController
        );

    /** @ngInject */
    AssessmentPapikostikController.$inject = [
        "$q",
        "$timeout",
        "$state",
        "$scope",
        "$mdDialog",
        "$localStorage",
        "$stateParams",
        "appConfig",
        "blockUI",
        "$location",
        "$interval",
        "$rootScope",
        "AssessmentPapikostik",
        "$mdToast"
    ];

    function AssessmentPapikostikController(
        $q,
        $timeout,
        $state,
        $scope,
        $mdDialog,
        $localStorage,
        $stateParams,
        appConfig,
        blockUI,
        $location,
        $interval,
        $rootScope,
        AssessmentPapikostik,
        $mdToast
    ) {
        var vm = this;
        var block = blockUI.instances.get("block-playground");
        vm.data = {
            questions: []
        };
        vm.questions = [];
        vm.runCheck = true;
        vm.progressWidth = {
            width: "0%",
            background: "#d32f2f",
            content: "0%"
        };
        vm.displayTimer = "00:00";
        vm.timeInterval = -1;
        vm.timerAssessment;
        vm.isSync = false;
        vm.syncMessage = "";
        vm.submit = submit;
        vm.submitConfirmation = submitConfirmation;
        vm.disabledFinish = true;

        activate();

        function activate() {
            block.start({ message: "Please Wait" });
            if ($stateParams.poolId) {
                var payload = {
                    pool_id: $stateParams.poolId,
                    session_id: $stateParams.sessionId,
                    uid: $localStorage.userId,
                    session_type: "papikostik"
                };
                $localStorage.sessionTake = $stateParams.sessionId;
                getQuestion(payload)
                    .then(function() {
                        setTimer().then(function() {
                            block.stop();
                            vm.runCheck = !vm.runCheck;
                        });
                    })
                    .catch(function(err) {
                        block.stop();
                    });
            }
        }

        function setTimer() {
            var defer = $q.defer();
            vm.timeInterval = vm.data.remaining_times;
            if (vm.timeInterval === 0) {
                lockQuestion();
                vm.disabledFinish = false;
                defer.resolve();
            } else {
                vm.timerAssessment = $interval(function() {
                    vm.timeInterval -= 1;
                    if (angular.isDefined(vm.data.remaining_times)) {
                        vm.data.remaining_times = vm.timeInterval;
                    }

                    var toMinute = vm.timeInterval / 60;
                    if (toMinute % 2 === 0) {
                        if (!vm.isSync) {
                            syncTemporary(vm.data);
                        }
                    }
                    vm.displayTimer = fmtMSS(vm.timeInterval);
                }, 1000);
                defer.resolve();
                $rootScope.timerAssessment = vm.timerAssessment;
            }
            return defer.promise;
        }

        function getQuestion(params) {
            var defer = $q.defer();
            var request = AssessmentPapikostik.getQuestion(params);
            request.then(
                function(response) {
                    vm.data = response.data;
                    if (vm.data.is_init) {
                        syncTemporary(vm.data).then(function(res) {
                            $localStorage.at_data = vm.data;
                            defer.resolve();
                        });
                    } else {
                        $localStorage.at_data = vm.data;
                        syncResponse("Bringing Back Last Session");
                        defer.resolve();
                    }
                },
                function(err) {
                    console.log(err);
                    defer.reject();
                }
            );
            return defer.promise;
        }

        $scope.$watch("vm.runCheck", function(nVal, oVal) {
            var counter = 0;
            vm.data.questions.map(function(val) {
                if (val.selected) {
                    counter += 1;
                }
            });
            var calculation = (counter / vm.data.questions.length) * 100;
            if (calculation) {
                if (calculation >= 25) {
                    vm.progressWidth.background = "#1976d2";
                } else if (calculation >= 50) {
                    vm.progressWidth.background = "#039be5";
                } else if (calculation >= 75) {
                    vm.progressWidth.background = "#43a047";
                }

                if (calculation === 100) {
                    vm.disabledFinish = false;
                }
                checkSync(calculation);
                vm.progressWidth.width = Math.round(calculation) + "%";
            }
        });

        function fmtMSS(s) {
            return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
        }

        $scope.$on("onBeforeUnload", function(e, confirmation) {
            confirmation.message = "All data willl be lost.";
            e.preventDefault();
        });

        $scope.$on("$destroy", function() {
            syncTemporary(vm.data).then(function() {
                delete $localStorage.at_data;
            });
        });

        function syncTemporary(payload) {
            var defer = $q.defer();
            var request = AssessmentPapikostik.syncTemp(payload);
            vm.isSync = true;
            request.then(
                function(res) {
                    $timeout(function() {
                        vm.isSync = false;
                    }, 20000);
                    defer.resolve(res.data);
                },
                function(err) {
                    defer.reject(err);
                    $timeout(function() {
                        vm.isSync = false;
                    }, 20000);
                    defer.reject(err.data);
                }
            );
            return defer.promise;
        }

        function submit() {
            block.start({ message: "Please Wait, Submitting Request" });
            var request = AssessmentPapikostik.submit(vm.data);
            request.then(
                function(res) {
                    console.log(res);
                    block.stop();
                    delete $localStorage.sessionTake;
                    responseDialog(res.data, "success", true);
                },
                function(err) {
                    console.log(err);
                    block.stop();
                    responseDialog(err.data, "warn", false);
                }
            );
        }

        function lockQuestion() {
            vm.disabledFinish = false;
            vm.data.questions.map(function(val) {
                val.disabled = true;
            });
        }

        function responseDialog(response, type, status) {
            swal(
                {
                    title: response.title,
                    text: response.message,
                    type: type,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                },
                function() {
                    if (status) {
                        $state.go("app.dashboard");
                    }
                }
            );
        }

        function checkSync(calculation) {
            switch (calculation) {
                case 25:
                case 50:
                case 75:
                case 100:
                    if (!vm.isSync) {
                        syncTemporary(vm.data).then(function() {
                            syncResponse("Saving Progress");
                        });
                    }
                    break;
            }
        }

        function submitConfirmation() {
            var isHaveTime = isStillHaveTime();
            if (isHaveTime.status) {
                swal(
                    {
                        title: isHaveTime.title,
                        text: isHaveTime.message,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function(isConfirm) {
                        if (isConfirm) {
                            submit();
                        }
                    }
                );
            } else {
                submit();
            }
        }

        function isStillHaveTime() {
            var response = {
                status: false,
                title: "",
                message: ""
            };

            if (vm.timeInterval > 300) {
                response.status = true;
                response.title = "Are you sure to submit this test ?";
                response.message = "You still have time to check your answer";
            } else if (vm.timeInterval < 300 && vm.timeInterval > 100) {
                response.status = true;
                response.title = "Are you sure to submit this test ?";
                response.message = "Be careful, this will ended your test";
            }

            return response;
        }

        function syncResponse(message) {
            $mdToast
                .show(
                    $mdToast
                        .simple()
                        .textContent(message)
                        .position("bottom right")
                        .hideDelay(2000)
                )
                .then(function() {
                    console.log("Toast dismissed.");
                })
                .catch(function() {
                    console.log(
                        "Toast failed or was forced to close early by another toast."
                    );
                });
        }

        $scope.$watch("vm.timeInterval", function(nval, oval) {
            if (nval == 0) {
                lockQuestion();
                if (angular.isDefined(vm.timerAssessment)) {
                    $interval.cancel(vm.timerAssessment);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('assessment_intray', ['ui.tinymce'])
        .config(config)
        .directive('disableRightClick', function() {
            return {
                restrict: 'A',
                link: function(scope, element, attr) {
                    element.bind('contextmenu', function(e) {
                        e.preventDefault();
                    });
                }
            };
        });

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('app.assessment-intray', {
            url: 'assessment-intray/{poolId}/{sessionId}',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/modules/assessment-intray/assessment-intray.html',
                    controller: 'AssessmentIntrayController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function() {
    angular
        .module('assessment_intray')
        .factory('AssessmentIntray', AssessmentIntray);

    function AssessmentIntray($http, appConfig, apiConfig, $resource) {
        var factory = {};
        var base = appConfig.appApi;

        factory.getQuestion = function(data) {
            return $http.post(base + apiConfig.intray.assessment.question, data);
        };

        factory.syncTemp = function(data) {
            return $http.post(base + apiConfig.intray.assessment.syncTemp, data);
        };

        factory.submit = function(data) {
            return $http.post(base + apiConfig.intray.assessment.submit, data);
        };

        return factory;
    }
})();

(function() {
    "use strict";

    angular
        .module("assessment_intray")
        .controller("AssessmentIntrayController", AssessmentIntrayController);

    /** @ngInject */
    AssessmentIntrayController.$inject = [
        "$q",
        "$timeout",
        "$state",
        "$scope",
        "$mdDialog",
        "$localStorage",
        "$stateParams",
        "appConfig",
        "blockUI",
        "$location",
        "$interval",
        "$rootScope",
        "AssessmentIntray",
        "$sce",
        "$mdToast",
        "$appHelper"
    ];

    function AssessmentIntrayController(
        $q,
        $timeout,
        $state,
        $scope,
        $mdDialog,
        $localStorage,
        $stateParams,
        appConfig,
        blockUI,
        $location,
        $interval,
        $rootScope,
        AssessmentIntray,
        $sce,
        $mdToast,
        $appHelper
    ) {
        var vm = this;
        var block = blockUI.instances.get("block-playground");
        vm.data = {
            questions: []
        };
        vm.disableRightclick = disableRightclick;
        vm.getQuestionUrl = getQuestionUrl;
        vm.tinyMceOptions = {
            menubar: false,
            toolbar:
                "undo redo | bold italic | alignleft aligncenter alignright | code",
            skin: "lightgray"
        };
        vm.displayTimer = "00:00";
        vm.submit = submit;
        vm.isSync = false;
        vm.timeInterval = -1;
        vm.timerAssessment;
        vm.syncMessage = "";
        vm.disabledAnswer = false;

        activate();

        function activate() {
            if ($stateParams.poolId) {
                var payload = {
                    pool_id: $stateParams.poolId,
                    session_id: $stateParams.sessionId,
                    uid: $localStorage.userId,
                    session_type: "intray"
                };
                $localStorage.sessionTake = $stateParams.sessionId;
                getQuestion(payload)
                    .then(function() {
                        setTimer().then(function() {
                            block.stop();
                            vm.runCheck = !vm.runCheck;
                        });
                    })
                    .catch(function(err) {
                        block.stop();
                    });
            }
        }

        function getQuestion(params) {
            var defer = $q.defer();
            var request = AssessmentIntray.getQuestion(params);
            request.then(
                function(response) {
                    vm.data = response.data;
                    if (vm.data.is_init) {
                        syncTemporary(vm.data).then(function(res) {
                            $localStorage.at_data = vm.data;
                            defer.resolve();
                        });
                    } else {
                        $localStorage.at_data = vm.data;
                        defer.resolve();
                    }
                },
                function(err) {
                    defer.reject();
                }
            );
            return defer.promise;
        }

        function setTimer() {
            var defer = $q.defer();
            vm.timeInterval = vm.data.remaining_times;
            if (vm.timeInterval === 0) {
                defer.resolve();
            } else {
                vm.timerAssessment = $interval(function() {
                    vm.timeInterval -= 1;
                    if (angular.isDefined(vm.data.remaining_times)) {
                        vm.data.remaining_times = vm.timeInterval;
                    }

                    var toMinute = vm.timeInterval / 60;
                    if (toMinute % 2 === 0) {
                        if (!vm.isSync) {
                            syncTemporary(vm.data);
                            autoSave("Saving current progress");
                        }
                    }
                    vm.displayTimer = fmtMSS(vm.timeInterval);
                }, 1000);
                defer.resolve();
                $rootScope.timerAssessment = vm.timerAssessment;
            }
            return defer.promise;
        }

        function syncTemporary(payload) {
            var defer = $q.defer();
            var request = AssessmentIntray.syncTemp(payload);
            vm.isSync = true;
            request.then(
                function(res) {
                    $timeout(function() {
                        vm.isSync = false;
                    }, 5000);
                    defer.resolve(res.data);
                },
                function(err) {
                    defer.reject(err);
                    $timeout(function() {
                        vm.isSync = false;
                    }, 5000);
                    defer.reject(err.data);
                }
            );
            return defer.promise;
        }

        function fmtMSS(s) {
            return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
        }

        function getQuestionUrl(questionId) {
            return $sce.trustAsResourceUrl(
                appConfig.appApi +
                    "/storage/intray/" +
                    questionId +
                    "#toolbar=0"
            );
        }

        function disableRightclick(evt) {
            if (evt.button == 2) {
                return false;
            }
        }

        function submit() {
            block.start({ message: "Please Wait, Submitting Request" });
            var request = AssessmentIntray.submit(vm.data);
            request.then(
                function(res) {
                    block.stop();
                    if (angular.isDefined(vm.timerAssessment)) {
                        $interval.cancel(vm.timerAssessment);
                    }
                    delete $localStorage.sessionTake;
                    responseDialog(res.data, "success", true);
                },
                function(err) {
                    block.stop();
                    responseDialog(err.data, "warn", false);
                }
            );
        }

        function responseDialog(response, type, status) {
            swal(
                {
                    title: response.title,
                    text: response.message,
                    type: type,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                },
                function() {
                    if (status) {
                        $state.go("app.dashboard");
                    }
                }
            );
        }

        function autoSave(message) {
            $mdToast
                .show(
                    $mdToast
                        .simple()
                        .textContent(message)
                        .position("bottom right")
                        .hideDelay(2000)
                )
                .then(function() {
                    console.log("Toast dismissed.");
                })
                .catch(function() {
                    console.log(
                        "Toast failed or was forced to close early by another toast."
                    );
                });
        }

        $scope.$watch("vm.timeInterval", function(nval, oval) {
            if (nval == 0) {
                vm.disabledAnswer = true;
                vm.tinyMceOptions.toolbar = false;
                if (angular.isDefined(vm.timerAssessment)) {
                    $interval.cancel(vm.timerAssessment);
                }
            }
        });
    }
})();

(function() {
    "use strict";

    angular.module("assessment_beq", ["ui.tinymce"]).config(config);

    config.$inject = ["$stateProvider"];

    function config($stateProvider) {
        $stateProvider.state("app.assessment-beq", {
            url: "assessment-beq/{poolId}/{sessionId}",
            views: {
                "content@app": {
                    templateUrl:
                        "app/main/modules/assessment-beq/assessment-beq.html",
                    controller: "AssessmentBeqController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function() {
    angular.module("assessment_beq").factory("AssessmentBeq", AssessmentBeq);

    function AssessmentBeq(
        $q,
        $http,
        $location,
        appConfig,
        apiConfig,
        $timeout
    ) {
        var factory = {};

        factory.getQuestion = function(data) {
            return $http.post(
                appConfig.appApi + apiConfig.beq.getQuestion,
                data
            );
        };

        factory.submit = function(data) {
            return $http.post(appConfig.appApi + apiConfig.beq.submit, data);
        };

        factory.syncTemp = function(data) {
            return $http.post(appConfig.appApi + apiConfig.beq.syncTemp, data);
        };

        return factory;
    }
})();


(function() {
    angular.module("assessment_beq").factory("AssessmentBeq", AssessmentBeq);

    function AssessmentBeq(
        $q,
        $http,
        $location,
        appConfig,
        apiConfig,
        $timeout
    ) {
        var factory = {};

        factory.getQuestion = function(data) {
            return $http.post(
                appConfig.appApi + apiConfig.beq.getQuestion,
                data
            );
        };

        factory.submit = function(data) {
            return $http.post(appConfig.appApi + apiConfig.beq.submit, data);
        };

        factory.syncTemp = function(data) {
            return $http.post(appConfig.appApi + apiConfig.beq.syncTemp, data);
        };

        return factory;
    }
})();

(function() {
    "use strict";

    angular
        .module("assessment_beq")
        .controller("AssessmentBeqController", AssessmentBeqController);

    /** @ngInject */
    AssessmentBeqController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "$localStorage",
        "$stateParams",
        "appConfig",
        "blockUI",
        "$location",
        "$interval",
        "$rootScope",
        "AssessmentBeq",
        "$anchorScroll",
        "$q",
        "toastr"
    ];

    function AssessmentBeqController(
        $timeout,
        $state,
        $scope,
        $localStorage,
        $stateParams,
        appConfig,
        blockUI,
        $location,
        $interval,
        $rootScope,
        AssessmentBeq,
        $anchorScroll,
        $q,
        toastr
    ) {
        var vm = this;
        var block = blockUI.instances.get("block-playground");

        vm.data = {
            questions: []
        };

        vm.tinyMceOptions = {
            menubar: false,
            toolbar:
                "undo redo | bold italic | alignleft aligncenter alignright | code",
            skin: "lightgray"
        };

        vm.submit = submit;
        vm.goToQuestion = goToQuestion;
        vm.displayTimer = "00:00";
        vm.isSync = false;
        vm.timeInterval = -1;
        vm.timerAssessment;
        vm.syncMessage = "";
        vm.disabledSubmit = false;

        activate();

        function activate() {
            $localStorage.sessionTake = $stateParams.sessionId;
            if ($stateParams.poolId) {
                var payload = {
                    pool_id: $stateParams.poolId,
                    session_id: $stateParams.sessionId,
                    uid: $localStorage.userId,
                    session_type: "beq"
                };
                loadData(payload)
                    .then(function() {
                        setTimer().then(function() {
                            block.stop();
                            vm.runCheck = !vm.runCheck;
                        });
                    })
                    .catch(function(err) {
                        block.stop();
                    });
            }
        }

        function setTimer() {
            var defer = $q.defer();
            vm.timeInterval = vm.data.remaining_times;
            if (vm.timeInterval === 0) {
                defer.resolve();
            } else {
                vm.timerAssessment = $interval(function() {
                    vm.timeInterval -= 1;
                    if (angular.isDefined(vm.data.remaining_times)) {
                        vm.data.remaining_times = vm.timeInterval;
                    }

                    var toMinute = parseInt(vm.timeInterval);
                    console.log(toMinute);
                    if (toMinute % 30 === 0) {
                        if (!vm.isSync) {
                            syncTemporary(vm.data);
                            autoSave("Saving current progress");
                        }
                    }
                    vm.displayTimer = fmtMSS(vm.timeInterval);
                }, 1000);
                defer.resolve();
                $rootScope.timerAssessment = vm.timerAssessment;
            }
            return defer.promise;
        }

        function syncTemporary(payload) {
            var defer = $q.defer();
            var request = AssessmentBeq.syncTemp(payload);
            vm.isSync = true;
            request.then(
                function(res) {
                    $timeout(function() {
                        vm.isSync = false;
                    }, 5000);
                    defer.resolve(res.data);
                },
                function(err) {
                    defer.reject(err);
                    $timeout(function() {
                        vm.isSync = false;
                    }, 5000);
                    defer.reject(err.data);
                }
            );
            return defer.promise;
        }

        function fmtMSS(s) {
            return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
        }

        function showMessage(status, message) {
            switch (status) {
                case "success":
                    toastr.success(message);
                    break;
                case "warning":
                    toastr.warning(message);
                    break;
                case "error":
                    toastr.error(message);
                    break;
                case "info":
                    toastr.info(message);
                    break;
            }
        }

        function loadData(params) {
            var defer = $q.defer();
            var request = AssessmentBeq.getQuestion(params);
            request.then(
                function(response) {
                    vm.data = response.data;
                    if (vm.data.is_init) {
                        syncTemporary(vm.data).then(function(res) {
                            $localStorage.at_data = vm.data;
                            defer.resolve();
                        });
                    } else {
                        $localStorage.at_data = vm.data;
                        defer.resolve();
                    }
                },
                function(err) {
                    defer.reject();
                }
            );
            return defer.promise;
        }

        function submit(ev) {
            vm.disabledSubmit = true;
            $timeout(function() {
                var isValid = true;
                for (var i = 0; i < vm.data.questions.length; i++) {
                    if (!vm.data.questions[i].answer) {
                        vm.data.questions[i].is_valid = false;
                        isValid = false;
                    } else {
                        vm.data.questions[i].is_valid = true;
                    }
                }

                if (!isValid) {
                    vm.disabledSubmit = false;
                    return;
                } else {
                    vm.disabledSubmit = false;
                    saveData();
                }
            }, 500);
        }

        function saveData() {
            vm.disabledSubmit = true;
            block.start({ message: "Please wait" });
            var request = AssessmentBeq.submit(vm.data);
            request.then(
                function(res) {
                    block.stop();
                    delete $localStorage.sessionTake;
                    if (angular.isDefined(vm.timerAssessment)) {
                        $interval.cancel(vm.timerAssessment);
                    }
                    vm.disabledSubmit = false;
                    responseDialog(res, "app.dashboard", 1);
                },
                function(res) {
                    block.stop();
                    vm.disabledSubmit = false;
                    responseDialog(res, null, 2);
                }
            );
        }

        function responseDialog(response, $state, type) {
            swal(
                {
                    title: response.data.title,
                    text: response.data.message,
                    type: response.data.type,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                },
                function() {
                    goTo(type, $state);
                }
            );
        }

        function goTo(type, state) {
            if (type == 1) {
                $state.go(state);
            } else {
                $state.reload();
            }
        }

        function goToQuestion(id) {
            var newHash = "anchor_" + id;
            if ($location.hash() !== newHash) {
                $location.hash("anchor_" + id);
            } else {
                $anchorScroll();
            }
        }

        function autoSave(message) {
            showMessage("info", message);
        }

        $scope.$watch("vm.timeInterval", function(nval, oval) {
            if (nval == 0) {
                vm.disabledAnswer = true;
                vm.tinyMceOptions.toolbar = false;
                if (angular.isDefined(vm.timerAssessment)) {
                    $interval.cancel(vm.timerAssessment);
                }
                block.start({ message: "Prepare to submit request" });
                $timeout(function() {
                    saveData();
                }, 3000);
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('assessment_behavioral', []).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('app.assessment-behavioral', {
            url: 'assessment-behavioral/{poolId}/{sessionId}',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/modules/assessment-behavioral/assessment-behavioral.html',
                    controller: 'AssessmentBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function() {
    angular
        .module('assessment_behavioral')
        .factory('AssessmentBehavioral', AssessmentBehavioral);

    function AssessmentBehavioral($http, appConfig, apiConfig, $resource) {
        var factory = {};
        var base = appConfig.appApi;

        factory.getQuestion = function(data) {
            return $http.post(base + apiConfig.behavioral.assessment.question, data);
        };

        factory.syncTemp = function(data) {
            return $http.post(base + apiConfig.behavioral.assessment.syncTemp, data);
        };

        factory.submit = function(data) {
            return $http.post(base + apiConfig.behavioral.assessment.submit, data);
        };

        return factory;
    }
})();

(function() {
    "use strict";

    angular
        .module("assessment_behavioral")
        .controller(
            "AssessmentBehavioralController",
            AssessmentBehavioralController
        );

    /** @ngInject */
    AssessmentBehavioralController.$inject = [
        "$q",
        "$timeout",
        "$state",
        "$scope",
        "$mdDialog",
        "$localStorage",
        "$stateParams",
        "appConfig",
        "blockUI",
        "$location",
        "$interval",
        "$rootScope",
        "AssessmentBehavioral",
        "$mdToast",
        "BehavioralQuality"
    ];

    function AssessmentBehavioralController(
        $q,
        $timeout,
        $state,
        $scope,
        $mdDialog,
        $localStorage,
        $stateParams,
        appConfig,
        blockUI,
        $location,
        $interval,
        $rootScope,
        AssessmentBehavioral,
        $mdToast,
        BehavioralQuality
    ) {
        var vm = this;
        var block = blockUI.instances.get("block-playground");
        vm.data = {
            questions: []
        };
        vm.questions = [];
        vm.runCheck = true;
        vm.progressWidth = {
            width: "0%",
            background: "#d32f2f",
            content: "0%"
        };
        vm.displayTimer = "00:00";
        vm.timeInterval = -1;
        vm.timerAssessment;
        vm.isSync = false;
        vm.syncMessage = "";
        vm.submit = submit;
        vm.submitConfirmation = submitConfirmation;
        vm.disabledFinish = true;
        vm.pad2 = pad2;
        vm.qualities = [];
        vm.onQualityChange = onQualityChange;
        vm.scrollToQuestion = scrollToQuestion;
        vm.getNavigationClass = getNavigationClass;
        vm.activeQuestionIndex = 0;
        vm.colors = [
            '#59d20e',
            '#0f63ad',
            '#c59f05',
            '#c20303'
        ]

        activate();

        function pad2(number) {
            return (number < 10 ? "0" : "") + number;
        }

        function onQualityChange() {
            // Ensure only one answer in a question uses the same quality
            vm.runCheck = !vm.runCheck;
        }

        function hasReason(item) {
            if (!item || item.reason === null || item.reason === undefined) {
                return false;
            }

            return item.reason.toString().trim().length > 0;
        }

        function getNavigationClass(item, index) {
            var hasAnswer = !!(item && item.selectedAnswer);
            var reasonFilled = hasReason(item);
            var isPartial = (hasAnswer || reasonFilled) && !(hasAnswer && reasonFilled);
            var isComplete = hasAnswer && reasonFilled;

            return {
                active: vm.activeQuestionIndex === index,
                partial: isPartial,
                complete: isComplete
            };
        }

        function isQuestionComplete(item) {
            var hasAnswer = !!(item && item.selectedAnswer);
            var reasonFilled = hasReason(item);

            return hasAnswer && reasonFilled;
        }

        function findFirstIncompleteQuestionIndex() {
            if (!vm.data || !vm.data.questions || !vm.data.questions.length) {
                return -1;
            }

            for (var i = 0; i < vm.data.questions.length; i++) {
                if (!isQuestionComplete(vm.data.questions[i])) {
                    return i;
                }
            }

            return -1;
        }

        function scrollToQuestion(index) {
            vm.activeQuestionIndex = index;

            $timeout(function() {
                var wrapper = document.getElementById("question-wrapper");
                var target = document.getElementById("question-item-" + index);

                if (!wrapper || !target) {
                    return;
                }

                var targetTop = target.offsetTop - 12;
                if (targetTop < 0) {
                    targetTop = 0;
                }

                if ("scrollBehavior" in document.documentElement.style && typeof wrapper.scrollTo === "function") {
                    wrapper.scrollTo({
                        top: targetTop,
                        behavior: "smooth"
                    });
                    return;
                }

                wrapper.scrollTop = targetTop;
            }, 0);
        }

        function normalizeQualities() {
            if (!vm.data.questions) {
                return;
            }

            vm.data.questions.forEach(function(item) {
                var used = {};

                item.answers.forEach(function(answer) {
                    if (!answer.quality_id) {
                        return;
                    }
                    if (used[answer.quality_id]) {
                        answer.quality_id = null;
                    } else {
                        used[answer.quality_id] = true;
                    }
                });

                item.selected = item.answers.every(function(a) {
                    return a.quality_id;
                });
            });
        }

        function activate() {
            block.start({ message: "Please Wait" });
            BehavioralQuality.get(1, '', 20).then(function(data) {
                vm.qualities = data.data.data;
                console.log(vm.qualities);
            })
            if ($stateParams.poolId) {
                var payload = {
                    pool_id: $stateParams.poolId,
                    session_id: $stateParams.sessionId,
                    uid: $localStorage.userId,
                    session_type: "behavioral"
                };
                $localStorage.sessionTake = $stateParams.sessionId;
                getQuestion(payload)
                    .then(function() {
                        setTimer().then(function() {
                            block.stop();
                            vm.runCheck = !vm.runCheck;
                        });
                    })
                    .catch(function(err) {
                        block.stop();
                    });
            }
        }

        function setTimer() {
            var defer = $q.defer();
            vm.timeInterval = vm.data.remaining_times;
            if (vm.timeInterval === 0) {
                lockQuestion();
                vm.disabledFinish = false;
                defer.resolve();
            } else {
                vm.timerAssessment = $interval(function() {
                    vm.timeInterval -= 1;
                    if (angular.isDefined(vm.data.remaining_times)) {
                        vm.data.remaining_times = vm.timeInterval;
                    }

                    var toMinute = vm.timeInterval / 60;
                    if (toMinute % 2 === 0) {
                        if (!vm.isSync) {
                            syncTemporary(vm.data);
                        }
                    }
                    vm.displayTimer = fmtMSS(vm.timeInterval);
                }, 1000);
                defer.resolve();
                $rootScope.timerAssessment = vm.timerAssessment;
            }
            return defer.promise;
        }



        function getQuestion(params) {
            var defer = $q.defer();
            var request = AssessmentBehavioral.getQuestion(params);
            request.then(
                function(response) {
                    vm.data = response.data;
                    vm.activeQuestionIndex = 0;
                    normalizeQualities();
                    console.log(vm.data);
                    if (vm.data.is_init) {
                        syncTemporary(vm.data).then(function(res) {
                            $localStorage.at_data = vm.data;
                            defer.resolve();
                        });
                    } else {
                        $localStorage.at_data = vm.data;
                        syncResponse("Bringing Back Last Session");
                        defer.resolve();
                    }
                },
                function(err) {
                    console.log(err);
                    defer.reject();
                }
            );
            return defer.promise;
        }

        $scope.$watch("vm.runCheck", function(nVal, oVal) {
            var counter = 0;
            vm.data.questions.map(function(val) {
                if (val.selectedAnswer) {
                    counter += 1;
                }
            });
            var calculation = (counter / vm.data.questions.length) * 100;
            if (calculation) {
                if (calculation >= 25) {
                    vm.progressWidth.background = "#1976d2";
                } else if (calculation >= 50) {
                    vm.progressWidth.background = "#039be5";
                } else if (calculation >= 75) {
                    vm.progressWidth.background = "#43a047";
                }

                if (calculation === 100) {
                    vm.disabledFinish = false;
                }
                checkSync(calculation);
                vm.progressWidth.width = Math.round(calculation) + "%";
            }
        });

        function fmtMSS(s) {
            return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
        }

        $scope.$on("onBeforeUnload", function(e, confirmation) {
            confirmation.message = "All data willl be lost.";
            e.preventDefault();
        });

        $scope.$on("$destroy", function() {
            syncTemporary(vm.data).then(function() {
                delete $localStorage.at_data;
            });
        });

        function syncTemporary(payload) {
            var defer = $q.defer();
            var request = AssessmentBehavioral.syncTemp(payload);
            vm.isSync = true;
            request.then(
                function(res) {
                    $timeout(function() {
                        vm.isSync = false;
                    }, 20000);
                    defer.resolve(res.data);
                },
                function(err) {
                    defer.reject(err);
                    $timeout(function() {
                        vm.isSync = false;
                    }, 20000);
                    defer.reject(err.data);
                }
            );
            return defer.promise;
        }

        function submit() {
            block.start({ message: "Please Wait, Submitting Request" });
            var request = AssessmentBehavioral.submit(vm.data);
            request.then(
                function(res) {
                    console.log(res);
                    block.stop();
                    delete $localStorage.sessionTake;
                    responseDialog(res.data, "success", true);
                },
                function(err) {
                    console.log(err);
                    block.stop();
                    responseDialog(err.data, "warn", false);
                }
            );
        }

        function lockQuestion() {
            vm.disabledFinish = false;
            vm.data.questions.map(function(val) {
                val.disabled = true;
            });
        }

        function responseDialog(response, type, status) {
            swal(
                {
                    title: response.title,
                    text: response.message,
                    type: type,
                    showCancelButton: false,
                    confirmButtonText: "OK",
                    closeOnConfirm: true
                },
                function() {
                    if (status) {
                        $state.go("app.dashboard");
                    }
                }
            );
        }

        function checkSync(calculation) {
            switch (calculation) {
                case 25:
                case 50:
                case 75:
                case 100:
                    if (!vm.isSync) {
                        syncTemporary(vm.data).then(function() {
                            syncResponse("Saving Progress");
                        });
                    }
                    break;
            }
        }

        function submitConfirmation() {
            var incompleteIndex = findFirstIncompleteQuestionIndex();
            var stillHaveTime = vm.timeInterval > 0;

            if (stillHaveTime && incompleteIndex !== -1) {
                scrollToQuestion(incompleteIndex);
                syncResponse("Masih ada soal yang belum lengkap. Silakan lengkapi jawaban dan alasan.");
                return;
            }

            var isHaveTime = isStillHaveTime();
            if (isHaveTime.status) {
                swal(
                    {
                        title: isHaveTime.title,
                        text: isHaveTime.message,
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55",
                        confirmButtonText: "Yes",
                        cancelButtonText: "No",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function(isConfirm) {
                        if (isConfirm) {
                            submit();
                        }
                    }
                );
            } else {
                submit();
            }
        }

        function isStillHaveTime() {
            var response = {
                status: false,
                title: "",
                message: ""
            };

            if (vm.timeInterval > 300) {
                response.status = true;
                response.title = "Are you sure to submit this test ?";
                response.message = "You still have time to check your answer";
            } else if (vm.timeInterval < 300 && vm.timeInterval > 100) {
                response.status = true;
                response.title = "Are you sure to submit this test ?";
                response.message = "Be careful, this will ended your test";
            }

            return response;
        }

        function syncResponse(message) {
            $mdToast
                .show(
                    $mdToast
                        .simple()
                        .textContent(message)
                        .position("bottom right")
                        .hideDelay(2000)
                )
                .then(function() {
                    console.log("Toast dismissed.");
                })
                .catch(function() {
                    console.log(
                        "Toast failed or was forced to close early by another toast."
                    );
                });
        }

        $scope.$watch("vm.timeInterval", function(nval, oval) {
            if (nval == 0) {
                lockQuestion();
                if (angular.isDefined(vm.timerAssessment)) {
                    $interval.cancel(vm.timerAssessment);
                }
            }
        });
    }
})();

(function() {
    "use strict";

    angular.module("assessment", []).config(config);

    config.$inject = ["$stateProvider"];

    function config($stateProvider) {
        $stateProvider.state("app.assessment", {
            url: "assessment/{poolId}/{sessionId}",
            views: {
                "content@app": {
                    templateUrl: "app/main/modules/assessment/assessment.html",
                    controller: "AssessmentController as vm"
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function() {
    angular.module("assessment").factory("Assessment", AssessmentFactory);

    function AssessmentFactory(
        $q,
        $http,
        $location,
        appConfig,
        apiConfig,
        $timeout
    ) {
        var factory = {};

        factory.getQuestion = function(data) {
            return $http.post(
                appConfig.appApi + apiConfig.assessment.getQuestion,
                data
            );
        };

        factory.submit = function(data) {
            return $http.post(
                appConfig.appApi + apiConfig.assessment.submit,
                data
            );
        };

        factory.getQuestionTiki = function() {
            return $http.get(
                appConfig.appApi + apiConfig.assessment.getQuestionTiki
            );
        };

        factory.syncTemporary = function(data) {
            return $http.post(
                appConfig.appApi + apiConfig.assessment.syncTemporary,
                data
            );
        };

        return factory;
    }
})();

(function () {
    "use strict";

    angular
        .module("assessment")
        .controller("AssessmentController", AssessmentController);

    /** @ngInject */
    AssessmentController.$inject = [
        "$timeout",
        "$state",
        "$scope",
        "Assessment",
        "$localStorage",
        "$stateParams",
        "appConfig",
        "blockUI",
        "$location",
        "$interval",
        "$rootScope",
    ];

    function AssessmentController(
        $timeout,
        $state,
        $scope,
        Assessment,
        $localStorage,
        $stateParams,
        appConfig,
        blockUI,
        $location,
        $interval,
        $rootScope
    ) {
        var vm = this;
        var dt = new Date();
        vm.convertIntToChar = convertIntToChar;
        vm.localStorage = $localStorage;
        vm.questions = [];
        vm.questionsLength = 0;
        vm.linkImages = appConfig.questionPic;
        vm.progressWidth = {
            width: "0%",
        };
        vm.zoom = "assessment-img-normal";
        vm.zoomEvent = zoomEvent;
        vm.submittedQuestion = [];
        vm.submitQuestion = submitQuestion;
        vm.editQuestion = editQuestion;
        vm.disabledSubmitQuestion = disabledSubmitQuestion;
        vm.disabledEditQuestion = disabledEditQuestion;
        vm.disabledCheckbox = disabledCheckbox;
        vm.progress = true;
        vm.nextQuestion = nextQuestion;
        vm.prevQuestion = prevQuestion;
        vm.nextDisabled = nextDisabled;
        vm.prevDisabled = prevDisabled;
        vm.showFinalSubmit = false;
        vm.submitAssessment = submitAssessment;
        vm.toggleFullScreen = toggleFullScreen;
        vm.isFullScreen = false;
        vm.isCurrentAnsweredList = false;
        vm.goToQuestionIndex = goToQuestionIndex;
        vm.isDisabledListQuestion = isDisabledListQuestion;
        vm.timerAssessment;
        vm.isExplanationRead = false;
        vm.slideIndex = 2;
        vm.slide1 = true;
        vm.slide2 = false;
        vm.slide3 = false;
        vm.gotoSlides = gotoSlides;
        vm.isAlreadyReaded = isAlreadyReaded;
        vm.displayTimer = "00:00";
        vm.timeInterval = -1;
        vm.showAction = true;

        activate();

        function activate() {
            checkStart();
            sessionData();
        }

        function setTimer() {
            vm.timeInterval = $localStorage.sessionData.remaining_times;
            vm.timerAssessment = $interval(function () {
                vm.timeInterval -= 1;
                if (angular.isDefined($localStorage.sessionData)) {
                    $localStorage.sessionData.remaining_times = vm.timeInterval;
                }
                vm.displayTimer = fmtMSS(vm.timeInterval);
            }, 1000);
            $rootScope.timerAssessment = vm.timerAssessment;
        }

        function isAlreadyReaded() {
            if (angular.isDefined(vm.timerAssessment)) {
                $interval.cancel(vm.timerAssessment);
            }
            $localStorage.isExplanationRead = true;
            vm.isExplanationRead = true;
            setTimer();
        }

        $scope.$watch("vm.timeInterval", function (newVal, oldVal) {
            if (newVal <= 0) {
                $interval.cancel(vm.timerAssessment);
                vm.timeInterval = 0;
                for (var i = 0; i < vm.questionsLength; i++) {
                    vm.questions[i].question_data.isSubmitted = 1;
                }
                vm.progress = !vm.progress;
            }
        });

        function gotoSlides(slide) {
            switch (slide) {
                case 1:
                    vm.slideIndex = 2;
                    vm.slide1 = true;
                    vm.slide2 = false;
                    vm.slide3 = false;
                    break;
                case 2:
                    vm.slideIndex = 3;
                    vm.slide1 = false;
                    vm.slide2 = true;
                    vm.slide3 = false;
                    break;
                case 3:
                    vm.slideIndex = 1;
                    vm.slide1 = false;
                    vm.slide2 = false;
                    vm.slide3 = true;
                    break;
            }
        }

        function zoomEvent() {
            if (vm.zoom == "assessment-img-normal") {
                vm.zoom = "assessment-img-zoom";
            } else {
                vm.zoom = "assessment-img-normal";
            }
        }

        function checkStart() {
            if ($localStorage.isExplanationRead) {
                vm.isExplanationRead = true;
                setTimer();
            } else {
                vm.isExplanationRead = false;
            }
        }

        function isDisabledListQuestion(i) {
            if (typeof i.index === "undefined") {
                return true;
            }
            return false;
        }

        function goToQuestionIndex(index) {
            vm.question = vm.questions[index];
        }

        function sessionData() {
            if ($localStorage.isAlreadyStart == 1) {
                var index = $localStorage.lastIndex
                    ? $localStorage.lastIndex
                    : 0;
                vm.questions = $localStorage.questions;
                vm.questionsLength = $localStorage.questionsLength;
                vm.question = vm.questions[index];
                vm.progress = $localStorage.progress;
            } else {
                getQuestion();
            }
        }

        function nextQuestion() {
            var tmpIndex = angular.copy(vm.question.index);
            var index = tmpIndex + 1;
            $localStorage.lastIndex = index;
            if (index < vm.questionsLength) {
                vm.question = vm.questions[index];
                vm.question.index = index;
            }
        }

        function prevQuestion() {
            var tmpIndex = angular.copy(vm.question.index);
            var index = tmpIndex - 1;
            $localStorage.lastIndex = index;
            if (index != -1) {
                vm.question = vm.questions[index];
                vm.question.index = index;
            }
        }

        function getQuestion() {
            blockUI.start("Load question data");
            var payload = {
                qid: $stateParams.poolId,
                sessionID: $stateParams.sessionId,
            };
            Assessment.getQuestion(payload).then(
                function (resp) {
                    blockUI.stop();
                    if (resp.status == 200) {
                        vm.questions = resp.data;
                        vm.questionsLength = vm.questions.length;
                        vm.question = vm.questions[0];
                        vm.question.index = 0;
                        $localStorage.isAlreadyStart = 1;
                        $localStorage.questions = vm.questions;
                        $localStorage.questionsLength = vm.questions.length;
                    } else {
                        vm.questions = [];
                        delete $localStorage.questions;
                        delete $localStorage.questionsLength;
                    }
                },
                function () {
                    blockUI.stop();
                    vm.questions = [];
                    delete $localStorage.questions;
                    delete $localStorage.questionsLength;
                }
            );
        }

        function disabledEditQuestion(data) {
            if (typeof data !== "undefined") {
                return data.isSubmitted == 0;
            }
        }

        function disabledSubmitQuestion(data) {
            if (typeof data !== "undefined") {
                var collections = data.answer;
                var ctrNeededAnswer = 0;
                for (var i = 0; i < collections.length; i++) {
                    if (collections[i].flag == 1) {
                        ctrNeededAnswer += 1;
                    }
                }
                return (
                    ctrNeededAnswer != data.correct_answer_count ||
                    data.isSubmitted != 0
                );
            }
        }

        function prevDisabled(data) {
            if (typeof data !== "undefined") {
                return data.index - 1 == -1;
            }
            return false;
        }

        function nextDisabled(data) {
            if (typeof data !== "undefined") {
                return (
                    data.isSubmitted == 0 ||
                    vm.question.index == vm.questionsLength - 1
                );
            }
            return false;
        }

        function disabledCheckbox(submitStatus) {
            return submitStatus == 1;
        }

        function submitQuestion(data, index) {
            vm.progress = !vm.progress;
            data.isSubmitted = 1;
            $localStorage.questions[index].isSubmitted = 1;
            $localStorage.questions[index].question_data.answer = data.answer;
        }

        function editQuestion(data, index) {
            data.isSubmitted = 0;
            $localStorage.questions[index].isSubmitted = 0;
            $localStorage.questions[index].question_data.answer = data.answer;
        }

        function convertIntToChar(data) {
            return String.fromCharCode(65 + data);
        }

        $scope.$watch("vm.progress", function (newVal, oldVal) {
            var counter = 0;
            for (var i = 0; i < vm.questionsLength; i++) {
                if (vm.questions[i].question_data.isSubmitted == 1) {
                    counter++;
                }
            }
            if (counter == 0) {
                vm.progressWidth.width = 0 + "%";
                $localStorage.progress = 0;
            } else {
                var calculation = (counter / vm.questionsLength) * 100;
                $localStorage.progress = Math.round(calculation);
                vm.progressWidth.width = Math.round(calculation) + "%";
                vm.showFinalSubmit = Math.round(calculation) == 100;
            }
        });

        function submitAssessment() {
            try {
                var result = {};
                blockUI.start("Mohon tunggu");
                result.uid = $localStorage.userId;
                result.session = $localStorage.sessionData;
                result.data = vm.questions;
                Assessment.submit(result).then(
                    function (response) {
                        blockUI.stop();
                        delete $localStorage.sessionData;
                        delete $localStorage.lastIndex;
                        responseDialog(response, $state, 1);
                    },
                    function (error) {
                        blockUI.stop();
                        responseDialog(error, $state, 0);
                    }
                );
            } catch (error) {
                responseDialog(error, 0);
            }
        }
    }

    function responseDialog(response, $state, type) {
        swal(
            {
                title: response.data.title,
                text: response.data.message,
                type: response.data.type,
                showCancelButton: false,
                confirmButtonText: "OK",
                closeOnConfirm: true,
            },
            function () {
                goTo(type, $state);
            }
        );
    }

    function goTo(type, $state) {
        if (type == 1) {
            $state.go("app.dashboard");
        } else {
            $state.reload();
        }
    }

    function fmtMSS(s) {
        return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
    }

    function toggleFullScreen() {
        if (
            !document.fullscreenElement &&
            !document.mozFullScreenElement &&
            !document.webkitFullscreenElement
        ) {
            if (document.documentElement.requestFullscreen) {
                document.documentElement.requestFullscreen();
            } else if (document.documentElement.mozRequestFullScreen) {
                document.documentElement.mozRequestFullScreen();
            } else if (document.documentElement.webkitRequestFullscreen) {
                document.documentElement.webkitRequestFullscreen(
                    Element.ALLOW_KEYBOARD_INPUT
                );
            }
        } else {
            if (document.cancelFullScreen) {
                document.cancelFullScreen();
            } else if (document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
                document.webkitCancelFullScreen();
            }
        }
    }
})();

(function () {

  'use strict';

  angular
    .module('achievement', [])
    .config(config);

  config.$inject = ['$stateProvider'];

  function config($stateProvider) {

    $stateProvider
      .state('app.achievement', {
        url: 'achievement',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/achievement/achievement.html',
            controller: 'AchievementController as vm'
          }
        },
        data: {
          requiresLogin: true
        }
      });

    $stateProvider
      .state('app.achievement.detail', {
        url: '/detail/:id/:userId',
        views: {
          'content@app': {
            templateUrl: 'app/main/modules/achievement/achievement-detail.html',
            controller: 'AchievementDetailController as vm'
          }
        },
        params: {
          obj: null,
          id: null,
          userId: null
        },
        data: {
          requiresLogin: true
        }
      });



  }

})();

(function () {
  angular
    .module('achievement')
    .factory('Achievement', Achievement);

  function Achievement(
    $q,
    $http,
    $location,
    appConfig,
    apiConfig,
    $timeout
  ) {

    var factory = {};

    factory.getData = function (data) {
      $http.defaults.headers.post["Content-Type"] = "application/json";
      return $http.get(appConfig.appApi + apiConfig.achievement.data + '/' + data);
    };

    factory.getDetail = function (data) {
      $http.defaults.headers.post["Content-Type"] = "application/json";
      return $http.get(appConfig.appApi + apiConfig.achievement.detail + '/' + data);
    };

    return factory;

  }

})();

(function () {
  'use strict';

  angular
    .module('achievement')
    .controller('AchievementController', AchievementController);

  /** @ngInject */
  AchievementController.$inject = [
    '$timeout',
    '$state',
    '$stateParams',
    '$localStorage',
    'Achievement'
  ];

  function AchievementController(
    $timeout,
    $state,
    $stateParams,
    $localStorage,
    Achievement
  ) {

    var vm = this;
    vm.user = $localStorage;
    vm.achievement = [];
    vm.getDetail = getDetail;

    activate();

    function activate() {
      getData();
    }

    function getData() {
      Achievement.getData(vm.user.userId).then(
        function (res) {
          if (res.data.code == 1) {
            vm.achievement = res.data.data;
            console.log(vm.achievement);
          } else {
            vm.achievement = [];
          }
        },
        function (err) {
          console.log(err);
        }
      )
    }

    function getDetail(data) {
      console.log(data);
      $state.go('app.achievement.detail', {
        obj: data,
        id: data.achievement_id,
        userId: data.user_id
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('achievement')
    .controller('AchievementDetailController', AchievementDetailController);
  /** @ngInject */
  AchievementDetailController.$inject = [
    '$timeout',
    '$state',
    '$localStorage',
    'Report',
    'Achievement',
    '$stateParams',
    'blockUI',
    'AccountFactory'
  ];

  function AchievementDetailController(
    $timeout,
    $state,
    $localStorage,
    Report,
    Achievement,
    $stateParams,
    blockUI,
    AccountFactory
  ) {
    var vm = this;
    vm.data = $stateParams;
    vm.roles = $localStorage.rolesId;
    vm.isCanPreviewAbjact = isCanPreviewAbjact;

    console.log('localStorage', $localStorage);


    activate();

    function activate() {
      getDetail(vm.data.id);
      getDetailUser(vm.data.userId);
    }

    function getDetailUser(params) {
      AccountFactory.getUser(params).then(
        function (res) {
          vm.data.user = res.data;
        },
        function (err) {
          console.log(err);
        }
      )
    }

    function isCanPreviewAbjact() {
      if (vm.roles !== 1 && typeof ($localStorage.isCanPreview) === 'undefined') {
        return false;
      } else {
        if (vm.roles === 1 || typeof ($localStorage.isCanPreview) !== 'undefined') {
          return true;
        } else {
          return false;
        }
      }
    }

    function getDetail(params) {
      Achievement.getDetail(params).then(
        function (resp) {
          vm.data.achievement = resp.data.achievement;
          vm.data.response = resp.data.achievementDetail;
        },
        function (err) {
          console.log(err);
        }
      )
    }
  }
})();

(function() {
    angular.module('account').factory('AccountFactory', AccountFactory);

    function AccountFactory($localStorage, $http, appConfig, apiConfig) {
        var factory = {};
        factory.getDataUser = function(data, search) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(
                appConfig.appApi +
                    apiConfig.accounts.list +
                    '?page=' +
                    data +
                    '&search=' +
                    search
            );
        };

        factory.getDataUserOnly = function() {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(appConfig.appApi + apiConfig.accounts.data);
        };

        factory.getDataGroup = function() {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(appConfig.appApi + apiConfig.accounts.group);
        };

        factory.createDataUser = function(data) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.post(appConfig.appApi + apiConfig.accounts.create, data);
        };

        factory.deleteDataUser = function(data) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.post(appConfig.appApi + apiConfig.accounts.delete, data);
        };

        factory.updateDataUser = function(data) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.post(appConfig.appApi + apiConfig.accounts.update, data);
        };

        factory.getUser = function(data) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(
                appConfig.appApi + apiConfig.accounts.getUser + '/' + data
            );
        };

        factory.syncLogs = function(data) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(
                appConfig.appApi + apiConfig.accounts.syncLogs + '?page=' + data
            );
        };

        factory.findUser = function(data) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(
                appConfig.appApi + apiConfig.accounts.findUser + '?search=' + data
            );
        };

        return factory;
    }
})();

(function() {
    'use strict';

    angular.module('account').controller('AccountController', AccountController);

    /** @ngInject */
    AccountController.$inject = [
        '$timeout',
        '$state',
        'AccountFactory',
        '$mdDialog',
        'appConfig',
        'SyncFactory',
        '$localStorage',
        '$mdToast'
    ];

    function AccountController(
        $timeout,
        $state,
        AccountFactory,
        $mdDialog,
        appConfig,
        SyncFactory,
        $localStorage,
        $mdToast
    ) {
        var vm = this;

        vm.currentPage = 1;
        vm.loadData = loadData;
        vm.search = '';
        vm.gotoCreate = gotoCreate;
        vm.gotoImport = gotoImport;
        vm.gotoDelete = gotoDelete;
        vm.gotoEdit = gotoEdit;
        vm.gotoSync = gotoSync;

        activate();

        function activate() {
            loadData(1);
        }

        function gotoCreate() {
            $state.go('app.account.create_account');
        }

        function gotoEdit(data) {
            $state.go('app.account.update_account', {
                obj: data
            });
        }

        function gotoDelete(data) {
            console.log(data);
            swal(
                {
                    title: 'Would you like to delete this account ?',
                    text: 'Account data will be deleted!',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#DD6B55',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function(isConfirm) {
                    if (isConfirm) {
                        AccountFactory.deleteDataUser({
                            id: data.id
                        }).then(
                            function(resp) {
                                $mdToast
                                    .show(
                                        $mdToast
                                            .simple()
                                            .textContent(
                                                resp.data.messages.toUpperCase()
                                            )
                                            .position('bottom right')
                                            .hideDelay(3000)
                                    )
                                    .then(function() {
                                        console.log('Toast dismissed.');
                                    })
                                    .catch(function() {
                                        console.log(
                                            'Toast failed or was forced to close early by another toast.'
                                        );
                                    });
                                loadData(1);
                            },
                            function(err) {
                                swal('Oops!', 'Something went wrong', 'error');
                            }
                        );
                    }
                }
            );
        }

        function gotoSync(ev) {
            $state.go('app.account.sync');
        }

        function gotoImport(ev) {
            $mdDialog
                .show({
                    controller: 'ImportAccountController',
                    controllerAs: 'vm',
                    templateUrl:
                        'app/main/modules/account/import-account/import-account.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true // Only for -xs, -sm breakpoints.
                })
                .then(
                    function(answer) {
                        vm.status = 'You said the information was "' + answer + '".';
                    },
                    function() {
                        vm.status = 'You cancelled the dialog.';
                    }
                );
        }

        function loadData(pageNo) {
            AccountFactory.getDataUser(pageNo, vm.search).then(
                function(resp) {
                    vm.listUser = resp.data.data;
                    vm.paginate = resp.data;
                    vm.totalItems = vm.paginate.total;
                    vm.currentPage = vm.paginate.current_page;
                    vm.pageSize = vm.paginate.per_page;
                    console.log(vm.listUser);
                },
                function(err) {
                    console.log(err);
                }
            );
        }
    }
})();

(function () {
  'use strict';

  angular
    .module('core')
    .directive('sidebarAssessment', SidebarConfig);

  /** @ngInject */
  function SidebarConfig() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/core/sidebar/sidebar.html',
      scope: {
        creationDate: '='
      },
      controller: SidebarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function SidebarController($scope, $location, $window) {
      var vm = this;
      
    }
  }

})();

(function() {
    angular.module('core').directive('sectionTiki', SectionConfig);

    /** @ngInject */
    function SectionConfig() {
        var directive = {
            restrict: 'EA',
            templateUrl: 'app/components/core/section/section.html',
            scope: {
                data: '='
            },
            link: linkFunc,
            controller: SectionController,
            controllerAs: 'vm',
            bindToController: true
        };

        function linkFunc(scope, el, attr, ctrl) {
            console.log('LINK', scope.vm.data);
        }

        return directive;
    }

    SectionController.$inject = ['$location', '$window', '$state'];
    function SectionController($location, $window, $state) {
        var vm = this;
        vm.$state = $state;
    }
})();

(function() {
    "use strict";

    angular.module("assesmenttools", [
        "core",
        "checklist-model",
        "ngResource",
        "ui.router",
        "angular-jwt",
        "ngStorage",
        "ngNotify",
        "ngDialog",
        "dashboard",
        "login",
        "question_bank",
        "enrollment",
        "assessment",
        "assessment_tiki",
        "assessment_papikostik",
        "assessment_intray",
        "assessment_beq",
        "assessment_survey",
        "assessment_behavioral",
        "account",
        "achievement",
        "wizard",
        "master_data",
        "report"
    ]);
})();

(function () {
  angular
    .module('assesmenttools')
    .provider('general', generalProvider);

    generalProvider.$inject = ['$stateProvider']

  function generalProvider($stateProvider) {
    return {
      $get: function() {
        return {
          setBackground: function() {
            return new Date();
          }
        }
      }
    }
  }

})();

/**
 * @ngDoc directive
 * @name ng.directive:paging
 *
 * @description
 * A directive to aid in paging large datasets
 * while requiring a small amount of page
 * information.
 *
 * @element EA
 *
 */
angular.module('bw.paging', []).directive('paging', function () {


  /**
   * The regex expression to use for any replace methods
   * Feel free to tweak / fork values for your application
   */
  var regex = /\{page\}/g;
  

  /**
   * The angular return value required for the directive
   * Feel free to tweak / fork values for your application
   */
  return {

      // Restrict to elements and attributes
      restrict: 'EA',

      // Assign the angular link function
      link: fieldLink,
      
      // Assign the angular directive template HTML
      template: fieldTemplate,

      // Assign the angular scope attribute formatting
      scope: {
          page: '=',
          pageSize: '=',
          total: '=',
          disabled: '@',
          dots: '@',
          ulClass: '@',
          activeClass: '@',
          disabledClass: '@',
          adjacent: '@',
          pagingAction: '&',
          pgHref: '@',
          textFirst: '@',
          textLast: '@',
          textNext: '@',
          textPrev: '@',
          textFirstClass: '@',
          textLastClass: '@',
          textNextClass: '@',
          textPrevClass: '@',
          textTitlePage: '@',
          textTitleFirst: '@',
          textTitleLast: '@',
          textTitleNext: '@',
          textTitlePrev: '@'
      }
                  
  };


  /**
   * Link the directive to enable our scope watch values
   *
   * @param {object} scope - Angular link scope
   * @param {object} el - Angular link element
   * @param {object} attrs - Angular link attribute
   */
  function fieldLink(scope, el, attrs) {

      // Hook in our watched items
      scope.$watchCollection('[page,pageSize,total,disabled]', function () {
          build(scope, attrs);
      });
  }
  
  
  /**
   * Create our template html 
   * We use a function to figure out how to handle href correctly
   * 
   * @param {object} el - Angular link element
   * @param {object} attrs - Angular link attribute
   */
  function fieldTemplate(el, attrs){
          return '<ul data-ng-hide="Hide" data-ng-class="ulClass"> ' +
              '<li ' +
                  'title="{{Item.title}}" ' +
                  'data-ng-class="Item.liClass" ' +
                  'class="page-item"' +
                  'data-ng-repeat="Item in List"> ' +
                      '<a ' + 
                          (attrs.pgHref ? 'data-ng-href="{{Item.pgHref}}" ' : 'href ') +
                          'data-ng-class="Item.aClass" ' +
                          'class="page-link"' +
                          'data-ng-click="Item.action()" ' +
                          'data-ng-bind="Item.value">'+ 
                      '</a> ' +
              '</li>' +
          '</ul>' 
  }


  /**
   * Assign default scope values from settings
   * Feel free to tweak / fork these for your application
   *
   * @param {Object} scope - The local directive scope object
   * @param {Object} attrs - The local directive attribute object
   */
  function setScopeValues(scope, attrs) {

      scope.List = [];
      scope.Hide = false;
      
      scope.page = parseInt(scope.page) || 1;
      scope.total = parseInt(scope.total) || 0;
      scope.adjacent = parseInt(scope.adjacent) || 2;

      scope.pgHref = scope.pgHref || '';
      scope.dots = scope.dots || '...';
      
      scope.ulClass = scope.ulClass || 'pagination';
      scope.activeClass = scope.activeClass || 'active';
      scope.disabledClass = scope.disabledClass || 'disabled';

      scope.textFirst = scope.textFirst || '<<';
      scope.textLast = scope.textLast || '>>';
      scope.textNext = scope.textNext || '>';
      scope.textPrev = scope.textPrev || '<';
      
      scope.textFirstClass = scope.textFirstClass || '';
      scope.textLastClass= scope.textLastClass || '';
      scope.textNextClass = scope.textNextClass || '';
      scope.textPrevClass = scope.textPrevClass || '';

      scope.textTitlePage = scope.textTitlePage || 'Page {page}';
      scope.textTitleFirst = scope.textTitleFirst || 'First Page'; 
      scope.textTitleLast = scope.textTitleLast || 'Last Page'; 
      scope.textTitleNext = scope.textTitleNext || 'Next Page'; 
      scope.textTitlePrev = scope.textTitlePrev || 'Previous Page'; 

      scope.hideIfEmpty = evalBoolAttribute(scope, attrs.hideIfEmpty);
      scope.showPrevNext = evalBoolAttribute(scope, attrs.showPrevNext);
      scope.showFirstLast = evalBoolAttribute(scope, attrs.showFirstLast);
      scope.scrollTop = evalBoolAttribute(scope, attrs.scrollTop);
      scope.isDisabled = evalBoolAttribute(scope, attrs.disabled);
  }


  /**
   * A helper to perform our boolean eval on attributes
   * This allows flexibility in the attribute for strings and variables in scope
   * 
   * @param {Object} scope - The local directive scope object
   * @param {Object} value - The attribute value of interest
   */
  function evalBoolAttribute(scope, value){
      return angular.isDefined(value)
          ? !!scope.$parent.$eval(value)
          : false;
  }


  /**
   * Validate and clean up any scope values
   * This happens after we have set the scope values
   *
   * @param {Object} scope - The local directive scope object
   * @param {int} pageCount - The last page number or total page count
   */
  function validateScopeValues(scope, pageCount) {

      // Block where the page is larger than the pageCount
      if (scope.page > pageCount) {
          scope.page = pageCount;
      }

      // Block where the page is less than 0
      if (scope.page <= 0) {
          scope.page = 1;
      }

      // Block where adjacent value is 0 or below
      if (scope.adjacent <= 0) {
          scope.adjacent = 2;
      }

      // Hide from page if we have 1 or less pages
      // if directed to hide empty
      if (pageCount <= 1) {
          scope.Hide = scope.hideIfEmpty;
      }
  }


  /**
   * Assign the method action to take when a page is clicked
   *
   * @param {Object} scope - The local directive scope object
   * @param {int} page - The current page of interest
   */
  function internalAction(scope, page) {

      // Block clicks we try to load the active page
      if (scope.page == page) {
          return;
      }

      // Block if we are forcing disabled 
      if(scope.isDisabled)
      {
          return;
      }

      // Update the page in scope
      scope.page = page;

      // Pass our parameters to the paging action
      scope.pagingAction({
          page: scope.page,
          pageSize: scope.pageSize,
          total: scope.total
      });

      // If allowed scroll up to the top of the page
      if (scope.scrollTop) {
          scrollTo(0, 0);
      }
  }


  /**
   * Add the first, previous, next, and last buttons if desired
   * The logic is defined by the mode of interest
   * This method will simply return if the scope.showPrevNext is false
   * This method will simply return if there are no pages to display
   *
   * @param {Object} scope - The local directive scope object
   * @param {int} pageCount - The last page number or total page count
   * @param {string} mode - The mode of interest either prev or last
   */
  function addPrevNext(scope, pageCount, mode) {

      // Ignore if we are not showing
      // or there are no pages to display
      if ((!scope.showPrevNext && !scope.showFirstLast) || pageCount < 1) {
          return;
      }

      // Local variables to help determine logic
      var disabled, alpha, beta;

      // Determine logic based on the mode of interest
      // Calculate the previous / next page and if the click actions are allowed
      if (mode === 'prev') {

          disabled = scope.page - 1 <= 0;
          var prevPage = scope.page - 1 <= 0 ? 1 : scope.page - 1;

          if(scope.showFirstLast){
              alpha = {
                  value: scope.textFirst,
                  title: scope.textTitleFirst, 
                  aClass: scope.textFirstClass,
                  page: 1
              };                
          }

          if(scope.showPrevNext){
              beta = {
                  value: scope.textPrev,
                  title: scope.textTitlePrev, 
                  aClass: scope.textPrevClass,
                  page: prevPage
              };    
          }

      } else {

          disabled = scope.page + 1 > pageCount;
          var nextPage = scope.page + 1 >= pageCount ? pageCount : scope.page + 1;

          if(scope.showPrevNext){
              alpha = {
                  value: scope.textNext,
                  title: scope.textTitleNext, 
                  aClass: scope.textNextClass,
                  page: nextPage
              };    
          }
          
          if(scope.showFirstLast){
              beta = {
                  value: scope.textLast,
                  title: scope.textTitleLast, 
                  aClass: scope.textLastClass,
                  page: pageCount
              };    
          }
          
      }

      // Create the Add Item Function
      var buildItem = function (item, disabled) {
          return {
              title: item.title,
              aClass: item.aClass,
              value: item.aClass ? '' : item.value,
              liClass: disabled ? scope.disabledClass : '',
              pgHref: disabled ? '' : scope.pgHref.replace(regex, item.page),
              action: function () {
                  if (!disabled) {
                      internalAction(scope, item.page);
                  }
              }
          };    
      };

      // Force disabled if specified
      if(scope.isDisabled){
          disabled = true;
      }

      // Add alpha items
      if(alpha){
          var alphaItem = buildItem(alpha, disabled);
          scope.List.push(alphaItem);    
      }
      
      // Add beta items
      if(beta){
          var betaItem = buildItem(beta, disabled);
          scope.List.push(betaItem);    
      }
  }


  /**
   * Adds a range of numbers to our list
   * The range is dependent on the start and finish parameters
   *
   * @param {int} start - The start of the range to add to the paging list
   * @param {int} finish - The end of the range to add to the paging list
   * @param {Object} scope - The local directive scope object
   */
  function addRange(start, finish, scope) {
  
      // Add our items where i is the page number
      var i = 0;
      for (i = start; i <= finish; i++) {

          var pgHref = scope.pgHref.replace(regex, i);
          var liClass = scope.page == i ? scope.activeClass : ''; 

          // Handle items that are affected by disabled
          if(scope.isDisabled){
              pgHref = '';
              liClass = scope.disabledClass;
          }


          scope.List.push({
              value: i,
              title: scope.textTitlePage.replace(regex, i),
              liClass: liClass,
              pgHref: pgHref,
              action: function () {
                  internalAction(scope, this.value);
              }
          });
      }
  }


  /**
   * Add Dots ie: 1 2 [...] 10 11 12 [...] 56 57
   * This is my favorite function not going to lie
   *
   * @param {Object} scope - The local directive scope object
   */
  function addDots(scope) {
      scope.List.push({
          value: scope.dots,
          liClass: scope.disabledClass
      });
  }


  /**
   * Add the first or beginning items in our paging list
   * We leverage the 'next' parameter to determine if the dots are required
   *
   * @param {Object} scope - The local directive scope object
   * @param {int} next - the next page number in the paging sequence
   */
  function addFirst(scope, next) {

      addRange(1, 2, scope);

      // We ignore dots if the next value is 3
      // ie: 1 2 [...] 3 4 5 becomes just 1 2 3 4 5
      if (next != 3) {
          addDots(scope);
      }
  }


  /**
   * Add the last or end items in our paging list
   * We leverage the 'prev' parameter to determine if the dots are required
   *
   * @param {int} pageCount - The last page number or total page count
   * @param {Object} scope - The local directive scope object
   * @param {int} prev - the previous page number in the paging sequence
   */
  // Add Last Pages
  function addLast(pageCount, scope, prev) {

      // We ignore dots if the previous value is one less that our start range
      // ie: 1 2 3 4 [...] 5 6  becomes just 1 2 3 4 5 6
      if (prev != pageCount - 2) {
          addDots(scope);
      }

      addRange(pageCount - 1, pageCount, scope);
  }



  /**
   * The main build function used to determine the paging logic
   * Feel free to tweak / fork values for your application
   *
   * @param {Object} scope - The local directive scope object
   * @param {Object} attrs - The local directive attribute object
   */
  function build(scope, attrs) {

      // Block divide by 0 and empty page size
      if (!scope.pageSize || scope.pageSize <= 0) {
          scope.pageSize = 1;
      }

      // Determine the last page or total page count
      var pageCount = Math.ceil(scope.total / scope.pageSize);

      // Set the default scope values where needed
      setScopeValues(scope, attrs);

      // Validate the scope values to protect against strange states
      validateScopeValues(scope, pageCount);

      // Create the beginning and end page values
      var start, finish;

      // Calculate the full adjacency value
      var fullAdjacentSize = (scope.adjacent * 2) + 2;


      // Add the Next and Previous buttons to our list
      addPrevNext(scope, pageCount, 'prev');

      // If the page count is less than the full adjacnet size
      // Then we simply display all the pages, Otherwise we calculate the proper paging display
      if (pageCount <= (fullAdjacentSize + 2)) {

          start = 1;
          addRange(start, pageCount, scope);

      } else {

          // Determine if we are showing the beginning of the paging list
          // We know it is the beginning if the page - adjacent is <= 2
          if (scope.page - scope.adjacent <= 2) {

              start = 1;
              finish = 1 + fullAdjacentSize;

              addRange(start, finish, scope);
              addLast(pageCount, scope, finish);
          }

          // Determine if we are showing the middle of the paging list
          // We know we are either in the middle or at the end since the beginning is ruled out above
          // So we simply check if we are not at the end
          // Again 2 is hard coded as we always display two pages after the dots
          else if (scope.page < pageCount - (scope.adjacent + 2)) {

              start = scope.page - scope.adjacent;
              finish = scope.page + scope.adjacent;

              addFirst(scope, start);
              addRange(start, finish, scope);
              addLast(pageCount, scope, finish);
          }

          // If nothing else we conclude we are at the end of the paging list
          // We know this since we have already ruled out the beginning and middle above
          else {

              start = pageCount - fullAdjacentSize;
              finish = pageCount;

              addFirst(scope, start);
              addRange(start, finish, scope);
          }
      }

      // Add the next and last buttons to our paging list
      addPrevNext(scope, pageCount, 'next');
  }

});
(function () {
  angular
    .module('core')
    .directive('pagination', paginationConfig);

  /** @ngInject */
  function paginationConfig() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/core/pagination/pagination.html'
    };

    return directive;

  }



})();

(function () {
    angular.module("core").directive("navbarAssessment", NavbarConfig);

    /** @ngInject */
    function NavbarConfig($localStorage) {
        var directive = {
            restrict: "E",
            templateUrl: "app/components/core/navbar/navbar.html",
            scope: {
                creationDate: "=",
            },
            controller: NavbarController,
            controllerAs: "vm",
            bindToController: true,
        };

        return directive;

        /** @ngInject */
        function NavbarController($scope, $location, $window, $state) {
            vm = this;
            vm.$state = $state;
            vm.roles = $localStorage.rolesId;

            // Activate sidenav treemenu
            angular.element.tree(".sidebar");
            angular.element.pushMenu.activate("[data-toggle='offcanvas']");
            // side button js code

            angular.element(document).ready(function () {
                window.addEventListener("resize", setHorMenu, false);
                window.addEventListener("load", setHorMenu, false);

                function setHorMenu() {
                    var $window = angular.element(window);
                    if (angular.element(window).width() > 767) {
                        angular.element("body").addClass("fixed");
                    } else if ($window.width() < 540 && $window.width() < 767) {
                        angular
                            .element(".main-header")
                            .css("margin-top", "50px");
                        angular.element("body").removeClass("fixed");
                    } else if ($window.width() > 540 && $window.width() < 767) {
                        angular
                            .element(".main-header")
                            .css("margin-top", "0px");
                        angular.element("body").removeClass("fixed");
                    }
                }
            });
        }
    }
})();

(function() {
    angular.module('core').directive('imageonload', [
        '$timeout',
        function($timeout) {
            return {
                link: function($scope, element, attrs) {
                    function waitForImage(url) {
                        var tempImg = new Image();
                        tempImg.onload = function() {
                            $timeout(function() {
                                element.attr('src', url);
                            });
                        };
                        tempImg.src = url;
                    }

                    attrs.$observe('imageonload', function(newValue) {
                        if (newValue) {
                            waitForImage(newValue);
                        }
                    });
                }
            };
        }
    ]);
})();

(function () {
    angular.module("core").directive("headerAssessment", HeaderConfig);

    /** @ngInject */
    function HeaderConfig(Auth, $state, blockUI, $timeout) {
        var directive = {
            restrict: "E",
            templateUrl: "app/components/core/header/header.html",
            scope: {
                creationDate: "=",
            },
            controller: HeaderController,
            controllerAs: "vm",
            bindToController: true,
        };

        return directive;

        /** @ngInject */

        function HeaderController(
            appConfig,
            $state,
            $localStorage,
            Auth,
            blockUI,
            $timeout,
            $apiService,
            $appHelper
        ) {
            var vm = this;
            var auth = $apiService.auth();
            vm.appDesc = appConfig.appDesc;
            vm.appName = appConfig.appName;
            vm.appVersion = appConfig.appVersion;
            vm.userName = $localStorage.userName;
            vm.$state = $state;
            vm.windowWidth = $(window);
            vm.toggleFullScreen = toggleFullScreen;
            vm.displayChatBox = displayChatBox;
            vm.designation = designation;
            vm.logout = logout;

            var a = vm.windowWidth.height() - 50;
            vm.friendListScroll = {
                height: a,
                allowPageScroll: false,
                wheelStep: 1,
                color: "#1b8bf9",
            };

            // toggle full screen
            function toggleFullScreen() {
                if (
                    !document.fullscreenElement && // alternative standard method
                    !document.mozFullScreenElement &&
                    !document.webkitFullscreenElement
                ) {
                    // current working methods
                    if (document.documentElement.requestFullscreen) {
                        document.documentElement.requestFullscreen();
                    } else if (document.documentElement.mozRequestFullScreen) {
                        document.documentElement.mozRequestFullScreen();
                    } else if (
                        document.documentElement.webkitRequestFullscreen
                    ) {
                        document.documentElement.webkitRequestFullscreen(
                            Element.ALLOW_KEYBOARD_INPUT
                        );
                    }
                } else {
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    }
                }
            }

            function logout() {
                blockUI.start();
                var request = auth.logout({ token: $appHelper.getToken() });
                request.$promise.then(function (resp) {
                    $timeout(function () {
                        $state.go("app.login");
                        blockUI.stop();
                    }, 1000);
                });

                request.$promise.catch(function (err) {
                    $state.go("app.login");
                    blockUI.stop();
                });
            }

            // open chat box
            function displayChatBox() {
                var options = {
                    direction: "right",
                };
                angular.element(".showChat").toggle("slide", options, 500);
            }

            //open friend chat
            function friendListBox() {
                var options = {
                    direction: "right",
                };
                angular
                    .element(".showChat_inner")
                    .toggle("slide", options, 500);
            }

            //back to main chatbar
            function backChatBox() {
                var options = {
                    direction: "right",
                };
                angular
                    .element(".showChat_inner")
                    .toggle("slide", options, 500);
                angular.element(".showChat").css("display", "block");
            }
            /*chatbar js ends*/

            //sidebar dropdown open
            function designation() {
                angular.element(".extra-profile-list").slideToggle();
            }

            // search
            angular.element("#search-friends").on("keyup", function () {
                vm.g = $(this).val().toLowerCase();
                angular
                    .element(".friendlist-box .media-body .friend-header")
                    .each(function () {
                        vm.s = $(this).text().toLowerCase();
                        $(this)
                            .closest(".friendlist-box")
                            [vm.s.indexOf(vm.g) !== -1 ? "show" : "hide"]();
                    });
            });
        }
    }
})();

(function() {
    angular.module('assesmenttools').factory('SyncFactory', SyncFactory);

    function SyncFactory($localStorage, $http, appConfig, apiConfig) {
        var factory = {};

        factory.getDivision = function() {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(appConfig.appApi + apiConfig.sync.getDivision);
        };

        factory.getDepartment = function(division) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(
                appConfig.appApi + apiConfig.sync.getDepartment + '/' + division
            );
        };

        factory.syncAccount = function(division, department) {
            $http.defaults.headers.post['Content-Type'] = 'application/json';
            return $http.get(
                appConfig.appApi +
                    apiConfig.sync.account +
                    '/' +
                    division +
                    '/' +
                    department
            );
        };

        return factory;
    }
})();

(function() {
    'use strict';
    angular.module('assesmenttools').factory('Auth', Auth);

    function Auth(
        $http,
        $rootScope,
        $localStorage,
        $location,
        appConfig,
        apiConfig,
        jwtHelper
    ) {
        function user() {
            return $localStorage.user;
        }

        function isLogin() {
            var token = $localStorage.jwt;
            $rootScope.token = token;
            if (typeof token === 'undefined') {
                $location.path('/login');
            }
        }

        function toLogin() {
            $location.path('/login');
        }

        function clearToken() {
            delete $localStorage.jwt;
        }

        function getAccountFromToken() {
            var token = $localStorage.jwt;
            var account = {};
            if (typeof token !== 'undefined') {
                account = token && jwtHelper.decodeToken(token);
            }
            return account;
        }

        return {
            register: function(data, success, error) {
                $http
                    .post(appConfig.appApi + apiConfig.auth.register, data)
                    .success(success)
                    .error(error);
            },
            refreshToken: function() {
                return $http.post(appConfig.appApi + apiConfig.auth.refresh, {
                    token: $localStorage.jwt
                });
            },
            getToken: function() {
                return $localStorage.jwt;
            },
            setToken: function(token) {
                $localStorage.jwt = token;
            },
            login: function(data, success, error) {
                delete $http.defaults.headers.common.Authorization;
                $http.defaults.useXDomain = false;
                // Set the Content-Type
                $http.defaults.headers.post['Content-Type'] = 'application/json';
                // Delete the Requested With Header
                delete $http.defaults.headers.common['X-Requested-With'];
                $http
                    .post(appConfig.appApi + apiConfig.auth.login, data)
                    .then(success, error);
            },
            logout: function(success, error) {
                if ($localStorage.jwt) {
                    $http.defaults.headers.common.Authorization =
                        'Bearer ' + $localStorage.jwt;
                }
                $http
                    .post(appConfig.appApi + apiConfig.auth.logout)
                    .success(success)
                    .error(error);

                $localStorage.$reset();
                success();
                delete $http.defaults.headers.common.Authorization;
            },
            isLogin: isLogin,
            getAccountFromToken: getAccountFromToken,
            user: user,
            toLogin: toLogin,
            clearToken: clearToken
        };
    }
})();

(function() {
    'use strict';

    angular.module('assesmenttools').directive('fileModel', fileModel);

    function fileModel() {
        return {
            restrict: 'A',
            scope: {
                fileModel: '='
            },
            link: function(scope, element) {
                element.bind('change', function(event) {
                    scope.$apply(function() {
                        scope.fileModel = event.target.files[0];
                    });
                });
            }
        };
    }
})();
(function() {
    angular
        .module('assesmenttools')
        .factory('beforeUnload', BeforeUnload)
        .run(BeforeUnload);

    function BeforeUnload($window, $rootScope) {
        // Events are broadcast outside the Scope Lifecycle
        $window.onbeforeunload = function(e) {
            var confirmation = {};
            var event = $rootScope.$broadcast('onBeforeUnload', confirmation);
            if (event.defaultPrevented) {
                event.returnValue = confirmation.message;
                return event;
            }
        };

        $window.onunload = function() {
            $rootScope.$broadcast('onUnload');
        };

        return {};
    }
})();

(function() {
    'use strict';

    angular.module('assesmenttools').controller('MainController', MainController);

    /** @ngInject */
    MainController.$inject = ['$rootScope', '$scope', '$timeout'];

    function MainController($rootScope, $scope, $timeout) {
        $rootScope.SwitchClassBody = 'horizontal-fixed fixed';
    }
})();

(function() {
    "use strict";
    angular.module("assesmenttools").factory("$appHelper", AppHelper);

    AppHelper.$inject = ["$localStorage", "jwtHelper"];

    function AppHelper($localStorage, jwtHelper) {
        var Helper = {
            setToken: setToken,
            decodeToken: decodeToken,
            getToken: getToken,
            clearToken: clearToken
        };

        return Helper;

        function setToken(token) {
            if (!token) {
                return false;
            }
            $localStorage.token = token;
            var decoded = jwtHelper.decodeToken(token);
            Object.keys(decoded.data).forEach(function(key) {
                $localStorage[key] = decoded.data[key];
            });
        }

        function decodeToken() {
            if (!token) {
                return false;
            }
            return jwtHelper.decodeToken;
        }

        function getToken() {
            return $localStorage.token;
        }

        function clearToken() {
            delete $localStorage.token;
        }
    }
})();

(function() {
    "use strict";
    angular.module("assesmenttools").factory("$apiService", ApiService);

    ApiService.$inject = ["appConfig", "$resource"];

    function ApiService(appConfig, $resource) {
        var base = appConfig.appApi;

        var service = {
            auth: auth,
            papikostik: papikostik,
            intray: intray,
            beq: beq,
            behavioral: behavioral,
            survey: survey,
            assessment: assessment
        };

        return service;

        function auth() {
            return $resource(base + "/auth/:action", null, {
                login: {
                    params: { action: "login" },
                    method: "POST",
                    withCredentials: false
                },
                refresh: {
                    params: { action: "refresh" },
                    method: "POST",
                    withCredentials: false
                },
                logout: {
                    params: { action: "logout" },
                    method: "POST",
                    withCredentials: false
                }
            });
        }

        function papikostik(isManagement) {
            var sub = isManagement ? "/management/" : "/assessment/";
            return $resource(base + "/papikostik" + sub + ":endpoint");
        }

        function intray(isManagement) {
            var sub = isManagement ? "/management/" : "/assessment/";
            return $resource(base + "/intray" + sub + ":endpoint");
        }

        function beq() {
            return $resource(base + "/beq/:endpoint");
        }

        function behavioral() {
            return $resource(base + "/behavioral/:endpoint");
        }

        function assessment() {
            return $resource(base + "/assessment/:endpoint", null, {
                sync: {
                    params: { endpoint: "syncTemporary" },
                    method: "POST",
                    withCredentials: false
                },
                submit: {
                    params: { endpoint: "submit" },
                    method: "POST",
                    withCredentials: false
                }
            });
        }

        function survey() {
            return $resource(base + "/survey/:endpoint");
        }
    }
})();

(function() {
    'use strict';
    angular.module('assesmenttools').run(runBlock);
    /** @ngInject */
    function runBlock(
        $log,
        $rootScope,
        $state,
        $localStorage,
        $location,
        jwtHelper,
        blockUI,
        $timeout
    ) {
        $rootScope.$state = $state;

        $rootScope.$on('$stateChangeStart', function(evt, to, params) {
            if (to.url === '/') {
                if (!$localStorage.jwt) {
                    $location.path('/login');
                } else {
                    if ($localStorage.rolesId == 1) {
                        $location.path('/dashboard/admin');
                    } else {
                        $location.path('/dashboard');
                    }
                }
            }
        });

        // var elBody = angular.element(document.body);
        // elBody.niceScroll();

        $rootScope.$on('$stateChangeSuccess', function(evt, to, params) {});

        angular.element.pushMenu = {
            activate: function(toggleBtn) {
                //Enable sidebar toggle
                angular.element(toggleBtn).on('click', function(e) {
                    e.preventDefault();
                    //Enable sidebar push menu
                    if (angular.element(window).width() > 767) {
                        if (angular.element('body').hasClass('sidebar-collapse')) {
                            angular
                                .element('body')
                                .removeClass('sidebar-collapse')
                                .trigger('expanded.pushMenu');
                        } else {
                            angular
                                .element('body')
                                .addClass('sidebar-collapse')
                                .trigger('collapsed.pushMenu');
                        }
                    }
                    //Handle sidebar push menu for small screens
                    else {
                        if (angular.element('body').hasClass('sidebar-open')) {
                            angular
                                .element('body')
                                .removeClass('sidebar-open')
                                .removeClass('sidebar-collapse')
                                .trigger('collapsed.pushMenu');
                        } else {
                            angular
                                .element('body')
                                .addClass('sidebar-open')
                                .trigger('expanded.pushMenu');
                        }
                    }
                    if (
                        angular.element('body').hasClass('fixed') &&
                        angular.element('body').hasClass('sidebar-mini') &&
                        angular.element('body').hasClass('sidebar-collapse')
                    ) {
                        angular.element('.sidebar').css('overflow', 'visible');
                        angular
                            .element('.main-sidebar')
                            .find('.slimScrollDiv')
                            .css('overflow', 'visible');
                    }
                    if (angular.element('body').hasClass('only-sidebar')) {
                        angular.element('.sidebar').css('overflow', 'visible');
                        angular
                            .element('.main-sidebar')
                            .find('.slimScrollDiv')
                            .css('overflow', 'visible');
                    }
                });

                angular.element('.content-wrapper').on('click', function() {
                    //Enable hide menu when clicking on the content-wrapper on small screens
                    if (
                        angular.element(window).width() <= 767 &&
                        angular.element('body').hasClass('sidebar-open')
                    ) {
                        angular.element('body').removeClass('sidebar-open');
                    }
                });
            }
        };

        angular.element.tree = function(menu) {
            var _this = this;
            var animationSpeed = 200;
            angular.element(document).on('click', menu + ' li a', function(e) {
                //Get the clicked link and the next element
                var $this = angular.element(this);
                var checkElement = $this.next();
                //Check if the next element is a menu and is visible
                if (
                    checkElement.is('.treeview-menu') &&
                    checkElement.is(':visible')
                ) {
                    //Close the menu
                    checkElement.slideUp(animationSpeed, function() {
                        checkElement.removeClass('menu-open');
                        //Fix the layout in case the sidebar stretches over the height of the window
                        //_this.layout.fix();
                    });
                    checkElement.parent('li').removeClass('active');
                }
                //If the menu is not visible
                else if (
                    checkElement.is('.treeview-menu') &&
                    !checkElement.is(':visible')
                ) {
                    //Get the parent menu
                    var parent = $this.parents('ul').first();
                    //Close all open menus within the parent
                    var ul = parent.find('ul:visible').slideUp(animationSpeed);
                    //Remove the menu-open class from the parent
                    ul.removeClass('menu-open');
                    //Get the parent li
                    var parent_li = $this.parent('li');
                    //Open the target menu and add the menu-open class
                    checkElement.slideDown(animationSpeed, function() {
                        //Add the class active to the parent li
                        checkElement.addClass('menu-open');
                        parent.find('li.active').removeClass('active');
                        parent_li.addClass('active');
                    });
                }
                //if this isn't a link, prevent the page from being redirected
                if (checkElement.is('.treeview-menu')) {
                    e.preventDefault();
                }
            });
        };
        $log.debug('runBlock end');
    }
})();

(function() {
    'use strict';

    angular.module('assesmenttools').config(routerConfig);

    /** @ngInject */
    function routerConfig(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider,
        $httpProvider
    ) {
        $locationProvider.html5Mode(true);

        $httpProvider.defaults.useXDomain = true;
        $httpProvider.defaults.headers.post['Content-Type'] = 'application/json';
        delete $httpProvider.defaults.headers.common['X-Requested-With'];
        $httpProvider.interceptors.push('AppAuthInterceptor');

        $stateProvider.state('app', {
            url: '/',
            views: {
                'main@': {
                    templateUrl: 'app/main/main.html',
                    controller: 'MainController',
                    controllerAs: 'main'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $urlRouterProvider.otherwise('/');
    }
})();

(function() {
    'use strict';
    angular.module('assesmenttools').factory('AppAuthInterceptor', [
        '$q',
        '$injector',
        function($q, $injector) {
            var cachedRequest = null;
            return {
                request: function(config) {
                    //If request is for refreshToken pass it without Authorization header
                    if (
                        config.url.indexOf('refresh') !== -1 ||
                        config.url.indexOf('login') !== -1
                    ) {
                        return config;
                    } else if (config.url.indexOf('api') !== -1) {
                        var accessToken = $injector.get('$appHelper').getToken();
                        config.headers['Authorization'] = 'Bearer ' + accessToken;
                    }
                    return config;
                },
                responseError: function(response) {
                    switch (response.status) {
                        //Detect if reponse error is 401 (Unauthorized)
                        case 401:
                            //Cache this request
                            var deferred = $q.defer();
                            var apiService = $injector.get('$apiService').auth();
                            var appHelper = $injector.get('$appHelper');
                            if (!cachedRequest) {
                                //Cache request for renewing Access Token and wait for Promise
                                var oToken = appHelper.getToken();
                                cachedRequest = apiService.refresh({
                                    token: oToken
                                });
                            }
                            //When Promise is resolved, new Access Token is returend
                            cachedRequest.$promise.then(function(accessToken) {
                                cachedRequest = null;
                                if (accessToken) {
                                    // renew token on storage
                                    appHelper.setToken(accessToken.token);

                                    //Resend this request when Access Token is renewed
                                    $injector
                                        .get('$http')(response.config)
                                        .then(
                                            function(resp) {
                                                //Resolve this request (successfully this time)
                                                deferred.resolve(resp);
                                            },
                                            function(resp) {
                                                deferred.reject();
                                            }
                                        );
                                } else {
                                    //If any error occurs reject the Promise
                                    deferred.reject();
                                }
                            });
                            cachedRequest.$promise.catch(function(response) {
                                //If any error occurs reject the Promise
                                cachedRequest = null;
                                deferred.reject();
                                return;
                            });
                            return deferred.promise;
                    }
                    //If any error occurs reject the Promise
                    return $q.reject(response);
                }
            };
        }
    ]);
})();

(function () {
    "use strict";

    angular
        .module("assesmenttools")
        .constant("appConfig", {
            appID: "assessmenttools",
            appName: "Assessment Tools",
            appDesc: "Assessment Tools Application",
            appVersion: "1.0.0",
            appApi: "/api/endpoint/v1",
            // appApi: "/api/v1",
            baseUrlApi: "/api",
            questionPic: "/api/question",
        })
        .constant("moment", moment);
})();

(function() {
    'use strict';

    angular.module('assesmenttools').config(config);

    /** @ngInject */
    function config($logProvider, blockUIConfig, $httpProvider, uiSelectConfig) {
        // Enable log
        $logProvider.debugEnabled(true);

        blockUIConfig.message = 'Please wait';
        // blockUIConfig.delay = 300;
        blockUIConfig.autoBlock = false;
        blockUIConfig.templateUrl = 'app/components/core/preloader/loader.html';
        uiSelectConfig.theme = 'selectize';
    }
})();

(function () {
    "use strict";
    angular.module("assesmenttools").constant("apiConfig", {
        auth: {
            login: "/auth/login",
            register: "/auth/register",
            logout: "/auth/logout",
            refresh: "/auth/refresh",
            userlist: "/auth/getUsers"
        },
        accounts: {
            list: "/accounts/list",
            data: "/accounts/data",
            group: "/accounts/group",
            upload: "/accounts/upload",
            create: "/accounts/create",
            delete: "/accounts/delete",
            update: "/accounts/update",
            getUser: "/accounts/getUser",
            sync: "/accounts/sync",
            syncLogs: "/accounts/syncLogs",
            findUser: "/accounts/findUser"
        },
        questionBank: {
            getDataOnly: "/question/bank/data",
            getData: "/question/bank/list",
            getQuestionData: "/question/bank/question",
            saveData: "/question/bank/save",
            uploadData: "/question/bank/upload",
            deleteData: "/question/bank/delete",
            updateData: "/question/bank/update",
            questionPool: {
                getDataOnly: "/question/bank/pool/data",
                getData: "/question/bank/pool/list",
                saveData: "/question/bank/pool/save",
                deleteData: "/question/bank/pool/delete",
                updateData: "/question/bank/pool/update",
                exportData: "/question/bank/pool/export",
                unarchiveData: "/question/bank/pool/unarchive"
            },
            questionCategory: {
                getData: "/question/category/list",
                getDataOnly: "/question/category/data",
                saveData: "/question/category/create",
                deleteData: "/question/category/delete",
                updateData: "/question/category/update"
            }
        },
        behavioral: {
            assessment: {
                question: "/behavioral/assessment/question",
                session: "/behavioral/assessment/session",
                syncTemp: "/behavioral/assessment/syncTemp",
                submit: "/behavioral/assessment/submit"
            },
            question: {
                list: "/behavioral/question/list",
                save: "/behavioral/question/save",
                update: "/behavioral/question/update",
                delete: "/behavioral/question/delete",
                upload: "/behavioral/question/upload",
                template: "/behavioral/question/template"
            },
            range: {
                list: "/behavioral/range/list",
                save: "/behavioral/range/save",
                update: "/behavioral/range/update",
                delete: "/behavioral/range/delete"
            },
            category: {
                list: "/behavioral/category/list",
                save: "/behavioral/category/save",
                update: "/behavioral/category/update",
                delete: "/behavioral/category/delete"
            },
            quality: {
                list: "/behavioral/quality/list",
                save: "/behavioral/quality/save",
                update: "/behavioral/quality/update",
                delete: "/behavioral/quality/delete"
            }
        },

        question: {
            excel: {
                list: "/question/excel/list",
                show: "/question/excel/show/{id}",
                save: "/question/excel/save",
                update: "/question/excel/update",
                delete: "/question/excel/delete"
            },
            excelFile: {
                list: "/question/excel-file/list",
                show: "/question/excel-file/show/{id}",
                save: "/question/excel-file/upload",
                delete: "/question/excel-file/delete",
                download: "/question/excel-file/download/{id}",
                viewer: "/question/excel-file/viewer/{id}"
            }
        },
        tiki: {
            question: {
                load: "/tiki/question/load",
                detail: "/tiki/question/detail",
                create: "/tiki/question/create",
                delete: "/tiki/question/delete",
                update: "/tiki/question/update"
            },
            section: {
                load: "/tiki/section/load",
                detail: "/tiki/section/detail",
                create: "/tiki/section/create",
                delete: "/tiki/section/delete",
                update: "/tiki/section/update"
            },
            assessment: {
                getQuestion: "/tiki/assessment/getQuestion",
                submit: "/tiki/assessment/submit",
                getResult: "/tiki/assessment/getData",
                export: "/tiki/assessment/export",
                sync: "/tiki/assessment/sync",
                date: "/tiki/assessment/date"
            }
        },
        assessment: {
            getQuestion: "/assessment/getquestion",
            getSession: "/assessment/session",
            submit: "/assessment/submit",
            syncTemporary: "/assessment/syncTemporary"
        },
        assessmentTiki: {
            getQuestion: "/tiki/getQuestion",
            submit: "/tiki/submit",
            getResult: "/tiki/getData",
            export: "/tiki/export",
            sync: "/tiki/sync",
            date: "/tiki/date"
        },
        beq: {
            getQuestion: "/beq/question",
            submit: "/beq/submit",
            syncTemp: "/beq/syncTemp"
        },
        survey: {
            getQuestion: "/survey/question",
            submit: "/survey/submit",
            syncTemp: "/survey/syncTemp"
        },
        achievement: {
            data: "/achievement/data",
            detail: "/achievement/detail",
            export: "/achievement/export"
        },
        general: {
            competency: {
                getComp: "/general/competency/list",
                getCompCategory: "/general/competency/category",
                getCompByCategory: "/general/competency/list-by-category",
                getCompCatDataOnly: "/general/competency/data-category",
                getCompDataOnly: "/general/competency/data-competency",
                createCompetency: "/general/competency/createCompetency",
                updateCompetency: "/general/competency/updateCompetency",
                deleteCompetency: "/general/competency/deleteCompetency"
            },
            dashboard: {
                getcomponent: "/general/dashboard/getcomponent",
                getlastsubmit: "/general/dashboard/getlastsubmit"
            }
        },
        enrollment: {
            questionEnrollment: "/enrollment/question-enrollment",
            userParticipant: {
                list: "/enrollment/user-participant/list",
                assign: "/enrollment/user-participant/assign",
                unassign: "/enrollment/user-participant/unassign",
                update: "/enrollment/user-participant/update"
            },
            groupParticipant: {
                data: "/enrollment/group-participant/data",
                list: "/enrollment/group-participant/list",
                save: "/enrollment/group-participant/save",
                update: "/enrollment/group-participant/update",
                delete: "/enrollment/group-participant/delete"
            },
            class: "/enrollment/class/data",
            session: {
                list: "/enrollment/session/list",
                save: "/enrollment/session/save",
                update: "/enrollment/session/update",
                delete: "/enrollment/session/delete"
            }
        },
        MasterData: {
            classroom: {
                getData: "/master/classroom/list",
                save: "/master/classroom/save",
                update: "/master/classroom/update",
                delete: "/master/classroom/delete"
            }
        },
        report: {
            list: "/report/list",
            date: "/report/date",
            detail: "/report/detail",
            export: "/report/export"
        },
        sync: {
            getDivision: "/sync/syncDivision",
            getDepartment: "/sync/syncDepartment",
            account: "/sync/syncAccount"
        },
        papikostik: {
            assessment: {
                question: "/papikostik/assessment/question",
                session: "/papikostik/assessment/session",
                syncTemp: "/papikostik/assessment/syncTemp",
                submit: "/papikostik/assessment/submit"
            },
            management: {
                question: "/papikostik/management/loadDataReport"
            }
        },
        intray: {
            assessment: {
                question: "/intray/assessment/question",
                session: "/intray/assessment/session",
                syncTemp: "/intray/assessment/syncTemp",
                submit: "/intray/assessment/submit"
            }
        }
    });
})();

(function() {
    'use strict';

    angular
        .module('question_bank')
        .config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('app.question_bank.question_behavioral', {
            url: '/question-behavioral',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-behavioral/question-behavioral.html',
                    controller: 'QuestionBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.create', {
            url: '/create',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-behavioral/create-question-behavioral.html',
                    controller: 'CreateQuestionBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.edit', {
            url: '/edit',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-behavioral/edit-question-behavioral.html',
                    controller: 'EditQuestionBehavioralController as vm'
                }
            },
            params: {
                obj: null
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.import', {
            url: '/import',
            views: {
                'question@app.question_bank': {
                    templateUrl:
                        'app/main/modules/question-bank/question-behavioral/import-question-behavioral.html',
                    controller: 'ImportQuestionBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        // range score CRUD
        $stateProvider.state('app.question_bank.question_behavioral.behavioral_range', {
            url: '/behavioral-range',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-range/list-range-behavioral.html',
                    controller: 'RangeBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.behavioral_range.create', {
            url: '/create',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-range/create-range-behavioral.html',
                    controller: 'CreateRangeBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.behavioral_range.edit', {
            url: '/edit',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-range/edit-range-behavioral.html',
                    controller: 'EditRangeBehavioralController as vm'
                }
            },
            params: {
                obj: null
            },
            data: {
                requiresLogin: true
            }
        });

        // category score CRUD
        $stateProvider.state('app.question_bank.question_behavioral.behavioral_category', {
            url: '/behavioral-category',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-category/list-category-behavioral.html',
                    controller: 'CategoryBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.behavioral_category.create', {
            url: '/create',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-category/create-category-behavioral.html',
                    controller: 'CreateCategoryBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.behavioral_category.edit', {
            url: '/edit',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-category/edit-category-behavioral.html',
                    controller: 'EditCategoryBehavioralController as vm'
                }
            },
            params: {
                obj: null
            },
            data: {
                requiresLogin: true
            }
        });

        // quality score CRUD
        $stateProvider.state('app.question_bank.question_behavioral.behavioral_quality', {
            url: '/behavioral-quality',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-quality/list-quality-behavioral.html',
                    controller: 'QualityBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.behavioral_quality.create', {
            url: '/create',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-quality/create-quality-behavioral.html',
                    controller: 'CreateQualityBehavioralController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });

        $stateProvider.state('app.question_bank.question_behavioral.behavioral_quality.edit', {
            url: '/edit',
            views: {
                'question@app.question_bank': {
                    templateUrl: 'app/main/modules/question-bank/question-behavioral/behavioral-quality/edit-quality-behavioral.html',
                    controller: 'EditQualityBehavioralController as vm'
                }
            },
            params: {
                obj: null
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('assessment_papikostik', []).config(config);

    config.$inject = ['$stateProvider'];

    function config($stateProvider) {
        $stateProvider.state('app.assessment-papikostik', {
            url: 'assessment-papi/{poolId}/{sessionId}',
            views: {
                'content@app': {
                    templateUrl:
                        'app/main/modules/assessment-papikostik/assessment-papikostik.html',
                    controller: 'AssessmentPapikostikController as vm'
                }
            },
            data: {
                requiresLogin: true
            }
        });
    }
})();


angular.module("assesmenttools").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<header-assessment></header-assessment><navbar-assessment></navbar-assessment><sidebar-assessment></sidebar-assessment><div class=content-wrapper ui-view=content></div>");
$templateCache.put("app/components/core/lightbox/lightbox.html","<div class=modal-body><!-- image --><div class=lightbox-image-container><img lightbox-src={{Lightbox.imageUrl}} style=\"width: 600px\"></div><!-- caption --><div class=\"alert alert-info\" style=\"margin: 1em 0 0\"><strong>{{Lightbox.imageCaption}}</strong></div></div>");
$templateCache.put("app/components/core/header/header.html","<!-- Navbar--><header class=\"main-header-top hidden-print\"><a href=index.html class=logo><img class=\"img-fluid able-logo\" src=assets/images/logo.png alt=Theme-logo> {{vm.appName}}</a><nav class=\"navbar navbar-static-top\"><!-- Sidebar toggle button--> <a href=#! data-toggle=offcanvas class=\"sidebar-toggle hidden-md-up\"></a><!-- Navbar Right Menu--><div class=navbar-custom-menu><ul class=top-nav><!-- User Menu--><li class=dropdown><a href=#! data-toggle=dropdown role=button aria-haspopup=true aria-expanded=false class=\"dropdown-toggle drop icon-circle drop-image\"><span><img class=rounded-circle src=assets/images/avatar-4.png style=width:30px alt=\"User Image\"> </span><span><b>{{vm.userName}}</b> <i class=\"icofont icofont-simple-down\"></i></span></a><ul class=\"dropdown-menu settings-menu\"><li ng-click=vm.logout()><a href=javascript:void(0);><i class=icon-logout></i> Logout</a></li></ul></li></ul></div></nav></header>");
$templateCache.put("app/components/core/navbar/navbar.html","<!-- Side-Nav--><aside class=\"main-sidebar hidden-print\"><section class=sidebar id=sidebar-scroll><div class=user-panel><div class=\"f-left image\"><img src=assets/images/avatar-1.png alt=\"User Image\" class=rounded-circle></div><div class=\"f-left info\"><p>John Doe</p><p class=designation>UX Designer <i class=\"fa fa-sort-down m-l-5\"></i></p></div></div><!--horizontal Menu Starts--><ul class=sidebar-menu><li class=nav-level>Navigation</li><li ng-class=\"{active: vm.$state.includes(\'app.dashboard\')}\" ng-if=\"vm.roles == 3\"><a ui-sref=app.dashboard><i class=icon-speedometer></i> <span>Dashboard</span></a></li><li ng-class=\"{active: vm.$state.includes(\'app.dashboard.admin\')}\" ng-if=\"vm.roles != 3\"><a ui-sref=app.dashboard.admin><i class=icon-speedometer></i> <span>Dashboard</span></a></li><li ng-class=\"{active: vm.$state.includes(\'app.account\')}\" ng-if=\"vm.roles != 3\"><a ui-sref=app.account><i class=icon-people></i> <span>Accounts</span></a></li><li ng-class=\"{active: vm.$state.includes(\'app.question_bank\')}\" ng-if=\"vm.roles != 3\"><a ui-sref=app.question_bank><i class=icon-question></i> <span>Question & Answer</span></a></li><li ng-class=\"{active: vm.$state.includes(\'app.enrollment\')}\" ng-if=\"vm.roles != 3\"><a ui-sref=app.enrollment><i class=icon-pin></i> <span>Enrollment</span></a></li><li ng-class=\"{active: vm.$state.includes(\'app.report\')}\" ng-if=\"vm.roles != 3\"><a ui-sref=app.report><i class=icon-badge></i> <span>Report</span></a></li></ul><!--horizontal Menu Ends--></section></aside>");
$templateCache.put("app/components/core/pagination/pagination.html","<nav aria-label=\"Page navigation\"><ul class=\"pagination justify-content-end\"><li ng-show=\"vm.currentPage != 1\" class=page-item><a href=javascript:void(0) class=page-link tabindex=-1 ng-click=vm.loadData(vm.currentPage-1)>Previous</a></li><li ng-repeat=\"i in vm.range\" class=page-item ng-class=\"{active : vm.currentPage == i}\"><a href=javascript:void(0) class=page-link ng-click=vm.loadData(i)>{{i}}</a></li><li ng-show=\"vm.currentPage != vm.totalPages\" class=page-item><a href=javascript:void(0) class=page-link ng-click=vm.loadData(vm.currentPage+1)>Next</a></li></ul></nav>");
$templateCache.put("app/components/core/preloader/loader.html","<div class=block-ui-overlay></div><div class=block-ui-message-container><div class=loader-block><div class=lds-ripple><div></div><div></div></div></div><div class=block-ui-message style=\"font-size: 16px; font-weight: 400\">{{ state.message }}</div></div>");
$templateCache.put("app/components/core/section/section.html","<img ng-src={{vm.instruction}} alt=\"\">");
$templateCache.put("app/components/core/sidebar/sidebar.html","<div id=sidebar class=\"p-fixed header-users showChat\"><div class=had-container><div class=\"card card_main header-users-main\"><div class=\"card-content user-box\"><div class=\"md-group-add-on p-20\"><span class=md-add-on><i class=\"icofont icofont-search-alt-2 chat-search\"></i></span><div class=md-input-wrapper><input type=text class=md-form-control name=username id=search-friends><label>Search</label></div></div><div class=\"media friendlist-main\"><h6>Friend List</h6></div><div class=main-friend-list><div class=\"media friendlist-box\" data-id=1 data-status=online data-username=\"Josephin Doe\" data-toggle=tooltip data-placement=left title=\"Josephin Doe\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Josephin Doe</div><span>20min ago</span></div></div><div class=\"media friendlist-box\" data-id=3 data-status=online data-username=Alice data-toggle=tooltip data-placement=left title=Alice><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-2.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Alice</div><span>1 hour ago</span></div></div><div class=\"media friendlist-box\" data-id=7 data-status=offline data-username=\"Michael Scofield\" data-toggle=tooltip data-placement=left title=\"Michael Scofield\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-3.png alt=\"Generic placeholder image\"><div class=\"live-status bg-danger\"></div></a><div class=media-body><div class=friend-header>Michael Scofield</div><span>3 hours ago</span></div></div><div class=\"media friendlist-box\" data-id=5 data-status=online data-username=\"Irina Shayk\" data-toggle=tooltip data-placement=left title=\"Irina Shayk\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-4.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Irina Shayk</div><span>1 day ago</span></div></div><div class=\"media friendlist-box\" data-id=6 data-status=offline data-username=\"Sara Tancredi\" data-toggle=tooltip data-placement=left title=\"Sara Tancredi\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-5.png alt=\"Generic placeholder image\"><div class=\"live-status bg-danger\"></div></a><div class=media-body><div class=friend-header>Sara Tancredi</div><span>2 days ago</span></div></div><div class=\"media friendlist-box\" data-id=1 data-status=online data-username=\"Josephin Doe\" data-toggle=tooltip data-placement=left title=\"Josephin Doe\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Josephin Doe</div><span>20min ago</span></div></div><div class=\"media friendlist-box\" data-id=3 data-status=online data-username=Alice data-toggle=tooltip data-placement=left title=Alice><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-2.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Alice</div><span>1 hour ago</span></div></div><div class=\"media friendlist-box\" data-id=1 data-status=online data-username=\"Josephin Doe\" data-toggle=tooltip data-placement=left title=\"Josephin Doe\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Josephin Doe</div><span>20min ago</span></div></div><div class=\"media friendlist-box\" data-id=3 data-status=online data-username=Alice data-toggle=tooltip data-placement=left title=Alice><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-2.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Alice</div><span>1 hour ago</span></div></div><div class=\"media friendlist-box\" data-id=1 data-status=online data-username=\"Josephin Doe\" data-toggle=tooltip data-placement=left title=\"Josephin Doe\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Josephin Doe</div><span>20min ago</span></div></div><div class=\"media friendlist-box\" data-id=3 data-status=online data-username=Alice data-toggle=tooltip data-placement=left title=Alice><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-2.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Alice</div><span>1 hour ago</span></div></div><div class=\"media friendlist-box\" data-id=1 data-status=online data-username=\"Josephin Doe\" data-toggle=tooltip data-placement=left title=\"Josephin Doe\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Josephin Doe</div><span>20min ago</span></div></div><div class=\"media friendlist-box\" data-id=1 data-status=online data-username=\"Josephin Doe\" data-toggle=tooltip data-placement=left title=\"Josephin Doe\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Josephin Doe</div><span>20min ago</span></div></div><div class=\"media friendlist-box\" data-id=1 data-status=online data-username=\"Josephin Doe\" data-toggle=tooltip data-placement=left title=\"Josephin Doe\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Josephin Doe</div><span>20min ago</span></div></div><div class=\"media friendlist-box\" data-id=1 data-status=online data-username=\"Josephin Doe\" data-toggle=tooltip data-placement=left title=\"Josephin Doe\"><a class=media-left href=\"\"><img class=\"media-object img-circle\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=media-body><div class=friend-header>Josephin Doe</div><span>20min ago</span></div></div></div></div></div></div></div><div class=showChat_inner><div class=\"media chat-inner-header\"><a class=back_chatBox><i class=\"icofont icofont-rounded-left\"></i> Josephin Doe</a></div><div class=\"media chat-messages\"><a class=\"media-left photo-table\" href=\"\"><img class=\"media-object img-circle m-t-5\" src=assets/images/avatar-1.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a><div class=\"media-body chat-menu-content\"><div><p class=chat-cont>I\'m just looking around. Will you tell me something about yourself?</p><p class=chat-time>8:20 a.m.</p></div></div></div><div class=\"media chat-messages\"><div class=\"media-body chat-menu-reply\"><div><p class=chat-cont>I\'m just looking around. Will you tell me something about yourself?</p><p class=chat-time>8:20 a.m.</p></div></div><div class=\"media-right photo-table\"><a href=\"\"><img class=\"media-object img-circle m-t-5\" src=assets/images/avatar-2.png alt=\"Generic placeholder image\"><div class=\"live-status bg-success\"></div></a></div></div><div class=\"media chat-reply-box\"><div class=md-input-wrapper><input type=text class=md-form-control id=inputEmail name=inputEmail><label>Share your thoughts</label><span class=highlight></span> <span class=bar></span> <button type=button class=\"chat-send waves-effect waves-light\"><i class=\"icofont icofont-location-arrow f-20\"></i></button></div></div></div>");
$templateCache.put("app/main/modules/account/account.html","<div class=container-fluid><div class=row><div class=\"col-md-12 m-t-20\"><div class=card><div class=card-header><h5>List Account</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create Account</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button><md-button ng-click=vm.gotoImport($event) class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Import Account</md-tooltip><md-font-icon class=\"fa fa-upload fa-lg\"></md-font-icon>&nbsp;&nbsp;IMPORT</md-button><!-- <md-button ng-click=\"vm.gotoSync($event)\" class=\"btn btn-mini-center btn-primary m-t-0\">\n                                    <md-tooltip md-direction=\"top\">Sync Account</md-tooltip>\n                                    <md-font-icon class=\"fa fa-refresh fa-lg\"></md-font-icon>&nbsp;&nbsp;SYNC\n                                </md-button> --></div></div><div class=col-md-7><div class=row><div class=col-md-2></div><div class=col-md-10><form class=form-horizontal><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table style=\"padding: 2px\" class=\"table table-small-font table-condensed table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th>NIK</th><th>NAME</th><!-- <th>EMAIL</th> --><th>GROUP</th><th>UPDATED AT</th><th>ACTION</th></tr></thead><tbody><tr ng-repeat=\"item in vm.listUser\"><td class=text-center>{{item.id}}</td><td class=text-center>{{item.nik}}</td><td class=text-center>{{item.name}}</td><!-- <td class=\"text-center\">{{ item.email }}</td> --><td class=text-center>{{item.roles.group.name}}</td><td class=text-center>{{item.updated_at != null ? item.updated_at : \'-\'}}</td><td style=\"text-align: center\"><button class=\"btn btn-mini-center btn-primary\" ng-click=vm.gotoEdit(item)><md-tooltip md-direction=top>Edit</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=vm.gotoDelete(item)><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/achievement/achievement-detail.html","<!-- Container-fluid starts --><div class=container-fluid><div class=row><div class=\"col-md-12 m-t-20\"><div class=card><div class=card-header><h5 class=text-center>Detail Report {{ vm.data.user.name }} - {{ vm.data.user.nik }}</h5><p class=text-center>Question Total : {{ vm.data.achievement.question_total}}</p><p class=text-center>Finished Date : {{ vm.data.achievement.finished_date}}</p><p class=text-center>Finished Time : {{ vm.data.achievement.finished_at}}</p><p class=text-center>Score : {{ vm.data.achievement.score}}</p></div><div class=card-block><div class=md-card-block><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\" id=table-detail><thead><tr><th style=\"vertical-align: middle\">NO</th><th style=\"vertical-align: middle\">Question</th><th style=\"vertical-align: middle\">Competency</th><th style=\"vertical-align: middle\">Category</th><th style=\"vertical-align: middle\" ng-if=vm.isCanPreviewAbjact()>User Answer</th><th style=\"vertical-align: middle\" ng-if=vm.isCanPreviewAbjact()>User Abjact</th><th style=\"vertical-align: middle\">Flag</th></tr></thead><tbody><tr ng-repeat=\"item in vm.data.response\"><td style=\"vertical-align: middle\">{{$index+1}}</td><td style=\"vertical-align: middle\">{{item.question.question}}</td><td style=\"vertical-align: middle; width: 20%\">{{item.competency.code}} - {{item.competency.competency}}</td><td style=\"vertical-align: middle; width: 15%\">{{item.category.name}}</td><td style=\"vertical-align: middle\" ng-if=vm.isCanPreviewAbjact()>{{item.user_answer_text}}</td><td style=\"vertical-align: middle; text-align: center\" ng-if=vm.isCanPreviewAbjact()>{{item.user_answer_abjact}}</td><td style=\"vertical-align: middle; text-align: center\"><span class=\"badge badge-success\" ng-if=\"item.flag == 1\">TRUE</span> <span class=\"badge badge-danger\" ng-if=\"item.flag == 0\">FALSE</span></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/achievement/achievement.html","<div class=container-fluid><div class=row><div class=\"col-md-12 m-t-10\"><div class=card><div class=card-header><div class=card-header-text>Assessment Result</div></div><div class=card-block><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>No</th><th>Name</th><th>Nik</th><th>Group Code</th><th>Group Name</th><th>Finished Date</th><th>Submit time</th><th>Question Total</th><th>Correct</th><th>Wrong</th><th>Score</th><th>action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.achievement\" ng-if=vm.achievement><td>{{$index+1}}</td><td>{{item.user_name}}</td><td>{{item.user_nik}}</td><td>{{item.user_group_code}}</td><td>{{item.user_group_name}}</td><td>{{item.finished_date}}</td><td>{{item.submit_time}}</td><td style=\"background-color: #DAA520; color: #fff\">{{item.question_total}}</td><td style=\"background-color: #29AB87; color: #fff\">{{item.correct_answer}}</td><td style=\"background-color: #FA8072; color: #fff\">{{item.wrong_answer}}</td><td style=\"background-color: #008ECC; color: #fff\">{{item.score}}</td><td style=\"text-align: center; width: 5%\"><span class=badge ng-click=vm.getDetail(item) style=\"padding: 0\"><md-tooltip md-direction=top>View Detail</md-tooltip><i class=\"material-icons text-primary\">visibility</i></span></td></tr></tbody></table></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/assessment/assessment.html","<div class=container-fluid block-ui=block-playground id=assessment><div class=row><div class=col-md-12><div class=row><div class=\"col-md-12 m-t-20\"><div class=assessment-progress ng-if=vm.isExplanationRead><div class=assessment-bar ng-style=vm.progressWidth>{{vm.progressWidth.width}}</div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"row m-b-0 m-t-10\"><div class=col-lg-12 ng-if=!vm.isExplanationRead><div class=\"row d-block p-10\"><div class=col><div class=card><div class=card-block><div class=row><div class=col><h4 style=\"font-weight:bold; color: green\" class=card-title>{{ vm.sessionLocal.pool.name }}</h4></div><div class=col style=\"text-align: end\"><button ng-click=\"vm.gotoSlides(vm.slideIndex, true)\" class=\"btn btn-primary\" ng-disabled=vm.slide1><i class=\"fa fa-chevron-left\"></i></button> <button ng-click=\"vm.gotoSlides(vm.slideIndex, false)\" ng-disabled=vm.slide3 class=\"btn btn-primary\"><i class=\"fa fa-chevron-right\"></i></button></div></div><p class=card-text></p><h5 style=\"font-weight:bold; color: green\">Waktu {{vm.sessionLocal.duration}} Menit</h5><h6 style=\"font-weight:bold; color: green\">Instruksi :</h6><div ng-if=vm.slide1><p style=font-size:1.5em>Dalam test ini terdiri dari {{ vm.questions.length }} soal Cara mengerjakannya :</p><p><b style=font-size:1.5em>Cara Menjawab :</b></p><p style=margin:1em><ol><li>Pilihlah salah satu jawaban yang anda anggap benar dengan cara memilih salah satu huruf pilihan jawaban sesuai dengan nomor soal pada lembar jawaban anda</li><li>klik “SUBMIT”</li><li>klik tombol “NEXT” untuk soal selanjutnya.</li></ol></p></div><div ng-if=vm.slide2><p style=font-size:1.5em>Dalam test ini terdiri dari {{ vm.questions.length }} soal terkait dengan test teknikal. Cara mengerjakannya :</p><p><b style=font-size:1.5em>Cara Edit:</b></p><p style=font-size:1.5em>Apabila terdapat ralat/perbaikan terhadap jawaban anda,</p><p style=margin:1em><ol><li>Anda klik “EDIT” pilih jawaban yang benar</li><li>klik “SUBMIT”</li><li>“NEXT” untuk soal selanjutnya.</li></ol></p></div><div ng-if=vm.slide3><div style=\"font-size:1.5em; padding: 1em\"><p style=font-size:1.2em>Pada test ini, waktu yang disediakan {{ vm.sessionLocal.duration }} menit.</p><p style=font-size:1.2em>Ketika anda menekan tombol <b>MULAI</b>,<br>maka waktu test akan mulai berjalan.</p></div><div style=\"padding: 1em\"><button ng-click=vm.isAlreadyReaded() class=\"btn btn-primary\">MULAI</button></div></div><p></p></div><img class=card-img-top style=\"width:600px; height:300px\" imageonload=assets/guide/guide2.PNG src=assets/loader.svg ng-if=vm.slide1> <img class=card-img-top style=\"width:600px; height:300px\" imageonload=assets/guide/guide1.PNG src=assets/loader.svg ng-if=vm.slide2></div></div></div></div><div class=col-lg-12 ng-if=vm.isExplanationRead><div class=card><div class=card-header><div class=\"d-flex flex-row justify-content-between align-items-center\"><div class=d-flex><h4 class=card-header-text>Question : {{vm.question.index + 1}} from {{vm.localStorage.questions.length}}</h4></div><div class=\"d-flex flex-column align-self-start\"><h4 class=\"d-flex flex-row card-header-text p-b-5\">Remaining times : {{ vm.displayTimer }}</h4></div></div></div><div class=card-block><div class=\"row m-l-20 m-b-10 assessment-question\">{{vm.question.question_data.question}}</div><div class=\"row m-b-10 align-items-center justify-content-center container-img\" ng-if=\"vm.question.question_data.having_images == 1\"><img class=\"img-fluid img-assessment\" ng-class=vm.zoom imageonload={{vm.linkImages}}/{{vm.question.question_data.images}} src=assets/loader.svg ng-click=vm.zoomEvent() alt=\"\"></div><div class=\"row m-l-20 assessment-answer-list\" ng-repeat=\"item in vm.question.question_data.answer\"><label class=align-items-center><md-checkbox class=blue id=answer-{{item.id}} ng-change=\"vm.progress = !vm.progress\" ng-disabled=vm.disabledCheckbox(vm.question.question_data.isSubmitted) ng-model=item.flag aria-label=\"Checkbox 2\" ng-true-value=1 ng-false-value=0 name=answer{{$index}}-{{item.id}}></md-checkbox><span class=\"p-l-5 text-answer\"><b style=\"font-size: 1.2em\">{{vm.convertIntToChar($index)}}.</b> {{item.answer}}</span></label></div><div class=row><div class=\"p-l-15 p-t-10 m-t-5 m-l-20\" ng-if=vm.showAction><button class=\"btn btn-primary\" ng-disabled=vm.disabledEditQuestion(vm.question.question_data) ng-click=\"vm.editQuestion(vm.question.question_data, vm.question.index)\">edit</button></div><div class=\"p-l-5 p-t-10 m-t-5\" ng-if=vm.showAction><button class=\"btn btn-warning\" ng-disabled=vm.disabledSubmitQuestion(vm.question.question_data) ng-click=\"vm.submitQuestion(vm.question.question_data, vm.question.index)\">submit</button></div></div><div class=\"row align-items-center justify-content-center m-t-20\"><nav><ul class=\"pagination assessment-nav\"><li class=\"page-item p-r-5\" ng-if=vm.showAction><button class=\"btn btn-inverse-danger page-link nav-button\" ng-disabled=vm.prevDisabled(vm.question) ng-click=vm.prevQuestion()>Previous</button></li><li class=page-item ng-if=vm.showAction><button class=\"btn btn-inverse-danger page-link nav-button\" ng-disabled=vm.nextDisabled(vm.question.question_data) ng-click=vm.nextQuestion(vm.question)>Next</button></li></ul></nav></div></div></div></div></div><div class=\"row assessment-final-submit m-b-10\" ng-if=vm.showFinalSubmit><div class=col-md-12><button type=button ng-click=vm.submitAssessment() class=\"btn btn-block btn-primary\"><i class=\"icon icon-check\" style=\"font-size: 25px\"></i> <span style=\"font-size: 25px\">&nbsp;Submit</span></button></div></div></div></div></div>");
$templateCache.put("app/main/modules/assessment-behavioral/assessment-behavioral.html","<div class=container-fluid id=assessment-behavioral block-ui=block-playground><div class=row><div class=col-lg-12><div class=header-content><div flex=100 layout=row layout-align=\"start center\"><div flex-gt-sm=10 flex-xs=15><h4 class=card-header-text><span hide show-gt-sm>Question :</span> <span hide show-xs>Q : </span>{{vm.data.questions.length}}</h4></div><div flex flex-gt-sm=70 flex-xs=25><div hide show-gt-xs class=assessment-progress><div class=assessment-bar ng-style=vm.progressWidth>{{vm.progressWidth.width}}</div></div><span hide class=progress-mobile show-xs>P : {{vm.progressWidth.width}}</span></div><div class=\"p-l-10 p-r-10\" flex flex-xs=20 layout=row layout-align=\"end center\"><h4 class=card-header-text>{{ vm.displayTimer }}</h4></div><div flex flex-gt-sm=10 layout=row layout-align=\"end center\"><button ng-click=vm.submitConfirmation() class=\"btn btn-outline-primary btn-submit rounded-circle\"><i class=\"fa fa-1x fa-send\"></i> <span>Finish</span></button></div></div></div></div><div class=col-lg-12><div class=card><div class=card-content><div class=behavioral-layout><div class=question-wrapper id=question-wrapper><div class=question-navigation-mobile><div class=question-navigation-title>Navigasi</div><div class=question-navigation-list><button type=button class=question-navigation-item ng-repeat=\"item in vm.data.questions track by $index\" ng-click=vm.scrollToQuestion($index) ng-class=\"vm.getNavigationClass(item, $index)\">{{ vm.pad2(item.number) }}</button></div></div><div layout=column flex layout-align=\"start center\" class=question-container ng-repeat=\"item in vm.data.questions track by $index\" id=question-item-{{$index}} ng-class=\"vm.getNavigationClass(item, $index)\"><div class=content-number><span>SOAL {{ vm.pad2(item.number)}} : </span>{{ item.text }} &lt;- [{{item.competency.competency}}]</div><div class=answer-list><label class=answer-item ng-repeat=\"a in item.answers\" ng-class=\"{\'selected\': item.selectedAnswer === a.option}\"><input class=answer-radio type=radio ng-change=vm.onQualityChange() name=question{{item.number}} ng-model=item.selectedAnswer ng-value=a.option><div class=answer-option>{{a.option}}</div><div class=answer-text>{{a.text}}</div></label></div><div layout=column layout-align=\"start start\" class=reason-container><div>Reason:</div><textarea class=input-rationale name=question{{item.number}}_reason ng-model=item.reason rows=4 placeholder=\"Tuliskan alasan Anda\"></textarea></div></div></div><div class=question-navigation><div class=question-navigation-title>Navigasi</div><div class=question-navigation-list><button type=button class=question-navigation-item ng-repeat=\"item in vm.data.questions track by $index\" ng-click=vm.scrollToQuestion($index) ng-class=\"vm.getNavigationClass(item, $index)\">{{ vm.pad2(item.number) }}</button></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/assessment-beq/assessment-beq.html","<div class=container-fluid id=assessment-beq block-ui=block-playground><div class=\"row section-row\"><div class=\"col-lg-9 question-container\"><div class=\"row m-10 m-b-20\" ng-repeat-start=\"item in vm.data.questions\"><div id=anchor_{{item.number}} class=\"col-md-12 question-wrapper\"><span class=no>{{item.number}}</span> {{item.question}}</div><div class=\"col-md-12 text-right\"><div ng-if=\"!item.is_valid && !item.answer\" class=empty-answer>This is required</div></div><div class=col-md-12><textarea rows=20 ui-tinymce=vm.tinyMceOptions ng-model=item.answer>\n                  </textarea></div></div><div class=divider ng-repeat-end></div></div><div class=col-lg-3><div layout=row><div class=\"m-10 m-t-30 m-b-20\" layout=column flex=100 layout-align=\"space-between center\"><div class=instruction><span style=\"display: block\"><b>INSTRUKSI</b></span> jawablah setiap pertanyaan dengan jelas berdasarkan pengalaman saudara yang paling berkesan.</div><button ng-class=\"{\'btn-danger\' : vm.timeInterval <= 0 || (vm.timeInterval < 30 && vm.timeInterval % 2 == 0)}\" class=\"btn btn-block btn-primary\">{{ vm.displayTimer }}</button> <button ng-click=vm.goToQuestion(item.number) ng-repeat=\"item in vm.data.questions\" class=\"btn btn-block\" ng-class=\"{\'btn-success\' : item.answer, \'btn-danger\' : !item.is_valid && !item.answer}\">{{item.number}}</button> <button ng-disabled=vm.disabledSubmit ng-click=vm.submit($event) class=\"btn btn-block btn-outline-primary btn-submit rounded-circle\"><i class=\"fa fa-1x fa-send\"></i> <span>Finish</span></button></div></div></div></div></div>");
$templateCache.put("app/main/modules/assessment-excel/assessment-excel.html","");
$templateCache.put("app/main/modules/assessment-intray/assessment-intray.html","<div class=container-fluid id=assessment-intray block-ui=block-playground><div class=\"row p-t-20\"><div class=col-lg-12><div class=header-content flex=100 layout=row layout-align=\"start center\"><div class=instruction><span style=\"display: block\"><b>INSTRUKSI</b></span> berikan respon terhadap persoalan yang ada! jawablah pertanyaan dengan jawaban yang relevan</div><div class=\"p-l-10 p-r-10\" flex flex-xs=20 layout=row layout-align=\"end center\"><h4 class=card-header-text>{{ vm.displayTimer }}</h4></div><div flex flex-gt-sm=10 layout=row layout-align=\"end center\"><button ng-click=vm.submit() class=\"btn btn-outline-primary btn-submit rounded-circle\"><i class=\"fa fa-1x fa-send\"></i> <span>Finish</span></button></div></div></div></div><div class=\"row main-content\" ng-repeat=\"item in vm.data.questions\"><div class=\"col-md-6 question-content\"><embed ng-src={{vm.getQuestionUrl(item.filename)}} type=application/pdf></div><div class=\"col-md-6 answer-content\"><div ng-repeat=\"answer in item.answers\" class=answer-content-container><textarea ng-disabled=vm.disabledAnswer rows=20 ui-tinymce=vm.tinyMceOptions ng-model=answer.content>\n                        </textarea></div></div></div></div>");
$templateCache.put("app/main/modules/assessment-papikostik/assessment-papikostik.html","<div class=container-fluid id=assessment-papikostik block-ui=block-playground><div class=row><div class=col-md-12><div class=\"row m-b-0\"><div class=col-lg-12><div class=header-content><div flex=100 layout=row layout-align=\"start center\"><div flex-gt-sm=10 flex-xs=15><h4 class=card-header-text><span hide show-gt-sm>Question :</span> <span hide show-xs>Q : </span>{{vm.data.questions.length}}</h4></div><div flex flex-gt-sm=70 flex-xs=25><div hide show-gt-xs class=assessment-progress><div class=assessment-bar ng-style=vm.progressWidth>{{vm.progressWidth.width}}</div></div><span hide class=progress-mobile show-xs>P : {{vm.progressWidth.width}}</span></div><div class=\"p-l-10 p-r-10\" flex flex-xs=20 layout=row layout-align=\"end center\"><h4 class=card-header-text>{{ vm.displayTimer }}</h4></div><div flex flex-gt-sm=10 layout=row layout-align=\"end center\"><button ng-disabled=vm.disabledFinish ng-click=vm.submitConfirmation() class=\"btn btn-outline-primary btn-submit rounded-circle\"><i class=\"fa fa-1x fa-send\"></i> <span>Finish</span></button></div></div></div></div><div class=col-lg-12><div class=card><div class=card-content><div class=question-wrapper><div flex flex-gt-sm=50 layout=row><span class=instruction>Pilihlah satu pernyataan itu yang anda rasakan paling mendekati gambaran diri anda.</span></div><div layout=row flex layout-align=\"start center\" class=question-container ng-repeat=\"item in vm.data.questions\"><div flex=5 class=content-number ng-style=\"{\'background\': item.selected ? \'green\' : \'bisque\', \'color\': item.selected ? \'white\' : \'black\'}\">{{$index + 1}}</div><div flex layout-align=center class=content-answer-wrapper><div class=content-answer-container ng-repeat=\"point in item.papikostik_answers\"><label for={{item.id}}_{{point.id}}_radio class=\"input-control radio\"><input type=radio id={{item.id}}_{{point.id}}_radio name={{item.id}} ng-value=point.id ng-model=item.selected ng-disabled=item.disabled ng-click=\"vm.runCheck = !vm.runCheck\"> <span class=input-control__indicator></span> {{point.text}}</label></div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/assessment-survey/assessment-survey.html","<div class=container-fluid id=assessment-survey block-ui=block-playground><div class=row><div class=col-lg-12><div class=\"row main-wrapper\"><div class=\"col-lg-10 m-t-20 form-wrapper\"><form name=frmSurvey ng-cloack><table class=custom-table><thead><tr><th>No</th><th>Pernyataan</th><th class=column-answer>STS</th><th class=column-answer>TS</th><th class=column-answer>N</th><th class=column-answer>S</th><th class=column-answer>SS</th></tr></thead><tbody><tr ng-repeat=\"item in vm.data.questions.normal\"><td class=align-center>{{item.number}}</td><td>{{item.question}}</td><td class=column-answer ng-repeat=\"answer in item.answers\"><div class=text-center><input type=radio class=answer-radio required name=answers_radio_{{item.number}} ng-model=item.selected ng-value=answer.value></div></td></tr></tbody></table><div class=\"row m-l-0 m-r-5 m-t-10 m-b-20\" ng-repeat-start=\"item in vm.data.questions.essay\"><div id=anchor_{{item.number}} class=\"col-md-12 question-wrapper\"><span class=no>{{item.number}}</span> <strong>{{item.question}}</strong></div><div class=\"col-md-12 text-right\"><div ng-show=\"frmSurvey[\'essay_\' + {{$index}}].$invalid && !frmSurvey[\'essay_\' + {{$index}}].$pristine\" class=empty-answer>This is required</div></div><div class=\"col-md-12 p-0\"><textarea name=essay_{{$index}} required rows=10 class=answer_essay ng-model=item.answer>\n                          </textarea></div></div><div class=divider ng-repeat-end></div></form></div><div class=col-lg-2><div layout=row><div class=\"m-10 m-t-30 m-b-20\" layout=column flex=100><div class=instruction><span style=\"display: block\"><b>INSTRUKSI</b></span> Dari pernyataan yang tertera, silahkan pilih salah satu yang sangat sesuai dengan diri anda.</div><div class=instruction><span style=\"display: block\"><b>KETERANGAN</b></span><table><tr><td>STS</td><td>:</td><td>Sangat Tidak Setuju</td></tr><tr><td>TS</td><td>:</td><td>Tidak Setuju</td></tr><tr><td>N</td><td>:</td><td>Netral</td></tr><tr><td>S</td><td>:</td><td>Setuju</td></tr><tr><td>SS</td><td>:</td><td>Sangat Setuju</td></tr></table></div><button ng-class=\"{\'btn-danger\' : vm.timeInterval <= 0 || (vm.timeInterval < 30 && vm.timeInterval % 2 == 0)}\" class=\"btn btn-block btn-primary\">{{ vm.displayTimer }}</button> <button ng-disabled=vm.disabledSubmit ng-click=vm.submit($event) class=\"btn btn-block btn-outline-primary btn-submit rounded-circle\"><i class=\"fa fa-1x fa-send\"></i> <span>Finish</span></button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/assessment-tiki/assessment-tiki.html","<div class=container-fluid id=assessment><div class=row><div class=col-md-12><div class=row><div class=\"col-md-12 m-t-20\"><div class=card style=margin-bottom:10px ng-if=vm.selectedSection.is_guide_finished><div class=row><div class=\"col align-self-center p-5\" style=\"margin-left:1em; font-size: 1em\">Pertanyaan ke {{ vm.selectedQuestion.index + 1 }} Dari {{ vm.selectedSection.question_count }} Pertanyaan</div><div class=\"col align-self-center p-5\" style=\"text-align:end; margin-right:1em;  font-size: 1.5em\">Waktu Tersisa: <span ng-style=\"{\'color\' : vm.timeInterval > 100 ? \'green\' : \'#CA2600\' }\">{{ vm.displayTimer }}</span></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"row m-b-0\"><div class=col-lg-12><div class=card><div class=card-block ng-if=vm.isFetchingData>Mohon Tunggu Beberapa Saat</div><div class=card-block ng-if=!vm.isFetchingData><div class=\"row intructions\" ng-if=!vm.selectedSection.is_guide_finished><div class=col-md-12><h4 style=\"font-weight:bold; color: green\">BAGIAN {{ vm.selectedSection.id }}</h4><h5 style=\"font-weight:bold; color: green\">Waktu {{ vm.selectedSection.duration }} Menit</h5><h5>Instruksi :</h5><div ng-if=\"vm.selectedSection.id === 1\"><p class=part-1>Test berikut ini terdiri dari soal-soal berhitung. Setiap soal disertai dengan kemungkinan jawaban a, b, c, dan d.</p><p class=part-1 style=margin-bottom:15px>Salah satu diantaranya adalah jawaban yang benar dari soal tersebut.</p><p class=part-1>Perhatikan sekarang contoh dibawah ini.</p><p class=question>18 + 7 = ...</p><div class=row><div class=\"col-md-2 p-t-10\"><label><md-checkbox class=blue ng-checked=true></md-checkbox><span class=\"p-l-5 text-answer\"><b>A. </b>25</span></label></div><div class=\"col-md-2 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>B. </b>26</span></label></div><div class=\"col-md-2 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>C. </b>24</span></label></div><div class=\"col-md-2 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>D. </b>23</span></label></div></div><p class=part-1 style=margin-bottom:10px>Pada contoh 1 dapat dilihat bahwa 18 + 7 = 25. Jawaban yang benar adalah <b>A</b></p><p class=part-1>Untuk mencorat-coret hitungan diperkenankan untuk menggunakan kertas, tetapi <b style=\"font-size:20px; color:#CA2600\">\"Tidak boleh menggunakan Kalkulator\"</b>.<br>Untuk melanjutkan pada test bagian 1, anda perlu klik tombol <b><span class=text-primary>MULAI BAGIAN {{ vm.selectedSection.id }} </span></b>.</p><p class=part-1 style=\"margin-bottom: 20px\">Ketika anda klik <b><span class=text-primary>MULAI BAGIAN {{ vm.selectedSection.id }} </span></b>, maka waktu akan mulai berjalan.<br>Pada Bagian 1, waktu yang disediakan adalah <span class=text-danger style=font-weight:bold>7 menit</span>.</p></div><div ng-if=\"vm.selectedSection.id === 2\"><p class=part-1>Tes berikut ini terdiri dari gambar bentuk-bentuk. Gambar dari setiap soal merupakan bentuk yang terpotong menjadi 3 bagian yang sudah ditentukan. Terdapat 6 gambar a, b, c, d, e, dan f. Dua diantaranya terbuat dari bagian-bagian yang terdapat dipilihan jawaban. Carilah kedua gambar tersebut. Apabila sudah ditemukan, Pilih seperti dibawah ini untuk mengisi jawaban.</p><p class=part-1>Carilah kedua gambar tersebut. Apabila sudah ditemukan, Pilih seperti dibawah ini untuk mengisi jawaban.</p><p class=question><img imageonload=assets/tiki/S21.JPG src=assets/loader.svg></p><div class=row><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>A. </b><img imageonload=assets/tiki/Z21A.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=true></md-checkbox><span class=\"p-l-5 text-answer\"><b>B. </b><img imageonload=assets/tiki/Z21B.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>C. </b><img imageonload=assets/tiki/Z21C.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=true></md-checkbox><span class=\"p-l-5 text-answer\"><b>D. </b><img imageonload=assets/tiki/Z21D.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>E. </b><img imageonload=assets/tiki/Z21E.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>F. </b><img imageonload=assets/tiki/Z21F.JPG src=assets/loader.svg></span></label></div></div><p class=part-1>Jawaban yang benar adalah <b>B</b> dan <b>D</b></p><p class=part-1 style=\"margin-bottom: 20px\">Untuk melanjutkan pada test section 2, anda perlu klik <b>MULAI BAGIAN {{ vm.selectedSection.id }}</b>. Ketika anda klik <b>MULAI BAGIAN {{ vm.selectedSection.id }}”</b>, maka waktu akan mulai berjalan.<br>Pada bagian 2, waktu yang disediakan 7 menit.<br>Silahkan klik <b>MULAI BAGIAN {{ vm.selectedSection.id }}</b> untuk MULAI BAGIAN 2.</p></div><div ng-if=\"vm.selectedSection.id === 3\"><p class=part-1>Test berikut ini terdiri dari kata-kata. Setiap soal terdiri dari 4 kata, a, b, c, dan d. Pilihlah 2 buah kata yang memiliki persamaan arti yang paling dekat atau yang mempunyai arti yang berlawanan. Setelah kata-kata itu ditemukan,</p><p class=part-1>Pilih seperti dibawah ini untuk mengisi jawaban.</p><p class=question>Pilihlah 2 buah kata yang memiliki persamaan arti yang paling dekat atau yang mempunyai arti yang berlawanan.</p><div class=\"col-md-12 p-t-10\"><label><md-checkbox class=blue ng-checked=true></md-checkbox><span class=\"p-l-5 text-answer\"><b>A. </b>Menikah</span></label></div><div class=col-md-12><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>B. </b>Menebang</span></label></div><div class=col-md-12><label><md-checkbox class=blue ng-checked=true></md-checkbox><span class=\"p-l-5 text-answer\"><b>C. </b>Kawin</span></label></div><div class=col-md-12><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>D. </b>Meneduh</span></label></div><p class=part-1>Pada contoh 1 dapat dilihat, bahwa kata-kata menikah dan kawin memiliki keasamaan arti. Jadi, jawaban contoh 1 adalah <b>A</b> dan <b>C</b>.</p><p class=part-1 style=\"margin-bottom: 20px\">Untuk melanjutkan pada test bagian 3, anda perlu klik <b>MULAI BAGIAN {{ vm.selectedSection.id }}”</b>.<br>Ketika anda klik <b>MULAI BAGIAN {{ vm.selectedSection.id }}”</b>, maka waktu akan mulai berjalan.<br>Pada bagian 3, waktu yang disediakan 5 menit.<br>Silahkan klik <b>MULAI BAGIAN {{ vm.selectedSection.id }}</b> untuk meMENGERTI, mulai bagian 3.</p></div><div ng-if=\"vm.selectedSection.id === 4\"><p class=part-1>Dalam test ini setiap soal terdiri dari 10 gambar. Empat gambar pertama dari setiap soal menunjukkan kesamaan dalam suatu hal atau segi tertentu.<br>Dua diantara enam gambar a, b, c, d, e, dan f berikutnya menunjukkan kesamaan dengan keempat gambar pertama itu.</p><p class=part-1>Carilah kedua gambar yang dimaksudkan itu. Apabila kedua gambar itu sudah ditemukan, Pilih seperti dibawah ini untuk mengisi jawaban.</p><p class=question><img imageonload=assets/tiki/S41.JPG src=assets/loader.svg></p><div class=row><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=true></md-checkbox><span class=\"p-l-5 text-answer\"><b>A. </b><img imageonload=assets/tiki/Z41A.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>B. </b><img imageonload=assets/tiki/Z41B.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>C. </b><img imageonload=assets/tiki/Z41C.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>D. </b><img imageonload=assets/tiki/Z41D.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=false></md-checkbox><span class=\"p-l-5 text-answer\"><b>E. </b><img imageonload=assets/tiki/Z41E.JPG src=assets/loader.svg></span></label></div><div class=\"col-md-3 p-t-10\"><label><md-checkbox class=blue ng-checked=true></md-checkbox><span class=\"p-l-5 text-answer\"><b>F. </b><img imageonload=assets/tiki/Z41F.JPG src=assets/loader.svg></span></label></div></div><p class=part-1>Pada contoh 1 dapat dilihat, bahwa 4 gambar yang pertama semuanya adalah segi empat atau bujur sangkar.<br>Dari 6 gambar berikutnya, hanya gambar a dan f saja yang menunjukkan kesamaan itu, yaitu berupa segi empat atau bujur sangkar.</p><p class=part-1 style=\"margin-bottom: 20px\">Untuk melanjutkan pada test section 4, anda perlu klik <b>MULAI BAGIAN {{ vm.selectedSection.id }}</b>. Ketika anda klik <b><b>MULAI BAGIAN {{ vm.selectedSection.id }}”</b></b>>, maka waktu akan mulai berjalan.<br>Pada bagian 4, waktu yang disediakan 11 menit.<br>Silahkan klik <b>MULAI BAGIAN {{ vm.selectedSection.id }}</b> untuk meMENGERTI, mulai bagian 4.</p></div></div><div class=col-md-12><button class=\"btn btn-primary\" ng-click=vm.startSection()>MULAI BAGIAN {{ vm.selectedSection.id }}</button></div></div><div class=\"col-md-12 assessment\" ng-if=vm.selectedSection.is_guide_finished><div class=\"col-md-12 tiki-type-1\" ng-if=\"vm.selectedQuestion.type === 2\"><div class=\"row question\"><div class=\"col-md-12 p-b-10\"><img imageonload=\"assets/tiki/{{ vm.selectedQuestion.question }}\" src=assets/loader.svg></div></div><div class=\"row answer\"><div class=\"col-md-3 answer-item\" ng-repeat=\"item in vm.selectedQuestion.answer\"><label><md-checkbox class=blue id=answer-{{item.id}} ng-model=item.selected aria-label=\"Checkbox {{item.id}}\" name=answer{{$index}}-{{item.id}}></md-checkbox><span class=\"p-l-5 text-answer\"><b>{{vm.convertIntToChar($index)}}. </b><img imageonload=\"assets/tiki/{{ item.answer }}\" src=assets/loader.svg></span></label></div></div></div><div class=\"col-md-12 tiki-type-1\" ng-if=\"vm.selectedQuestion.type === 1\"><div class=\"row question\"><div class=\"col-md-12 p-b-10\">{{ vm.selectedQuestion.question }}</div></div><div class=\"row answer\"><div class=\"col-md-12 answer-item\" ng-repeat=\"item in vm.selectedQuestion.answer\"><label><md-checkbox class=blue id=answer-{{item.id}} ng-model=item.selected aria-label=\"Checkbox {{item.id}}\" name=answer{{$index}}-{{item.id}}></md-checkbox><span class=\"p-l-5 text-answer\"><b>{{vm.convertIntToChar($index)}}. </b>{{ item.answer }}</span></label></div></div></div><div class=\"row col-md-12\" ng-if=!vm.isFinished><button class=\"btn btn-primary mr-2\" ng-click=vm.prevQuestion(vm.selectedQuestion.index)>SEBELUMNYA</button> <button class=\"btn btn-primary mr-5\" ng-click=\"vm.nextQuestion(vm.selectedQuestion, $event)\">SELANJUTNYA</button><div class=messageNotify ng-class=\"{\'showNotify\' : vm.showMessageNotify, \'hideNotify\' : !vm.showMessageNotify }\">Pertanyaan ini membutuhkan {{ vm.selectedQuestion.valid_answer_count}} Jawaban</div></div><div class=col-md-12 ng-if=vm.isFinished><button class=\"btn btn-primary\" ng-click=vm.submit()>SELESAI</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/dashboard/dashboard-admin.html","<!-- Container-fluid starts --><div class=container-fluid><div class=row><div class=\"col-md-6 m-t-20\"><div class=row><div class=col-md-6><div class=card><div class=\"card-body card-block bg-primary\"><div class=\"row d-flex\"><div class=\"col-md-3 align-item-center\"><i class=\"fa fa-question-circle fa-5x\"></i></div><div class=\"col-md-9 align-item-center\"><p class=card-header-text style=\"color: #fff\">TOTAL QUESTION : {{vm.data.total_question}}</p></div></div></div></div></div><div class=col-md-6><div class=card><div class=\"card-body card-block bg-success\"><div class=\"row d-flex\"><div class=\"col-md-3 align-item-center\"><i class=\"fa fa-user fa-5x\"></i></div><div class=\"col-md-9 align-item-center\"><p class=card-header-text style=\"color: #fff\">TOTAL USER : {{vm.data.total_user}}</p></div></div></div></div></div><div class=col-md-12><div class=card><div class=\"card-body card-block\"><div class=chart-container><canvas id=pie class=\"chart chart-doughnut\" chart-data=vm.dataQBC chart-labels=vm.labelsQBC chart-options=vm.optionsQBC></canvas></div></div></div></div></div></div><div class=\"col-md-6 m-t-20\"><div class=card><div class=card-header><h5 class=card-header-text>Latest Asessment Submit</h5></div><div class=\"card-block p-0\"><div class=\"list-group list-group-flush\" ng-repeat=\"item in vm.lastSubmit\"><div class=\"list-group-item list-group-item-action list-group-item-info\" ng-click=vm.getDetail(item) style=\"cursor: pointer\"><div class=col-md-1 style=\"font-size: 12px\">{{$index+1}}</div><div class=col-md-2 style=\"font-size: 12px\">{{item.user_nik}}</div><div class=col-md-4 style=\"font-size: 12px\">{{item.user_name}}</div><div class=col-md-4 style=\"font-size: 12px\"><p class=mb-1>{{item.user_gpart_name}}</p><small>{{item.submit_date}} - {{item.submit_time}}</small></div></div></div></div><div class=card-footer><button type=button ng-click=vm.getLastSubmit() class=\"btn btn-primary pull-right btn-sm\">RELOAD</button></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/dashboard/dashboard.html","<!-- Container-fluid starts --><div class=container-fluid><!-- Row Starts --><div class=row><div class=\"col-sm-12 p-0\"><div class=main-header><!-- <h4>Hello {{vm.username}}, Welcome to PMA Assessment Tools</h4> --></div></div></div><div class=row ng-if=!vm.isClear><div class=col-md-6><div class=\"card portlets portlets-info\"><div class=\"card-header text-uppercase\"><strong>Intruksi</strong></div><div class=\"card-block text-left\" ng-if=vm.showIntruction><p class=mandatory-test>Hello {{vm.username}}, Selamat Datang di {{vm.appName}}.</p><div ng-repeat=\"item in vm.session\"><a href=# class=\"list-group-item list-group-item-action flex-column align-items-start\"><div class=\"d-flex w-100 justify-content-between\"><h5 class=mb-1>Intruksi {{ item.pool.name }}</h5></div><p class=mb-1><ul class=list-test ng-if=\"item.session_type === \'tiki\'\"><li><ul class=list-test-sub><li>Bagian 1 : Berhitung Angka ( <span style=color:brown><strong>7 Menit</strong> </span>)</li><li>Bagian 2 : Gabungan Bagian ( <span style=color:brown><strong>7 Menit</strong> </span>)</li><li>Bagian 3 : Hubungan Kata ( <span style=color:brown><strong>5 Menit</strong> </span>)</li><li>Bagian 4 : Abstraksi Non Verbal ( <span style=color:brown><strong>11 Menit</strong> </span>)</li></ul></li></ul></p><p class=mandatory-test>Total waktu yang disediakan adalah <span style=color:brown><strong>{{ item.session_duration }} Menit</strong> </span>. Silahkan pergunakan waktu yang anda miliki dengan sebaik-baiknya.</p></a></div><p class=mandatory-test>Untuk melanjutkan, Silahkan pilih tes yang tersedia di dalam list <b style=color:brown>Assessment yang tersedia</b>.</p></div><div class=\"card-block text-left\" ng-if=!vm.showIntruction>Intruksi tidak ditemukan</div></div></div><div class=col-md-6><div class=\"list-group list-group-flush\"><div class=\"list-group-item list-group-item-action\" style=\"cursor: pointer\">Assessment yang tersedia</div><div class=\"list-group-item list-group-item-action\" ng-class=\"{\'disabled-assessment\': item.disabled, \'enabled-assessment\' : !item.disabled}\" ng-repeat=\"item in vm.session\" ng-click=vm.gotoAssessment(item)><div class=col-md-1 style=\"font-size: 12px\">{{$index+1}}</div><div class=col-md-2 style=\"font-size: 12px\">{{item.pool.name}}</div><div class=col-md-4 style=\"font-size: 12px\">{{vm.sessionTake[$index].text}}</div><div class=col-md-4 style=\"font-size: 12px\"><p class=mb-1>{{item.group_participant.name}}</p><small>{{item.session_start_date}} - {{item.session_end_date}}</small></div></div></div></div></div><div class=row ng-if=vm.isClear><div class=col-md-12><div class=\"card portlets portlets-info\"><div class=\"card-block text-left\">Anda tidak memiliki asssessment yang tersedia</div></div></div></div></div><!-- Row end -->");
$templateCache.put("app/main/modules/enrollment/enrollment-toolbar.html","<div class=topnav id=myTopnav><a ng-class=\"{active: vm.$state.includes(\'app.enrollment.class_room\')}\" ui-sref=app.enrollment.class_room>Proxy </a><a ng-class=\"{active: vm.$state.includes(\'app.enrollment.group_participant\')}\" ui-sref=app.enrollment.group_participant>Group Participant </a><a ng-class=\"{active: vm.$state.includes(\'app.enrollment.user_participant\')}\" ui-sref=app.enrollment.user_participant>User Participant </a><a ng-class=\"{active: vm.$state.includes(\'app.enrollment.assessment_session\')}\" ui-sref=app.enrollment.assessment_session>Session Group </a><a class=icon href=javascript:void(0); ng-click=vm.toggleNav()><i class=\"fa fa-bars\"></i></a></div>");
$templateCache.put("app/main/modules/enrollment/enrollment.html","<!-- Container-fluid starts --><div class=container-fluid><div class=row><div class=\"col-md-12 m-t-10\"><enrollment-toolbar></enrollment-toolbar></div></div><div class=row><div class=col-md-12 ng-if=vm.checkState()><div class=card><div class=card-block>hello welcome back to this menu</div></div></div><div class=col-md-12 ui-view=enrollment></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/login/login.html","<div id=login-wrapper><div class=login-overlay><div class=overlay></div></div><div id=logo-login><img src=/assets/images/logo.png></div><div id=login-container><div class=login-panel><!-- <img src=\"/assets/richeese.png\" class=\"login-panel-img\"> --> <span class=text-title><span style=color:#A71A22>Assessment</span><!-- <span style=\"color:#C58008\">&nbsp;Assessment</span> --> <span>&nbsp;Tools</span></span><form ng-submit=vm.login()><div class=login-field-content><div class=login-field-group><!-- <label for=\"nik\">UserID</label> --> <input id=nik name=nik ng-model=vm.nik required placeholder=\"Enter UserID\" autofocus type=text></div><div class=login-field-group><!-- <label for=\"password\">Password</label> --> <input name=password id=password placeholder=\"Enter Password\" type=password id=password ng-model=vm.password required></div></div><div class=login-field-action><button class=\"btn-login primary\">SIGN IN</button></div><span class=login-message ng-class=\"{\'error\' : vm.isNotValid}\" ng-show=vm.isNotValid>{{vm.messages}}</span></form><span class=text-copyright>Copyrights &copy; Nabati 2018</span></div></div></div>");
$templateCache.put("app/main/modules/master-data/master-data-toolbar.html","<div class=card><div class=card-header><h5 class=card-header-text>Master Data Mangement</h5></div><div class=\"card-block accordion-block\"><div class=list-group><!-- <a ng-class=\"{active: vm.$state.includes(\'app.master_data.class_room\')}\" ui-sref=\"app.master_data.class_room\" class=\"list-group-item list-group-item-action\">Class Room</a> --> <a ng-class=\"{active: vm.$state.includes(\'app.master_data.question_competency\')}\" ui-sref=app.master_data.question_competency class=\"list-group-item list-group-item-action\">Question Competency</a> <a ng-class=\"{active: vm.$state.includes(\'app.master_data.question_category_competency\')}\" ui-sref=app.master_data.question_category_competency class=\"list-group-item list-group-item-action\">Question Category Competency</a></div></div></div>");
$templateCache.put("app/main/modules/master-data/master-data.html","<!-- Container-fluid starts --><div class=container-fluid><div class=row><div class=\"col-md-3 m-t-10\"><master-data-toolbar></master-data-toolbar></div><div class=\"col-md-9 m-t-10\" ui-view=master-data></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/question-bank/question-bank-toolbar.html","<div class=topnav id=myTopnav><a ng-class=\"{active: vm.$state.includes(\'app.question_bank.question_pool\')}\" ui-sref=app.question_bank.question_pool>Questions Pool</a> <a ng-class=\"{active: vm.$state.includes(\'app.question_bank.question_competency\')}\" ui-sref=app.question_bank.question_competency>Questions Competency</a> <a ng-class=\"{active: vm.$state.includes(\'app.question_bank.question_category\')}\" ui-sref=app.question_bank.question_category>Questions Category</a> <a ng-class=\"{active: vm.$state.includes(\'app.question_bank.question_answer\')}\" ui-sref=app.question_bank.question_answer>Questions & Answers</a> <a ng-class=\"{active: vm.$state.includes(\'app.question_bank.question_behavioral\')}\" ui-sref=app.question_bank.question_behavioral>Behavioral Questions</a> <a ng-class=\"{active: vm.$state.includes(\'app.question_bank.question_answer_tiki\')}\" ui-sref=app.question_bank.question_answer_tiki>Questions & Answers Tiki</a><!-- <a ng-class=\"{active: vm.$state.includes(\'app.question_bank.question_excel_file\')}\"\n      ui-sref=\"app.question_bank.question_excel_file\">Questions Excel File</a> --><!-- <a ng-class=\"{active: vm.$state.includes(\'app.question_bank.question_excel\')}\"\n      ui-sref=\"app.question_bank.question_excel\">Questions Excel</a> --> <a href=javascript:void(0); class=icon ng-click=vm.toggleNav()><i class=\"fa fa-bars\"></i></a></div>");
$templateCache.put("app/main/modules/question-bank/question-bank.html","<!-- Container-fluid starts --><div class=container-fluid><div class=row><div class=\"col-md-12 m-t-10\"><question-bank-toolbar></question-bank-toolbar></div></div><div class=row><div class=col-md-12 ng-if=vm.checkState()><div class=card><div class=card-block>hello welcome back to this menu</div></div></div><div class=col-md-12 ui-view=question></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/report/report-toolbar.html","<div class=topnav id=myTopnav><a ng-class=\"{active: vm.$state.includes(\'app.report.general\')}\" ui-sref=app.report.general>General</a> <a ng-class=\"{active: vm.$state.includes(\'app.report.tiki\')}\" ui-sref=app.report.tiki>Tiki</a> <a ng-class=\"{active: vm.$state.includes(\'app.report.intray\')}\" ui-sref=app.report.intray>Intray</a> <a ng-class=\"{active: vm.$state.includes(\'app.report.papikostik\')}\" ui-sref=app.report.papikostik>Papikostik</a> <a ng-class=\"{active: vm.$state.includes(\'app.report.beq\')}\" ui-sref=app.report.beq>Beq</a> <a ng-class=\"{active: vm.$state.includes(\'app.report.behavioral\')}\" ui-sref=app.report.behavioral>Behavioral</a> <a ng-class=\"{active: vm.$state.includes(\'app.report.survey\')}\" ui-sref=app.report.survey>Survey</a> <a href=javascript:void(0); class=icon ng-click=vm.toggleNav()><i class=\"fa fa-bars\"></i></a></div>");
$templateCache.put("app/main/modules/report/report.html","<!-- Container-fluid starts --><div class=container-fluid><div class=row><div class=\"col-md-12 m-t-10\"><report-toolbar></report-toolbar></div></div><div class=row><div class=col-md-12 ng-if=vm.checkState()><div class=card><div class=card-block>hello welcome back to this menu</div></div></div><div class=col-md-12 ui-view=report></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/wizard/wizard.html","<!-- Container-fluid starts --><div class=container-fluid><div class=row><div class=\"col-md-12 card m-t-10 p-20\"><div class=row><div class=col-md-12><h4>Form wizard</h4><small>This form wizard for building new assessment</small></div></div><div class=\"row m-t-10\"><div class=col-sm-12><div class=progress><div class=progress-bar style=width:70%></div></div></div></div><div class=row><div class=col-sm-12><div class=p-t-30 ui-view=wizard></div></div></div><div class=\"row pull-right\"><div class=col-sm-12><ul class=pagination><li class=page-item><a class=page-link href=#>Previous</a></li><li class=page-item><a class=page-link href=#>1</a></li><li class=page-item><a class=page-link href=#>2</a></li><li class=page-item><a class=page-link href=#>3</a></li><li class=page-item><a class=page-link href=#>Next</a></li></ul></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/account/import-account/import-account.html","<md-dialog aria-label=\"Mango (Fruit)\"><form ng-cloak name=formImport><md-toolbar><div class=\"md-toolbar-tools bg-primary\"><h2>Upload Data</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeDialog()><md-icon md-font-icon=icon-close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><label for=importQuestion>Click button to choose file</label><input type=file class=form-control-file id=importUser ngf-select ng-model=importFile name=file accept=.xlsx ngf-max-size=2MB aria-describedby=fileHelp ngf-model-invalid=errorFile required> <small id=fileHelp class=\"form-text text-muted\">Format accepted (xlxs), Size 2 MB</small> <i ng-show=formImport.file.$error.maxSize>File too large {{errorFile.size / 1000000|number:1}}MB: max 2M</i> <span class=progress ng-show=\"importFile.progress >= 0\"><div ng-style=\"{\'width\' :importFile.progress + \'%\' }\" ng-bind=\"importFile.progress + \'%\'\"></div></span><span ng-show=importFile.result>Upload Successful</span></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=\"btn btn-primary\" ng-disabled=!formImport.$valid ng-click=vm.uploadData(importFile)>Import</md-button><md-button class=\"btn btn-warning\" ng-click=vm.closeDialog()>Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/account/create-account/create-account.html","<div class=container-fluid><div class=row><div class=\"col-md-12 m-t-20\"><div class=card><div class=card-header><i class=\"fa fa-arrow-left fa-lg\" style=\"line-height: 1\" ng-click=vm.back()></i><h3 class=\"card-header-text pull-right\" style=\"line-height: 2\">Create Account</h3></div><div class=card-block><div class=row><div class=col-md-12><form ng-cloak name=formAccount><div class=\"form-group row\"><div class=col-md-2><label for=userid class=form-control-label>User ID</label></div><div class=col-md-10><input type=text name=userid ng-model=vm.userid id=userid class=form-control placeholder=\"NIK or Other\" required></div></div><div class=\"form-group row\"><div class=col-md-2><label for=username class=form-control-label>User Name</label></div><div class=col-md-10><input type=text name=username ng-model=vm.username id=username class=form-control placeholder=\"User Name\" required></div></div><!-- <div class=\"form-group row\"\n                                    ng-class=\"{\'has-warning\' : formAccount.email.$dirty && formAccount.email.$error.pattern, \'has-danger\' : formAccount.email.$error.required && formAccount.email.$dirty}\">\n                                    <div class=\"col-md-2\">\n                                        <label for=\"email\" class=\"form-control-label\">Email</label>\n                                    </div>\n                                    <div class=\"col-md-10\">\n                                        <input type=\"email\" name=\"email\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"\n                                            ng-model=\"vm.email\" id=\"email\" class=\"form-control\" placeholder=\"Email\"\n                                            required />\n                                        <div ng-show=\"formAccount.email.$error.required && formAccount.email.$dirty\">\n                                            <div class=\"form-control-feedback\">Required</div>\n                                            <small class=\"form-text text-muted\">Make sure you are entering the\n                                                email\n                                            </small>\n                                        </div>\n                                        <div ng-show=\"formAccount.email.$dirty && formAccount.email.$error.pattern\">\n                                            <div class=\"form-control-feedback\">Please Enter Valid Email</div>\n                                            <small class=\"form-text text-muted\">\n                                                Make sure you are entering the valid email\n                                            </small>\n                                        </div>\n                                    </div>\n                                </div> --><div class=\"form-group row\"><div class=col-md-2><label for=password class=form-control-label>Password</label></div><div class=col-md-10><div class=input-group><input ng-attr-type=\"{{ vm.showPasswordData ? \'text\' : \'password\' }}\" id=password ng-model=vm.password name=password placeholder=Password required class=form-control> <span class=\"input-group-addon {{ vm.showPasswordData ? \'bg-primary\' : \'\'}}\" ng-click=vm.showPassword() ng-model=vm.showPasswordData><i class=\"icon icon-eye\"></i> </span><span class=input-group-addon ng-click=vm.generatePassword() ng-model=vm.showPasswordData><i class=\"icon icon-settings\"></i></span></div></div></div><div class=\"form-group row\"><div class=col-md-2><label for=passwordConfirm class=form-control-label>Password Confirmation</label></div><div class=\"col-md-10 {{ vm.msg ? \'has-warning\' : \'\'}}\"><div class=input-group><input type=\"{{ vm.showPasswordData ? \'text\' : \'password\' }}\" id=passwordConfirm ng-model=vm.passwordConfirm name=passwordConfirm placeholder=\"Password Confirmation\" required class=form-control> <span class=\"input-group-addon {{ vm.showPasswordData ? \'bg-primary\' : \'\'}}\" ng-click=vm.showPassword() ng-model=vm.showPasswordData><i class=\"icon icon-eye\"></i></span></div><div ng-if=vm.msg><div class=form-control-feedback>Password is not match</div><small class=\"form-text text-muted\">Make sure you are entering the same password</small></div></div></div><div class=\"form-group row\"><div class=col-md-2><label for=QuestionCategory class=form-control-label>Group</label></div><div class=col-md-10><ui-select name=group id=group allow-clear ng-model=vm.selectedGroup theme=select2 required><ui-select-match placeholder=\"Select Group\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.group | filter: $select.search\"><small>{{item.name}}</small></ui-select-choices></ui-select></div></div><div class=\"form-group row p-t-10 pull-right\"><div class=col-md-12><md-button type=button ng-disabled=\"formAccount.$invalid || formAccount.$pristine\" ng-click=vm.save(formAccount) class=\"btn btn-primary\">Submit</md-button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/account/update-account/update-account.html","<div class=container-fluid><div class=row><div class=\"col-md-12 m-t-20\"><div class=card><div class=card-header><i class=\"fa fa-arrow-left fa-lg\" style=\"line-height: 1\" ng-click=vm.back()></i><h3 class=\"card-header-text pull-right\" style=\"line-height: 2\">Create Account</h3></div><div class=card-block><div class=row><div class=col-md-12><form ng-cloak name=formAccount><div class=\"form-group row\"><div class=col-md-2><label for=userid class=form-control-label>User ID</label></div><div class=col-md-10><input type=text name=userid ng-model=vm.userid id=userid class=form-control placeholder=\"NIK or Other\" required></div></div><div class=\"form-group row\"><div class=col-md-2><label for=username class=form-control-label>User Name</label></div><div class=col-md-10><input type=text name=username ng-model=vm.username id=username class=form-control placeholder=\"User Name\" required></div></div><!-- <div class=\"form-group row\"\n                                    ng-class=\"{\'has-warning\' : formAccount.email.$dirty && formAccount.email.$error.pattern, \'has-danger\' : formAccount.email.$error.required && formAccount.email.$dirty}\">\n                                    <div class=\"col-md-2\">\n                                        <label for=\"email\" class=\"form-control-label\">Email</label>\n                                    </div>\n                                    <div class=\"col-md-10\">\n                                        <input type=\"email\" name=\"email\" ng-pattern=\"/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/\"\n                                            ng-model=\"vm.email\" id=\"email\" class=\"form-control\" placeholder=\"Email\"\n                                            required />\n                                        <div ng-show=\"formAccount.email.$error.required && formAccount.email.$dirty\">\n                                            <div class=\"form-control-feedback\">Required</div>\n                                            <small class=\"form-text text-muted\">Make sure you are entering the\n                                                email\n                                            </small>\n                                        </div>\n                                        <div ng-show=\"formAccount.email.$dirty && formAccount.email.$error.pattern\">\n                                            <div class=\"form-control-feedback\">Please Enter Valid Email</div>\n                                            <small class=\"form-text text-muted\">\n                                                Make sure you are entering the valid email\n                                            </small>\n                                        </div>\n                                    </div>\n                                </div> --><div class=\"form-group row\"><div class=col-md-2><label for=password class=form-control-label>Password</label></div><div class=col-md-10><div class=input-group><input ng-attr-type=\"{{ vm.showPasswordData ? \'text\' : \'password\' }}\" id=password ng-model=vm.password name=password placeholder=Password required class=form-control> <span class=\"input-group-addon {{ vm.showPasswordData ? \'bg-primary\' : \'\'}}\" ng-click=vm.showPassword() ng-model=vm.showPasswordData><i class=\"icon icon-eye\"></i> </span><span class=input-group-addon ng-click=vm.generatePassword()><i class=\"icon icon-settings\"></i></span></div></div></div><div class=\"form-group row\"><div class=col-md-2><label for=passwordConfirm class=form-control-label>Password Confirmation</label></div><div class=\"col-md-10 {{ vm.msg ? \'has-warning\' : \'\'}}\"><div class=input-group><input type=\"{{ vm.showPasswordData ? \'text\' : \'password\' }}\" id=passwordConfirm ng-model=vm.passwordConfirm name=passwordConfirm placeholder=\"Password Confirmation\" required class=form-control> <span class=\"input-group-addon {{ vm.showPasswordData ? \'bg-primary\' : \'\'}}\" ng-click=vm.showPassword() ng-model=vm.showPasswordData><i class=\"icon icon-eye\"></i></span></div><div ng-if=vm.msg><div class=form-control-feedback>Password is not match</div><small class=\"form-text text-muted\">Make sure you are entering the same password</small></div></div></div><div class=\"form-group row\"><div class=col-md-2><label for=QuestionCategory class=form-control-label>Group</label></div><div class=col-md-10><ui-select name=group id=group allow-clear ng-model=vm.selectedGroup theme=select2 required><ui-select-match placeholder=\"Select Group\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.group | filter: $select.search\"><small>{{item.name}}</small></ui-select-choices></ui-select></div></div><div class=\"form-group row p-t-10 pull-right\"><div class=col-md-12><md-button type=button ng-disabled=\"formAccount.$invalid || formAccount.$pristine || vm.msg\" ng-click=vm.updateData(formAccount) class=\"btn btn-primary\">Submit</md-button></div></div></form></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/account/sync-account/sync-account.html","<div class=container-fluid><div class=row><div class=\"col-md-12 m-t-20\"><div class=card><div class=card-header><i class=\"fa fa-arrow-left fa-lg\" style=\"line-height: 1\" ng-click=vm.back()></i><h3 class=\"card-header-text pull-right\" style=\"line-height: 2\">Syncrhonize Account</h3></div><div class=card-block><div class=row><div class=col-md-7><form ng-cloak name=formAccount><fieldset ng-disabled=vm.formDisabled block-ui=formAccount><div class=\"form-group row\"><div class=col-md-3><label for=divisions class=form-control-label>Divisions</label></div><div class=col-md-9><ui-select name=division ng-change=vm.getDepartment(vm.selectedDivision.id) id=division allow-clear ng-model=vm.selectedDivision theme=selectize><ui-select-match placeholder=\"Select or search division\">{{$select.selected.description}}</ui-select-match><ui-select-choices repeat=\"item in vm.division | filter: $select.search\"><small ng-bind-html=\"item.description | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=department class=form-control-label>Department</label></div><div class=col-md-9><ui-select name=department ng-disabled=!vm.division id=department allow-clear ng-model=vm.selectedDepartment theme=selectize><ui-select-match placeholder=\"Select or search department\">{{$select.selected.description}}</ui-select-match><ui-select-choices repeat=\"item in vm.department | filter: $select.search\"><small ng-bind-html=\"item.description | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-12><button type=submit ng-disabled=\"formAccount.$invalid || formAccount.$pristine\" ng-click=vm.syncAccount(formAccount) class=\"btn btn-primary\">Submit</button></div></div></fieldset></form></div><div class=col-md-5><div class=list-group><a href=javascript:void(0) class=\"list-group-item list-group-item-action\"><h6>Sync Logs</h6></a><a href=javascript:void(0) class=\"list-group-item list-group-item-action col-md-12\" ng-repeat=\"item in vm.logs\" ng-if=\"vm.logs.length > 0\"><div class=col-md-2>{{ $index + 1}}</div><div class=col-md-2>{{ item.by }}</div><div class=col-md-6><small>{{item.date}}</small> <small>{{item.time}}</small></div><div class=col-md-2><small class=\"badge {{item.status == 1 ? \'badge-success\' : \'badge-danger\'}}\">{{item.status == 1 ? \'SUCCESS\' : \'FALSE\'}}</small></div></a></div><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.getSyncLogs(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div><div class=\"row container-logs\"><h5>Sync Logs</h5><md-progress-linear ng-show=vm.syncProgress md-mode=indeterminate></md-progress-linear><div class=\"col-md-12 list-group\"><a href=# data-toggle=collapse data-target=#createdLogs class=\"list-group-item list-group-item-action list-group-item-success d-flex justify-content-between align-items-center\">Created Accounts <span class=\"badge badge-primary badge-pill\">{{ vm.syncResult.created ? vm.syncResult.created.length : 0 }}</span></a><div class=collapse id=createdLogs><div class=\"card card-body p-10\"><pre>\n                                    {{ vm.syncResult.created | json }}\n                                    </pre></div></div><a href=# data-toggle=collapse data-target=#updatedLogs class=\"list-group-item list-group-item-action list-group-item-info d-flex justify-content-between align-items-center\">Updated Accounts <span class=\"badge badge-primary badge-pill\">{{ vm.syncResult.updated ? vm.syncResult.updated.length : 0 }}</span></a><div class=collapse id=updatedLogs><div class=\"card card-body p-10\"><pre>\n                                    {{ vm.syncResult.updated | json }}\n                                    </pre></div></div><a href=# data-toggle=collapse data-target=#failedLogs class=\"list-group-item list-group-item-action list-group-item-danger d-flex justify-content-between align-items-center\">Failed Accounts <span class=\"badge badge-primary badge-pill\">{{ vm.syncResult.failed ? vm.syncResult.failed.length : 0 }}</span></a><div class=collapse id=failedLogs><div class=\"card card-body p-10\"><pre>\n                                    {{ vm.syncResult.failed | json }}\n                                    </pre></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/enrollment/assessment-session/assessment-session.html","<div class=card><div class=card-header><h5 class=card-header-text>Asessment Session List</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new session</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button><!-- <md-button ng-click=\"vm.gotoImport()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n            <md-tooltip md-direction=\"top\">Import Question</md-tooltip>\n            <md-font-icon class=\"fa fa-upload fa-lg\"></md-font-icon>&nbsp;&nbsp;IMPORT\n          </md-button> --></div></div><div class=col-md-7><div class=row><div class=\"col-md-2 p-r-0\"><select class=\"custom-select mb-2 mr-sm-2 mb-sm-0 pull-right\" hide show-gt-sm ng-model=vm.pageLength ng-change=vm.loadData(1)><option ng-value=5>5</option><option ng-value=10>10</option><option ng-value=20>20</option><option ng-value=25>25</option><option ng-value=50>50</option></select></div><div class=col-md-10><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=button><i class=\"fa fa-search fa-lg\"></i></button></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped\"><thead><tr><th>NO</th><th>ID</th><th class=text-left>Pool</th><th class=text-left>Group</th><th class=text-left>Class</th><th class=text-center>Session Type</th><th class=text-center>Order</th><th class=text-center>Rules</th><th class=text-center>Start Date</th><th class=text-center>End Date</th><th class=text-center>Start Time</th><th class=text-center>End Time</th><th class=text-center>Duration</th><th class=text-center>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.list\"><td style=\"font-size: 12px\">{{$index+1}}</td><td style=\"font-size: 12px\">{{item.id}}</td><td style=\"font-size: 12px\">{{item.pool.name}}</td><td style=\"font-size: 12px\">{{item.group_participant.name}}</td><td style=\"font-size: 12px\">{{item.class.name}}</td><td style=\"font-size: 12px\">{{ item.session_type.toUpperCase() }}</td><td style=\"font-size: 12px; text-align: center\">{{item.session_order}}</td><td style=\"font-size: 12px; text-align: center\">{{item.has_rules == 1 ? \'Yes\' : \'No\'}}</td><td style=\"font-size: 12px; text-align: center\">{{item.session_start_date}}</td><td style=\"font-size: 12px; text-align: center\">{{item.session_end_date}}</td><td style=\"font-size: 12px; text-align: center\">{{item.session_start_time}}</td><td style=\"font-size: 12px; text-align: center\">{{item.session_end_time}}</td><td style=\"font-size: 12px; text-align: center\">{{item.session_duration}}</td><td class=text-center style=\"width: 8%\"><button class=\"btn btn-mini-center btn-danger\" ng-click=\"vm.deleteData($event, item)\"><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-info\" ng-click=vm.gotoUpdate(item)><md-tooltip md-direction=top>Edit</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=\"vm.loadData(page); vm.lastPage = page\" show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div>");
$templateCache.put("app/main/modules/enrollment/classroom/index.html","<div class=card><div class=card-header><h5 class=card-header-text>Proxy</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button><!-- <md-button ng-click=\"vm.gotoCreate()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n            <md-tooltip md-direction=\"top\">Import Question</md-tooltip>\n            <md-font-icon class=\"fa fa-upload fa-lg\"></md-font-icon>&nbsp;&nbsp;IMPORT\n          </md-button>\n          <md-button ng-click=\"vm.gotoCreate()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n            <md-tooltip md-direction=\"top\">Import Question</md-tooltip>\n            <md-font-icon class=\"fa fa-download fa-lg\"></md-font-icon>&nbsp;&nbsp;EXPORT\n          </md-button> --></div></div><div class=col-md-7><div class=row><div class=col-md-2><!-- <select>\n                  <option>1</option>\n                  <option>2</option>\n                  <option>3</option>\n                  <option>4</option>\n                  <option>5</option>\n                </select> --></div><div class=col-md-10><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th class=text-left>Name</th><th class=text-left>Description</th><!-- <th>Duration</th>\n                                <th>Start</th>\n                                <th>End</th> --><th>Participant</th><th>Location</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td style=\"width: 5%; vertical-align: middle\" class=text-center>{{item.id}}</td><td style=\"vertical-align: middle\">{{item.name}}</td><td style=\"vertical-align: middle\">{{item.description}}</td><!-- <td style=\"vertical-align: middle\" class=\"text-center\">{{item.duration}}</td>\n                                <td style=\"vertical-align: middle\" class=\"text-center\">{{item.start_at}}</td>\n                                <td style=\"vertical-align: middle\" class=\"text-center\">{{item.end_at}}</td> --><td style=\"vertical-align: middle\" class=text-center>{{item.total_participant}}</td><td style=\"vertical-align: middle\" class=text-center>{{item.location}}</td><td style=\"width: 10%; vertical-align: middle\" class=text-center><button class=\"btn btn-mini-center btn-danger\" ng-click=vm.deleteData(item)><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-info\" ng-click=vm.edit(item)><md-tooltip md-direction=top>Edit</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><!-- <pagination></pagination> --></div></div></div></div></div>");
$templateCache.put("app/main/modules/enrollment/group-participant/group-participant.html","<div class=card><div class=card-header><h5 class=card-header-text>Group Participant</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new group participant</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button></div></div><div class=col-md-7><div class=row><div class=col-md-2><!-- <select>\n              <option>1</option>\n              <option>2</option>\n              <option>3</option>\n              <option>4</option>\n              <option>5</option>\n            </select> --></div><div class=col-md-10><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table table-sm table-bordered table-striped\"><thead><tr><th class=text-center>ID</th><th class=text-center>Code</th><th class=text-left>Name</th><th class=text-left>Description</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.list\"><td class=text-center>{{item.id}}</td><td class=text-center>{{item.code}}</td><td>{{item.name}}</td><td>{{item.description}}</td><td style=\"text-align: center\"><button class=\"btn btn-mini-center btn-danger\" ng-click=vm.gotoDelete(item)><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-primary\" ng-click=vm.gotoUpdate(item)><md-tooltip md-direction=top>Update</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div>");
$templateCache.put("app/main/modules/enrollment/user-participant/user-participant.html","<div class=card><div class=card-header><h5 class=card-header-text>User Participant List</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoAssign() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new session</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;ASSIGN USER</md-button></div></div><div class=col-md-7><div class=row><div class=col-md-2><!-- <select>\n              <option>1</option>\n              <option>2</option>\n              <option>3</option>\n              <option>4</option>\n              <option>5</option>\n            </select> --></div><div class=col-md-10><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table table-sm table-bordered table-striped\"><thead><tr><th>ID</th><th class=text-center>Nik</th><th class=text-left>Name</th><th class=text-center>Code</th><th class=text-left>Group</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.list\"><td>{{item.id}}</td><td class=text-center>{{item.user.nik}}</td><td class=text-left>{{item.user.name}}</td><td class=text-center>{{item.group_participant.code}}</td><td class=text-left>{{item.group_participant.name}}</td><td style=\"text-align: center\"><button class=\"btn btn-mini-center btn-danger\" ng-click=vm.deleteData(item)><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-primary\" ng-click=vm.gotoUpdate(item)><md-tooltip md-direction=top>Update</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div>");
$templateCache.put("app/main/modules/enrollment/question-assignment/question-assignment.html","<div class=card><div class=card-header><h5 class=card-header-text>Question Assignment</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-12><form class=form-horizontal name=questionForm><div class=\"form-group row\"><div class=col-md-3><label for=categoryCompetency class=form-control-label>Category Competency</label></div><div class=col-md-9><ui-select name=CategoryCompetency id=categoryCompetency ng-change=vm.getCompetencyByCategory(vm.selectedCategory.id) allow-clear ng-model=vm.selectedCategory theme=bootstrap><ui-select-match placeholder=\"Select or search category competency\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.categoryCompetency | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=competency class=form-control-label>Competency</label></div><div class=col-md-9><ui-select name=Competency id=competency allow-clear ng-model=vm.selectedCompetency theme=bootstrap><ui-select-match placeholder=\"Select Competency\">{{$select.selected.code}} | {{$select.selected.competency}}</ui-select-match><ui-select-choices repeat=\"item in vm.competency | filter: $select.search\"><div><b ng-bind-html=\"item.code | highlight: $select.search\"></b> <span ng-bind-html=\"item.competency | highlight: $select.search\"></span></div><small>{{item.description }}</small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=QuestionCategory class=form-control-label>Question Category</label></div><div class=col-md-9><ui-select name=QuestionCategory id=Question allow-clear ng-model=vm.selectedQuestionCategory theme=bootstrap><ui-select-match placeholder=\"Select Question Category\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionCategory | filter: $select.search\"><small>{{item.name}}</small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=Question class=form-control-label>Question</label></div><div class=col-md-9><ui-select name=Question id=Question allow-clear ng-model=vm.selectedQuestion theme=bootstrap><ui-select-match placeholder=\"Select Question\">{{$select.selected.id}} | {{$select.selected.question}}</ui-select-match><ui-select-choices repeat=\"item in vm.questions | filter: $select.search\"><small>{{item.id}} . {{item.question }}</small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=QuestionPool class=form-control-label>Question Pool</label></div><div class=col-md-9><ui-select name=QuestionPool id=QuestionPool allow-clear ng-model=vm.selectedQuestionPool theme=bootstrap><ui-select-match placeholder=\"Select Pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><small>{{item.name }}</small></ui-select-choices></ui-select></div></div><button ng-disabled=!questionForm.$valid ng-click=\"vm.saveAssignment(questionForm) \" class=\"btn btn-success pull-right\">Save</button></form></div></div></div></div>");
$templateCache.put("app/main/modules/master-data/question-category-competency/question-category-competency.html","<div class=card><div class=card-header><h5 class=card-header-text>Question Competency</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><!-- <div class=\"btn-group\" role=\"group\" aria-label=\"Basic example\">\n          <md-button ng-click=\"vm.gotoCreate()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n            <md-tooltip md-direction=\"top\">Create new question</md-tooltip>\n            <md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE\n          </md-button>\n          <md-button ng-click=\"vm.gotoCreate()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n            <md-tooltip md-direction=\"top\">Import Question</md-tooltip>\n            <md-font-icon class=\"fa fa-upload fa-lg\"></md-font-icon>&nbsp;&nbsp;IMPORT\n          </md-button>\n          <md-button ng-click=\"vm.gotoCreate()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n            <md-tooltip md-direction=\"top\">Import Question</md-tooltip>\n            <md-font-icon class=\"fa fa-download fa-lg\"></md-font-icon>&nbsp;&nbsp;EXPORT\n          </md-button>\n        </div> --></div><div class=col-md-7><div class=row><div class=col-md-2><!-- <select>\n                  <option>1</option>\n                  <option>2</option>\n                  <option>3</option>\n                  <option>4</option>\n                  <option>5</option>\n                </select> --></div><div class=col-md-10><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=button><i class=\"fa fa-search fa-lg\"></i></button></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th>Name</th><th>Initial</th><!-- <th>Action</th> --></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td style=\"width: 5%\" class=text-center>{{item.id}}</td><td>{{item.name}}</td><td>{{item.initial}}</td><!-- <td style=\"width: 9%\">\n                  <button class=\"btn btn-mini-center btn-danger\">\n                    <md-tooltip md-direction=\"top\">Delete Pool</md-tooltip>\n                    <i class=\"fa fa-trash fa-lg\"></i>\n                  </button>\n                  <button class=\"btn btn-mini-center btn-info\">\n                    <md-tooltip md-direction=\"top\">Update Pool</md-tooltip>\n                    <i class=\"fa fa-pencil fa-lg\"></i>\n                  </button>\n                </td> --></tr></tbody></table><nav aria-label=\"Page navigation example\"><ul class=\"pagination justify-content-end\"><li class=\"page-item disabled\"><a class=page-link href=# tabindex=-1>Previous</a></li><li class=page-item><a class=page-link href=#>1</a></li><li class=page-item><a class=page-link href=#>2</a></li><li class=page-item><a class=page-link href=#>3</a></li><li class=page-item><a class=page-link href=#>Next</a></li></ul></nav></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-answer/question-answer.html","<div class=card><div class=card-header><div class=row><div class=\"col-md-5 d-flex align-items-center\"><h5 class=card-header-text>Question & Answer List</h5></div><div class=\"col-md-7 search-header\"><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div><div class=card-block><div class=\"row m-b-10\"><div class=\"col-md-2 m-r-0 p-r-0 toolbar-button\"><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new question</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button><md-button ng-click=vm.gotoImport() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Import Question</md-tooltip><md-font-icon class=\"fa fa-upload fa-lg\"></md-font-icon>&nbsp;&nbsp;IMPORT</md-button></div></div><div class=col-md-10><div class=row><div class=\"col-md-3 filter-select\"><ui-select name=competency id=competency allow-clear ng-model=vm.selectedCompetency theme=selectize><ui-select-match placeholder=Competency>{{$select.selected.competency}}</ui-select-match><ui-select-choices repeat=\"item in vm.competency | filter: $select.search\"><div ng-bind-html=\"item.code | highlight: $select.search\"></div><small ng-bind-html=\"item.competency | highlight: $select.search\"></small></ui-select-choices></ui-select></div><div class=\"col-md-3 filter-select\"><ui-select name=category id=category allow-clear ng-model=vm.selectedCategory theme=selectize><ui-select-match placeholder=Category>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.category | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div><div class=\"col-md-3 filter-select\"><ui-select name=QPool id=QPool allow-clear ng-model=vm.selectedQPool theme=selectize><ui-select-match placeholder=Pool>{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div><div class=\"col-md-1 p-t-2\"><button class=\"btn btn-primary shadow-none btn-block\" ng-click=vm.loadData(1)><i class=\"fa fa-filter\"></i></button></div><div class=\"col-md-1 p-t-2\"><button class=\"btn btn-primary shadow-none btn-block\" ng-click=vm.resetFilter()><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-md-1 filter-select\"><select class=\"custom-select mb-2 mr-sm-2 mb-sm-0\" ng-model=vm.pageLength ng-change=vm.loadData(1)><option ng-value=5>5</option><option ng-value=10>10</option><option ng-value=20>20</option><option ng-value=25>25</option><option ng-value=50>50</option></select></div></div></div></div><div class=row><div class=col-md-12 hide show-gt-sm flex block-ui=QaInstances><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th>Code</th><th>Main</th><th>Category</th><th>Pool</th><th>Question</th><th>Images</th><th>Answer</th><th>Flag</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.questionList\" ng-if=!vm.isLoading><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.id}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.code}}</td><td class=custom-td style=\"width: 10%; vertical-align: middle; text-align: center\">{{item.competency.competency}}</td><td class=custom-td style=\"width: 10%; vertical-align: middle; text-align: center\">{{item.question_category.name}}</td><td class=custom-td style=\"width: 10%; vertical-align: middle; text-align: center\">{{item.question_pool.name}}</td><td class=custom-td style=\"width: 20%; vertical-align: middle\">{{item.question.question}}</td><td class=custom-td style=\"text-align: center; vertical-align: middle\"><div class=label-main ng-if=\"item.question.having_images == 0\"><label class=\"label label-inverse-default\">No Images</label></div><div class=label-main ng-if=\"item.question.having_images == 1\"><md-tooltip md-direction=top>{{item.question.images}}</md-tooltip><a href=javascript:void(0); ng-click=vm.showImages(item.question.images) class=\"label label-inverse-success\">Have Images</a></div></td><td style=\"width: 20%; vertical-align: middle\" class=custom-td><ul ng-repeat=\"answer in item.question.answer_pool.answer_bank\"><li>{{ vm.convertIntToChar($index) }} . {{answer.answer | limitTo: 30}} {{answer.answer.length > 40 ? \'...\' : \'\'}}</li></ul></td><td style=\"text-align: center\"><ul ng-repeat=\"answer in item.question.answer_pool.answer_bank\"><li><span ng-if=\"answer.flag == 1\" class=\"badge badge-success\">true</span> <span ng-if=\"answer.flag == 0\" class=\"badge badge-danger\">false</span></li></ul></td><td style=\"text-align: center; vertical-align: middle\"><button class=\"btn btn-mini-center btn-info\" ng-click=vm.gotoEdit(item)><md-tooltip md-direction=top>Edit question</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=\"vm.deleteQuestion(ev, item.id)\"><md-tooltip md-direction=top>Delete Question</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr><tr ng-if=vm.isLoading><td colspan=10 class=text-center><span><i class=\"fa fa-spinner fa fa-pulse\"></i> </span>Loading Data ...</td></tr><tr ng-if=\"vm.questionList.length === 0 && !vm.isLoading\"><td colspan=10 class=text-center>No Data Available</td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-answer-tiki/question-answer-tiki.html","<div class=card><div class=card-header><div class=row><div class=\"col-md-5 d-flex align-items-center\"><h5 class=card-header-text>Tiki Question & Answer List</h5></div><div class=\"col-md-7 search-header\"><!-- <form>\n                    <div class=\"input-group\">\n                        <input type=\"text\" class=\"form-control\" ng-model=\"vm.search\" placeholder=\"Search\"\n                            aria-label=\"Search\" aria-describedby=\"basic-addon2\">\n                        <div class=\"input-group-append\">\n                            <button ng-click=\"vm.loadData(1)\" class=\"btn btn-primary shadow-none\" type=\"submit\">\n                                <i class=\"fa fa-search fa-lg\"></i>\n                            </button>\n                        </div>\n                    </div>\n                </form> --></div></div></div><div class=card-block><div class=\"row m-b-10\"><div class=\"col-md-7 m-r-0 p-r-0 toolbar-button\"><div class=btn-group role=group aria-label=\"Basic example\"><!-- <md-button ng-click=\"vm.gotoCreate()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n                        <md-tooltip md-direction=\"top\">Create new question</md-tooltip>\n                        <md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE\n                    </md-button>\n                    <md-button ng-click=\"vm.gotoImport()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n                        <md-tooltip md-direction=\"top\">Import Question</md-tooltip>\n                        <md-font-icon class=\"fa fa-upload fa-lg\"></md-font-icon>&nbsp;&nbsp;IMPORT\n                    </md-button> --></div></div><div class=col-md-5><div class=row><div class=\"col-md-8 filter-select\"><ui-select name=section id=section allow-clear ng-model=vm.selectedSection theme=selectize><ui-select-match placeholder=\"Question section\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.sections | filter: $select.search\"><div ng-bind-html=\"item.id | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div><div class=\"col-md-2 p-t-2\"><button class=\"btn btn-primary shadow-none btn-block\" ng-click=vm.loadData(1)><i class=\"fa fa-refresh\"></i></button></div><div class=\"col-md-2 filter-select\"><select class=\"custom-select mb-2 mr-sm-2 mb-sm-0\" ng-model=vm.pageLength ng-change=vm.loadData(1)><option ng-value=5>5</option><option ng-value=10>10</option><option ng-value=20>20</option><option ng-value=25>25</option><option ng-value=50>50</option></select></div></div></div></div><div class=row><div class=col-md-12 hide show-gt-sm flex block-ui=QaInstances><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered custom-th\"><thead><tr><th>section</th><th>Number</th><th>Question</th><th>Answer</th><th>Flag</th><!-- <th>Action</th> --></tr></thead><tbody><tr ng-repeat=\"item in vm.items\" ng-if=!vm.isLoading><td class=\"custom-td text-center\">{{item.section.id}}</td><td class=\"custom-td text-center\">{{item.question_number}}</td><td class=custom-td><div ng-if=\"item.type === 2\"><img class=question-img imageonload=\"assets/tiki/{{ item.question }}\" src=assets/loader.svg alt=\"\"></div><div ng-if=\"item.type === 1\">{{item.question}}</div></td><td class=custom-td><div ng-if=\"item.type === 1\"><ol><li ng-repeat=\"answer in item.answer\" style=\"list-style-type:upper-alpha; padding-bottom: 5px\">{{answer.answer}}</li></ol></div><div ng-if=\"item.type === 2\"><ol class=list-inline><li class=\"list-inline-item d-inline-flex\" ng-repeat=\"answer in item.answer\" style=list-style-type:upper-alpha><div class=abjact-list>{{ vm.convertIntToChar($index) }} .</div><img class=answer-img imageonload=\"assets/tiki/{{ answer.answer }}\" src=assets/loader.svg alt=\"\"></li></ol></div></td><td class=\"custom-td text-center\" style=width:10%><div style=display:inline ng-repeat=\"answer in item.answer\"><span ng-if=\"answer.flag == 1\" class=\"badge badge-success\">{{ vm.convertIntToChar($index) }}</span></div></td><!-- <td class=\"custom-td text-center\" style=\"width:10%\">\n                                    <button class=\"btn btn-mini-center btn-info\" ng-click=\"vm.gotoEdit(item)\">\n                                        <md-tooltip md-direction=\"top\">Edit question</md-tooltip>\n                                        <i class=\"fa fa-pencil fa-lg\"></i>\n                                    </button>\n                                    <button class=\"btn btn-mini-center btn-danger\"\n                                        ng-click=\"vm.deleteQuestion(ev, item.id)\">\n                                        <md-tooltip md-direction=\"top\">Delete Question</md-tooltip>\n                                        <i class=\"fa fa-trash fa-lg\"></i>\n                                    </button>\n                                </td> --></tr><tr ng-if=vm.isLoading><td colspan=10 class=text-center><span><i class=\"fa fa-spinner fa fa-pulse\"></i> </span>Loading Data ...</td></tr><tr ng-if=\"vm.items.length === 0 && !vm.isLoading\"><td colspan=10 class=text-center>No Data Available</td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/create-question-behavioral.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Behavioral Question</h5></div><div class=card-block><form class=form-horizontal name=behavioralForm><div class=\"form-group row\"><div class=col-md-2><label for=competency class=form-control-label>Competency</label></div><div class=col-md-6><ui-select name=competency required id=competency allow-clear ng-model=vm.selectedCompetency theme=selectize><ui-select-match placeholder=\"Select or search Competency\">{{$select.selected.competency}}</ui-select-match><ui-select-choices repeat=\"item in vm.competency | filter: $select.search\"><div ng-bind-html=\"item.code | highlight: $select.search\"></div><small ng-bind-html=\"item.competency | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=number class=form-control-label>Number</label></div><div class=col-md-4><input type=text class=form-control ng-model=vm.number name=number required id=number></div></div><div class=\"form-group row\"><div class=col-md-2><label for=QPool class=form-control-label>Question Pool</label></div><div class=col-md-6><ui-select name=QPool id=QPool allow-clear ng-model=vm.selectedQPool theme=selectize><ui-select-match placeholder=\"Select or search Question Pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=weight class=form-control-label>Weight (%)</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.weight name=weight id=weight min=0 max=100 step=0.01 placeholder=\"e.g. 100\"></div></div><div class=\"form-group row\"><div class=col-md-2><label for=question class=form-control-label>Question</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.text name=question required id=question rows=4></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Answers</label></div><div class=col-md-10><div class=\"input-group p-b-10 align-items-center\" ng-repeat=\"item in vm.answerOptions\"><div class=input-group-prepend><span class=input-group-text>{{item.option || \'•\'}}</span></div><input type=text placeholder=\"Answer text\" required class=\"form-control m-b-5\" ng-model=vm.answerOptions[$index].text> <input type=number placeholder=\"Value (int)\" min=1 step=1 class=\"form-control m-b-5\" style=\"max-width: 150px; margin-left: 8px\" ng-model=vm.answerOptions[$index].value ng-required=\"vm.answerOptions[$index].text && vm.answerOptions[$index].text.toString().trim() !== \'\'\"><div class=\"rkmd-checkbox checkbox-rotate checkbox-ripple m-2\"><label class=\"input-checkbox checkbox-primary\"><input type=checkbox ng-true-value=1 ng-false-value=0 ng-change=vm.toggleCorrect($index) ng-model=vm.answerOptions[$index].correct> <span class=checkbox></span></label><div class=captions style=margin-left:5px>{{vm.answerOptions[$index].correct == 1 ? \'correct\' : \'incorrect\'}}</div></div></div><div><span><md-button ng-click=vm.addOptions() class=\"btn btn-mini-center btn-primary\"><md-tooltip md-direction=top>Add Option</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon></md-button><md-button ng-click=vm.removeOptions() ng-disabled=\"vm.answerOptions.length == 1\" class=\"btn btn-mini-center btn-danger\"><md-tooltip md-direction=top>Remove Option</md-tooltip><md-font-icon class=\"fa fa-minus-square fa-lg\"></md-font-icon></md-button></span></div></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!behavioralForm.$valid ng-click=vm.saveQuestion() class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/edit-question-behavioral.html","<div class=card><div class=card-header><h5 class=card-header-text>Edit Behavioral Question</h5></div><div class=card-block><form class=form-horizontal name=behavioralForm><div class=\"form-group row\"><div class=col-md-2><label for=competency class=form-control-label>Competency</label></div><div class=col-md-6><ui-select name=competency required id=competency allow-clear ng-model=vm.selectedCompetency theme=selectize><ui-select-match placeholder=\"Select or search Competency\">{{$select.selected.competency}}</ui-select-match><ui-select-choices repeat=\"item in vm.competency | filter: $select.search\"><div ng-bind-html=\"item.code | highlight: $select.search\"></div><small ng-bind-html=\"item.competency | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=number class=form-control-label>Number</label></div><div class=col-md-4><input type=text class=form-control ng-model=vm.number name=number required id=number></div></div><div class=\"form-group row\"><div class=col-md-2><label for=QPool class=form-control-label>Question Pool</label></div><div class=col-md-6><ui-select name=QPool id=QPool allow-clear ng-model=vm.selectedQPool theme=selectize><ui-select-match placeholder=\"Select or search Question Pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=weight class=form-control-label>Weight (%)</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.weight name=weight id=weight min=0 max=100 step=0.01 placeholder=\"e.g. 100\"></div></div><div class=\"form-group row\"><div class=col-md-2><label for=question class=form-control-label>Question</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.text name=question required id=question rows=4></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Answers</label></div><div class=col-md-10><div class=\"input-group p-b-10 align-items-center\" ng-repeat=\"item in vm.answerOptions\"><div class=input-group-prepend><span class=input-group-text>{{item.option || \'•\'}}</span></div><input type=text placeholder=\"Answer text\" required class=\"form-control m-b-5\" ng-model=vm.answerOptions[$index].text> <input type=number placeholder=\"Value (int)\" min=1 step=1 class=\"form-control m-b-5\" style=\"max-width: 150px; margin-left: 8px\" ng-model=vm.answerOptions[$index].value ng-required=\"vm.answerOptions[$index].text && vm.answerOptions[$index].text.toString().trim() !== \'\'\"><div class=\"rkmd-checkbox checkbox-rotate checkbox-ripple m-2\"><label class=\"input-checkbox checkbox-primary\"><input type=checkbox ng-true-value=1 ng-false-value=0 ng-change=vm.toggleCorrect($index) ng-model=vm.answerOptions[$index].correct> <span class=checkbox></span></label><div class=captions style=margin-left:5px>{{vm.answerOptions[$index].correct == 1 ? \'correct\' : \'incorrect\'}}</div></div></div><div><span><md-button ng-click=vm.addOptions() class=\"btn btn-mini-center btn-primary\"><md-tooltip md-direction=top>Add Option</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon></md-button><md-button ng-click=vm.removeOptions() ng-disabled=\"vm.answerOptions.length == 1\" class=\"btn btn-mini-center btn-danger\"><md-tooltip md-direction=top>Remove Option</md-tooltip><md-font-icon class=\"fa fa-minus-square fa-lg\"></md-font-icon></md-button></span></div></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!behavioralForm.$valid ng-click=vm.saveQuestion() class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/import-question-behavioral.html","<div class=card><div class=card-header><button ng-click=vm.back() class=\"btn btn-warning\">Back</button><h5 class=card-header-text>Import Behavioral Questions</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-6><form name=importForm class=form-horizontal><div class=form-group><label for=importFile>Click button to choose file</label><input type=file class=form-control-file id=importFile ngf-select ng-model=vm.importFile name=file accept=.xlsx ngf-max-size=20MB aria-describedby=fileHelp required> <small id=fileHelp class=\"form-text text-muted\">Format accepted (.xlsx), max size 20 MB</small></div><div class=form-group><button type=button ng-disabled=importForm.$invalid ng-click=vm.uploadQuestion(vm.importFile) class=\"btn btn-primary\">Submit</button> <button type=button ng-click=vm.downloadTemplate() class=\"btn btn-secondary ml-2\"><i class=\"fa fa-download\"></i> Download Template</button></div></form><div ng-if=vm.progressEnable><md-progress-linear md-mode=determinate value=file.progress></md-progress-linear></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/question-behavioral.html","<div class=card><div class=card-header><div class=row><div class=\"col-md-5 d-flex align-items-center\"><h5 class=card-header-text>Behavioral Questions</h5></div><div class=\"col-md-7 search-header\"><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div><div class=card-block><div class=\"row m-b-10\"><div class=\"col-md-6 m-r-0 p-r-0 toolbar-button\"><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new question</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button><md-button ng-click=vm.gotoImport() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Import Question</md-tooltip><md-font-icon class=\"fa fa-upload fa-lg\"></md-font-icon>&nbsp;&nbsp;IMPORT</md-button><md-button ng-click=vm.gotoCategory() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Kategori Penilaian</md-tooltip><md-font-icon class=\"fa fa-list-alt fa-lg\"></md-font-icon>&nbsp;&nbsp;CATEGORY</md-button><md-button ng-click=vm.gotoRange() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Interpretasi Skor Final</md-tooltip><md-font-icon class=\"fa fa-chart-bar fa-lg\"></md-font-icon>&nbsp;&nbsp;RANGE</md-button><md-button ng-click=vm.gotoQuality() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Rubrik Penilaian Kualitas</md-tooltip><md-font-icon class=\"fa fa-star fa-lg\"></md-font-icon>&nbsp;&nbsp;QUALITY</md-button></div></div><div class=ml-auto><select class=\"custom-select mb-2 mr-3 mb-sm-0\" ng-model=vm.pageLength ng-change=vm.loadData(1)><option ng-value=5>5</option><option ng-value=10>10</option><option ng-value=20>20</option><option ng-value=25>25</option><option ng-value=50>50</option></select></div></div><div class=row><div class=col-md-12 hide show-gt-sm flex><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th>Number</th><th>Competency</th><th>Question</th><th>Answers</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.questionList\" ng-if=!vm.isLoading><td class=custom-td style=\"vertical-align: middle; text-align: center; width: 20px\">{{item.id}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center; width: 20px\">{{item.number}}</td><td class=custom-td style=\"vertical-align: middle; text-align: start; width: 150px\">{{item.competency.competency}}</td><td class=custom-td style=\"vertical-align: middle; width: 200px\">{{item.text}}</td><td style=\"vertical-align: middle\" class=custom-td><ul style=\"list-style-type:none; padding-left:0; margin-bottom:0\"><li ng-repeat=\"answer in item.answers\" ng-class=\"{\'text-success font-weight-bold\': answer.flag == 1}\">{{answer.option}}. {{answer.text}} <span ng-if=\"answer.value !== null && answer.value !== undefined\">(Value: {{answer.value}}) </span><span ng-if=\"(answer.value === null || answer.value === undefined) && (answer.proficiency_level !== null && answer.proficiency_level !== undefined)\">(Value: {{answer.proficiency_level}})</span></li></ul></td><td style=\"text-align: center; vertical-align: middle; width: 100px\"><button class=\"btn btn-mini-center btn-info\" ng-click=vm.gotoEdit(item)><md-tooltip md-direction=top>Edit question</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=\"vm.deleteQuestion(ev, item.id)\"><md-tooltip md-direction=top>Delete Question</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr><tr ng-if=vm.isLoading><td colspan=6 class=text-center><span><i class=\"fa fa-spinner fa fa-pulse\"></i> </span>Loading Data ...</td></tr><tr ng-if=\"vm.questionList.length === 0 && !vm.isLoading\"><td colspan=6 class=text-center>No Data Available</td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-category/question-category.html","<div class=card><div class=card-header><h5 class=card-header-text>Question Category</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create New Category</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button></div></div><div class=col-md-7><div class=row><div class=col-md-2><!-- <select>\n                  <option>1</option>\n                  <option>2</option>\n                  <option>3</option>\n                  <option>4</option>\n                  <option>5</option>\n                </select> --></div><div class=col-md-10><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.getQuestionCategory(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th style=\"width: 4%; vertical-align: middle\" class=text-center>ID</th><th class=text-left>Name</th><th class=text-left>Description</th><th style=\"width: 8%; vertical-align: middle\" class=text-center>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td style=\"width: 5%\" class=text-center>{{item.id}}</td><td>{{item.name}}</td><td>{{item.description}}</td><td style=\"width: 8%\" class=text-center><button class=\"btn btn-mini-center btn-danger\" ng-click=vm.deleteData(item)><md-tooltip md-direction=top>Delete Question Category</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-info\" ng-click=vm.edit(item)><md-tooltip md-direction=top>Update Question Category</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.getQuestionCategory(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-competency/form.html","<md-dialog aria-label=\"Mango (Fruit)\"><form ng-cloak name=frmCategory style=min-width:300px><md-toolbar><div class=\"md-toolbar-tools bg-primary\"><h2>Create Data</h2><span flex></span><md-button class=md-icon-button ng-click=vm.closeDialog()><md-icon md-font-icon=icon-close aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div class=md-dialog-content><div class=form-group><label for=code>Code</label><input type=text name=code required ng-model=vm.code class=form-control id=code placeholder=\"Enter Code\"></div><div class=form-group><label for=competency>Competency</label><input type=text name=competency required ng-model=vm.competency class=form-control id=competency placeholder=\"Main Category name\"></div><div class=form-group><label for=competencyDesc>Description</label><input type=text name=description required ng-model=vm.description class=form-control id=competencyDesc placeholder=\"Main Category Description\"></div></div></md-dialog-content><md-dialog-actions layout=row><span flex></span><md-button class=\"btn btn-primary\" ng-disabled=\"frmCategory.$invalid || frmCategory.$pristine\" type=submit ng-click=vm.submit(frmCategory)>SUBMIT</md-button><md-button class=\"btn btn-warning\" ng-click=vm.closeDialog()>CANCEL</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/question-bank/question-competency/question-competency.html","<div class=card><div class=card-header><h5 class=card-header-text>Question Competency</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><div class=\"btn-group pull-left\" role=group aria-label=\"Basic example\"><md-button ng-click=\"vm.showForm(null, $event)\" class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button></div></div><div class=col-md-7><div class=row><div class=col-md-2></div><div class=col-md-10><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.getCompetency(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th>Code</th><th class=text-left>Competency</th><th class=text-left>Description</th><th class=text-center>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td style=\"width: 4%; vertical-align: middle\" class=text-center>{{item.id}}</td><td style=\"width: 9%; vertical-align: middle\" class=text-center>{{item.code}}</td><td style=\"vertical-align: middle\" class=text-left>{{item.competency}}</td><td style=\"vertical-align: middle\" class=text-left>{{item.description}}</td><td style=\"text-align: center; vertical-align: middle\"><button class=\"btn btn-mini-center btn-info\" ng-click=\"vm.showForm(item, $event)\"><md-tooltip md-direction=top>Edit</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=vm.showDelete(item)><md-tooltip md-direction=top>Deletey</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.getCompetency(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-pool/question-pool.html","<div class=card><div class=card-header><h5 class=card-header-text>Question Pool</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new question</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button><md-button ng-click=vm.exportToExcels() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Export Pool</md-tooltip><md-font-icon class=\"fa fa-download fa-lg\"></md-font-icon>&nbsp;&nbsp;EXPORT</md-button><!-- <md-button ng-click=\"vm.gotoCreate()\" class=\"btn btn-mini-center btn-primary m-t-0\">\n            <md-tooltip md-direction=\"top\">Import Question</md-tooltip>\n            <md-font-icon class=\"fa fa-download fa-lg\"></md-font-icon>&nbsp;&nbsp;EXPORT\n          </md-button> --></div></div><div class=col-md-7><div class=row><div class=col-md-2><!-- <select>\n                  <option>1</option>\n                  <option>2</option>\n                  <option>3</option>\n                  <option>4</option>\n                  <option>5</option>\n                </select> --></div><div class=col-md-10><form><div class=input-group><div class=\"d-flex flex-row text-center align-items-center justify-content-between center mr-2 gap-2\"><input type=checkbox ng-change=vm.loadData(1) class=\"form-control mr-2\" ng-model=vm.archived aria-label=archived aria-describedby=basic-addon2 id=archived-checkbox><label for=archived-checkbox style=\"margin-top: 5px\">Archived</label></div><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12 block-ui=QuestionPoolBlock><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th style=\"width: 4%; vertical-align: middle\" class=text-center><input type=checkbox ng-model=vm.selectAll ng-click=vm.toggleSelectedAll(vm.selectAll)></th><th ng-click=\"vm.changeOrder(\'id\')\" style=\"vertical-align: middle; cursor: pointer; width:150px\" class=text-left><div class=\"d-flex flex-row justify-content-between align-items-center\"><span style=\"display: inline-block\">ID</span> <i style=\"margin-left: auto; display: inline-block; padding-right: 2px\" ng-class=\"vm.getHeaderIcon(\'id\')\"></i></div></th><th ng-click=\"vm.changeOrder(\'name\')\" style=\"vertical-align: middle; cursor: pointer; width:340px\" class=text-left><div class=\"d-flex flex-row justify-content-between align-items-center\"><span style=\"display: inline-block\">Name</span> <i style=\"margin-left: auto; display: inline-block; padding-right: 2px\" ng-class=\"vm.getHeaderIcon(\'name\')\"></i></div></th><th style=\"vertical-align: middle\" class=text-left>Description</th><th ng-click=\"vm.changeOrder(\'created_at\')\" style=\"vertical-align: middle; cursor: pointer; width:160px\" class=text-left><div class=\"d-flex flex-row justify-content-between align-items-center\"><span style=\"display: inline-block\">Created At</span> <i style=\"margin-left: auto; display: inline-block; padding-right: 2px\" ng-class=\"vm.getHeaderIcon(\'created_at\')\"></i></div></th><th ng-click=\"vm.changeOrder(\'last_used_at\')\" style=\"vertical-align: middle; cursor: pointer; width:160px\" class=text-left><div class=\"d-flex flex-row justify-content-between align-items-center\"><span style=\"display: inline-block\">Last Used At</span> <i style=\"margin-left: auto; display: inline-block; padding-right: 2px\" ng-class=\"vm.getHeaderIcon(\'last_used_at\')\"></i></div></th><th style=\"vertical-align: middle\" class=text-center>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td style=\"width: 4%; vertical-align: middle\" class=text-center><input type=checkbox checklist-model=vm.selected checklist-value=item.id></td><td style=\"width: 4%; vertical-align: middle\" class=text-center>{{item.id}}</td><td style=\"vertical-align: middle\" class=text-left>{{item.name}}</td><td style=\"vertical-align: middle\" class=text-left>{{item.description}}</td><td style=\"vertical-align: middle\" class=text-left>{{item.created_at}}</td><td style=\"vertical-align: middle\" class=text-left>{{item.last_used_at}}</td><td style=\"vertical-align: middle; width: 10%\" class=text-center><button ng-if=!item.deleted_at class=\"btn btn-mini-center btn-danger\" ng-click=vm.archive(item)><md-tooltip md-direction=top>Archive Pool</md-tooltip><i class=\"fa fa-archive\"></i></button> <button ng-if=item.deleted_at class=\"btn btn-mini-center btn-primary\" ng-click=vm.unarchive(item)><md-tooltip md-direction=top>Unarchive Pool</md-tooltip><i class=\"fa fa-archive\"></i></button> <button class=\"btn btn-mini-center btn-info\" ng-click=vm.edit(item)><md-tooltip md-direction=top>Edit Pool</md-tooltip><i class=\"fa fa-pencil\"></i></button> <button class=\"btn btn-mini-center btn-info\" ng-click=vm.exportToExcel(item)><md-tooltip md-direction=top>Export to Excel</md-tooltip><i class=\"fa fa-table\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div></div></div></div></div>");
$templateCache.put("app/main/modules/report/report-beq/report-beq.html","<!-- Container-fluid starts --><div class=card><div class=card-header><h5>Report Beq</h5></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=\"row m-b-10\"><div class=col-md-4><div class=btn-group role=group aria-label=\"Basic example\"><!-- <md-button ng-click=\"vm.exportDataMultiple()\"\n                                   ng-disabled=\"vm.selectedDate === \'all\'\"\n                                   class=\"btn btn-mini-center btn-primary m-t-0\">\n                            <md-tooltip md-direction=\"top\">Export Data</md-tooltip>\n                            <md-font-icon class=\"fa fa-table fa-lg\"></md-font-icon>&nbsp;&nbsp;Export\n                        </md-button> --></div></div><div class=col-md-8><div class=row><div class=col-md-5><ui-select name=date id=date ng-change=vm.loadData(1) allow-clear ng-model=vm.selectedDate theme=selectize><ui-select-match placeholder=\"Select or search date\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in vm.listDate | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-md-7><form class=form-horizontal><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\"><thead><tr><th class=text-center>NO</th><th class=text-center>NIK</th><th class=text-left>Name</th><th class=text-left>Group Participant</th><th class=text-center>Finsihed Date</th><th class=text-center>Finished Time</th><th class=text-center>#</th></tr></thead><tbody><tr ng-repeat=\"item in vm.paginate.data\"><td class=text-center>{{ $index + 1}}</td><td class=text-center>{{ item.user.nik }}</td><td class=text-left>{{ item.user.name }}</td><td>{{ item.session.group_participant.name }}</td><td class=text-center>{{ item.finished_date}}</td><td class=text-center>{{ item.finished_time}}</td><td class=text-center><button class=\"btn btn-primary badge\" ng-click=vm.exportDataSingle(item.id)><md-tooltip md-direction=top>Print</md-tooltip><i class=\"fa fa-print\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/report/report-behavioral/report-behavioral.html","<!-- Container-fluid starts --><div class=card><div class=card-header><h5>Report Behavioral</h5></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=\"row m-b-10\"><div class=col-md-4><div class=btn-group role=group aria-label=\"Basic example\"></div></div><div class=col-md-8><div class=row><div class=col-md-5><ui-select name=date id=date ng-change=vm.loadData(1) allow-clear ng-model=vm.selectedDate theme=selectize><ui-select-match placeholder=\"Select or search date\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in vm.listDate | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-md-7><form class=form-horizontal><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\"><thead><tr><th class=text-center>NO</th><th class=text-center>NIK</th><th class=text-left>Name</th><th class=text-left>Group Participant</th><th class=text-center>Finished Date</th><th class=text-center>Finished Time</th><th class=text-center>#</th></tr></thead><tbody><tr ng-repeat=\"item in vm.paginate.data\"><td class=text-center>{{ $index + 1}}</td><td class=text-center>{{ item.user.nik }}</td><td class=text-left>{{ item.user.name }}</td><td>{{ item.session.group_participant.name }}</td><td class=text-center>{{ item.finished_date}}</td><td class=text-center>{{ item.finished_time}}</td><td class=text-center><button class=\"btn btn-primary badge\" ng-click=vm.viewDetail(item)><md-tooltip md-direction=top>View</md-tooltip><i class=\"fa fa-eye\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/report/report-general/report-general.html","<!-- Container-fluid starts --><div class=card><div class=card-header><h5>Report General</h5></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=\"row m-b-10\"><div class=col-md-4><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.exportData() ng-disabled=\"vm.selectedDate.finished_date == \'all\'\" class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Export Data</md-tooltip><md-font-icon class=\"fa fa-table fa-lg\"></md-font-icon>&nbsp;&nbsp;Export</md-button></div></div><div class=col-md-8><div class=row><div class=col-md-4><ui-select name=questionPool id=questionPool ng-change=vm.loadData(1) allow-clear ng-model=vm.selectedPool theme=selectize><ui-select-match placeholder=\"Select or search question pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-md-2><ui-select name=date id=date ng-change=vm.loadData(1) allow-clear ng-model=vm.selectedDate theme=selectize><ui-select-match placeholder=\"Select or search date\">{{$select.selected.finished_date}}</ui-select-match><ui-select-choices repeat=\"item in vm.reportDate | filter: $select.search\"><div ng-bind-html=\"item.finished_date | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-md-6><form class=form-horizontal><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\"><thead><tr><th>NO</th><th class=text-center>NIK</th><th class=text-left>Name</th><th class=text-left>Group</th><th class=text-left>Question Pool</th><th>Finished Time</th><th>Finished Date</th><th>Question Total</th><th>Correct Answer</th><th>Wrong Answer</th><th>Score</th><th class=text-center>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.list\"><td style=\"vertical-align: middle\" class=text-center>{{$index+1}}</td><td class=text-center style=\"vertical-align: middle\">{{item.user.nik}}</td><td style=\"vertical-align: middle\">{{item.user.name}}</td><td style=\"vertical-align: middle\">{{item.user.user_participant.group_participant.name}}</td><td style=\"vertical-align: middle\">{{item.submission.session.pool.name}}</td><td style=\"vertical-align: middle\" class=text-center>{{item.finished_at}}</td><td style=\"vertical-align: middle\" class=text-center>{{item.finished_date}}</td><td style=\"vertical-align: middle\" class=text-center>{{item.question_total}}</td><td style=\"vertical-align: middle\" class=text-center>{{item.correct_answer}}</td><td style=\"vertical-align: middle\" class=text-center>{{item.wrong_answer}}</td><td style=\"vertical-align: middle\" class=text-center>{{item.score}}</td><td style=\"text-align: center; width: 15%\"><span class=badge ng-click=vm.exportDataAchievement(item)><md-tooltip md-direction=top>Export User Report</md-tooltip><i class=\"material-icons text-primary\">archive </i></span><span class=badge ng-click=vm.getDetail(item)><md-tooltip md-direction=top>View Detail</md-tooltip><i class=\"material-icons text-primary\">visibility </i></span><span class=badge ng-click=vm.exportQuestionPool(item)><md-tooltip md-direction=top>Download pool</md-tooltip><i class=\"material-icons text-primary\">file_download</i></span></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/report/report-intray/report-intray.html","<!-- Container-fluid starts --><div class=card><div class=card-header><h5>Report Intray</h5></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=\"row m-b-10\"><div class=col-md-4><div class=btn-group role=group aria-label=\"Basic example\"><!-- <md-button ng-click=\"vm.exportDataMultiple()\"\n                                   ng-disabled=\"vm.selectedDate === \'all\'\"\n                                   class=\"btn btn-mini-center btn-primary m-t-0\">\n                            <md-tooltip md-direction=\"top\">Export Data</md-tooltip>\n                            <md-font-icon class=\"fa fa-table fa-lg\"></md-font-icon>&nbsp;&nbsp;Export\n                        </md-button> --></div></div><div class=col-md-8><div class=row><div class=col-md-5><ui-select name=date id=date ng-change=vm.loadData(1) allow-clear ng-model=vm.selectedDate theme=selectize><ui-select-match placeholder=\"Select or search date\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in vm.listDate | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-md-7><form class=form-horizontal><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\"><thead><tr><th class=text-center>NO</th><th class=text-center>NIK</th><th class=text-left>Name</th><th class=text-left>Group Participant</th><th class=text-center>Finsihed Date</th><th class=text-center>Finished Time</th><th class=text-center>#</th></tr></thead><tbody><tr ng-repeat=\"item in vm.paginate.data\"><td class=text-center>{{ $index + 1}}</td><td class=text-center>{{ item.user.nik }}</td><td class=text-left>{{ item.user.name }}</td><td>{{ item.session.group_participant.name }}</td><td class=text-center>{{ item.finished_date}}</td><td class=text-center>{{ item.finished_time}}</td><td class=text-center><button class=\"btn btn-primary badge\" ng-click=vm.exportDataSingle(item.id)><md-tooltip md-direction=top>Print</md-tooltip><i class=\"fa fa-print\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/question-bank/question-excel/question-excel-file-formula.html","");
$templateCache.put("app/main/modules/question-bank/question-excel/question-excel-file.form.html","<md-dialog aria-label=\"Upload Excel File\"><form ng-submit=vm.submit()><md-dialog-content><div class=md-dialog-content><md-input-container class=md-block><label>Choose file (.xls/.xlsx)</label><input type=file file-model=vm.file></md-input-container></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>Upload</md-button><md-button ng-click=vm.cancel()>Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/question-bank/question-excel/question-excel-file.html","<div class=card layout=column layout-padding><div layout=row layout-align=\"space-between center\"><h2>Excel Files</h2><button class=\"btn btn-mini-center btn-info\" ng-click=vm.showForm($event)><md-tooltip md-direction=top>Upload</md-tooltip><i class=\"fa fa-upload fa-lg mr-2\"></i> Upload</button></div><table class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>#</th><th>Original Name</th><th>Filename</th><th>Uploaded At</th><th class=text-center>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td>{{$index + 1}}</td><td>{{item.original_name}}</td><td>{{item.filename}}</td><td>{{item.created_at}}</td><td class=text-center><button class=\"btn btn-mini-center btn-info\" ng-click=vm.goToDetail(item)><md-tooltip md-direction=top>Edit</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-info\" ng-click=vm.download(item)><md-tooltip md-direction=top>Download</md-tooltip><i class=\"fa fa-download fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=\"vm.showDelete($event, item.id)\"><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div>");
$templateCache.put("app/main/modules/question-bank/question-excel/question-excel-question.form.html","<form class=card layout=column layout-padding><div layout=row layout-align=\"space-between center\"><h2>Excel Questions</h2><button class=\"btn btn-mini-center btn-info\" ng-click=vm.submit()><md-tooltip md-direction=top>Submit</md-tooltip><i class=\"fa fa-save fa-lg mr-2\"></i> Submit</button></div><div layout=row flex layout-align=\"start center\" layout-gap=20px><div flex=50 layout=column><div class=\"form-group row\"><div class=col-md-3><label for=order_number class=form-control-label>Question Number</label></div><div class=col-md-9><input class=form-control ng-model=vm.model.order_number name=order_number required id=order_number></div></div><div class=\"form-group row\"><div class=col-md-3><label for=question class=form-control-label>Question</label></div><div class=col-md-9><textarea class=form-control ng-model=vm.model.question rows=5 name=question required id=question>\n                    </textarea></div></div><div flex layout=column layout-padding><div flex layout=row layout-align=\"space-between center\"><h4>Schemas</h4><button class=\"btn btn-mini-center btn-primary\" ng-click=vm.addSchema()><md-tooltip md-direction=top>Add</md-tooltip><i class=\"fa fa-plus fa-lg mr-2\"></i> Add</button></div><table class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>Description</th><th>Formula</th><th>Cell Start</th><th>Cell End</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"(idx, s) in vm.model.schemas\"><td><input class=form-control ng-model=s.description name=description_{{idx}} required id=description_{{idx}}></td><td><input class=form-control ng-model=s.formula name=formula_{{idx}} required id=formula_{{idx}}></td><td><input class=form-control ng-model=s.cell_start name=cell_start_{{idx}} required id=cell_start_{{idx}}></td><td><input class=form-control ng-model=s.cell_end name=cell_end_{{idx}} required id=cell_end_{{idx}}></td><td><button class=\"btn btn-mini-center btn-danger\" ng-click=vm.removeSchema(idx)><md-tooltip md-direction=top>Remove</md-tooltip><i class=\"fa fa-save fa-lg mr-2\"></i> Remove</button></td></tr></tbody></table></div></div><div class=p-10 flex layout=column><iframe ng-src={{vm.getViewerUrl()}} style=\"width: 100%; min-height: 400px\"></iframe></div></div></form>");
$templateCache.put("app/main/modules/question-bank/question-excel/question-excel.form.html","<md-dialog aria-label=\"Excel Question Form\"><form ng-submit=vm.submit()><md-dialog-content><div class=md-dialog-content><md-input-container class=md-block><label>Order Number</label><input ng-model=vm.model.order_number type=number></md-input-container><md-input-container class=md-block><label>Question</label><textarea ng-model=vm.model.question></textarea></md-input-container><div><h4>Schemas</h4><div ng-repeat=\"(idx, s) in vm.model.schemas\"><md-input-container class=md-block><label>Formula</label><input ng-model=s.formula></md-input-container><md-input-container class=md-block><label>Cell Start</label><input ng-model=s.cell_start></md-input-container><md-input-container class=md-block><label>Cell End</label><input ng-model=s.cell_end></md-input-container><md-input-container class=md-block><label>Description</label><input ng-model=s.description></md-input-container><md-input-container class=md-block><label>Formula Detail (JSON)</label><textarea ng-model=s.formula_detail_json></textarea></md-input-container><md-button ng-click=vm.removeSchema(idx) class=md-warn>Remove</md-button><md-divider></md-divider></div><md-button ng-click=vm.addSchema() class=md-primary>Add Schema</md-button></div></div></md-dialog-content><md-dialog-actions><md-button type=submit class=md-primary>Save</md-button><md-button ng-click=vm.cancel()>Cancel</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/modules/question-bank/question-excel/question-excel.html","<div class=card layout=column layout-padding><div layout=row layout-align=\"space-between center\"><div layout=row layout-align=\"start center\"><button class=\"btn btn-mini-center btn-warning mr-2\" ng-click=vm.back()><md-tooltip md-direction=top>Back</md-tooltip><i class=\"fa fa-chevron-left fa-lg mr-2\"></i>Back</button><h4>{{vm.file ? vm.file.original_name : \'\'}}</h4></div><button class=\"btn btn-mini-center btn-info\" ng-click=vm.goToQuestion(null)><md-tooltip md-direction=top>Add Question</md-tooltip><i class=\"fa fa-plus fa-lg mr-2\"></i>Add Question</button></div><table class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>#</th><th>Order</th><th>Question</th><th>Schemas</th><th class=text-right>Actions</th></tr></thead><tbody><tr ng-repeat=\"item in vm.items\"><td>{{$index + 1}}</td><td>{{item.order_number}}</td><td>{{item.question}}</td><td>{{item.schemas.length}} schema(s)</td><td class=text-right><button class=\"btn btn-mini-center btn-info\" ng-click=vm.goToQuestion(item)><md-tooltip md-direction=top>Edit question</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=\"vm.showDelete($event, item.id)\"><md-tooltip md-direction=top>Delete Question</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div>");
$templateCache.put("app/main/modules/report/report-papikostik/report-papikostik.html","<!-- Container-fluid starts --><div class=card><div class=card-header><h5>Report Papikostik</h5></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=\"row m-b-10\"><div class=col-md-4><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.exportDataMultiple() ng-disabled=\"vm.selectedDate === \'all\'\" class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Export Data</md-tooltip><md-font-icon class=\"fa fa-table fa-lg\"></md-font-icon>&nbsp;&nbsp;Export</md-button></div></div><div class=col-md-8><div class=row><div class=col-md-5><ui-select name=date id=date ng-change=vm.loadData(1) allow-clear ng-model=vm.selectedDate theme=selectize><ui-select-match placeholder=\"Select or search date\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in vm.listDate | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-md-7><form class=form-horizontal><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\"><thead><tr><th class=text-center>NO</th><th class=text-center>NIK</th><th class=text-left>Name</th><th class=text-left>Group Participant</th><th class=text-center>Finsihed Date</th><th class=text-center>Finished Time</th><th class=text-center>#</th></tr></thead><tbody><tr ng-repeat=\"item in vm.paginate.data\"><td class=text-center>{{ $index + 1}}</td><td class=text-center>{{ item.user.nik }}</td><td class=text-left>{{ item.user.name }}</td><td>{{ item.session.group_participant.name }}</td><td class=text-center>{{ item.finished_date}}</td><td class=text-center>{{ item.finished_time}}</td><td class=text-center><button class=\"btn btn-primary badge\" ng-click=vm.exportDataSingle(item.id)><md-tooltip md-direction=top>Print</md-tooltip><i class=\"fa fa-print\"></i></button> <button class=\"btn btn-success badge\" ng-click=\"vm.goToDetail(item.id, item.uid)\"><md-tooltip md-direction=top>Detail</md-tooltip><i class=\"fa fa-pie-chart\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/report/report-survey/report-survey.html","<!-- Container-fluid starts --><div class=card><div class=card-header><h5>Report Survey</h5></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=\"row m-b-10\"><div class=col-md-4><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=\"vm.exportDataMultiple(\'pdf\')\" ng-disabled=\"vm.selectedDate === \'all\'\" class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Export PDF</md-tooltip><md-font-icon class=\"fa fa-file-pdf-o fa-lg\"></md-font-icon>&nbsp;&nbsp;PDF</md-button><md-button ng-click=\"vm.exportDataMultiple(\'excel\')\" ng-disabled=\"vm.selectedDate === \'all\'\" class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Export Excel</md-tooltip><md-font-icon class=\"fa fa-file-excel-o fa-lg\"></md-font-icon>&nbsp;&nbsp;Excel</md-button></div></div><div class=col-md-8><div class=row><div class=col-md-5><ui-select name=date id=date ng-change=vm.loadData(1) allow-clear ng-model=vm.selectedDate theme=selectize><ui-select-match placeholder=\"Select or search date\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in vm.listDate | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-md-7><form class=form-horizontal><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\"><thead><tr><th class=text-center>NO</th><th class=text-center>NIK</th><th class=text-left>Name</th><th class=text-left>Group Participant</th><th class=text-center>Finsihed Date</th><th class=text-center>Finished Time</th><th class=text-center>#</th></tr></thead><tbody><tr ng-repeat=\"item in vm.paginate.data\"><td class=text-center>{{ $index + 1}}</td><td class=text-center>{{ item.user.nik }}</td><td class=text-left>{{ item.user.name }}</td><td>{{ item.session.group_participant.name }}</td><td class=text-center>{{ item.finished_date}}</td><td class=text-center>{{ item.finished_time}}</td><td class=text-center><button class=\"btn btn-primary badge\" ng-click=vm.exportDataSingle(item.id)><md-tooltip md-direction=top>Print</md-tooltip><i class=\"fa fa-print\"></i></button></td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/report/report-tiki/report-tiki.html","<div class=card><div class=card-header><h5>Report Tiki</h5></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=\"row m-b-10\"><div class=col-md-4><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.exportData() ng-disabled=\"vm.selectedDate === \'all\'\" class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Export Data</md-tooltip><md-font-icon class=\"fa fa-table fa-lg\"></md-font-icon>&nbsp;&nbsp;Export</md-button></div></div><div class=col-md-8><div class=row><div class=col-md-5><ui-select name=date id=date ng-change=vm.loadData(1) allow-clear ng-model=vm.selectedDate theme=selectize><ui-select-match placeholder=\"Select or search date\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in vm.listDate | filter: $select.search\"><div ng-bind-html=\"item | highlight: $select.search\"></div></ui-select-choices></ui-select></div><div class=col-md-7><form class=form-horizontal><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div></div><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\"><thead><tr><th rowspan=2>NO</th><th rowspan=2 class=text-center>NIK</th><th rowspan=2 class=text-left>Name</th><th rowspan=2 class=text-left>Group Participant</th><th colspan=3 style=width:20px>Section 1</th><th colspan=3 style=width:20px>Section 2</th><th colspan=3 style=width:20px>Section 3</th><th colspan=3 style=width:20px>Section 4</th><th rowspan=2 class=text-center>F1</th><th rowspan=2 class=text-center>F2</th><th rowspan=2 class=text-center>F3</th><th class=text-center rowspan=2>IQ</th><th rowspan=2>Submit at</th></tr><tr><th>C</th><th>I</th><th>STD</th><th>C</th><th>I</th><th>STD</th><th>C</th><th>I</th><th>STD</th><th>C</th><th>I</th><th>STD</th></tr></thead><tbody><tr ng-repeat=\"item in vm.paginate.data\"><td>{{ $index + 1}}</td><td class=text-center>{{ item.user.nik }}</td><td class=text-left>{{ item.user.name }}</td><td>{{ item.group }}</td><td class=text-center>{{ item.section_1.correct }}</td><td class=text-center>{{ item.section_1.incorrect }}</td><td class=text-center>{{ item.std_score_sec_1 }}</td><td class=text-center>{{ item.section_2.correct }}</td><td class=text-center>{{ item.section_2.incorrect }}</td><td class=text-center>{{ item.std_score_sec_2 }}</td><td class=text-center>{{ item.section_3.correct }}</td><td class=text-center>{{ item.section_3.incorrect }}</td><td class=text-center>{{ item.std_score_sec_3 }}</td><td class=text-center>{{ item.section_4.correct }}</td><td class=text-center>{{ item.section_4.incorrect }}</td><td class=text-center>{{ item.std_score_sec_4 }}</td><td class=text-center>{{ item.f1}}</td><td class=text-center>{{ item.f2}}</td><td class=text-center>{{ item.f3}}</td><td class=text-center>{{ item.iq }}</td><td class=text-center>{{ item.submit_date }}</td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/wizard/steps/step1.html","<div class=row><div class=col-md-5><form name=importForm class=form-horizontal><div class=form-group><label for=name>Pool Name</label><input type=text name=name ng-model=vm.name class=form-control id=name aria-describedby=nameHelp required> <small id=nameHelp class=\"form-text text-muted\">It\'s necessary for creating new question pool</small></div><div class=form-group><label for=description>Pool Description</label><input type=text name=description ng-model=vm.description class=form-control id=description aria-describedby=descHelp required> <small id=descHelp class=\"form-text text-muted\">It\'s necessary for creating new question pool</small></div><div class=form-group><label for=importQuestion>Click button to choose file</label><input type=file class=form-control-file id=importQuestion ngf-select ng-model=importFile name=file accept=.xlsx ngf-max-size=2MB aria-describedby=fileHelp ngf-model-invalid=errorFile required> <small id=fileHelp class=\"form-text text-muted\">Format accepted (xlxs), Size 2 MB</small></div><div class=form-group><button type=submit ng-disabled=\"importForm.$invalid || importForm.$pristine\" ng-click=vm.uploadQuestion(importFile) class=\"btn btn-primary\">Submit</button></div><div class=progress ng-if=vm.progressEnable><div class=\"progress-bar w-75\" role=progressbar aria-valuenow={{vm.progress}} aria-valuemin=0 aria-valuemax=100></div></div></form></div></div>");
$templateCache.put("app/main/modules/wizard/steps/step2.html","");
$templateCache.put("app/main/modules/wizard/steps/step3.html","");
$templateCache.put("app/main/modules/enrollment/assessment-session/create-session/create-session.html","<div class=card><div class=card-header><i class=\"fa fa-arrow-left fa-lg\" style=\"line-height: 1\" ng-click=vm.back()></i><h3 class=\"card-header-text pull-right\" style=\"line-height: 2\">Create Session</h3></div><div class=card-block><form class=form-horizontal name=sessionForm><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=classroom class=form-control-label>Proxy</label></div><div class=col-md-6><ui-select name=classroom id=classroom allow-clear ng-model=vm.selectedClassroom theme=selectize><ui-select-match placeholder=\"Select or search classroom\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.classroom | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=QPool class=form-control-label>Question Pool</label></div><div class=col-md-6><ui-select name=QPool id=QPool allow-clear ng-model=vm.selectedQPool theme=selectize><ui-select-match placeholder=\"Select or search Question Pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=GPart class=form-control-label>Group Participant</label></div><div class=col-md-6><ui-select name=GPart id=GPart allow-clear ng-model=vm.selectedGpart theme=selectize><ui-select-match placeholder=\"Select or search group participant\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.groupParticipant | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=sessionType class=form-control-label>Session Type</label></div><div class=col-md-6><ui-select name=sessionType id=sessionType allow-clear ng-model=vm.selectedSessionType theme=selectize><ui-select-match placeholder=\"Select or search session type\">{{$select.selected.toUpperCase()}}</ui-select-match><ui-select-choices repeat=\"item in vm.sessionType | filter: $select.search\"><div ng-bind-html=\"item.toUpperCase() | highlight: $select.search\"></div><small ng-bind-html=\"item.toUpperCase() | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=duration class=form-control-label>Duration</label></div><div class=col-md-6><input class=form-control type=number ng-model=vm.data.duration name=duration required id=duration placeholder=\"In Minutes\"> <span class=text-danger ng-if=\"!sessionForm.duration.$valid && sessionForm.duration.$touched\"><small>Duration field is required</small></span></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=startSession class=form-control-label>Start Date</label></div><div class=col-md-6><div class=input-group min-date=vm.minDateString moment-picker=vm.startSession format=YYYY-MM-DD><span class=input-group-addon><i class=\"icon icon-calendar\"></i> </span><input id=startSession name=startSession class=form-control placeholder=\"Select a date\" ng-model=vm.startSession ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=startAt class=form-control-label>Start At</label></div><div class=col-md-6><input class=form-control type=time ng-model=vm.data.startAt name=startAt required id=startAt> <span class=text-danger ng-if=\"!sessionForm.startAt.$valid && sessionForm.startAt.$touched\"><small>Start At field is required</small></span></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=endSession class=form-control-label>End Date</label></div><div class=col-md-6><div class=input-group min-date=vm.startSession moment-picker=vm.endSession format=YYYY-MM-DD><span class=input-group-addon><i class=\"icon icon-calendar\"></i> </span><input id=endSession ng-disabled=vm.endSessionDisabled name=endSession class=form-control placeholder=\"Select a date\" ng-model=vm.endSession ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=endAt class=form-control-label>End At</label></div><div class=col-md-6><input class=form-control type=time ng-model=vm.data.endAt name=endAt required id=endAt> <span class=text-danger ng-if=\"!sessionForm.endAt.$valid && sessionForm.endAt.$touched\"><small>End At field is required</small></span></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=sessionOrder class=form-control-label>Session Order</label></div><div class=col-md-6><input class=form-control type=number ng-model=vm.data.session_order name=sessionOrder required id=sessionOrder> <span class=text-danger ng-if=\"!sessionForm.sessionOrder.$valid && sessionForm.sessionOrder.$touched\"><small>Session Order Is Required</small></span></div></div><div class=\"form-group row d-flex align-items-center\"><div class=col-md-2><label for=hasRules class=form-control-label>Has Session Rules</label></div><div class=col-md-6><select class=form-control required name=hasRules id=hasRules ng-model=vm.data.has_rules><option ng-value=1>Yes</option><option ng-value=0>No</option></select><!-- <input class=\"form-control\"\n                           type=\"number\"\n                           ng-model=\"vm.data.has_rules\"\n                           name=\"hasRules\"\n                           required\n                           id=\"hasRules\" /> --> <span class=text-danger ng-if=\"!sessionForm.hasRules.$valid && sessionForm.hasRules.$touched\"><small>Session Rules Is Required</small></span></div></div><button ng-disabled=!sessionForm.$valid ng-click=vm.saveSession(sessionForm) class=\"btn btn-success pull-right\">Save</button></form></div></div>");
$templateCache.put("app/main/modules/enrollment/assessment-session/update-session/update-session.html","<div class=card><div class=card-header><i class=\"fa fa-arrow-left fa-lg\" style=\"line-height: 1\" ng-click=vm.back()></i><h3 class=\"card-header-text pull-right\" style=\"line-height: 2\">Update Session</h3></div><div class=card-block><form class=form-horizontal name=sessionForm><div class=\"form-group row\"><div class=col-md-3><label for=classroom class=form-control-label>Proxy</label></div><div class=col-md-9><ui-select name=classroom id=classroom allow-clear ng-model=vm.selectedClassroom theme=selectize><ui-select-match placeholder=\"Select or search classroom\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.classroom | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=QPool class=form-control-label>Question Pool</label></div><div class=col-md-9><ui-select name=QPool id=QPool allow-clear ng-model=vm.selectedQPool theme=selectize><ui-select-match placeholder=\"Select or search Question Pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=GPart class=form-control-label>Group Participant</label></div><div class=col-md-9><ui-select name=GPart id=GPart allow-clear ng-model=vm.selectedGpart theme=selectize><ui-select-match placeholder=\"Select or search group participant\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.groupParticipant | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=sessionType class=form-control-label>Session Type</label></div><div class=col-md-9><ui-select name=sessionType id=sessionType allow-clear ng-model=vm.selectedSessionType theme=selectize><ui-select-match placeholder=\"Select or search session type\">{{$select.selected}}</ui-select-match><ui-select-choices repeat=\"item in vm.sessionType | filter: $select.search\"><div ng-bind-html=\"item| highlight: $select.search\"></div><small ng-bind-html=\"item| highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=duration class=form-control-label>Duration</label></div><div class=col-md-9><input class=form-control type=number ng-model=vm.selectedDuration name=duration required id=duration placeholder=\"In Minutes\"> <span class=text-danger ng-if=\"!sessionForm.duration.$valid && sessionForm.duration.$touched\"><small>Duration field is required</small></span></div></div><div class=\"form-group row\"><div class=col-md-3><label for=startSession class=form-control-label>Start Session</label></div><div class=col-md-9><div class=input-group moment-picker=vm.startSession format=YYYY-MM-DD><span class=input-group-addon><i class=\"icon icon-calendar\"></i> </span><input id=startSession name=startSession class=form-control placeholder=\"Select a date\" ng-model=vm.startSession ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div><div class=\"form-group row\"><div class=col-md-3><label for=startAt class=form-control-label>Start At</label></div><div class=col-md-9><input class=form-control type=time ng-model=vm.selectedStartAt name=startAt required id=startAt> <span class=text-danger ng-if=\"!sessionForm.startAt.$valid && sessionForm.startAt.$touched\"><small>Start At field is required</small></span></div></div><div class=\"form-group row\"><div class=col-md-3><label for=endSession class=form-control-label>End Session</label></div><div class=col-md-9><div class=input-group min-date=vm.startSession moment-picker=vm.endSession format=YYYY-MM-DD><span class=input-group-addon><i class=\"icon icon-calendar\"></i> </span><input id=endSession name=endSession class=form-control placeholder=\"Select a date\" ng-model=vm.endSession ng-model-options=\"{ updateOn: \'blur\' }\"></div></div></div><div class=\"form-group row\"><div class=col-md-3><label for=endAt class=form-control-label>End At</label></div><div class=col-md-9><input class=form-control type=time ng-model=vm.selectedEndAt name=endAt required id=endAt> <span class=text-danger ng-if=\"!sessionForm.endAt.$valid && sessionForm.endAt.$touched\"><small>End At field is required</small></span></div></div><div class=\"form-group row\"><div class=col-md-3><label for=sessionOrder class=form-control-label>Session Order</label></div><div class=col-md-9><input class=form-control type=number ng-model=vm.data.session_order name=sessionOrder required id=sessionOrder> <span class=text-danger ng-if=\"!sessionForm.sessionOrder.$valid && sessionForm.sessionOrder.$touched\"><small>Session Order Is Required</small></span></div></div><div class=\"form-group row\"><div class=col-md-3><label for=hasRules class=form-control-label>Has Session Rules</label></div><div class=col-md-9><select class=form-control required name=hasRules id=hasRules ng-model=vm.data.has_rules><option ng-value=1>Yes</option><option ng-value=0>No</option></select><span class=text-danger ng-if=\"!sessionForm.hasRules.$valid && sessionForm.hasRules.$touched\"><small>Session Rules Is Required</small></span></div></div><button ng-disabled=!sessionForm.$valid ng-click=vm.updateSession(sessionForm) class=\"btn btn-success pull-right\">Save</button></form></div></div>");
$templateCache.put("app/main/modules/enrollment/classroom/create/form.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Class Room</h5></div><div class=card-block><div class=card-block><form class=form-horizontal name=classForm><div class=\"form-group row\"><div class=col-md-2><label for=name class=form-control-label>Name*</label></div><div class=col-md-10><input class=form-control ng-model=vm.data.name name=name required id=name> <span class=text-danger ng-if=\"!classForm.name.$valid && classForm.name.$touched\"><small>Name field is required</small></span></div></div><div class=\"form-group row\"><div class=col-md-2><label for=description class=form-control-label>Description*</label></div><div class=col-md-10><input class=form-control ng-model=vm.data.description name=description required id=description> <span class=text-danger ng-if=\"!classForm.description.$valid && classForm.description.$touched\"><small>Description field is required</small></span></div></div><!-- <div class=\"form-group row\">\n                    <div class=\"col-md-2\">\n                        <label for=\"duration\" class=\"form-control-label\">Duration*</label>\n                    </div>\n                    <div class=\"col-md-10\">\n                        <input class=\"form-control\" type=\"number\" ng-model=\"vm.data.duration\" name=\"duration\" required\n                            id=\"duration\" />\n                        <span class=\"text-danger\"\n                            ng-if=\"!classForm.duration.$valid && classForm.duration.$touched\"><small>Duration field is\n                                required</small></span>\n                    </div>\n                </div> --><!-- <div class=\"form-group row\">\n                    <div class=\"col-md-2\">\n                        <label for=\"start_at\" class=\"form-control-label\">Start At*</label>\n                    </div>\n                    <div class=\"col-md-10\">\n                        <input class=\"form-control\" type=\"time\" ng-model=\"vm.data.start_at\" name=\"start_at\" required\n                            id=\"start_at\" />\n                        <span class=\"text-danger\"\n                            ng-if=\"!classForm.start_at.$valid && classForm.start_at.$touched\"><small>Start At field is\n                                required</small></span>\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <div class=\"col-md-2\">\n                        <label for=\"end_at\" class=\"form-control-label\">End At*</label>\n                    </div>\n                    <div class=\"col-md-10\">\n                        <input class=\"form-control\" type=\"time\" ng-model=\"vm.data.end_at\" name=\"end_at\" required\n                            id=\"end_at\" />\n                        <span class=\"text-danger\"\n                            ng-if=\"!classForm.end_at.$valid && classForm.end_at.$touched\"><small>End At field is\n                                required</small></span>\n                    </div>\n                </div> --><div class=\"form-group row\"><div class=col-md-2><label for=total_participant class=form-control-label>Total Participant*</label></div><div class=col-md-10><input class=form-control type=number ng-model=vm.data.total_participant name=total_participant required id=total_participant> <span class=text-danger ng-if=\"!classForm.total_participant.$valid && classForm.total_participant.$touched\"><small>Total participant field is required</small></span></div></div><div class=\"form-group row\"><div class=col-md-2><label for=location class=form-control-label>Location*</label></div><div class=col-md-10><input class=form-control ng-model=vm.data.location name=location required id=location> <span class=text-danger ng-if=\"!classForm.location.$valid && classForm.location.$touched\"><small>Location field is required</small></span></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!classForm.$valid ng-click=vm.save() class=\"btn btn-success\">Submit</button></div></div></form></div></div></div>");
$templateCache.put("app/main/modules/enrollment/classroom/edit/form.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Class Room</h5></div><div class=card-block><div class=card-block><form class=form-horizontal name=classForm><div class=\"form-group row\"><div class=col-md-2><label for=name class=form-control-label>Name*</label></div><div class=col-md-10><input class=form-control ng-model=vm.data.name name=name required id=name> <span class=text-danger ng-if=\"!classForm.name.$valid && classForm.name.$touched\"><small>Name field is required</small></span></div></div><div class=\"form-group row\"><div class=col-md-2><label for=description class=form-control-label>Description*</label></div><div class=col-md-10><input class=form-control ng-model=vm.data.description name=description required id=description> <span class=text-danger ng-if=\"!classForm.description.$valid && classForm.description.$touched\"><small>Description field is required</small></span></div></div><!-- <div class=\"form-group row\">\n                    <div class=\"col-md-2\">\n                        <label for=\"duration\" class=\"form-control-label\">Duration*</label>\n                    </div>\n                    <div class=\"col-md-10\">\n                        <input class=\"form-control\" type=\"number\" ng-model=\"vm.data.duration\" name=\"duration\" required\n                            id=\"duration\" />\n                        <span class=\"text-danger\"\n                            ng-if=\"!classForm.duration.$valid && classForm.duration.$touched\"><small>Duration field is\n                                required</small></span>\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <div class=\"col-md-2\">\n                        <label for=\"start_at\" class=\"form-control-label\">Start At*</label>\n                    </div>\n                    <div class=\"col-md-10\">\n                        <input class=\"form-control\" placeholder=\"HH:mm:ss\" type=\"time\" ng-model=\"vm.data.start_at\"\n                            name=\"start_at\" required id=\"start_at\" />\n                        <span class=\"text-danger\"\n                            ng-if=\"!classForm.start_at.$valid && classForm.start_at.$touched\"><small>Start At field is\n                                required</small></span>\n                    </div>\n                </div>\n\n                <div class=\"form-group row\">\n                    <div class=\"col-md-2\">\n                        <label for=\"end_at\" class=\"form-control-label\">End At*</label>\n                    </div>\n                    <div class=\"col-md-10\">\n                        <input class=\"form-control\" placeholder=\"HH:mm:ss\" type=\"time\" ng-model=\"vm.data.end_at\"\n                            name=\"end_at\" required id=\"end_at\" />\n                        <span class=\"text-danger\"\n                            ng-if=\"!classForm.end_at.$valid && classForm.end_at.$touched\"><small>End At field is\n                                required</small></span>\n                    </div>\n                </div> --><div class=\"form-group row\"><div class=col-md-2><label for=total_participant class=form-control-label>Total Participant*</label></div><div class=col-md-10><input class=form-control type=number ng-model=vm.data.total_participant name=total_participant required id=total_participant> <span class=text-danger ng-if=\"!classForm.total_participant.$valid && classForm.total_participant.$touched\"><small>Total participant field is required</small></span></div></div><div class=\"form-group row\"><div class=col-md-2><label for=location class=form-control-label>Location*</label></div><div class=col-md-10><input class=form-control ng-model=vm.data.location name=location required id=location> <span class=text-danger ng-if=\"!classForm.location.$valid && classForm.location.$touched\"><small>Location field is required</small></span></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!classForm.$valid ng-click=vm.save() class=\"btn btn-success pull-right\">Submit</button></div></div></form></div></div></div>");
$templateCache.put("app/main/modules/enrollment/group-participant/edit-group-participant/edit-group-participant.html","<div class=card><div class=card-header><h5 class=card-header-text>Update Group Participant</h5></div><div class=card-block><div class=row><div class=col-md-12><form class=form-horizontal name=formGroupParticipant><div class=\"form-group row\"><div class=col-md-2><label for=code class=form-control-label>Code</label></div><div class=col-md-10><input type=text name=code ng-model=vm.code id=code class=form-control placeholder=\"Code group participant\" required></div></div><div class=\"form-group row\"><div class=col-md-2><label for=name class=form-control-label>Name</label></div><div class=col-md-10><input type=text name=name ng-model=vm.name id=name class=form-control placeholder=\"Name group participant\" required></div></div><div class=\"form-group row\"><div class=col-md-2><label for=description class=form-control-label>Description</label></div><div class=col-md-10><input type=text name=description ng-model=vm.description id=code class=form-control placeholder=\"Description group participant\" required></div></div><button ng-disabled=!formGroupParticipant.$valid ng-click=vm.updateData(formGroupParticipant) class=\"btn btn-success pull-right\">Update</button></form></div></div></div></div>");
$templateCache.put("app/main/modules/enrollment/group-participant/create-group-participant/create-group-participant.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Group Participant</h5></div><div class=card-block><div class=row><div class=col-md-12><form class=form-horizontal name=formGroupParticipant><div class=\"form-group row\"><div class=col-md-2><label for=code class=form-control-label>Code</label></div><div class=col-md-10><input type=text name=code ng-model=vm.code id=code class=form-control placeholder=Code required></div></div><div class=\"form-group row\"><div class=col-md-2><label for=name class=form-control-label>Name</label></div><div class=col-md-10><input type=text name=name ng-model=vm.name id=name class=form-control placeholder=Code required></div></div><div class=\"form-group row\"><div class=col-md-2><label for=description class=form-control-label>Description</label></div><div class=col-md-10><input type=text name=description ng-model=vm.description id=code class=form-control placeholder=Code required></div></div><button ng-disabled=!formGroupParticipant.$valid ng-click=vm.saveData(formGroupParticipant) class=\"btn btn-success pull-right\">Save</button></form></div></div></div></div>");
$templateCache.put("app/main/modules/enrollment/user-participant/edit-participant/edit-participant.html","<div class=card><div class=card-header><h5 class=card-header-text>User Assignment</h5></div><div class=card-block><div class=card-block><form class=form-horizontal name=AssignForm><div class=\"form-group row\"><div class=col-md-3><label for=username class=form-control-label>Username</label></div><div class=col-md-9><ui-select name=username id=username search-enabled=false allow-clear ng-model=vm.selectedUser theme=selectize><ui-select-match placeholder=\"Select or search Username or NIK\">{{$select.selected.nik}}</ui-select-match><ui-select-choices repeat=\"item in vm.user | filter: $select.search\"><div ng-bind-html=\"item.nik | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-3><label for=username class=form-control-label>Assign User To Group</label></div><div class=col-md-9><ui-select name=group id=group allow-clear ng-model=vm.selectedGroup theme=selectize><ui-select-match placeholder=\"Select or search Group\">{{$select.selected.code}} | {{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.group | filter: $select.search\"><div ng-bind-html=\"item.code | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default m-r-10\">Back</button> <button ng-disabled=\"AssignForm.$invalid || AssignForm.$pristine\" ng-click=vm.updateData() class=\"btn btn-success pull-right\">Update</button></div></div></form></div></div></div>");
$templateCache.put("app/main/modules/enrollment/user-participant/assign-participant/assign-participant.html","<div class=card><div class=card-header><i class=\"fa fa-arrow-left fa-lg\" ng-click=vm.back() style=\"line-height: 1\"></i><h3 class=\"card-header-text pull-right\" style=\"line-height: 2\">Assign Account</h3></div><div class=card-block><div class=card-block><div class=row><div class=col-md-5><form class=form-horizontal name=AssignForm><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label for=username>Username</label></div><div class=col-md-8><div class=input-group><ui-select id=username style=width:100% name=username ng-model=vm.selectedUser theme=selectize><ui-select-match placeholder=\"Select or search Username or NIK\">{{$select.selected.nik}} | {{$select.selected.name}}</ui-select-match><ui-select-choices refresh=vm.findUser($select) refresh-delay=1000 repeat=\"item in vm.user\"><div ng-bind-html=\"item.nik | highlight: propsFilter\"></div><small ng-bind-html=\"item.name | highlight: propsFilter\"></small></ui-select-choices></ui-select><span class=input-group-addon ng-show=vm.isLoading style=\"background: none;border:none\"><i class=\"fa fa-spinner fa fa-pulse\"></i></span></div></div><div class=col-md-2><button class=\"btn btn-primary\" ng-click=\"vm.addUser(vm.selectedUser, vm.selectedGroup)\" ng-disabled=!vm.selectedGroup><md-tooltip md-direction=top>Add User to Participant</md-tooltip><md-font-icon class=\"fa fa-plus-square\"></md-font-icon></button></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label for=username>Group</label></div><div class=col-md-10><ui-select allow-clear=\"\" id=group name=group ng-model=vm.selectedGroup theme=selectize><ui-select-match placeholder=\"Select or search Group\">{{$select.selected.code}} | {{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.group | filter: $select.search\"><div ng-bind-html=\"item.code | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div></form></div><div class=col-md-7><div class=\"well well-lg\"><div class=col-md-2 ng-repeat=\"item in vm.brackets\" style=\"display: inline\"><span class=\"badge-container badge badge-success\">{{item.user.name}} | {{item.user.nik}} | {{item.group.code}} </span><span class=\"fa fa-times text-danger\" ng-click=vm.removeUser($index)></span></div></div></div></div><div class=row><div class=\"col-md-12 text-center\"><button class=\"btn btn-success\" ng-click=vm.assignUser(AssignForm) ng-disabled=\"AssignForm.$invalid || AssignForm.$pristine || vm.brackets.length == 0\">Submit</button> <button class=\"btn btn-warning\" ng-click=vm.resetData() ng-disabled=\" vm.brackets.length == 0\">Reset</button></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-answer/create-question/create-question.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Question</h5></div><div class=card-block><div ng-show=vm.MsgDisabled class=\"alert alert-success\" role=alert><strong>Success</strong> Question Has Been Created.</div><form class=form-horizontal name=questionForm><div class=\"form-group row\"><div class=col-md-2><label for=competency class=form-control-label>Competency</label></div><div class=col-md-6><ui-select name=competency required id=competency allow-clear ng-model=vm.selectedCompetency theme=selectize><ui-select-match placeholder=\"Select or search Competency\">{{$select.selected.competency}}</ui-select-match><ui-select-choices repeat=\"item in vm.competency | filter: $select.search\"><div ng-bind-html=\"item.code | highlight: $select.search\"></div><small ng-bind-html=\"item.competency | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=category class=form-control-label>Category</label></div><div class=col-md-6><ui-select name=category required id=category allow-clear ng-model=vm.selectedCategory theme=selectize><ui-select-match placeholder=\"Select or search Question Category\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.category | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=QPool class=form-control-label>Pool</label></div><div class=col-md-6><ui-select name=QPool required id=QPool allow-clear ng-model=vm.selectedQPool theme=selectize><ui-select-match placeholder=\"Select or search Question Pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=question class=form-control-label>Question</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.question name=question required id=question rows=5></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label for=file class=form-control-label>Images</label></div><div class=col-md-10><img ng-show=questionForm.file.$valid ngf-thumbnail=picFile class=\"img-fluid m-b-5\"> <input class=form-control type=file ngf-select ng-model=picFile name=file accept=image/* ngf-max-size=2MB ngf-model-invalid=errorFile></div></div><div class=\"form-group row\"><div class=col-md-2><label for=questionType class=form-control-label>Question Type</label></div><div class=col-md-10><div class=\"checkbox-fade fade-in-primary\"><label><input type=checkbox name=selectedQuestionType ng-value=1 ng-true-value=1 ng-model=vm.selectedQuestionType> <span class=cr><i class=\"cr-icon fa fa-check txt-primary\"></i> </span><span>Multiple Choice</span></label></div><div class=\"checkbox-fade fade-in-primary\"><label><input ng-disabled={{true}} type=checkbox name=selectedQuestionType ng-value=2 ng-true-value=2 ng-model=vm.selectedQuestionType> <span class=cr><i class=\"cr-icon fa fa-check txt-primary\"></i> </span><span>Essay</span></label></div><!-- <select class=\"custom-select mb-2 mr-sm-2 mb-sm-0\" name=\"questionType\" ng-model=\"\" id=\"questionType\">\n            <option ng-value=\"1\">Multiple Choice</option>\n            <option ng-value=\"2\">Essay</option>\n          </select> --></div></div><div class=\"form-group row\" ng-if=\"vm.selectedQuestionType == 1\"><div class=col-md-2><label class=form-control-label>Answer</label></div><div class=col-md-10><div class=\"input-group p-b-10\" ng-repeat=\"item in vm.answerOptions\"><input type=text name=answerOptions{{$index}} placeholder={{item.placeholder}} required class=\"form-control m-b-5 col-md-10\" ng-model=vm.answerOptions[$index].option><div class=\"rkmd-checkbox checkbox-rotate checkbox-ripple m-2\"><label class=\"input-checkbox checkbox-primary col-md-2\"><input type=checkbox name=answer{{$index}} id=answer{{$index}} ng-change=vm.test(vm.answerOptions[$index].correct) ng-true-value=1 ng-false-value=0 ng-model=vm.answerOptions[$index].correct> <span class=checkbox></span></label><div class=captions>{{vm.answerOptions[$index].correct == 1 ? \'correct\' : \'incorrect\'}}</div></div></div><div><span><md-button ng-click=vm.addOptions() style=\"margin-left: 0px\" class=\"btn btn-mini-center btn-primary\"><md-tooltip md-direction=top>Create Option</md-tooltip><md-font-icon style=\"padding: 0px\" class=\"fa fa-plus-square fa-lg\"></md-font-icon></md-button><md-button ng-click=vm.removeOptions() ng-disabled=\"vm.answerOptions.length == 1\" style=\"margin-left: 0px\" class=\"btn btn-mini-center btn-danger\"><md-tooltip md-direction=top>Remove Option</md-tooltip><md-font-icon style=\"padding: 0px\" class=\"fa fa-minus-square fa-lg\"></md-font-icon></md-button></span></div></div><!-- <div class=\"col-md-2\">\n          <md-checkbox ng-repeat=\"item in vm.answerOptions\" ng-model=\"vm.answerOptions[$index].correct\" aria-label=\"Checkbox 2\" ng-true-value=\"1\"\n            ng-false-value=\"0\" name=\"answer{{$index}}\">\n          </md-checkbox>\n        </div> --></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-if=!picFile ng-disabled=!questionForm.$valid ng-click=vm.saveQuestionNoImage(questionForm) class=\"btn btn-success pull-right\">Save</button> <button ng-if=picFile ng-disabled=!questionForm.$valid ng-click=vm.saveQuestion($event,picFile) class=\"btn btn-success pull-right\">Save & Upload</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-answer/edit-question/edit.html","<div class=card><div class=card-header><h5 class=card-header-text>Edit Question</h5></div><div class=card-block><form class=form-horizontal name=questionForm><div class=\"form-group row\"><div class=col-md-2><label for=competency class=form-control-label>Competency</label></div><div class=col-md-6><ui-select name=competency required id=competency allow-clear ng-model=vm.selectedCompetency theme=selectize><ui-select-match placeholder=\"Select or search competency\">{{$select.selected.competency}}</ui-select-match><ui-select-choices repeat=\"item in vm.competency | filter: $select.search\"><div ng-bind-html=\"item.code | highlight: $select.search\"></div><small ng-bind-html=\"item.competency | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=category class=form-control-label>Category</label></div><div class=col-md-6><ui-select name=category required id=category allow-clear ng-model=vm.selectedCategory theme=selectize><ui-select-match placeholder=\"Select or search Question Category\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.category | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=QPool class=form-control-label>Job Title</label></div><div class=col-md-6><ui-select name=QPool required id=QPool allow-clear ng-model=vm.selectedQPool theme=selectize><ui-select-match placeholder=\"Select or search Question Pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div></div><div class=\"form-group row\"><div class=col-md-2><label for=question class=form-control-label>Question</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.question name=question required id=question rows=5></textarea></div></div><div class=\"form-group row\" ng-if=\"vm.linkImages && !questionForm.file.$ngfValidations\"><div class=col-md-2><label for=file class=form-control-label>Current Images</label></div><div class=col-md-10><img ng-src=\"{{ vm.linkImages }}\" class=img-fluid></div></div><div class=\"form-group row\"><div class=col-md-2><label for=file class=form-control-label>Images</label></div><div class=col-md-10><img ng-show=questionForm.file.$valid ngf-thumbnail=picFile class=\"img-fluid m-b-5\"> <input class=form-control type=file ngf-select ng-model=picFile name=file accept=image/* ngf-max-size=2MB ngf-model-invalid=errorFile></div></div><div class=\"form-group row\"><div class=col-md-2><label for=questionType class=form-control-label>Question Type</label></div><div class=col-md-10><div class=\"checkbox-fade fade-in-primary\"><label><input type=checkbox name=selectedQuestionType ng-value=1 ng-true-value=1 ng-model=vm.selectedQuestionType> <span class=cr><i class=\"cr-icon fa fa-check txt-primary\"></i> </span><span>Multiple Choice</span></label></div><div class=\"checkbox-fade fade-in-primary\"><label><input type=checkbox name=selectedQuestionType ng-value=2 ng-true-value=2 ng-model=vm.selectedQuestionType> <span class=cr><i class=\"cr-icon fa fa-check txt-primary\"></i> </span><span>Essay</span></label></div><!-- <select class=\"custom-select mb-2 mr-sm-2 mb-sm-0\" name=\"questionType\" ng-model=\"\" id=\"questionType\">\n            <option ng-value=\"1\">Multiple Choice</option>\n            <option ng-value=\"2\">Essay</option>\n          </select> --></div></div><div class=\"form-group row\" ng-if=\"vm.selectedQuestionType == 1\"><div class=col-md-2><label class=form-control-label>Answer</label></div><div class=col-md-10><div class=\"input-group p-b-10\" ng-repeat=\"item in vm.answerOptions\"><input type=text name=answerOptions{{$index}} placeholder={{item.placeholder}} required class=\"form-control m-b-5 col-md-10\" ng-model=vm.answerOptions[$index].option><div class=\"rkmd-checkbox checkbox-rotate checkbox-ripple m-2\"><label class=\"input-checkbox checkbox-primary col-md-2\"><input type=checkbox name=answer{{$index}} id=answer{{$index}} ng-change=vm.test(vm.answerOptions[$index].correct) ng-true-value=1 ng-false-value=0 ng-model=vm.answerOptions[$index].correct> <span class=checkbox></span></label><div class=captions>{{vm.answerOptions[$index].correct == 1 ? \'correct\' : \'incorrect\'}}</div></div></div><div><span><md-button ng-click=vm.addOptions() style=\"margin-left: 0px\" class=\"btn btn-mini-center btn-primary\"><md-tooltip md-direction=top>Create Option</md-tooltip><md-font-icon style=\"padding: 0px\" class=\"fa fa-plus-square fa-lg\"></md-font-icon></md-button><md-button ng-click=vm.removeOptions() ng-disabled=\"vm.answerOptions.length == 1\" style=\"margin-left: 0px\" class=\"btn btn-mini-center btn-danger\"><md-tooltip md-direction=top>Remove Option</md-tooltip><md-font-icon style=\"padding: 0px\" class=\"fa fa-minus-square fa-lg\"></md-font-icon></md-button></span></div></div><!-- <div class=\"col-md-2\">\n          <md-checkbox ng-repeat=\"item in vm.answerOptions\" ng-model=\"vm.answerOptions[$index].correct\" aria-label=\"Checkbox 2\" ng-true-value=\"1\"\n            ng-false-value=\"0\" name=\"answer{{$index}}\">\n          </md-checkbox>\n        </div> --></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-if=!picFile ng-disabled=!questionForm.$valid ng-click=vm.saveQuestionNoImage(questionForm) class=\"btn btn-success pull-right\">Save</button> <button ng-if=picFile ng-disabled=!questionForm.$valid ng-click=vm.saveQuestion(picFile) class=\"btn btn-success pull-right\">Save & Upload</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-answer/import-question/import-question.html","<div class=card><div class=card-header><h5 class=card-header-text>Import Question</h5></div><div class=card-block><div class=\"row m-b-10\"><div class=col-md-5><form name=importForm class=form-horizontal><div class=form-group><label for=name>Question Pool</label><ui-select name=QPool id=QPool allow-clear ng-model=vm.selectedQPool theme=selectize><ui-select-match placeholder=\"Select or search Question Pool\">{{$select.selected.name}}</ui-select-match><ui-select-choices repeat=\"item in vm.questionPool | filter: $select.search\"><div ng-bind-html=\"item.name | highlight: $select.search\"></div><small ng-bind-html=\"item.name | highlight: $select.search\"></small></ui-select-choices></ui-select></div><div class=form-group><label for=importQuestion>Click button to choose file</label><input type=file class=form-control-file id=importQuestion ngf-select ng-model=importFile name=file accept=.xlsx ngf-max-size=2MB aria-describedby=fileHelp ngf-model-invalid=errorFile required> <small id=fileHelp class=\"form-text text-muted\">Format accepted (xlxs), Size 2 MB</small></div><div class=form-group><button type=submit ng-disabled=\"importForm.$invalid || importForm.$pristine\" ng-click=vm.uploadQuestion(importFile) class=\"btn btn-primary\">Submit</button></div></form></div></div><!-- <div class=\"col p-0\" ng-cloak ng-if=\"vm.errors && vm.errors.length > 0\">\n      <h1 class=\"text-danger text-lg\">Errors Logs</h1>\n      <div class=\"form-group\">\n        <label for=\"statusFilter\">Filter Status:</label>\n        <select id=\"statusFilter\" ng-model=\"vm.statusFilter\" class=\"form-control\">\n          <option value=\"\">All</option>\n          <option value=\"valid\">Valid</option>\n          <option value=\"invalid\">Invalid</option>\n        </select>\n      </div>\n      <md-content>\n        <md-tabs md-dynamic-height md-border-bottom>\n          <md-tab ng-repeat=\"error in vm.errors\" label=\"{{error.sheetName}}\">\n            <md-content class=\"md-padding\">\n              <table class=\"table table-small-font table-sm table-bordered table-striped custom-th\">\n                <thead>\n                  <tr>\n                    <th style=\"width: 50px; text-align: center;\"\">Number</th>\n                    <th style=\"width: 100px; text-align: center;\">Status</th>\n                    <th>Message</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr ng-repeat=\"item in error.items | filter: vm.filterError\">\n                    <td style=\"text-align: center;\">{{item.number}}</td>\n                    <td style=\"text-align: center;\">{{item.status}}</td>\n                    <td>\n                      {{item.message}}\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </md-content>\n          </md-tab>\n        </md-tabs>\n      </md-content>\n    </div> --></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-category/create-category-behavioral.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Behavioral Category Score</h5></div><div class=card-block><form class=form-horizontal name=catForm><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Weighted Min</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.weighted_score_min name=weighted_score_min step=0.01 required></div><div class=col-md-2><label class=form-control-label>Weighted Max</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.weighted_score_max name=weighted_score_max step=0.01></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Category</label></div><div class=col-md-10><input type=text class=form-control ng-model=vm.category name=category></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>After AI Category</label></div><div class=col-md-10><input type=text class=form-control ng-model=vm.category_after_ai name=category_after_ai></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>After AI Min</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.after_ai_correction_score_min name=after_ai_correction_score_min step=0.01></div><div class=col-md-2><label class=form-control-label>After AI Max</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.after_ai_correction_score_max name=after_ai_correction_score_max step=0.01></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Recommendation</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.recommendation name=recommendation rows=3></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Follow up</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.follow_up name=follow_up rows=2></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!catForm.$valid ng-click=vm.save() class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-category/edit-category-behavioral.html","<div class=card><div class=card-header><h5 class=card-header-text>Edit Behavioral Category Score</h5></div><div class=card-block><form class=form-horizontal name=catForm><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Weighted Min</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.weighted_score_min name=weighted_score_min step=0.01 required></div><div class=col-md-2><label class=form-control-label>Weighted Max</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.weighted_score_max name=weighted_score_max step=0.01></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Category</label></div><div class=col-md-10><input type=text class=form-control ng-model=vm.data.category name=category></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>After AI Category</label></div><div class=col-md-10><input type=text class=form-control ng-model=vm.data.category_after_ai name=category_after_ai></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>After AI Min</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.after_ai_correction_score_min name=after_ai_correction_score_min step=0.01></div><div class=col-md-2><label class=form-control-label>After AI Max</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.after_ai_correction_score_max name=after_ai_correction_score_max step=0.01></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Recommendation</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.data.recommendation name=recommendation rows=3></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Follow up</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.data.follow_up name=follow_up rows=2></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!catForm.$valid ng-click=vm.save() class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-category/list-category-behavioral.html","<div class=card><div class=card-header><div class=row><div class=\"col-md-5 d-flex align-items-center\"><button class=\"btn btn-default btn-sm mr-2\" ng-click=vm.gotoBack()><i class=\"fa fa-arrow-left\"></i> Back</button><h5 class=card-header-text>Behavioral Category Scores</h5></div><div class=\"col-md-7 search-header\"><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div><div class=card-block><div class=\"row m-b-10\"><div class=\"col-md-2 m-r-0 p-r-0 toolbar-button\"><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new category</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button></div></div><div class=col-md-10><div class=row><div class=col-md-10><select class=\"custom-select mb-2 mr-sm-2 mb-sm-0\" ng-model=vm.pageLength ng-change=vm.loadData(1)><option ng-value=5>5</option><option ng-value=10>10</option><option ng-value=20>20</option><option ng-value=25>25</option><option ng-value=50>50</option></select></div></div></div></div><div class=row><div class=col-md-12 hide show-gt-sm flex><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th>Weighted Min</th><th>Weighted Max</th><th>Category</th><th>After AI Category</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.categoryList\" ng-if=!vm.isLoading><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.id}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.weighted_score_min}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.weighted_score_max}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.category}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.category_after_ai}}</td><td style=\"text-align: center; vertical-align: middle\"><button class=\"btn btn-mini-center btn-info\" ng-click=vm.gotoEdit(item)><md-tooltip md-direction=top>Edit</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=\"vm.deleteItem(ev, item.id)\"><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr><tr ng-if=vm.isLoading><td colspan=6 class=text-center><span><i class=\"fa fa-spinner fa fa-pulse\"></i> </span>Loading Data ...</td></tr><tr ng-if=\"vm.categoryList.length === 0 && !vm.isLoading\"><td colspan=6 class=text-center>No Data Available</td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-quality/create-quality-behavioral.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Behavioral Quality Score</h5></div><div class=card-block><form class=form-horizontal name=qualityForm><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Score</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.score name=score required></div><div class=col-md-2><label class=form-control-label>Label</label></div><div class=col-md-4><input type=text class=form-control ng-model=vm.label name=label required></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Primary Criteria</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.primary_criteria name=primary_criteria rows=3></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Concrete Indicator</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.concrete_indicator name=concrete_indicator rows=3></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!qualityForm.$valid ng-click=vm.save() class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-quality/edit-quality-behavioral.html","<div class=card><div class=card-header><h5 class=card-header-text>Edit Behavioral Quality Score</h5></div><div class=card-block><form class=form-horizontal name=qualityForm><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Score</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.score name=score required></div><div class=col-md-2><label class=form-control-label>Label</label></div><div class=col-md-4><input type=text class=form-control ng-model=vm.data.label name=label required></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Primary Criteria</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.data.primary_criteria name=primary_criteria rows=3></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Concrete Indicator</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.data.concrete_indicator name=concrete_indicator rows=3></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!qualityForm.$valid ng-click=vm.save() class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-quality/list-quality-behavioral.html","<div class=card><div class=card-header><div class=row><div class=\"col-md-5 d-flex align-items-center\"><button class=\"btn btn-default btn-sm mr-2\" ng-click=vm.gotoBack()><i class=\"fa fa-arrow-left\"></i> Back</button><h5 class=card-header-text>Behavioral Quality Scores</h5></div><div class=\"col-md-7 search-header\"><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div><div class=card-block><div class=\"row m-b-10\"><div class=\"col-md-2 m-r-0 p-r-0 toolbar-button\"><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new quality</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button></div></div><div class=col-md-10><div class=row><div class=col-md-10><select class=\"custom-select mb-2 mr-sm-2 mb-sm-0\" ng-model=vm.pageLength ng-change=vm.loadData(1)><option ng-value=5>5</option><option ng-value=10>10</option><option ng-value=20>20</option><option ng-value=25>25</option><option ng-value=50>50</option></select></div></div></div></div><div class=row><div class=col-md-12 hide show-gt-sm flex><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th>Score</th><th>Label</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.qualityList\" ng-if=!vm.isLoading><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.id}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.score}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.label}}</td><td style=\"text-align: center; vertical-align: middle\"><button class=\"btn btn-mini-center btn-info\" ng-click=vm.gotoEdit(item)><md-tooltip md-direction=top>Edit</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=\"vm.deleteItem(ev, item.id)\"><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr><tr ng-if=vm.isLoading><td colspan=4 class=text-center><span><i class=\"fa fa-spinner fa fa-pulse\"></i> </span>Loading Data ...</td></tr><tr ng-if=\"vm.qualityList.length === 0 && !vm.isLoading\"><td colspan=4 class=text-center>No Data Available</td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-range/create-range-behavioral.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Behavioral Range Score</h5></div><div class=card-block><form class=form-horizontal name=rangeForm><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Score Min</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.score_min name=score_min required></div><div class=col-md-2><label class=form-control-label>Score Max</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.score_max name=score_max></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>% Min</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.percentage_min name=percentage_min step=0.01></div><div class=col-md-2><label class=form-control-label>% Max</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.percentage_max name=percentage_max step=0.01></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Category</label></div><div class=col-md-10><input type=text class=form-control ng-model=vm.category name=category></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Recommendation</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.recommendation name=recommendation rows=3></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Follow up</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.follow_up name=follow_up rows=2></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!rangeForm.$valid ng-click=vm.save() class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-range/edit-range-behavioral.html","<div class=card><div class=card-header><h5 class=card-header-text>Edit Behavioral Range Score</h5></div><div class=card-block><form class=form-horizontal name=rangeForm><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Score Min</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.score_min name=score_min required></div><div class=col-md-2><label class=form-control-label>Score Max</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.score_max name=score_max></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>% Min</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.percentage_min name=percentage_min step=0.01></div><div class=col-md-2><label class=form-control-label>% Max</label></div><div class=col-md-4><input type=number class=form-control ng-model=vm.data.percentage_max name=percentage_max step=0.01></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Category</label></div><div class=col-md-10><input type=text class=form-control ng-model=vm.data.category name=category></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Recommendation</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.data.recommendation name=recommendation rows=3></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label class=form-control-label>Follow up</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.data.follow_up name=follow_up rows=2></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!rangeForm.$valid ng-click=vm.save() class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-behavioral/behavioral-range/list-range-behavioral.html","<div class=card><div class=card-header><div class=row><div class=\"col-md-5 d-flex align-items-center\"><button class=\"btn btn-default btn-sm mr-2\" ng-click=vm.gotoBack()><i class=\"fa fa-arrow-left\"></i> Back</button><h5 class=card-header-text>Behavioral Range Scores</h5></div><div class=\"col-md-7 search-header\"><form><div class=input-group><input type=text class=form-control ng-model=vm.search placeholder=Search aria-label=Search aria-describedby=basic-addon2><div class=input-group-append><button ng-click=vm.loadData(1) class=\"btn btn-primary shadow-none\" type=submit><i class=\"fa fa-search fa-lg\"></i></button></div></div></form></div></div></div><div class=card-block><div class=\"row m-b-10\"><div class=\"col-md-2 m-r-0 p-r-0 toolbar-button\"><div class=btn-group role=group aria-label=\"Basic example\"><md-button ng-click=vm.gotoCreate() class=\"btn btn-mini-center btn-primary m-t-0\"><md-tooltip md-direction=top>Create new range</md-tooltip><md-font-icon class=\"fa fa-plus-square fa-lg\"></md-font-icon>&nbsp;&nbsp;CREATE</md-button></div></div><div class=col-md-10><div class=row><div class=col-md-10><select class=\"custom-select mb-2 mr-sm-2 mb-sm-0\" ng-model=vm.pageLength ng-change=vm.loadData(1)><option ng-value=5>5</option><option ng-value=10>10</option><option ng-value=20>20</option><option ng-value=25>25</option><option ng-value=50>50</option></select></div></div></div></div><div class=row><div class=col-md-12 hide show-gt-sm flex><div class=table-responsive><table cellspacing=0 class=\"table table-small-font table-sm table-bordered table-striped custom-th\"><thead><tr><th>ID</th><th>Score Min</th><th>Score Max</th><th>% Min</th><th>% Max</th><th>Category</th><th>Action</th></tr></thead><tbody><tr ng-repeat=\"item in vm.rangeList\" ng-if=!vm.isLoading><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.id}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.score_min}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.score_max}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.percentage_min}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.percentage_max}}</td><td class=custom-td style=\"vertical-align: middle; text-align: center\">{{item.category}}</td><td style=\"text-align: center; vertical-align: middle\"><button class=\"btn btn-mini-center btn-info\" ng-click=vm.gotoEdit(item)><md-tooltip md-direction=top>Edit</md-tooltip><i class=\"fa fa-pencil fa-lg\"></i></button> <button class=\"btn btn-mini-center btn-danger\" ng-click=\"vm.deleteItem(ev, item.id)\"><md-tooltip md-direction=top>Delete</md-tooltip><i class=\"fa fa-trash fa-lg\"></i></button></td></tr><tr ng-if=vm.isLoading><td colspan=7 class=text-center><span><i class=\"fa fa-spinner fa fa-pulse\"></i> </span>Loading Data ...</td></tr><tr ng-if=\"vm.rangeList.length === 0 && !vm.isLoading\"><td colspan=7 class=text-center>No Data Available</td></tr></tbody></table><nav aria-label=\"Page navigation\"><paging page=vm.currentPage page-size=vm.pageSize total=vm.totalItems paging-action=vm.loadData(page) show-prev-next=true show-first-last=true text-first=first text-last=last text-next=next text-prev=previous text-title-page=\"Page {page}\" text-title-first=\"First hover\" text-title-last=\"Last hover\" text-title-next=\"Next hover\" text-title-prev=\"Prev hover\"></paging></nav><small class=text-muted>Page : {{vm.currentPage}} showing {{vm.from}} - {{vm.to}} from total {{vm.totalItems}} record</small></div></div></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-category/create-question-category/create-question-category.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Question Category</h5></div><div class=card-block><form class=form-horizontal name=questionForm><div class=\"form-group row\"><div class=col-md-2><label for=name class=form-control-label>Category Name</label></div><div class=col-md-10><input type=text class=form-control ng-model=vm.name name=name required id=name></div></div><div class=\"form-group row\"><div class=col-md-2><label for=desc class=form-control-label>Descriptions</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.desc name=desc required id=desc rows=5></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!questionForm.$valid ng-click=vm.saveData(questionForm) class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-category/update-question-category/update-question-category.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Question Category</h5></div><div class=card-block><form class=form-horizontal name=questionForm><div class=\"form-group row\"><div class=col-md-2><label for=name class=form-control-label>Category Name</label></div><div class=col-md-10><input type=text class=form-control ng-model=vm.name name=name required id=name></div></div><div class=\"form-group row\"><div class=col-md-2><label for=desc class=form-control-label>Descriptions</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.desc name=desc required id=desc rows=5></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=\"!questionForm.$valid || questionForm.$pristine\" ng-click=vm.updateData(questionForm) class=\"btn btn-success pull-right\">Save</button></div></div></form></div></div>");
$templateCache.put("app/main/modules/question-bank/question-pool/create-pool/create-pool.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Pool</h5></div><div class=card-block><div class=card-block><form class=form-horizontal name=questionPoolForm><div class=\"form-group row\"><div class=col-md-2><label for=poolName class=form-control-label>Pool Name</label></div><div class=col-md-10><input class=form-control ng-model=vm.poolName name=poolName required id=poolName></div></div><div class=\"form-group row\"><div class=col-md-2><label for=poolDesc class=form-control-label>Pool Description</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.poolDesc name=poolDesc required id=poolDesc rows=5></textarea></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!questionPoolForm.$valid ng-click=vm.savePool() class=\"btn btn-success pull-right\">Submit</button></div></div></form></div></div></div>");
$templateCache.put("app/main/modules/question-bank/question-pool/edit-pool/edit.html","<div class=card><div class=card-header><h5 class=card-header-text>Create Pool</h5></div><div class=card-block><div class=card-block><form class=form-horizontal name=questionPoolForm><div class=\"form-group row\"><div class=col-md-2><label for=poolName class=form-control-label>Pool Name</label></div><div class=col-md-10><input class=form-control ng-model=vm.poolName name=poolName required id=poolName></div></div><div class=\"form-group row\"><div class=col-md-2><label for=poolDesc class=form-control-label>Pool Description</label></div><div class=col-md-10><textarea class=form-control ng-model=vm.poolDesc name=poolDesc required id=poolDesc rows=5></textarea></div></div><div class=\"form-group row\"><div class=col-md-2><label for=poolCreatedAt class=form-control-label>Pool Created At</label></div><div class=col-md-10><input readonly type=datetime-local class=form-control ng-model=vm.poolCreatedAt name=poolCreatedAt id=poolCreatedAt> <small>Datetime created automatically</small></div></div><div class=row style=float:right><div class=col-md-12><button ng-click=vm.back() class=\"btn btn-default\">Back</button> <button ng-disabled=!questionPoolForm.$valid ng-click=vm.savePool() class=\"btn btn-success pull-right\">Submit</button></div></div></form></div></div></div>");
$templateCache.put("app/main/modules/report/report-behavioral/report-behavioral-detail/report-behavioral-detail.html","<!-- Container-fluid starts --><div class=\"card relative\"><div class=card-header><div layout=row layout-align=\"space-between center\"><div layout=row layout-align=\"start center\"><button class=\"btn btn-warning btn-icon btn-mini-center\" ng-click=vm.goBack()><md-tooltip md-direction=top>Back</md-tooltip><i class=\"fa fa fa-chevron-left\"></i></button><div class=title-report>Behavioral Detail <span ng-if=vm.submission.user><strong>{{vm.submission.user.nik}}</strong> / {{vm.submission.user.name}}</span></div></div><div><button class=\"btn btn-primary mr-2\" ng-click=\"vm.export(\'excel\')\"><i class=\"fa fa-file-excel-o\"></i>&nbsp;Excel</button> <button class=\"btn btn-primary mr-2\" ng-click=\"vm.export(\'pdf\')\"><i class=\"fa fa-file-pdf-o\"></i>&nbsp;PDF</button> <button class=\"btn btn-success\" ng-if=!vm.isAllFinished ng-click=vm.markAsFinished()><i class=\"fa fa-flag-checkered\"></i>&nbsp;Mark as Finished</button> <button class=\"btn btn-warning\" ng-if=vm.isAllFinished ng-click=vm.markAsDraft()><i class=\"fa fa-undo\"></i>&nbsp;Mark as Draft</button><div class=text-right style=\"margin-top:8px; font-weight:600\">Nilai Akhir: {{vm.finalScore}}</div></div></div></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=table-navigation><div class=table-navigation-title>Navigasi Soal</div><div class=table-navigation-list><div class=\"table-navigation-item table-navigation-home\" ng-click=vm.scrollToTop() ng-class=\"{\'active\': vm.activeQuestionIndex === -1}\"><i class=\"fa fa-home\"></i> <span>Home</span></div><div class=table-navigation-item ng-repeat=\"item in vm.results track by $index\" ng-click=vm.scrollToQuestion($index) ng-class=\"{\'checked\': item.checked, \'active\': vm.activeQuestionIndex === $index}\">{{item.question.number}}</div></div></div><div class=\"row relative\"><div class=col-md-12><div class=table-responsive><table class=\"table table-bordered table-hover\"><thead><tr><th>#</th><th>Kompetensi</th><th>Judul Soal</th><th>Kunci</th><th class=text-center>Jawaban Kandidat</th><th class=text-center>Skor Pilihan<br>(Value)</th><th class=text-center>Nilai Alasan<br>(0-4)</th><th class=text-center>Bobot Komp.</th><th class=text-center>Skor Berbobot</th><th>Catatan Asesor</th></tr></thead><tbody><tr ng-repeat-start=\"item in vm.results\" ng-class=\"{\'question-row-active\': vm.activeQuestionIndex === $index}\"><td rowspan=2>{{ $index + 1 }}</td><td>{{ item.question.competency.competency }}</td><td>{{ item.question.text }}</td><td class=text-center><span ng-if=item.question.answers><span ng-repeat=\"ans in item.question.answers\" ng-if=ans.flag>{{ ans.option }}</span></span></td><td class=text-center><span ng-if=item.answer>{{ item.answer.option }}</span></td><td class=text-center>{{ item.choiceScore }}</td><td class=text-center style=\"width: 200px\"><div style=\"margin: auto\" class=\"form-inline align-items-center items-center justify-content-center\"><label style=\"width: 10px; margin: auto\" class=radio-inline ng-repeat=\"n in [0,1,2,3,4]\"><input type=radio ng-model=item.reason_value ng-value=n ng-disabled=item.checked ng-change=vm.onReasonChange(item)> <span style=\"margin: 4px 2px\">{{n}}</span></label></div></td><td class=text-center>{{ item.weightPercent || 0 }}%</td><td class=text-center>{{ item.scorePercent }}</td><td id=question-row-{{$index}} class=text-center style=\"width: 120px\"><button class=\"btn btn-link\" ng-click=\"vm.openNoteDialog(item, $event)\" title=\"Catatan Asesor\"><i class=\"fa fa-sticky-note fa-lg\"></i> <span ng-if=item.accessor_note class=\"badge badge-pill badge-info\" style=margin-left:5px>!</span></button></td></tr><tr ng-repeat-end><td colspan=8 ng-class=\"{\'question-checked\': item.checked}\"><div>Alasan :</div><div>{{item.reason}}</div></td><td class=text-center style=\"width: 120px\"><button ng-click=vm.onCheckClick(item) ng-disabled=\"(item.status || \'\').toLowerCase() === \'finished\'\" class=\"btn btn-link\"><i ng-style=\"{\'color\': item.checked ? \'green\' : \'blue\'}\" class=\"fa fa-check fa-lg\"></i></button></td></tr></tbody></table></div></div></div></div></div></div><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/report/report-general/report-general-detail/report-detail-chart.html","<!-- Container-fluid starts --><md-dialog layout=row><md-dialog-content><div class=container-fluid layout=column><div class=row><div class=\"col-md-12 m-t-20\"><div class=card><div class=card-header><h5>Detail Report {{ vm.data.user.name }} - {{ vm.data.user.nik }}</h5></div><div class=card-block><div class=md-card-block><div class=row><div class=col-md-12><canvas class=\"chart chart-line\" chart-data=vm.data.chart chart-labels=vm.labels chart-series=vm.series chart-click=onClick></canvas></div></div></div></div></div></div></div></div></md-dialog-content></md-dialog><!-- Container-fluid ends -->");
$templateCache.put("app/main/modules/report/report-general/report-general-detail/report-detail.html","<div ng-if=vm.isLoading class=card><div class=text-center style=\"font-size: 2em; padding: 10px\">Please wait, generating data</div></div><div ng-if=!vm.isLoading class=card><div class=card-header><md-button ng-click=vm.goBack() class=\"btn btn-mini-center btn-primary m-t-0\"><md-font-icon class=\"fa fa-arrow-left fa-lg\"></md-font-icon>&nbsp;&nbsp;Back</md-button><h5 class=text-center>Detail Report {{ vm.data.user.name }} - {{ vm.data.user.nik }}</h5><p class=text-center>Question Total : {{ vm.data.achievement.question_total}}</p><p class=text-center>Finished Date : {{ vm.data.achievement.finished_date}}</p><p class=text-center>Finished Time : {{ vm.data.achievement.finished_time}}</p><p class=text-center>Score : {{ vm.data.achievement.score}}</p></div><div class=card-block><div class=md-card-block><div class=row><div class=col-md-12><div class=table-responsive><table cellspacing=0 class=\"table sm-font-table table-sm table-bordered table-striped\" id=table-detail><thead><tr><th style=\"vertical-align: middle\">NO</th><th style=\"vertical-align: middle\">Question</th><th style=\"vertical-align: middle\">Competency</th><th style=\"vertical-align: middle\">Category</th><th style=\"vertical-align: middle\">Server Answer</th><th style=\"vertical-align: middle\">User Answer</th><th style=\"vertical-align: middle\">Flag</th></tr></thead><tbody><tr ng-repeat=\"item in vm.detail\"><td style=\"vertical-align: middle\">{{$index+1}}</td><td style=\"vertical-align: middle\">{{item.question}}</td><td style=\"vertical-align: middle; width: 20%\">{{item.code}} - {{item.competency}}</td><td style=\"vertical-align: middle; width: 15%\">{{item.category}}</td><td style=\"vertical-align: middle\"><div class=row ng-repeat=\"a in item.answer_server\"><div class=col-md-2><div class=badge ng-class=\"{\'badge-success\': a.flag == 1}\">{{a.index}}</div></div><div class=col-md-10>{{a.answer}}</div></div></td><td style=\"vertical-align: middle\"><div class=row ng-repeat=\"a in item.answer_user\"><div class=col-md-2><div class=badge ng-class=\"{\'badge-success\': a.flag == 1, \'badge-danger\': a.flag == 0}\">{{a.index}}</div></div><div class=col-md-10>{{a.answer}}</div></div></td><td style=\"vertical-align: middle; text-align: center\"><span class=\"badge badge-success\" ng-if=item.is_correct>TRUE</span> <span class=\"badge badge-danger\" ng-if=!item.is_correct>FALSE</span></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/main/modules/report/report-papikostik/report-papikostik-detail/report-papikostik-detail.html","<!-- Container-fluid starts --><div class=card><div class=card-header><div layout=row layout-align=\"start center\"><button class=\"btn btn-warning btn-icon btn-mini-center\" ng-click=vm.back()><md-tooltip md-direction=top>Back</md-tooltip><i class=\"fa fa fa-chevron-left\"></i></button><div class=title-report>Papikostik <span ng-if=vm.submission.user><strong>{{vm.submission.user.nik}}</strong> / {{vm.submission.user.name}}</span></div></div></div><div class=card-block block-ui=block-container><div class=md-card-block><div class=row><div class=col-md-6><div class=table-responsive><table class=\"table table-bordered table-striped\"><thead><tr><th>FLAG</th><th>TOTAL</th></tr></thead><tbody><tr class=hoverable ng-click=\"item.collapse = !item.collapse\" ng-init=\"item.collapse = false\" ng-repeat-start=\"item in vm.tableData\"><td>{{item.flag_abjact}}</td><td>{{item.total}}</td></tr><tr class=child-row ng-if=item.collapse ng-repeat-end><td colspan=2><div class=table-responsive><table class=table><thead class=thead-dark><tr><th>Question Number</th><th>Abjact</th></tr></thead><tbody><tr ng-repeat=\"val in item.details\"><td>{{val.question_id}}</td><td>{{val.abjact}}</td></tr></tbody></table></div></td></tr></tbody></table></div></div><div class=col-md-6 style=\"max-height: 300px\"><canvas id=radar class=\"chart chart-radar\" chart-data=vm.chart.data chart-labels=vm.chart.labels chart-options=vm.chart.options chart-colors=vm.chart.colors chart-dataset-override=vm.chart.override></canvas></div></div></div></div></div><!-- Container-fluid ends -->");}]);